export const productList = {
    "pagination": {
        "pageSize": 2000,
        "pageNo": 1,
        "total": 2000,
        "start": 0,
        "end": 2000,
        "type": true
    },
    "succeed": true,
    "message": "查询选品相关信息成功！",
    "items": [{
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "Base Shaper 1/8” Thick Clear Acrylic for Hermes Bags Picotin 22, Tote, Handbag, Bag, Purse Insert, Plexiglas, Plexiglass Bottom, Plastic",
        "ASIN": "B07DBB3LVH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31BpYi4JIbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 13, 2018",
        "Id": 13,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 62.99,
        "ReviewItem5": 0,
        "Title": "LeSportsac Sunlight Floral Austin Crossbody Handbag Detachable/Adjustable/Interchangeable Strap Metal Hardware, Style 2435/Color E141",
        "ASIN": "B07NPZ9R8L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61FgwfvmegL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 62.99,
        "UploadTime": " August 23, 2017",
        "Id": 14,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 46.65,
        "ReviewItem5": 0,
        "Title": "UWear Polly Pocket Purple Bow Bag",
        "ASIN": "B07L62PWS5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lueZyxk9L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 46.65,
        "Id": 15,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Replacement Sunglass Lenses",
        "ReviewItem1": 12,
        "ReviewItem2": 10,
        "PriceMax": 32,
        "ReviewItem5": 62,
        "Title": "Revant Replacement Lenses for Oakley Fuel Cell",
        "ASIN": "B006NHRNB8",
        "ReviewItem3": 5,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31gA-4QYbPL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32,
        "UploadTime": " January 31, 2014",
        "Id": 16,
        "ReviewCount": 399
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "Marchome Women Snakeskin Hologram PU Leather Shoulder Bag Handbag Crossbody Bag Purse Evening Bag",
        "ASIN": "B07CYPWR1D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41GGTWPRi0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " May 9, 2018",
        "Id": 17,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cowboy Hats",
        "ReviewItem1": 14,
        "ReviewItem2": 8,
        "PriceMax": 32.02,
        "ReviewItem5": 54,
        "Title": "Western Express Classic Cattleman Straw Cowboy Hat with Silver Conchos",
        "ASIN": "B00FF58ETY",
        "ReviewItem3": 8,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31llbQ0N96L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " December 4, 2015",
        "Id": 18,
        "ReviewCount": 518
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 5,
        "PriceMax": 11.99,
        "ReviewItem5": 59,
        "Title": "Naimo Flap Dazzling Clutch Bag Evening Bag With Detachable Chain",
        "ASIN": "B01JROBO4A",
        "ReviewItem3": 18,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hxctevS4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " September 27, 2016",
        "Id": 19,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 100,
        "Title": "Women Backpack Purse Waterproof Nylon Anti-theft Rucksack Lightweight Shoulder Bag Ladies Travel bags",
        "ASIN": "B07P91BLNH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41i1RqQLxUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " February 27, 2019",
        "Id": 20,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 50,
        "PriceMax": 89.99,
        "ReviewItem5": 50,
        "Title": "Kate Spade New York Arbour hill Charline Top Handle Crossbody",
        "ASIN": "B07H4Y6YH5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31lm3JbrvDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.99,
        "UploadTime": " August 3, 2018",
        "Id": 21,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 63.99,
        "ReviewItem5": 0,
        "Title": "BLY Peanuts Snoopy 2way Bag (Tote and Shoulder Bag) Face 448201",
        "ASIN": "B07HNXG9RX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511xgbF59yL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 63.99,
        "Id": 22,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 4.21,
        "ReviewItem5": 0,
        "Title": "Small Crossbody Purse for Women With Pendant, Vintage Leopard Print PU Leather Wallet Bag Cell Phone Bag Tote for Girl",
        "ASIN": "B07N484JLV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51d0KV0qaGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 4.21,
        "UploadTime": " January 25, 2019",
        "Id": 23,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 9,
        "PriceMax": 288,
        "ReviewItem5": 63,
        "Title": "Fossil Maya Large Hobo Handbag",
        "ASIN": "B078233SVD",
        "ReviewItem3": 3,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Cd97EsJsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 288,
        "UploadTime": " February 13, 2018",
        "Id": 65,
        "ReviewCount": 32
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Borsani Women's Henry Tote Handbag with Zip Closure",
        "ASIN": "B078YF59GR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513PGN9H2IL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " January 11, 2018",
        "Id": 24,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 16,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 63,
        "Title": "Women's Canvas Handbag,Unives Ladies Tote Hobo Large Shopping Shoulder Bag",
        "ASIN": "B07CHDVF2B",
        "ReviewItem3": 16,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-29LA6YKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " July 3, 2018",
        "Id": 25,
        "ReviewCount": 19
    }, {
        "Sale": "[]",
        "Category": "Gift Baskets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 7.99,
        "ReviewItem5": 100,
        "Title": "Organza Bags - Jewelry Drawstring Pouch - Small Wedding Bags - Candy Favor- White Party Bag 4x6 - Pouches with Drawstrings - Clear sachets by My Gift Shop (Blue)",
        "ASIN": "B07MR9H3CC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31PdfEn68uL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.99,
        "Id": 26,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45.95,
        "ReviewItem5": 0,
        "Title": "Chala Paw Print Patch Crossbody Handbag",
        "ASIN": "B079P51391",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61UY2oV8kHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.95,
        "UploadTime": " December 12, 2017",
        "Id": 27,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 3,
        "PriceMax": 139,
        "ReviewItem5": 74,
        "Title": "MICHAEL Michael Kors Women's Mercer Mini Tote",
        "ASIN": "B0759L3N16",
        "ReviewItem3": 8,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31PFoBSVhDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 139,
        "UploadTime": " January 19, 2018",
        "Id": 28,
        "ReviewCount": 88
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.37,
        "ReviewItem5": 0,
        "Title": "Weixinbuy Rattan Bags for Women Handwoven Wicker Woven Circle Crossbody Chic Bag",
        "ASIN": "B07QNKZPDP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uuiEYV9rL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.37,
        "UploadTime": " April 15, 2019",
        "Id": 29,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 6,
        "ReviewItem2": 6,
        "PriceMax": 23.89,
        "ReviewItem5": 66,
        "Title": "Humble Chic Vegan Leather Small Crossbody Bag or Wristlet Clutch Purse, Includes Adjustable Shoulder and Wrist Straps",
        "ASIN": "B07LGGGQ1Y",
        "ReviewItem3": 9,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Hp-oWs6uL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.89,
        "UploadTime": " June 3, 2013",
        "Id": 30,
        "ReviewCount": 633
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 9,
        "PriceMax": 18.98,
        "ReviewItem5": 56,
        "Title": "LUI SUI-Stunning Parent-child Circular planet party bag women laser planet orbit bag shoulder bag C54",
        "ASIN": "B01KO13S3K",
        "ReviewItem3": 10,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WL6iy83%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.98,
        "UploadTime": " August 19, 2016",
        "Id": 31,
        "ReviewCount": 75
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 5,
        "ReviewItem2": 3,
        "PriceMax": 249,
        "ReviewItem5": 76,
        "Title": "MICHAEL Michael Kors Women's Jet Set Medium Tote",
        "ASIN": "B01H0SIR68",
        "ReviewItem3": 3,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eBijOTpnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 249,
        "UploadTime": " August 10, 2016",
        "Id": 32,
        "ReviewCount": 276
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Rock Rebel Blue Frankenstein Bowler Handbag",
        "ASIN": "B07Q77XT5T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415q9H%2BQ5KL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " April 2, 2019",
        "Id": 33,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 149,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke NCAA Florida Foldover Crossbody Shoulder Bag",
        "ASIN": "B077TP3HB7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KcClHyRCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 149,
        "UploadTime": " November 20, 2018",
        "Id": 66,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Casual Daypacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 53.82,
        "ReviewItem5": 0,
        "Title": "Levis L1 Backpack",
        "ASIN": "B06XYGXW44",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZEQafiaaL._SR38,50_.jpg",
        "AcquisitionTime": 1558022400000,
        "Price": "[]",
        "PriceMin": 53.82,
        "UploadTime": " October 3, 2017",
        "Id": 11921,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.09,
        "ReviewItem5": 0,
        "Title": "Transparent Messenger Bag,Women Simple Fashion Shoulder Bag Small Square Bag",
        "ASIN": "B07QKQSZQT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31uC7galjYL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.09,
        "Id": 34,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 128.69,
        "ReviewItem5": 0,
        "Title": "COACH ZIP SHOULDER BAG IN SIGNATURE CANVAS F29209 IMDQC",
        "ASIN": "B07DWGZYGW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51g7SqFPUPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 128.69,
        "UploadTime": " June 21, 2018",
        "Id": 35,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 290,
        "ReviewItem5": 67,
        "Title": "Roberto Cavalli Women's Bowling Bag",
        "ASIN": "B079LHD1QY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mHT27sAAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 290,
        "UploadTime": " February 5, 2018",
        "Id": 36,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.5,
        "ReviewItem5": 0,
        "Title": "Womens Large Capacity Flap Evening Clutch Bag Wedding Bridal Purse Casual Shoulder Bag",
        "ASIN": "B078KTKYH3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61E1%2BfmHSqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.5,
        "UploadTime": " August 16, 2018",
        "Id": 37,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 114.91,
        "ReviewItem5": 0,
        "Title": "Bogner Adora, Women’s Cross-Body Bag, Mehrfarbig (Camouflage), 10x15x20 cm (B x H x T)",
        "ASIN": "B07122NSGS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iLve0cpJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 114.91,
        "UploadTime": " July 1, 2018",
        "Id": 38,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.1,
        "ReviewItem5": 0,
        "Title": "Fashion Geometry Baobao Luxury Designer Brands Ladies Handbag Female Geometric Bao Women Big Shoulder Bag",
        "ASIN": "B07CSD4TPP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41865y30FUL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.1,
        "UploadTime": " May 2, 2018",
        "Id": 39,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 3,
        "ReviewItem2": 5,
        "PriceMax": 25,
        "ReviewItem5": 71,
        "Title": "KAVU Zippy Wallet Bi Fold Clutch with Removable Coin Pouch",
        "ASIN": "B07DF43H4W",
        "ReviewItem3": 7,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zhXw72bbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25,
        "UploadTime": " May 23, 2010",
        "Id": 40,
        "ReviewCount": 85
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 85.5,
        "ReviewItem5": 0,
        "Title": "AmeriBag Healthy Back Bag tote Print Small (Mojave)",
        "ASIN": "B07NYQ42P5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512bDHFluIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 85.5,
        "UploadTime": " March 7, 2019",
        "Id": 41,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.3,
        "ReviewItem5": 33,
        "Title": "Laurel Burch Polka Dot Cats Medium Shoulder Bag",
        "ASIN": "B07621JDS1",
        "ReviewItem3": 67,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61SZR0QU71L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.3,
        "UploadTime": " September 29, 2017",
        "Id": 42,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.35,
        "ReviewItem5": 0,
        "Title": "Blazin Roxx Women's Josie Satchel Bag",
        "ASIN": "B079C3P3GM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VbRAc8o6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.35,
        "UploadTime": " September 19, 2018",
        "Id": 43,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 80,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Iconic On The Go Crossbody, Signature Cotton",
        "ASIN": "B07P978LDG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jPvCZZl4L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 80,
        "UploadTime": " April 14, 2019",
        "Id": 44,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 7,
        "PriceMax": 55.78,
        "ReviewItem5": 72,
        "Title": "Goyarr Handbag Biggest GM Size Large Size 22\"x12\"x6\" Gift for Women Delicate Super Star Bag",
        "ASIN": "B07DXJ9QRS",
        "ReviewItem3": 0,
        "ReviewItem4": 21,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UQ9ai4q1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55.78,
        "UploadTime": " June 21, 2018",
        "Id": 45,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 74.99,
        "ReviewItem5": 100,
        "Title": "Calvin Klein Brooke Key Item Saffiano Tote",
        "ASIN": "B073VXSQPL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Nh8MNYQkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 74.99,
        "UploadTime": " December 8, 2017",
        "Id": 46,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 219,
        "ReviewItem5": 0,
        "Title": "KATE SPADE CARLYLE STREET KALLIE",
        "ASIN": "B07BVKWQTY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BjrP7r3VL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 219,
        "UploadTime": " April 1, 2018",
        "Id": 47,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Jenele Python Embossed Pattern Faux Leather Tote Shoulder Hand Bag",
        "ASIN": "B01FIQ915K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511CcuVJLsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " May 11, 2016",
        "Id": 48,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.88,
        "ReviewItem5": 86,
        "Title": "18MM Width Leather Adjustable Length Replacement Cross Body Purse Handbag Bag Shoulder Bag Wallet Strap",
        "ASIN": "B0736N2BVD",
        "ReviewItem3": 14,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31m%2BPzbfJJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.88,
        "UploadTime": " June 23, 2017",
        "Id": 49,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 42.95,
        "ReviewItem5": 0,
        "Title": "Lost Queen Gothic Black Magic Occult Pentagram & Esoteric Symbols Bowler Bag",
        "ASIN": "B07L3Z8GS9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HRDqi-YTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 42.95,
        "UploadTime": " June 28, 2016",
        "Id": 50,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 70,
        "Title": "ASK 4 JEANS Denim Jeans Purse Shoulder Hand bags For Women",
        "ASIN": "B01MR83DLX",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41n0EMhulBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " January 20, 2017",
        "Id": 51,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 218.08,
        "ReviewItem5": 40,
        "Title": "MICHAEL Michael Kors Women's Diamond Grommet Selma Top Zip Satchel",
        "ASIN": "B01H0Z6QLE",
        "ReviewItem3": 20,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ORdz9xpRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 218.08,
        "UploadTime": " October 17, 2016",
        "Id": 52,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 383.02,
        "ReviewItem5": 0,
        "Title": "Lulu Guinness Women's Wanda Top-Handle Bag Black (Black/Chalk)",
        "ASIN": "B075HGVJQ7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414VAO-XZAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 383.02,
        "UploadTime": " May 2, 2018",
        "Id": 53,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 75,
        "Title": "Clear Bag, Women Transparent Clear Purse Handbag",
        "ASIN": "B078Z3791N",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51yJXaa0WjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " January 12, 2018",
        "Id": 54,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 0,
        "Title": "Periea Handbag Organizer - Chelsy - 25 Colors Available - Small, Medium or Large",
        "ASIN": "B00UAH1XAO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BPDIQz6uL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " September 27, 2012",
        "Id": 67,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 100.59,
        "ReviewItem5": 0,
        "Title": "Kipling NEAT Bag Organiser, 39 cm, 13 liters, Grey (Metallic Stony)",
        "ASIN": "B07DRJ5GZD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mB8Lsi2tL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 100.59,
        "Id": 68,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 37.99,
        "ReviewItem5": 0,
        "Title": "MARCO Collection Fashion Women Handbag Packlock Shoulder Bag Designer Satchel Purse",
        "ASIN": "B06Y4H4M59",
        "ReviewItem3": 0,
        "ReviewItem4": 75,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YWEJZ%2BAZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.99,
        "UploadTime": " October 11, 2016",
        "Id": 55,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "IN Bag-In-Bag Multifunctional Organizer Tidy Travel Handbag Tote Organizer Insert Multi-Pocket Handbag Shaper",
        "ASIN": "B07BGW5NF4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PHnXOPvdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " March 15, 2018",
        "Id": 56,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 4,
        "PriceMax": 40.88,
        "ReviewItem5": 69,
        "Title": "Bagtopia Women's Fashion Leather Top-handle Handbags and Purses OL Casual Tote Crossbody Shoulder Bag Satchel Purse",
        "ASIN": "B01GFRFRK4",
        "ReviewItem3": 9,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kw3rO6qaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.88,
        "UploadTime": " June 1, 2016",
        "Id": 6,
        "ReviewCount": 80
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 155,
        "ReviewItem5": 0,
        "Title": "France YSL Women's Monogram Envelope Shoulder Bag",
        "ASIN": "B07PYW4MXN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412j%2BlIFKuL._SX38_SY50_CR,0,0,38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 155,
        "Id": 7,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Nuni Women's Pigeon Bird Print Cotton Canvas Tote Bag",
        "ASIN": "B072XV47TS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ScZN1GVgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " June 18, 2017",
        "Id": 8,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 48,
        "ReviewItem5": 100,
        "Title": "SUSU The Zoe Leather Small Crossbody Bag for Women Cute Cross Body for Teens Cell Phone Purse",
        "ASIN": "B01N0TXN31",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Yw0NqTCEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 48,
        "UploadTime": " December 23, 2016",
        "Id": 9,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.69,
        "ReviewItem5": 0,
        "Title": "Women Vintage Handbag ,Todaies Fashion Women Leather Splice Handbag Women Shoulder Bag Crossbody Bag Tote Bag 2018 (20cm(L)17cm(H)6cm(W), Brown)",
        "ASIN": "B07CN4H7LC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YTKBeAcIL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.69,
        "Id": 10,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 124.95,
        "ReviewItem5": 0,
        "Title": "100% Natural Portuguese Cork Shoulder Crossbody Bag Purse Made In Portugal",
        "ASIN": "B07KDK4CWD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TH06RId-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 124.95,
        "UploadTime": " November 9, 2018",
        "Id": 11,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Women’s long Wallet Lady Clutch Bag Phone Purse Card Holder Zip around",
        "ASIN": "B07J6SPYN5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ECODZQp%2BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " October 9, 2018",
        "Id": 12,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 76.82,
        "ReviewItem5": 82,
        "Title": "Lug Double Dutch Crossbody Bag, Brushed Gold Cross Body Bag",
        "ASIN": "B074MQZPXD",
        "ReviewItem3": 0,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hlmrGMKSL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 76.82,
        "UploadTime": " September 2, 2017",
        "Id": 57,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 6,
        "ReviewItem2": 0,
        "PriceMax": 29.98,
        "ReviewItem5": 82,
        "Title": "BOSTANTEN Womens Wallet Genuine Leather Wallets Large Capacity Cash Cluth Purses with Zipper Pocket",
        "ASIN": "B01H4X8L2E",
        "ReviewItem3": 0,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517WDux129L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.98,
        "UploadTime": " June 16, 2016",
        "Id": 58,
        "ReviewCount": 17
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 4,
        "PriceMax": 35.99,
        "ReviewItem5": 69,
        "Title": "InterestPrint Sugar Skull Women's Leather Tote Shoulder Bags Handbags",
        "ASIN": "B078F1M79J",
        "ReviewItem3": 5,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61-rfxkse8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " December 12, 2017",
        "Id": 59,
        "ReviewCount": 77
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.98,
        "ReviewItem5": 0,
        "Title": "EROUGE Acrylic Bag Bag Crossbody Bag With Chain Marbling PU Leather Hard Surface",
        "ASIN": "B07QGCYTMN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QEsPyLHDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.98,
        "UploadTime": " April 4, 2019",
        "Id": 60,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.01,
        "ReviewItem5": 100,
        "Title": "Loungefly Pokemon Starter All Over Print Bag Purse",
        "ASIN": "B078BFZZWJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EXH9l0okL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.01,
        "UploadTime": " December 15, 2017",
        "Id": 61,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 135,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Sawyer Street Declan Classic Leather Crossbody Bag - Plum dawn",
        "ASIN": "B07BN9P31J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31MeuQ7s6FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 135,
        "UploadTime": " March 15, 2018",
        "Id": 62,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 109,
        "ReviewItem5": 0,
        "Title": "Kipling CANDY Handbag (convertible to backpack) Sand Summer Str",
        "ASIN": "B07L1Y5PXJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FRXvUBEtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 109,
        "UploadTime": " April 14, 2018",
        "Id": 63,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.08,
        "ReviewItem5": 50,
        "Title": "Sunyastor Women's Canvas Handbags Hobo Vintage Female Hobos Single Shoulder Bags Top-Handle Purse High Capacity",
        "ASIN": "B07CR9YVLQ",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41h-mFZeAKL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.08,
        "UploadTime": " March 27, 2018",
        "Id": 64,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 15,
        "ReviewItem2": 4,
        "PriceMax": 14.25,
        "ReviewItem5": 54,
        "Title": "Donalworld Women PVC Clear Bag Summer Beach Jelly Handbag",
        "ASIN": "B01CHED1OI",
        "ReviewItem3": 12,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/411JNEs1RVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.25,
        "UploadTime": " March 3, 2016",
        "Id": 69,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Jack and Sally Print Women's Leather Tote Shoulder Bag Big Capacity Work Travel Handbag (11)",
        "ASIN": "B07PXTJV8J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cHy4AhLnL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "Id": 98,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 79.99,
        "ReviewItem5": 0,
        "Title": "EMINI HOUSE Crossbody Bags for Women Nappa Leather Shoulder Bag with Chain Strap Indian Style Padlock Niche Chic Purse",
        "ASIN": "B072SB3Y6P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514wLm5xvFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79.99,
        "UploadTime": " October 15, 2017",
        "Id": 1,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 6,
        "PriceMax": 22.99,
        "ReviewItem5": 75,
        "Title": "Women's Satin Flower Evening Clutch Bags Pearl Beaded Evening Handbag for Prom Bride Wedding",
        "ASIN": "B07C2RL3JD",
        "ReviewItem3": 7,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iDzMHghOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " April 9, 2018",
        "Id": 2,
        "ReviewCount": 83
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 194.5,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Women's Saffiano LARGE TOTE HANDBAG Vanilla/luggage",
        "ASIN": "B01MT5QB2Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zAGY%2BLIlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 194.5,
        "UploadTime": " January 4, 2017",
        "Id": 3,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Men's Genuine Leather Brown wallet Bifold Multi Card Holder Purse Minimalist Front Pocket with 1 ID Window",
        "ASIN": "B07QXC3TV8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51J%2BRCpdVUL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " April 19, 2019",
        "Id": 4,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29,
        "ReviewItem5": 0,
        "Title": "Women's Bags PU(Polyurethane) Crossbody Bag Pocket Yellow/Fuchsia/Light Purple",
        "ASIN": "B07MZLDKVG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MiLtxAhHL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29,
        "UploadTime": " January 22, 2019",
        "Id": 5,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 10,
        "PriceMax": 24.99,
        "ReviewItem5": 90,
        "Title": "Partrisee Rattan bags for Women, Round Straw Shoulder Crossbody Tote bags Handwoven by Bali Artisans",
        "ASIN": "B07CYZV2DY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61%2BNh0tio2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " May 9, 2018",
        "Id": 70,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 3,
        "ReviewItem2": 1,
        "PriceMax": 22.98,
        "ReviewItem5": 84,
        "Title": "Victus Outdoors Zip Top Mesh Beach Bag Large Black Tote Bag 24 x 16, Long 12in Handles, Inside Zippered Pocket, Spring Clip, 8 Big Outside Pockets, Sand and Water Drains Away, with Bonus Tote Bag",
        "ASIN": "B01BLTOEMS",
        "ReviewItem3": 5,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41syyo5HdhL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.98,
        "Id": 71,
        "ReviewCount": 112
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 100,
        "Title": "Celina Snakeskin Pattern Embossed Faux Leather Satchel Hand Bag",
        "ASIN": "B01FIQ8OQM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51N5rxgApbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " May 11, 2016",
        "Id": 103,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 75,
        "Title": "Disney Lilo & Stitch Sketch Hawaiian Hobo Bag",
        "ASIN": "B00I6C6DOG",
        "ReviewItem3": 6,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BEHDLqFLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " June 1, 2015",
        "Id": 211,
        "ReviewCount": 16
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 75,
        "Title": "Vercord X-large Purse Organizer Insert Women Tote Handbag Liner With Zipper Organizador",
        "ASIN": "B07B8C93C9",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lZxoi5paL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " March 5, 2018",
        "Id": 72,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.08,
        "ReviewItem5": 0,
        "Title": "Women Tassels Crossbody Bag Ladies String Bucket Messenger Bag Pure Colour Leather Shoulder Bag Phone Bags S",
        "ASIN": "B07D77RWDH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417cKJ4YshL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.08,
        "UploadTime": " May 22, 2018",
        "Id": 73,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35,
        "ReviewItem5": 0,
        "Title": "Blazin Roxx Women's American Flag Crossbody Bag, Multi, OS",
        "ASIN": "B00VTV5S42",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51M8GwZ%2BuHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35,
        "UploadTime": " April 8, 2015",
        "Id": 74,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 7.99,
        "ReviewItem5": 0,
        "Title": "6 Pocket Handbag Organizers Anti-dust Cover Clear Hanging Closet Bags Organizer Purse Holder Collection Shoes Save Space",
        "ASIN": "B07HJZXXJ5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41smd1bE7BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.99,
        "UploadTime": " September 21, 2018",
        "Id": 75,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 109.67,
        "ReviewItem5": 0,
        "Title": "PIJUSHI Shoulder Handbags For Women Genuine Leather Quilted Chain Bag Cross Body Purses",
        "ASIN": "B07QZX526N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5122W3R3gyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 98.11,
        "UploadTime": " May 8, 2019",
        "Id": 76,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.9,
        "ReviewItem5": 0,
        "Title": "Beach Bag With Inner Zipper Pocket, Canvas Shoulder Tote Bag with Cotton Rope Handles",
        "ASIN": "B07P8X3RFM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41G9XLKxpbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.9,
        "UploadTime": " February 26, 2019",
        "Id": 77,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.95,
        "ReviewItem5": 0,
        "Title": "CafePress - Social Work Hearts - Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00O13XI24",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41v0Qz6PS6L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.95,
        "Id": 95,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "NeverOut Genuine Leather Bag Soft Ladies Small Crossbody Shoulder Bag Purse with Chain Strap (NP2006)",
        "ASIN": "B07G34G9BK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51fvztawReL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " August 1, 2018",
        "Id": 78,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 120.01,
        "ReviewItem5": 0,
        "Title": "Kipling Womens Chipper Cross-Body Bag Beige (Cloud Beige)",
        "ASIN": "B01NCK9KBH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WOxYCtS5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 120.01,
        "UploadTime": " May 2, 2018",
        "Id": 79,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 100,
        "Title": "Wallets Men Magic Wallets Designer Purse Rfid Credit Card Holder",
        "ASIN": "B07CMZSP75",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Y%2B9lKxzIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " April 25, 2018",
        "Id": 80,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 109.77,
        "ReviewItem5": 54,
        "Title": "Coach Women's North-South Logo Swingpack",
        "ASIN": "B00LO6Z57M",
        "ReviewItem3": 21,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sAi4Dt9HL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 109.77,
        "UploadTime": " August 12, 2015",
        "Id": 81,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.59,
        "ReviewItem5": 0,
        "Title": "US Flag Trending Cross Body Bag",
        "ASIN": "B07MPW5Z5R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41G2Gr5HxeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.59,
        "UploadTime": " January 5, 2019",
        "Id": 82,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.95,
        "ReviewItem5": 0,
        "Title": "CafePress - Green Recycle Symbol - Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00O13XHQG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41muS2WNc4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.95,
        "Id": 83,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 124.1,
        "ReviewItem5": 0,
        "Title": "Kate Spade Women's Magnolia Street Small Mina Leather Handbag",
        "ASIN": "B07P3XNMK3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31yYTQOg7qL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 124.1,
        "UploadTime": " February 24, 2019",
        "Id": 84,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 440.74,
        "ReviewItem5": 0,
        "Title": "GON Handmade Leather Shoulder Bag Hawai (Taba)",
        "ASIN": "B07NC8XMHL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Bte5M8%2BXL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 440.74,
        "UploadTime": " February 2, 2019",
        "Id": 85,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 19,
        "PriceMax": 11.9,
        "ReviewItem5": 52,
        "Title": "Hoxis Travel Grain Soft Faux Leather Mini Duffle Crossbody Shoulder Bag for Womens 3 Solid Colors",
        "ASIN": "B00ITJJJJM",
        "ReviewItem3": 14,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417MRMPNXwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.9,
        "UploadTime": " March 6, 2014",
        "Id": 86,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.95,
        "ReviewItem5": 0,
        "Title": "Luv Betsey Crossbody Mini-Barrel Satchel Purse Rose Gold Base / Roses & Stars Print",
        "ASIN": "B074613NQZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61nLDFcB3aL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " July 22, 2017",
        "Id": 87,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 1,
        "ReviewItem2": 3,
        "PriceMax": 22.95,
        "ReviewItem5": 85,
        "Title": "Beach Bags and Totes - Premium Canvas Travel Beach Tote – Cute Chic Water-Resistant Large Beach Tote Bag for Women Boasts Cell Phone Pocket, Small Bag Matching Wristlet, Compact Design",
        "ASIN": "B07693YLYD",
        "ReviewItem3": 5,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61jzT06eLcL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.95,
        "Id": 88,
        "ReviewCount": 66
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.9,
        "ReviewItem5": 0,
        "Title": "Lady Couture Rhinestone Clutch Bag by, GEM Bag",
        "ASIN": "B07CXTVM6P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61BuOeX17YL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.9,
        "UploadTime": " May 4, 2018",
        "Id": 96,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Tie Clips",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15,
        "ReviewItem5": 0,
        "Title": "GuoShuang Stainless Steel Nordic Viking Odin Wolf Amulet Rune Tie Clips -Small Size with Valknut Gift Bag",
        "ASIN": "B07M95JQFB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41EFA9mINSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15,
        "UploadTime": " December 20, 2018",
        "Id": 89,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.16,
        "ReviewItem5": 0,
        "Title": "SIAM YIM SA-RA-EI style 02 :Thai style paraphernalia small bag (Sling shoulder bag/Wallet purse coin/Purse cell/Phone pouch)",
        "ASIN": "B079Y1JQMH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kQMhMxgjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.16,
        "UploadTime": " February 19, 2018",
        "Id": 90,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.15,
        "ReviewItem5": 0,
        "Title": "Enjoyba Men's Short Vintage Multi-function Zipper Coin Purse Card Holder Bag",
        "ASIN": "B07RS925NS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uiQp17I%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.15,
        "UploadTime": " May 10, 2019",
        "Id": 91,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 17,
        "PriceMax": 8.99,
        "ReviewItem5": 33,
        "Title": "American Trends Expandable Handbags Purse Insert Organizers with Handles (FBA)",
        "ASIN": "B01E78DMRI",
        "ReviewItem3": 33,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514bfFaxVhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " April 13, 2016",
        "Id": 92,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.95,
        "ReviewItem5": 50,
        "Title": "Mundi Chelsea Double Bow Womens RFID Crossbody Wallet Bag",
        "ASIN": "B07FKQMZL3",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wLhf2BcpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.95,
        "UploadTime": " July 31, 2018",
        "Id": 93,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 100,
        "Title": "Myra Bags Artisan Upcycled Canvas Tote Bag M-0745",
        "ASIN": "B078HJHKMH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TZc9WeXnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " September 4, 2014",
        "Id": 94,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 150,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Mitsuko Handbag, Vintage Collection, Chili (Brown)",
        "ASIN": "B07G2QBWYK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Hc2JqIr-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 150,
        "UploadTime": " July 31, 2018",
        "Id": 97,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22,
        "ReviewItem5": 0,
        "Title": "Stepping Out-African Hi Target Print clutch purse/Sunny Peek",
        "ASIN": "B07CX45GYT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31ctMthq9%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22,
        "UploadTime": " May 7, 2018",
        "Id": 99,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.62,
        "ReviewItem5": 50,
        "Title": "Canvas Tote Bag For Women, Canvas Owl Tote Bag with Zipper Closure, Large Compartment, Perfect for School, Work, or the Beach",
        "ASIN": "B079QH3V42",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51g4iZ3J7TL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.62,
        "UploadTime": " February 9, 2018",
        "Id": 100,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.95,
        "ReviewItem5": 0,
        "Title": "Base Shaper 1/16” Lightweight Clear Acrylic for Goyard Sac Hardy Pet Bag GM - Tote Handbag Carrier, Purse Insert, Plexiglas, Plexiglass Bottom, Plastic",
        "ASIN": "B07DH1V2L6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31aHbKeAP9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.95,
        "UploadTime": " March 13, 2018",
        "Id": 101,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 11,
        "PriceMax": 29.95,
        "ReviewItem5": 56,
        "Title": "Western Style Butterfly Tooled Leather Women Purse Cross Body Handbag Concealed Carry Single Shoulder Bag",
        "ASIN": "B07CLJ3F9Y",
        "ReviewItem3": 0,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UtHOtpKiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " February 5, 2018",
        "Id": 102,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "Mens Slim Front Pocket Genuine Leather Wallet, Bifold Card Case with ID Window & RFID Blocking, Card/Photo Holder with 2 Zippers Bags, Stylish Coin Pocket",
        "ASIN": "B07QWZXNX4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jdblMb4ML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " April 18, 2019",
        "Id": 104,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0.01,
        "ReviewItem5": 0,
        "Title": "Big Sale! Fashion Elegant Girls Shoulder Bag Floral Printed Canvas Shopping Handbag For Women Shoulder Tote Shopper Bag",
        "ASIN": "B07QW5F1SS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51chdtSJiZL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0.01,
        "Id": 105,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Ephraim Women Handbags Elegant Travel Bag Shoulder Beach Bags Tote Bag for Women (grey)",
        "ASIN": "B07BC8J6Q5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iVUZ1zd2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " March 10, 2018",
        "Id": 106,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Daddy Dad Funny Gift For Father's Day Holiday - Tote Bag With Zip",
        "ASIN": "B0798N6ZY8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KnfMP4JNL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " January 24, 2018",
        "Id": 107,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Heather Tassel Saddle Handbag",
        "ASIN": "B01N4IK09B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MSQydBFVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " December 28, 2016",
        "Id": 148,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 181.48,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Tatiana Small Leather Satchel Gold-Toned Hardware",
        "ASIN": "B07HWVYWQP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TKs3aW%2BDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 181.48,
        "UploadTime": " October 1, 2018",
        "Id": 328,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "AWESAMA Waterproof Chain Strap Women Girls small Shoulder Bag Crossbody Purse",
        "ASIN": "B07DLJP7XF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uFdOP3cnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " June 7, 2018",
        "Id": 108,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 57.04,
        "ReviewItem5": 88,
        "Title": "Vera Bradley Triple Zip Hipster Cross-body Bag with Updated Solid Interiors",
        "ASIN": "B077Q4KSQG",
        "ReviewItem3": 4,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61vqC0naHJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 57.04,
        "UploadTime": " November 23, 2017",
        "Id": 109,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 76,
        "ReviewItem5": 0,
        "Title": "Maxwell-Scott Luxury Handcrafted Italian Full Grain Leather Key Wallet (The Vinci)",
        "ASIN": "B01H3KJAAA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MY4s3ZJpL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 76,
        "UploadTime": " November 15, 2017",
        "Id": 110,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.99,
        "ReviewItem5": 0,
        "Title": "Cath Kidston Matt Oilcloth Busy Bag Handbag Crossbody Garden Rose Charcoal",
        "ASIN": "B018UR4OPQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tNs-WOtsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "Id": 120,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 299,
        "ReviewItem5": 50,
        "Title": "Marc Jacobs Women's Mini Boho Grind Bag",
        "ASIN": "B078JP4BGY",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31XDghMgztL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 299,
        "UploadTime": " February 28, 2018",
        "Id": 111,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 53.9,
        "ReviewItem5": 0,
        "Title": "Heshe Womens Leather Cube Small Shoulder Handbags Ladies Designer Purse Cross Body Bag",
        "ASIN": "B07PJHB38P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lbEeu%2BSBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 53.9,
        "UploadTime": " March 10, 2019",
        "Id": 112,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Lonson Big Canvas Work Bag Weekend Shopping Tote Bag Handbag for Women",
        "ASIN": "B07BK1PCZV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VS4064mFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " March 1, 2018",
        "Id": 113,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 5,
        "ReviewItem2": 6,
        "PriceMax": 16.99,
        "ReviewItem5": 66,
        "Title": "WOZEAH Women's RFID Blocking Large Capacity Luxury Wax PU Leather Clutch Wallet Card Holder Organizer Ladies Purse",
        "ASIN": "B07KRM2B8F",
        "ReviewItem3": 6,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PSSSuE8TL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " July 12, 2018",
        "Id": 114,
        "ReviewCount": 82
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.63,
        "ReviewItem5": 0,
        "Title": "Men Tactical Chest Rig Waist Bag Hip Hop Street Wear Shoulder Bag",
        "ASIN": "B07PWJYQC9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oNLw5TYfL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.63,
        "UploadTime": " March 22, 2019",
        "Id": 115,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.49,
        "ReviewItem5": 67,
        "Title": "ESONE Waterprof Backpack Dry Bag Roll Top Gear Sack for Water Sports Kayaking Rafting Floating Camping Hiking",
        "ASIN": "B07739G4Q7",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Tq4htqS5L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.9,
        "Id": 116,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 123.43,
        "ReviewItem5": 0,
        "Title": "Love Moschino Borsa Calf Pu, Women’s Cross-Body Bag, Gold (Oro), 6x19x28 cm (W x H L)",
        "ASIN": "B07LBGPYG4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eyiZGTnfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 123.43,
        "UploadTime": " February 27, 2019",
        "Id": 927,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.49,
        "ReviewItem5": 0,
        "Title": "Brown Card Holder Slim Credit Card Id Card Holder Case Bag Wallet Holder - HHmei Double Card Driver's License Bag",
        "ASIN": "B07Q3X1X6W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510Yw68UyoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.49,
        "Id": 117,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.49,
        "ReviewItem5": 0,
        "Title": "FENICAL Straw Bags Cherry Crossbody Bag Cute Fruits Wicker Purse for Women Girl Lady",
        "ASIN": "B07QYQL43G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KA0DSVIoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.49,
        "UploadTime": " April 23, 2019",
        "Id": 118,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.99,
        "ReviewItem5": 67,
        "Title": "Lug Women's Shimmy Crossbody Bag, Brushed Orchid Cross Body, One Size",
        "ASIN": "B074JJ877C",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51r66%2BeV70L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.99,
        "UploadTime": " August 17, 2017",
        "Id": 119,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.95,
        "ReviewItem5": 0,
        "Title": "Red White and Blue American Flag Crossbody Bag",
        "ASIN": "B07912BYRR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ALTyskg4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.95,
        "UploadTime": " January 14, 2018",
        "Id": 121,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 50,
        "Title": "Small Wallets for Women Bifold Leather Short Wallet Lady Mini Purse Card Case Holder with ID Window",
        "ASIN": "B07Q2F2ZK3",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Hbx4FxXtL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " March 26, 2019",
        "Id": 122,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 298,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Sylvia Large Tri-Color Crossgrain Leather Satchel Bag, Butternut Cream Acorn",
        "ASIN": "B07M92R95Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fN3U8t%2BQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 298,
        "UploadTime": " May 4, 2019",
        "Id": 123,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 195.9,
        "ReviewItem5": 0,
        "Title": "Love Moschino Women's Cross-Body-Handbags",
        "ASIN": "B07F5YBHPJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-6j41TXkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 195.9,
        "UploadTime": " September 7, 2018",
        "Id": 124,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "FiveloveTwo Women 4 Pcs Top Handle Satchel Hobo Handbag Set Large Tote +Purse +Shoulder Bag+Card Holder",
        "ASIN": "B07F8QGDW5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515d37saAnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " November 29, 2017",
        "Id": 125,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 100,
        "Title": "Ladies Practical Leather Handbag with Side Buckle Design",
        "ASIN": "B00ISS72GG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WCYCNS3xL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " March 5, 2014",
        "Id": 156,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Women Soft Leather Crossbody Bags Large Slim Clutch Purse With Removable Strap",
        "ASIN": "B07DNBRB52",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31UKxajbvjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " January 18, 2019",
        "Id": 126,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "Kenneth Cole New York Women's Stud Sense Mini Cross-Body",
        "ASIN": "B01D4MO4A2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51XJFyWzSnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " March 1, 2016",
        "Id": 127,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89.99,
        "ReviewItem5": 0,
        "Title": "Steven Alan Women's Martin Flap Crossbody",
        "ASIN": "B07NDG32R2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ch1pEqCfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.99,
        "UploadTime": " February 5, 2019",
        "Id": 128,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 22.85,
        "ReviewItem5": 81,
        "Title": "DELUXITY | Crossbody Hobo Slouch Bucket Purse Bag | Side Pockets with Tassel | Adjustable Strap",
        "ASIN": "B07J2VZ9TL",
        "ReviewItem3": 3,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41HtMyP2JcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.85,
        "UploadTime": " October 5, 2018",
        "Id": 129,
        "ReviewCount": 37
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Red Royal Stewart Tartan Top-Handle Shoulder Bag by Signare/Branded Women's Scottish Plaid Side/CONV-RSTT",
        "ASIN": "B01AWDKK2C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51m3Lnj4KXL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "Id": 130,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 138.95,
        "ReviewItem5": 50,
        "Title": "The Sak Women's Tahoe Medium Hobo The Sak Collective",
        "ASIN": "B078J3RCKJ",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410Y9ygiTTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138.95,
        "UploadTime": " March 24, 2018",
        "Id": 131,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Sandals",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.9,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Summer Men's Slippers Outdoor & Indoor Sandals Mix Flip Flops",
        "ASIN": "B07MMWSQR2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41O%2BWISqYPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.9,
        "UploadTime": " December 28, 2018",
        "Id": 132,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Gacchi Sequins Purse Handbag Tote bag Handcraft Casual formal woven mesh knit pu faux leather",
        "ASIN": "B07DS6XN2D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IOavT4pJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " June 15, 2018",
        "Id": 133,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 115.99,
        "ReviewItem5": 0,
        "Title": "Patricia Nash Women's Leather Turati Convertible Crossbody Shoulder Bag Metallic",
        "ASIN": "B07FKLB64W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CWOGA2X%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 115.99,
        "UploadTime": " March 1, 2019",
        "Id": 134,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.99,
        "ReviewItem5": 0,
        "Title": "Yoome Women Genuine Leather Crossbody Shoulder Bag Small Butterfly Clutch Handbags for Girls",
        "ASIN": "B07KM57K2N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qhM3B%2BuaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.99,
        "UploadTime": " November 16, 2018",
        "Id": 135,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 258,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Women's Bridgette Medium Tote Leather Handbag",
        "ASIN": "B075H3HWYX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SOa-hEvoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 258,
        "UploadTime": " September 8, 2017",
        "Id": 136,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 70.3,
        "ReviewItem5": 0,
        "Title": "Sakroots Dakota Bucket",
        "ASIN": "B07HKLWR14",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51k0qZPehbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 70.3,
        "UploadTime": " October 23, 2018",
        "Id": 190,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 5,
        "PriceMax": 25.99,
        "ReviewItem5": 60,
        "Title": "S-ZONE Women's Handbags Lightweight Large Tote Casual Work Bag Shoulder Bag",
        "ASIN": "B072LJF6YF",
        "ReviewItem3": 11,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ECBL0dbCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " December 1, 2016",
        "Id": 137,
        "ReviewCount": 173
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.95,
        "ReviewItem5": 0,
        "Title": "Bamboo Trading Company Cell Phone or Club Bag, Gleaming Stars",
        "ASIN": "B075H2XKNN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61JVJfEwPNL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " October 14, 2016",
        "Id": 138,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Pink Women Tote Boston Terrier Cartoon Shoulder Bags Ladies Satchel Waterproof",
        "ASIN": "B07GGLKFCK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OTYReSSAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " August 15, 2018",
        "Id": 139,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 0,
        "Title": "Kailey",
        "ASIN": "B07MKZBZLL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Dq8Bp8EPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " December 31, 2018",
        "Id": 161,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.98,
        "ReviewItem5": 80,
        "Title": "Koi Lite Backpack",
        "ASIN": "B01LXUS5NU",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41v2e3wb74L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.98,
        "UploadTime": " July 28, 2016",
        "Id": 162,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 15,
        "ReviewItem2": 10,
        "PriceMax": 19.99,
        "ReviewItem5": 35,
        "Title": "Acrylic Clutch, Acrylic Box Evening Bag Purse Handbag for Women Ladies Ideal Gift",
        "ASIN": "B07B4TH1WR",
        "ReviewItem3": 15,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519YVUF-Z8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " December 27, 2017",
        "Id": 140,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.88,
        "ReviewItem5": 100,
        "Title": "LABANCA Women Girls PU Leather Solid Color Crossbody Shoulder Bag Slim Envelope Purse Bag",
        "ASIN": "B07G82BJHT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51STaps%2BnHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.88,
        "UploadTime": " August 7, 2018",
        "Id": 141,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 23,
        "ReviewItem2": 6,
        "PriceMax": 9,
        "ReviewItem5": 44,
        "Title": "Mud Pie Wedding Canvas Tote Bag Bridesmaid",
        "ASIN": "B01N0XUMU2",
        "ReviewItem3": 12,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Y8s3h10mL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9,
        "Id": 142,
        "ReviewCount": 115
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 0,
        "Title": "Queena Ethnic Tribal Embroidered Shoulder Bag Vintage Tassel Sling Bag Boho Hippie Purse",
        "ASIN": "B07G7PC21P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jNjatae2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " August 6, 2018",
        "Id": 143,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.88,
        "ReviewItem5": 100,
        "Title": "Fanrich Woman Fashion Flamingo Reversible Sequin Tote Bag PU Leather Glitter Paillette Handbag",
        "ASIN": "B07KLG7WRB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VinnqjOCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.88,
        "UploadTime": " November 15, 2018",
        "Id": 144,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 128,
        "ReviewItem5": 100,
        "Title": "Lucky Kady Small Crossbody",
        "ASIN": "B0744R119H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DRDrOMAfL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 128,
        "UploadTime": " January 16, 2018",
        "Id": 145,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.11,
        "ReviewItem5": 0,
        "Title": "Gerry Weber Women's Piacenza Ladies Purse S Wallet",
        "ASIN": "B00MRPJLAQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wbz5fHJUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.11,
        "UploadTime": " May 1, 2018",
        "Id": 146,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 80,
        "Title": "The Sak Women's Holden Crossbody by The Sak Collective",
        "ASIN": "B07KXGDY6R",
        "ReviewItem3": 20,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rWOPvcNjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " November 27, 2018",
        "Id": 147,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 0,
        "Title": "Yoome Straw Handbags Women Beach Shoulder Bag Summer Top Handle Crossbody Round Purse Ladies Woven Fashion Crochet Satchel with Metal Chain Strap",
        "ASIN": "B07DWVM9L3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YSO8PXiHL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "Id": 149,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 83.59,
        "ReviewItem5": 0,
        "Title": "Kipling Lyanne Crossbody Bag, Removable, Adjustable Straps, Zip Closure",
        "ASIN": "B07FLN4MCK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416KhIwldBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 83.59,
        "UploadTime": " March 18, 2019",
        "Id": 150,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.49,
        "ReviewItem5": 0,
        "Title": "Women's Crossbody,Clearance!AgrinTol Girl Fashion Flap Bag Pretty Broadband Shoulder Bag",
        "ASIN": "B07H7HDBRN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gLoMEFK7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.49,
        "UploadTime": " September 10, 2018",
        "Id": 279,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 349.5,
        "ReviewItem5": 0,
        "Title": "COACH Women's Parker in Signature Canvas With Tea Rose Turnlock B4/Rust One Size",
        "ASIN": "B07CP4V4VZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ks77vyeXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 349.5,
        "UploadTime": " June 29, 2018",
        "Id": 151,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Men Genuine Leather Wallets Purse Slim Bifold Stylish Large Capacity Credit Card Holder Case with ID Window Front Pocket",
        "ASIN": "B07PN9SFC3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eKQFHWoHL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " March 13, 2019",
        "Id": 152,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 122.23,
        "ReviewItem5": 0,
        "Title": "Hand woven by the Arhuacos of Colombia. Authentic. Ethnic. Wooden Handle Handbag. Patchwork combination of woven reeds, string, and fabric. One of a kind. Lined with inside pocket and zipper closure",
        "ASIN": "B07CRKKBZH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Q0baDlKrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 122.23,
        "UploadTime": " March 11, 2019",
        "Id": 153,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 26.98,
        "ReviewItem5": 59,
        "Title": "UBORSE Beaded Sequin Design Flower Wedding Evening Purse Vintage Large Clutch Bag",
        "ASIN": "B01JS7GTEG",
        "ReviewItem3": 8,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Wdg5KrGHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.98,
        "UploadTime": " August 5, 2016",
        "Id": 154,
        "ReviewCount": 49
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Rangren Genuine Leather Business Mens Clutch Bag Organizer Handbag Phone Card Carrier Purse Long Wallet",
        "ASIN": "B07K51PTJ7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517OWaf87qL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " November 2, 2018",
        "Id": 155,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 36.86,
        "ReviewItem5": 0,
        "Title": "Laurel Burch Laurel's Garden Shoulder Tote",
        "ASIN": "B06XTJ4JM5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/618KZeBzVML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.86,
        "UploadTime": " March 24, 2017",
        "Id": 338,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 64.59,
        "ReviewItem5": 73,
        "Title": "On Clearance Heshe Womens Multi-color Shoulder Bag Hobo Tote Handbag Cross Body Purse",
        "ASIN": "B01FRU6O4I",
        "ReviewItem3": 3,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61l5Kc9LxNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.59,
        "UploadTime": " December 2, 2017",
        "Id": 157,
        "ReviewCount": 199
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 4,
        "PriceMax": 29.99,
        "ReviewItem5": 69,
        "Title": "InterestPrint Sugar Skull Women's Leather Tote Shoulder Bags Handbags",
        "ASIN": "B01D4NGYI6",
        "ReviewItem3": 5,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511ET3qyY0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 18, 2016",
        "Id": 158,
        "ReviewCount": 77
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 22,
        "ReviewItem2": 0,
        "PriceMax": 99.95,
        "ReviewItem5": 22,
        "Title": "BURGAN Magnus Unlined Hobo - Leather Shoulder Handbags",
        "ASIN": "B076HZ3TCN",
        "ReviewItem3": 22,
        "ReviewItem4": 34,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tOiJWctbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 99.95,
        "UploadTime": " October 17, 2017",
        "Id": 159,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 1,
        "ReviewItem2": 5,
        "PriceMax": 65.98,
        "ReviewItem5": 77,
        "Title": "Baggallini Hanover Crossbody Cross Body",
        "ASIN": "B00XLYYTJA",
        "ReviewItem3": 6,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51c3WJvNjTL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 65.98,
        "UploadTime": " July 16, 2015",
        "Id": 160,
        "ReviewCount": 169
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 57,
        "Title": "Women Sparkly Purse Handbags Rhinestone Evening Bags Crystal Party Clutches Bag",
        "ASIN": "B073QQX3TS",
        "ReviewItem3": 14,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tWfxUzYcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " July 5, 2017",
        "Id": 163,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 100,
        "Title": "Genuine Leather Front Pocket Zipper Crossbody Handbag for Women - Handmade by LEVOGUE",
        "ASIN": "B07P9ZW85R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dTuaE1VdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " May 16, 2018",
        "Id": 164,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 72.99,
        "ReviewItem5": 0,
        "Title": "Lucky CORA Tote",
        "ASIN": "B07JFQ3TS2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yO5DOkcEL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 72.99,
        "UploadTime": " December 9, 2018",
        "Id": 165,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Onfashion Women's Faux Fur Clutch Bag Zipper Furry Purse Shoulder Handbag",
        "ASIN": "B079L568JQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ClE%2B3weIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " February 5, 2018",
        "Id": 166,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.95,
        "ReviewItem5": 100,
        "Title": "Raffia Chevron Clutch",
        "ASIN": "B06XKNQL9B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/610rGR-EFVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " March 12, 2017",
        "Id": 167,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "YAOSEN Women Geometric Metal Clutch Diamond Chain Purse Handbag",
        "ASIN": "B07R4J36G3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41riLcnsRGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " April 28, 2019",
        "Id": 168,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.99,
        "ReviewItem5": 0,
        "Title": "Straw Crossbody Bag Women Weave Shoulder Bag Round Summer Beach Purse and Handbags (Khaki)",
        "ASIN": "B07BZGWRKJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51StjUBup-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.99,
        "UploadTime": " March 28, 2018",
        "Id": 169,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.59,
        "ReviewItem5": 0,
        "Title": "Green Elephant Modern Bohemian Sling Bag Crossbody Shoulder Purse Hippie Hobo Gypsy",
        "ASIN": "B01NAP7SXX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41krLUcVWsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.59,
        "Id": 170,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 36.93,
        "ReviewItem5": 100,
        "Title": "Travelon Anti-theft Courier Saddle Crossbody Cross Body Bag",
        "ASIN": "B07M6RNTBV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412%2BSJaDE8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.93,
        "UploadTime": " January 3, 2019",
        "Id": 171,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 74.95,
        "ReviewItem5": 67,
        "Title": "Chala Sweet Tote Shoulder Bag",
        "ASIN": "B07FFSW6RW",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51faXZK9XUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 74.95,
        "UploadTime": " March 4, 2018",
        "Id": 172,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.99,
        "ReviewItem5": 0,
        "Title": "Santoro Gorjuss Large Coated Shopper Bag - Ladybird",
        "ASIN": "B075HD227F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41O18Dql01L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.99,
        "UploadTime": " September 9, 2017",
        "Id": 181,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "Women Lip Evening Clutch Purses Leather Lips-shaped Crossbody Bags Vintage Banquet Handbag",
        "ASIN": "B07Q2BGN92",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ceayJTTtL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " March 26, 2019",
        "Id": 173,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 298,
        "ReviewItem5": 0,
        "Title": "Kate Spade Womens Emerson Place Dewy Quilted Leather Satchel Handbag Pink Medium",
        "ASIN": "B071JJ7ZLF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AEiz1KKzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 298,
        "UploadTime": " June 3, 2017",
        "Id": 174,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 67,
        "Title": "Medium Crossbody Bags for Women Soft PU Leather Purses and Handbags Zipper Shoulder Bags",
        "ASIN": "B07HK4SRPS",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MXSfH-d5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " September 21, 2018",
        "Id": 175,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Iconic Hipster Cross Body Purse In Regal Paisley, Gorgeous Red/Aqua Tones",
        "ASIN": "B07NMNHD9C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61e4JC4Y-pL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 68,
        "Id": 176,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Fuinloth Leather Condom Case Condom Holder Small Zipper Bag",
        "ASIN": "B07MK5B17S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yc0LAwEsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " December 21, 2018",
        "Id": 177,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 80.99,
        "ReviewItem5": 0,
        "Title": "Kipling Women’s Art S Top-Handle Bag",
        "ASIN": "B01IR7VVTG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LbhSVDvZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 80.99,
        "UploadTime": " August 11, 2017",
        "Id": 938,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 10,
        "ReviewItem2": 10,
        "PriceMax": 28.98,
        "ReviewItem5": 50,
        "Title": "Mn&Sue Designer Diamond Quilted Pattern Leather Top Handle Lady Handbag Shoulder Satchel Bag Doctor Purse",
        "ASIN": "B01HXCBW04",
        "ReviewItem3": 20,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516R8XoWFaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.98,
        "UploadTime": " July 3, 2016",
        "Id": 178,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 10.99,
        "ReviewItem5": 66,
        "Title": "Lonika Clutch Purse For Women Elephant Handmade Ethnic Vintage Handbags Crossbody Bag",
        "ASIN": "B0796F3KWP",
        "ReviewItem3": 10,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61aNdyBccbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " February 19, 2017",
        "Id": 179,
        "ReviewCount": 51
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.98,
        "ReviewItem5": 0,
        "Title": "Bausweety Girls Vintage Satchel Crossbody Bag PU Leather Shoulder Bag",
        "ASIN": "B07BTS8TNP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NAv7JoFkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.98,
        "UploadTime": " March 30, 2018",
        "Id": 180,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "H76 Radley London Light Pink Palace Street Small Flapover Crossbody Handbag",
        "ASIN": "B07R69W6YS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4126yc2z3%2BL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 26, 2019",
        "Id": 6435,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.21,
        "ReviewItem5": 0,
        "Title": "Niktest Women's Casual Korean Style Faux Leather Shoulder Cross Boby Bags",
        "ASIN": "B011294EP4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514fr1s9b3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.21,
        "UploadTime": " July 24, 2015",
        "Id": 182,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.88,
        "ReviewItem5": 0,
        "Title": "Simple Fashion Handbags, CalbaG Evening Wallets Classy Clutch Purse Shoulder Crossbody Bag for Women,Girls",
        "ASIN": "B07PGS5P46",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41M-hY1PmoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.88,
        "UploadTime": " March 7, 2019",
        "Id": 183,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Messenger & Shoulder Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 8,
        "PriceMax": 39.99,
        "ReviewItem5": 61,
        "Title": "EDODAY Laptop Bag for Women,Business Computer Bags for Women Up to 15.6 Inch,Multi Pockets Zippered Laptop Tote Bag(A.Coffee)",
        "ASIN": "B074SJ95RV",
        "ReviewItem3": 13,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DwgHjNrgL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "Id": 184,
        "ReviewCount": 200
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39,
        "ReviewItem5": 0,
        "Title": "Qidell Women's Genuine Leather Crossbody Wallet Purse Clutch Handbag With Shoulder Strap On Clearance",
        "ASIN": "B073QW5M9S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31nhwSksV1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39,
        "UploadTime": " June 29, 2017",
        "Id": 185,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 78,
        "ReviewItem5": 0,
        "Title": "Sydney Love Fuchsia Golf Print Bag",
        "ASIN": "B00J65V0X6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w6N3--2HL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 78,
        "UploadTime": " April 9, 2014",
        "Id": 186,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 72,
        "ReviewItem5": 0,
        "Title": "AmeriBag Small Classic Microfiber Healthy Back Bag",
        "ASIN": "B07N7NC2FL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ldnLK7HzL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 72,
        "UploadTime": " February 15, 2019",
        "Id": 187,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 41.99,
        "ReviewItem5": 100,
        "Title": "Jessica Simpson Womens Kiana Satchel",
        "ASIN": "B07K7MPDDL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zFditwJQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 41.99,
        "UploadTime": " December 30, 2018",
        "Id": 188,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 210,
        "ReviewItem5": 100,
        "Title": "Michael Kors Whitney Large Leather Shoulder Bag",
        "ASIN": "B07KGLQRH6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VWPNxnhXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 210,
        "UploadTime": " November 13, 2018",
        "Id": 189,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 57.95,
        "ReviewItem5": 50,
        "Title": "Baggallini Womens Yosemite Crossbody",
        "ASIN": "B06XQD2J5T",
        "ReviewItem3": 17,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Nwiis6fsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 57.95,
        "UploadTime": " June 25, 2017",
        "Id": 191,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.97,
        "ReviewItem5": 0,
        "Title": "Victoria's Secret Bombshell Signature Pink Stripe Canvas Tote Bag",
        "ASIN": "B07C35VF4V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41dBUAOPuZL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.97,
        "Id": 193,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 82.95,
        "ReviewItem5": 34,
        "Title": "Concealed Carry Purse - Locking Cora Stitched Gun Tote by Lady Conceal",
        "ASIN": "B07HLYNV5Q",
        "ReviewItem3": 33,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IK3UtM%2BDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 82.95,
        "UploadTime": " September 23, 2018",
        "Id": 194,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Kids' Backpacks",
        "ReviewItem1": 3,
        "ReviewItem2": 0,
        "PriceMax": 62.85,
        "ReviewItem5": 93,
        "Title": "Justin West Trendy Western Rhinestone Leather Conceal Carry Top Handle Backpack Purse",
        "ASIN": "B07BCTFGLF",
        "ReviewItem3": 0,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61P4gt9KP7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 62.85,
        "UploadTime": " May 12, 2016",
        "Id": 195,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 10,
        "PriceMax": 59.9,
        "ReviewItem5": 80,
        "Title": "Sugar Skull Punk Art Rivet Stud Biker Purse Women Fashion Backpack Python Daypack Shoulder Bag Wallet Set",
        "ASIN": "B0793KW713",
        "ReviewItem3": 0,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gEY65M%2BiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.9,
        "UploadTime": " December 7, 2017",
        "Id": 196,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 82,
        "Title": "French Style Basket with long and short leather handles: Sasha",
        "ASIN": "B00BGQ6LIC",
        "ReviewItem3": 0,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5172rX1XlML._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 21, 2017",
        "Id": 6436,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "DuoGaoTe Women Fashion Backpack Purse Washed PU Leather Anti-theft Rucksack With Fringe for Shopping Travel Ladies Large-capacity Shoulder Bag(black)",
        "ASIN": "B07QC5GHD5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41C0ZWUugoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "Id": 197,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 15.99,
        "ReviewItem5": 58,
        "Title": "ZORFIN Small Crossbody Bag 3 Zippers Nylon Cell Phone Purse Wallet For Women",
        "ASIN": "B07CYY4WPC",
        "ReviewItem3": 9,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QgKUCIu9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " May 9, 2018",
        "Id": 198,
        "ReviewCount": 55
    }, {
        "Sale": "[]",
        "Category": "Card Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 224.85,
        "ReviewItem5": 0,
        "Title": "Hugo Boss Men's Hugo Fashion Document Case Bag",
        "ASIN": "B07D63Z9K2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BJhdwuMRL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 224.85,
        "UploadTime": " December 29, 2018",
        "Id": 199,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 9,
        "ReviewItem2": 9,
        "PriceMax": 14.99,
        "ReviewItem5": 82,
        "Title": "Money Clip Wallet for Men RFID Blocking Genuine Leather Minimalist Card Holder",
        "ASIN": "B07HWN3XXH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nJN6qZe9L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " October 12, 2018",
        "Id": 200,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "Boshiho Real Leather RFID Blocking Bifold Wallets for Men Double Zipper Coin Pocket Purse with Anti-Theft Chain",
        "ASIN": "B07NPNBRRL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iCA9Y5-dL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " February 12, 2019",
        "Id": 201,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 79.99,
        "ReviewItem5": 0,
        "Title": "Pifuren Ladies Designer Purses Cross Body Handbags for Women Shoulder Bags",
        "ASIN": "B07PWW3WCN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41drPQWmvLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79.99,
        "UploadTime": " March 24, 2019",
        "Id": 202,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.49,
        "ReviewItem5": 0,
        "Title": "Darling's Damask Velvet Designer Carryall Tote - 2 Piece Shoulder Bag Set - Large & Small",
        "ASIN": "B06XR9FNPJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41scMeV0vHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.49,
        "UploadTime": " March 20, 2017",
        "Id": 203,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 55.99,
        "ReviewItem5": 100,
        "Title": "Myra Bag Genuine Leather with Black & White Cowhide Shoulder Bag S-0708",
        "ASIN": "B078HH2XMW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41znCSOKxLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55.99,
        "UploadTime": " September 4, 2014",
        "Id": 257,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 165,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Rony Handbag, Vintage Collection, Rio (Maroon)",
        "ASIN": "B07G2P3RCX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31mURh8j8BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 165,
        "UploadTime": " July 31, 2018",
        "Id": 204,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "JanSport Unisex Brannan Tote",
        "ASIN": "B01DRHT45O",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31LYGr8oeEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " March 13, 2017",
        "Id": 205,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 0,
        "PriceMax": 329.99,
        "ReviewItem5": 74,
        "Title": "MICHAEL Michael Kors Hamilton N/S Tote",
        "ASIN": "B00594OCMY",
        "ReviewItem3": 5,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41I7uN7lVsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 329.99,
        "UploadTime": " July 8, 2011",
        "Id": 206,
        "ReviewCount": 19
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 215,
        "ReviewItem5": 83,
        "Title": "Coach AVA Legacy Jacquard Tote Bag Handbag",
        "ASIN": "B07DS954FT",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51XoxRIC6sL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 215,
        "UploadTime": " September 18, 2018",
        "Id": 209,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Women's Casual Bag Shoulder Bag PU Leather Handbags",
        "ASIN": "B07MJPQVG2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cNkfDGWXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " January 11, 2019",
        "Id": 247,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 50,
        "Title": "Zarapack Women's Large Sequin Shopping Tote Handbag Purse",
        "ASIN": "B01442EPP0",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517RszrTHfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " August 19, 2015",
        "Id": 208,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 98,
        "ReviewItem5": 0,
        "Title": "Think Royln Women's Convertible Belt Crossbody Bag, Black Patent, One Size",
        "ASIN": "B07HRR3MCK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/318ojw7jRAL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 98,
        "Id": 212,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 67,
        "Title": "Paul & Taylor Genuine Leather Crossbody Bag with Pockets 5931",
        "ASIN": "B00G5JM76A",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KquxrA-7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " October 24, 2013",
        "Id": 213,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.5,
        "ReviewItem5": 0,
        "Title": "Chala Raccoon Cellphone Crossbody Handbag - Convertible Strap Wildlife",
        "ASIN": "B07PN6BFGL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51yKcrrHjdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.5,
        "UploadTime": " March 12, 2019",
        "Id": 214,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 15,
        "ReviewItem2": 19,
        "PriceMax": 18.99,
        "ReviewItem5": 42,
        "Title": "Genuine RFID Blocking RFID Blocking Leather Crossbody Bag",
        "ASIN": "B078MGV8CZ",
        "ReviewItem3": 12,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fqO3ztm4L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " March 5, 2017",
        "Id": 215,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.95,
        "ReviewItem5": 57,
        "Title": "Peach Couture LARGE Nautical Anchor Print Bold Stripe Summer Purse Beach Bag Totes",
        "ASIN": "B07R3D41V3",
        "ReviewItem3": 0,
        "ReviewItem4": 43,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AKLLmgD4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.95,
        "UploadTime": " March 15, 2018",
        "Id": 216,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.81,
        "ReviewItem5": 0,
        "Title": "African Tribal Print On Canvas Clutch Shoulder Bag",
        "ASIN": "B01C6AZRQI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517Wiwy9egL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.81,
        "UploadTime": " February 24, 2016",
        "Id": 218,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.59,
        "ReviewItem5": 0,
        "Title": "Genuine Soft Leather Floral Tooled Side Purse",
        "ASIN": "B01N9V5Z3P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41m8lC6E4uL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.59,
        "Id": 217,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 138.76,
        "ReviewItem5": 0,
        "Title": "Lacoste Women's Classic Crossover Bag",
        "ASIN": "B07BB2QDYY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51N0mLanN6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138.76,
        "UploadTime": " October 4, 2018",
        "Id": 219,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 189.97,
        "ReviewItem5": 0,
        "Title": "Love Moschino Women's Pebbled & Studded Tote Handbag W/Scarf",
        "ASIN": "B014LLOKKY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2Bi3y-z%2BtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 189.97,
        "UploadTime": " August 28, 2015",
        "Id": 221,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 119,
        "ReviewItem5": 0,
        "Title": "Kipling womens Anet Shoulder Bag",
        "ASIN": "B07CH9G9QM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410dYkfh7sL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 119,
        "UploadTime": " October 24, 2018",
        "Id": 222,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 12,
        "PriceMax": 45.99,
        "ReviewItem5": 75,
        "Title": "BISON DENIM Mens Clutch Bag Genuine Leather Clutch Purse Men's Leather Handbag Anti-theft Wallet",
        "ASIN": "B01J1F94FQ",
        "ReviewItem3": 13,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41my5frnnVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.99,
        "UploadTime": " July 25, 2016",
        "Id": 223,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Toprint Tropical Animal Fish Dolphin Glasses Bag Pouch Portable Travel Zipper Light Sunglasses Case Pencil Case Cosmetic Bag",
        "ASIN": "B07PQDTH1Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41faezw0h7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " February 9, 2019",
        "Id": 224,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "16\" Womens Leather Tote Bag Big Capacity Shopper Should Travel Handbag with Jack and Sally Print",
        "ASIN": "B07MVJS95T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CVIcEB6vL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "Id": 225,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 74.97,
        "ReviewItem5": 50,
        "Title": "Women's Faux Leather Handbag: Alfred Durante The Manhattan Gallery Handbag by The Bradford Exchange",
        "ASIN": "B00I3SGZV4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BRZUxqQUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 74.97,
        "UploadTime": " January 29, 2014",
        "Id": 226,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 79,
        "Title": "Cute Small Backpack Mini Purse Casual Daypacks Leather for Teen Girls and Women (White)",
        "ASIN": "B07CK7NZWP",
        "ReviewItem3": 4,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51rGGiN2lML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "Id": 227,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 36.99,
        "ReviewItem5": 0,
        "Title": "JOZEN Cowhide Handmade Shoulder Bag Cross Body Bag For Women",
        "ASIN": "B06XRPQH1V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tv2PkETML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.99,
        "UploadTime": " March 20, 2017",
        "Id": 228,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Franco Sarto Womens Alyse Embossed Faux Leather Shopper Handbag",
        "ASIN": "B0727R6BYT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LaBcUP2oL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " November 25, 2017",
        "Id": 258,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 10,
        "ReviewItem2": 0,
        "PriceMax": 36.9,
        "ReviewItem5": 40,
        "Title": "Copi Women's Fashion bags Lovely, feminine Round zipper Design Small Backpacks purse",
        "ASIN": "B079NXCFNH",
        "ReviewItem3": 10,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TpUpR28yL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.9,
        "UploadTime": " February 7, 2018",
        "Id": 620,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 12,
        "ReviewItem2": 5,
        "PriceMax": 42,
        "ReviewItem5": 67,
        "Title": "MICHAEL Michael Kors Signature Jet Set Item Medium Wristlet",
        "ASIN": "B06XWLZMHL",
        "ReviewItem3": 9,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514ZN7EyAyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43,
        "UploadTime": " March 28, 2017",
        "Id": 360,
        "ReviewCount": 197
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 5.59,
        "ReviewItem5": 0,
        "Title": "Swyss Ladies Transparent Retro Laser Holographic Handbag Shoulder Bag Shining Cross Body Bag with Chains",
        "ASIN": "B07QT8SHPL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mE%2BuzBKYL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 5.59,
        "Id": 229,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Bow Tote Bag",
        "ASIN": "B07HJLPS9C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nXuBO8Z3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " January 6, 2018",
        "Id": 230,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 9,
        "PriceMax": 13.59,
        "ReviewItem5": 22,
        "Title": "Women's Practical Handbag Oxford Cloth Multi-Pocket High-Capacity Shoulder Bag",
        "ASIN": "B07BSFNW3L",
        "ReviewItem3": 9,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qvoBxvxsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.59,
        "UploadTime": " March 28, 2018",
        "Id": 231,
        "ReviewCount": 58
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 29,
        "ReviewItem2": 0,
        "PriceMax": 27.97,
        "ReviewItem5": 57,
        "Title": "Victoria Secret Women's Tote Bag silver silber",
        "ASIN": "B00S6WEKDM",
        "ReviewItem3": 14,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41dpl-2CWVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.97,
        "UploadTime": " August 3, 2015",
        "Id": 232,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 167.95,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Sonoma Reversible Novelty North/South Tote",
        "ASIN": "B07KRNRZW7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31EEkQuGi8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 167.95,
        "UploadTime": " April 16, 2019",
        "Id": 233,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hats & Caps",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 49.5,
        "ReviewItem5": 58,
        "Title": "Conner Hats Aussie Golf Soakable Mesh Hat",
        "ASIN": "B072LD5J3N",
        "ReviewItem3": 10,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KxSoujz7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.5,
        "UploadTime": " April 14, 2016",
        "Id": 234,
        "ReviewCount": 158
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.29,
        "ReviewItem5": 0,
        "Title": "Genuine Leather Handbag Organizer Card Case Zipper Long Wallet",
        "ASIN": "B01LY99ZUK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MQVy79RgL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.29,
        "UploadTime": " September 22, 2016",
        "Id": 235,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 5,
        "ReviewItem2": 7,
        "PriceMax": 26.99,
        "ReviewItem5": 65,
        "Title": "LUUFAN Men's Genuine Leather Long Wallet Chain Wallet, Engraved Bifold Wallet",
        "ASIN": "B01N9COSWF",
        "ReviewItem3": 4,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZqWzIpOFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " December 2, 2016",
        "Id": 236,
        "ReviewCount": 154
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 8,
        "ReviewItem2": 8,
        "PriceMax": 25.99,
        "ReviewItem5": 67,
        "Title": "Nine West Womens Genevieve Tote",
        "ASIN": "B07FQSQX9R",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410tGrPkVSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " October 3, 2018",
        "Id": 237,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "Dual Top Handle Boston Bag For Women With Adjustable/Detachable Shoulder Strap",
        "ASIN": "B07PV12H6S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mdrqBkvJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " April 8, 2019",
        "Id": 238,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Replacement Adjustable Canvas Shoulder Strap With Leather Purse Strap Cross-Body Strap for Handbags",
        "ASIN": "B07DLWT7D2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412rfsvepjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " June 8, 2018",
        "Id": 239,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 109.99,
        "ReviewItem5": 0,
        "Title": "ZAC Zac Posen Earthette Flat Clutch Crossbody Black Satin Ruffle",
        "ASIN": "B07D6X3Q5Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419ym8giB8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 109.99,
        "UploadTime": " October 20, 2018",
        "Id": 240,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Lemon Squeeze The Day Tote Bag 2ecd5",
        "ASIN": "B079TJLQ96",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PHxOuY%2BAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " February 15, 2018",
        "Id": 242,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Women's Straw Handbags Beach Tote Woven Summer Shoulder Bag",
        "ASIN": "B07R45SPJ2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NRS4PzAVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " April 25, 2019",
        "Id": 244,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 34,
        "Title": "Womens Luxury Evening Purse Clutch Rhinestone Leather Evening Bag Handbag Wallet for Wedding and Party (Red)",
        "ASIN": "B07G44Y7S6",
        "ReviewItem3": 33,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51h1dy4dtxL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "Id": 245,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 97,
        "Title": "Miss Lulu Messenger Bag School Bag Crossbody Satchel Shoulder Bag for Women Girls with Polka Dots Flower Horse Patterns",
        "ASIN": "B01N25VRWC",
        "ReviewItem3": 3,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61FbgtkvDTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " January 19, 2017",
        "Id": 246,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "QZUnique Women's PU Plush Handbag Rivet Crossbody Bag Leopard Print Shoulder Bag Handbag Purse with Zipper Closure",
        "ASIN": "B07K7HK1W3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mc4Aw%2BSCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " November 6, 2018",
        "Id": 243,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "Sherry Bucket Bag Women Straw Drawstring Handbag Small Party Outdoor Purse",
        "ASIN": "B07C5Q6ZYD",
        "ReviewItem3": 50,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hDQPTyNwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " April 13, 2018",
        "Id": 248,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 75.99,
        "ReviewItem5": 0,
        "Title": "Giorgio Costa Farrah Leather Shoulder Bag",
        "ASIN": "B07MKNPHXN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w-9Wi9DZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 75.99,
        "UploadTime": " December 27, 2018",
        "Id": 249,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30,
        "ReviewItem5": 0,
        "Title": "Baggallini Cosmetic Trio Set",
        "ASIN": "B01MT1TB5I",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31kAU0AlC3L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30,
        "UploadTime": " March 21, 2017",
        "Id": 251,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.95,
        "ReviewItem5": 100,
        "Title": "Large Tote Bag for Women, Mom - Unique Fun Gifts for Mom, Mother, Wife - Many Varieties to Choose From!",
        "ASIN": "B07P254CWD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ECUOoGEgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " March 8, 2019",
        "Id": 253,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 100,
        "Title": "Ruiatoo Women Clutches Luxury Evening Bag for Wedding With Detachable Chain",
        "ASIN": "B07DZYHZMD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PIs3AZSCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " June 24, 2018",
        "Id": 254,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Water Shoes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.49,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Men's and Women's Kid's Quick-Dry Water Shoes Barefoot Aqua Socks for Beach Swim Surf Yoga",
        "ASIN": "B07M6816FS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zrhIjshrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.49,
        "UploadTime": " December 28, 2018",
        "Id": 255,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 5,
        "PriceMax": 52.5,
        "ReviewItem5": 50,
        "Title": "SAIERLONG Women's Tote Single Shoulder Bag Genuine Leather",
        "ASIN": "B00KZL3VY6",
        "ReviewItem3": 18,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41L9ruvKBBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52.5,
        "UploadTime": " June 14, 2014",
        "Id": 256,
        "ReviewCount": 40
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 9.99,
        "ReviewItem5": 68,
        "Title": "Caixia Women's Cotton Daisy Floral Canvas Tote Shopping Bag Light Brown",
        "ASIN": "B01HCFF76C",
        "ReviewItem3": 11,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xuMEXU-vL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " June 21, 2016",
        "Id": 252,
        "ReviewCount": 47
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "Ita Bag Heart Japanese Bag High School JK Bag Girls Duffle Purse Anime School Bags",
        "ASIN": "B07MD1ZGTG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mEhz7%2B7nL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " December 22, 2018",
        "Id": 259,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Longchamp 'Le Pliage Neo' Nylon Top Handle Tote Shoulder Bag, Navy",
        "ASIN": "B07NQ12XW8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TbC8%2BNiPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 16, 2018",
        "Id": 261,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.99,
        "ReviewItem5": 100,
        "Title": "Jessica Simpson St.Pete Tote",
        "ASIN": "B078GN3LX8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WOtADmcEL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.99,
        "UploadTime": " March 2, 2018",
        "Id": 262,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.83,
        "ReviewItem5": 0,
        "Title": "Tattooed Skeleton Cat With A Heart Shoulder Crossbody Bag",
        "ASIN": "B01C6B0R6W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51B3djFBnSL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.83,
        "Id": 271,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Best 40th Birthday Ever Tote Bag 30dfe",
        "ASIN": "B07JPFQSV1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OTOMlzaEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " June 5, 2018",
        "Id": 311,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Zhao Xiemao Ladies Handbag Women's Vintage Stripe Leather Handbags Personality Portable Organ Shape Creative Top-Handle Tote Bag Catwalk Accessories Top Handle Bags (Color : White, Size : M)",
        "ASIN": "B07Q8DY2K5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31l217rT1tL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 263,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 38.95,
        "ReviewItem5": 71,
        "Title": "Italian Suede Leather Hand Made Envelope Design Clutch, Wrist, Shoulder or Crossbody Bag. Branded Protective Storage Bag",
        "ASIN": "B00VC75ZKK",
        "ReviewItem3": 0,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CmPqAypfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.95,
        "UploadTime": " August 16, 2016",
        "Id": 264,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "EROUGE Women Evening Clutch Bag Sequins Clutch Purse Fashion Handbags Clutch Bag",
        "ASIN": "B07DZZ35F1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61lh91hJn6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " June 25, 2018",
        "Id": 265,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 0,
        "Title": "NICOLE & DORIS Women handbags fashion over the shoulder Bags for lady Top Handle bags",
        "ASIN": "B07NVJLCZP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IM%2BSlreCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " January 20, 2019",
        "Id": 266,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 73,
        "Title": "Betsey Johnson Womens Trap Tote",
        "ASIN": "B07KY1GKM6",
        "ReviewItem3": 9,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ahvwYDKaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " November 28, 2018",
        "Id": 267,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.57,
        "ReviewItem5": 0,
        "Title": "Men's Bifold Leather Credit ID Card Holder Wallet Coin Pocket Billfold Purse",
        "ASIN": "B07HPGXFC3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IGAxKda8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.57,
        "UploadTime": " September 26, 2018",
        "Id": 1763,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0.01,
        "ReviewItem5": 0,
        "Title": "Respctful Women Leather Handbags Designer Shoulder Bag Fashion Mini Crossbody Bag Party Handbag Classic Clutch",
        "ASIN": "B07MLS7MGV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31y4Bh2dWxL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0.01,
        "UploadTime": " January 7, 2019",
        "Id": 268,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Women",
        "ReviewItem1": 3,
        "ReviewItem2": 2,
        "PriceMax": 69.99,
        "ReviewItem5": 71,
        "Title": "Scala Men's Crushable Wool Outback Hat - Df105",
        "ASIN": "B004W0FWRA",
        "ReviewItem3": 5,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5181iMLn%2BIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.63,
        "UploadTime": " November 18, 2011",
        "Id": 269,
        "ReviewCount": 337
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 42.93,
        "ReviewItem5": 0,
        "Title": "Imoshion Women's Large Reversibile Genuine Faux Leather Bag-In-A-Bag Tote Bag With Small Removable Zip Pouch Shoulder Bag",
        "ASIN": "B075FCBTJ2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4122dAm3TaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 42.93,
        "UploadTime": " September 6, 2017",
        "Id": 270,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 2,
        "PriceMax": 12.49,
        "ReviewItem5": 78,
        "Title": "Vivoi Multi-Pocket Genuine Leather Crossbody Bag(Black)",
        "ASIN": "B01N5P1G3W",
        "ReviewItem3": 4,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Sg7UHYbzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.49,
        "UploadTime": " January 1, 2016",
        "Id": 272,
        "ReviewCount": 174
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "mywalit Women's Double Flap Purse/Wallet Seascape",
        "ASIN": "B0073T7ALS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31EQUBT76yL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 24, 2013",
        "Id": 273,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 81,
        "Title": "Otto Angelino Designer Women’s Bohemian Clutch Purse - Multiple Slots Money, Cards, Smartphone - Ultra Slim",
        "ASIN": "B07DWCF4PB",
        "ReviewItem3": 4,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61a5C8e-JYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " July 26, 2017",
        "Id": 274,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18,
        "ReviewItem5": 0,
        "Title": "Small Wristlet Clutch for Women's Leather Crossbody Bag with Chain Strap Leopard",
        "ASIN": "B07MQ91G54",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EO-KqkOEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18,
        "UploadTime": " January 7, 2019",
        "Id": 275,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 0,
        "Title": "Geometric Luminous Clutches Purses and Handbags Shard Lattice Eco-friendly Leather Rainbow Holographic Top Womens Girl",
        "ASIN": "B07BHHJMBT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PFyH60PBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " March 16, 2018",
        "Id": 276,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ALDO Womens Galeiniel",
        "ASIN": "B07L5Q8QVB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wzUPvxurL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 18, 2019",
        "Id": 277,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 229.99,
        "ReviewItem5": 100,
        "Title": "Marc by Marc Jacobs Women's New Q Percy Cross Body Bag",
        "ASIN": "B00XN8ZM9K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31rsd6IbY%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 229.99,
        "UploadTime": " May 13, 2015",
        "Id": 278,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Indian Handicrafts Women's embroidered Shoulder Cotton Sling Handbags Nepal Bags Monk Bags",
        "ASIN": "B07FK3P113",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MsUqlp38L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "Id": 280,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Base Shaper 1/16” Lightweight Clear Acrylic for LV Louis Vuitton ARTSY MM (NEW after 2010) bag tote, Handbag, Purse Insert, Plexiglas, Plexiglass Bottom, Plastic",
        "ASIN": "B07D62LY2D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31YOQTdcosL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 13, 2018",
        "Id": 281,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "EvaLuLu Women's Padlock Genuine Leather Handbags with Golden Hardware Brown Color",
        "ASIN": "B0759PQMP2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hDsKPlTcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 1, 2017",
        "Id": 282,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shirt Studs",
        "ReviewItem1": 10,
        "ReviewItem2": 10,
        "PriceMax": 16.98,
        "ReviewItem5": 65,
        "Title": "HAWSON Mother of Pearl Man Tuxedo Shirt Studs and Cufflinks Set for Wedding Business",
        "ASIN": "B072BRXWRC",
        "ReviewItem3": 0,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SdpPY0QLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.98,
        "UploadTime": " May 12, 2017",
        "Id": 283,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 86.99,
        "ReviewItem5": 94,
        "Title": "The Sak Cole Valley Hobo",
        "ASIN": "B078N8NCBY",
        "ReviewItem3": 0,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418evXGkMkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 86.99,
        "UploadTime": " February 28, 2018",
        "Id": 301,
        "ReviewCount": 18
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "4 Pack Women Handbag Set, Soft PU Leather Top Handle Bag, Tote Bag, Shoulder Bags Crossbody Bag Wallet Purse",
        "ASIN": "B07KSXWY3C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419eBt2keVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " November 22, 2018",
        "Id": 284,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 65.99,
        "ReviewItem5": 0,
        "Title": "[Disney] A140.Disney Mickey Mouse Women Small T Vintage Shoulder Cross Body Bag Handbag",
        "ASIN": "B07H3J7HXM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DXeJMvzML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 65.99,
        "UploadTime": " March 11, 2018",
        "Id": 285,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 100,
        "Title": "Women's Oversized Envelope Handbag Leather Clutch Evening Bag with Wrist Strap",
        "ASIN": "B07CBQHTDC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jupofBgCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " April 8, 2018",
        "Id": 286,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Canvas Tote Bag Collection Rock Star Lettering Dark Grunge Style Backdrop with a Star Concert Music Hanbag Women Shoulder Bag Fashion Tote Bag W16.5xH14xD7 INCH",
        "ASIN": "B07GPZVQJX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41E6vZpJ32L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "Id": 287,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.5,
        "ReviewItem5": 0,
        "Title": "Chala Womens' Canvas Patch Crossbody Handbag Sea Turtle with Baby - Brown",
        "ASIN": "B07CZRX131",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51d%2Bpw0K-fL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.5,
        "UploadTime": " September 15, 2017",
        "Id": 288,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 595,
        "ReviewItem5": 100,
        "Title": "Hammitt Women's Montana Reversible Crossbody Bag",
        "ASIN": "B00JWG1Q9M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31nR7Fq25oL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 595,
        "UploadTime": " August 23, 2018",
        "Id": 289,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 17,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 33,
        "Title": "Pavel Handbags for 3 Bags Women Handbag + Shoulder Bags+wallet 3 Piece Set Bag Leather Top Handle Bag Ladies (Black)",
        "ASIN": "B01D3LAHIW",
        "ReviewItem3": 33,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5167hgBKYuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 17, 2016",
        "Id": 290,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YIBANG-Bag Men's Wallet Leather Coin Purse Vintage Crazy Horseskin Card Holder Short Zipper Wallet Men's Fashion (Color : Brown, Size : S)",
        "ASIN": "B07RS9H5C7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51E6sf%2BuorL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 291,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Women's Genuine Leather Small Size Cross Body Messenger Every Day Purse 3 Zipper Pocket BLACK, PURPLE (Black)",
        "ASIN": "B072HXD5Q2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rkwL9Ic3L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 292,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 46.96,
        "ReviewItem5": 0,
        "Title": "Les Tropéziennes Tyr04, Women’s Cross-Body Bag, Noir (Black), 11x18x30 cm (W x H L)",
        "ASIN": "B073X38QMH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xXWiSCFAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 46.96,
        "UploadTime": " May 1, 2018",
        "Id": 621,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LANVERA Satchel Leather Handbags for Women Handware Lock Long Strap Worn Across Body",
        "ASIN": "B07FFLMBP5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41W9A20D6sL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 6, 2018",
        "Id": 293,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 58.95,
        "ReviewItem5": 0,
        "Title": "Sherpani 18-vale0-05-11-0 Cross Body Bag",
        "ASIN": "B07BD27MMW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UNhZYw96L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58.95,
        "UploadTime": " August 29, 2018",
        "Id": 294,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 119.19,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Wes Loom Tote Bag",
        "ASIN": "B01N33D31T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31d08zxFPJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 119.19,
        "UploadTime": " February 1, 2017",
        "Id": 295,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 4,
        "PriceMax": 128,
        "ReviewItem5": 57,
        "Title": "kate spade new york Cedar Street Cami Convertible Cross-Body Bag",
        "ASIN": "B0169MV2EU",
        "ReviewItem3": 17,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TZ1laXOYL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 128,
        "UploadTime": " March 9, 2016",
        "Id": 296,
        "ReviewCount": 72
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 168,
        "ReviewItem5": 67,
        "Title": "Leather House V Style Bags Women Handbag Tote GM Shoulder Bag",
        "ASIN": "B07P6XZNNK",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xrrIwUxIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 110,
        "UploadTime": " February 28, 2019",
        "Id": 297,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Gabrine Womens Evening Envelop Bag Handbag Clutch Purse Shiny Sequins Fabric Material for Wedding Party Prom",
        "ASIN": "B07FDVB3MD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41y8D9wiRrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " July 10, 2018",
        "Id": 298,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 1,
        "ReviewItem2": 0,
        "PriceMax": 64.99,
        "ReviewItem5": 89,
        "Title": "Loungefly Faux Leather Minnie Mouse Crossbody Bag",
        "ASIN": "B077YW5XQT",
        "ReviewItem3": 5,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51F9E7JHpuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.99,
        "UploadTime": " December 8, 2017",
        "Id": 299,
        "ReviewCount": 63
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 20,
        "ReviewItem2": 0,
        "PriceMax": 181.95,
        "ReviewItem5": 80,
        "Title": "Anuschka Anna Hand Painted Leather Women's Medium Shoulder HOBO",
        "ASIN": "B074QQWP43",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hoXUXZiwL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 181.95,
        "UploadTime": " April 18, 2018",
        "Id": 1049,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "Sequins Evening Clutch Box Purse, Glitter Hard Case Shoulder Crossbody Handbag Bag, Acrylic Clutch Wallet for Women Ladies Prom Ball Shopping Party (Red)",
        "ASIN": "B07J4R1PPY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61J6-pG%2Bk9L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "Id": 300,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 78,
        "Title": "Rebecca Minkoff Small Vanity Saddle",
        "ASIN": "B01N0MAST3",
        "ReviewItem3": 11,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51prrnHD%2BIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 16, 2017",
        "Id": 302,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 0,
        "PriceMax": 26.78,
        "ReviewItem5": 72,
        "Title": "Hologram Stone-print Shoulder Handbag Holographic Clear Tote Bag Crossbody Beach Bag",
        "ASIN": "B073VJC3WP",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518TuHx-2ZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.78,
        "UploadTime": " July 11, 2017",
        "Id": 303,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 132.99,
        "ReviewItem5": 0,
        "Title": "Versace EE1VSBBEB E899 Black Shoulder Bag for Womens",
        "ASIN": "B07DDYTZY3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iz8ni7JqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 132.99,
        "UploadTime": " October 26, 2018",
        "Id": 304,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.58,
        "ReviewItem5": 0,
        "Title": "Geometric Sequins Laser Plain Folding H bag Water Wave Shoulder Bag Dark gray",
        "ASIN": "B07Q6J64V7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4150WEMbZAL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.58,
        "Id": 305,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Womens Small Crossbody Handbag 6912762",
        "ASIN": "B007Q2T0VK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JuuT2HQsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 30, 2012",
        "Id": 306,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "Heshe Leather Handbags for Women and Ladies Purses Hobo Tote Top-handle Bag Satchel Cross-body Bags",
        "ASIN": "B07NVBW1XM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SXxYTywzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " February 17, 2019",
        "Id": 307,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.95,
        "ReviewItem5": 0,
        "Title": "CafePress - Physical Therapy - Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00QP8S6MA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YCS%2BaMeNL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.95,
        "Id": 308,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 55,
        "ReviewItem5": 100,
        "Title": "SCOUT ERRAND BOY, Extra-Large Grocery Tote Bag with Max-Capacity Breakaway Zipper (Multiple Patterns Available)",
        "ASIN": "B07MC5RNV8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EKyYKFHGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55,
        "UploadTime": " January 6, 2019",
        "Id": 309,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Wallet Men Leather Short Wallet Vintage Cow Leather Casual Man Wallets Purse Standard Card Holders",
        "ASIN": "B07PG512K6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kyUoI%2BcrL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " March 9, 2019",
        "Id": 310,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 50,
        "PriceMax": 19.95,
        "ReviewItem5": 50,
        "Title": "Urban Energy Boulevard Crossbody Bag, Ivory",
        "ASIN": "B079Z24W2X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31W%2BzIuHe2L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 6, 2018",
        "Id": 312,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 72,
        "ReviewItem5": 80,
        "Title": "Lily Bloom Landon Triple Section Satchel, Who Let The Dogs Out",
        "ASIN": "B0775D1K6C",
        "ReviewItem3": 0,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kHbPcb1qL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " May 7, 2018",
        "Id": 313,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 249,
        "ReviewItem5": 0,
        "Title": "Kate Spade Evangelie Laurel Way Dotty Plaid Shoulder Bag Purse Handbag, Black Multi",
        "ASIN": "B07BW98KJ2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FDPw%2BFiyL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 249,
        "UploadTime": " April 3, 2018",
        "Id": 314,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 83,
        "Title": "Michael Kors Hamilton Large East West Tote (Vanilla)",
        "ASIN": "B00S3V5DC8",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51E74WQkNdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 11, 2015",
        "Id": 315,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Cold Weather Gloves",
        "ReviewItem1": 6,
        "ReviewItem2": 4,
        "PriceMax": 21.99,
        "ReviewItem5": 62,
        "Title": "Winter Gloves Magic Gloves Wholesale 12 Pairs- One Size Fits All",
        "ASIN": "B013FBR0EY",
        "ReviewItem3": 9,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41w7484pVTL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " August 4, 2015",
        "Id": 316,
        "ReviewCount": 144
    }, {
        "Sale": "[]",
        "Category": "Kids' Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 100,
        "Title": "Wraifa Kids Purse, Cute Cat Crossbody Bag Mini Toddler Backpack for Little Girls (Kids Purse Purple)",
        "ASIN": "B07KQ19R51",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vmmvubRtL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "Id": 317,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Ship Faced Cotton Canvas Tote Bag",
        "ASIN": "B01MTD8G2F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WjQYcJqlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 26, 2017",
        "Id": 2427,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "World's Greatest Grandma Canvas Tote Bag -Mothers Day Gifts for Grandma",
        "ASIN": "B0773ZR2ST",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hUBJX6QCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 2, 2017",
        "Id": 318,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20,
        "ReviewItem5": 50,
        "Title": "Havaianas Minibag",
        "ASIN": "B06XCFGJPL",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gln2AJTVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20,
        "UploadTime": " February 16, 2017",
        "Id": 319,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 280,
        "ReviewItem5": 0,
        "Title": "Fashion Alma BB Epi Leather Shoulder Removable Monogram Toron Handle Canvas Handbag",
        "ASIN": "B07Q4QJ1BS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lqRgqXDTL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 280,
        "Id": 320,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 92,
        "Title": "MILATA Bright Color Women's Transparent Cross Body Bag Summer Jelly PVC Clutch Purse Beach Bag",
        "ASIN": "B07CT9XGYQ",
        "ReviewItem3": 0,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZgZKfiBTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " February 23, 2017",
        "Id": 340,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 67.37,
        "ReviewItem5": 50,
        "Title": "Kipling Women’s Gabbie S Cross-Body Bag",
        "ASIN": "B07DKHD5P2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51f85JWOeAL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 67.37,
        "UploadTime": " January 2, 2019",
        "Id": 6437,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Round Straw Rattan Crossbody Boho Bag for Women Purse Handmade Clutch Woven Handbag",
        "ASIN": "B07G5CZN37",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51XGOz7Hg5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 3, 2018",
        "Id": 321,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "HW Jp Cheetah Leopard Bling Rhinestone Womens Girls Cross Body Messenger Bag Purse",
        "ASIN": "B07FDHDLYY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CXl3NdFVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " July 10, 2018",
        "Id": 322,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 17,
        "PriceMax": 9.95,
        "ReviewItem5": 33,
        "Title": "Ladies Classic Elegant Vegan Faux Leather Bag Purse with Chain Strap Clutch",
        "ASIN": "B079GS77VB",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418ogsiEAoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.95,
        "UploadTime": " January 31, 2018",
        "Id": 323,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Aldo Yilari",
        "ASIN": "B077QPJLY4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51QBrH2u7zL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 14, 2018",
        "Id": 324,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 2.99,
        "ReviewItem5": 0,
        "Title": "Womail Women Zipper Long Wallet Card Coin Change Holder Clutch Handbags",
        "ASIN": "B072J47YPH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51COhbQt0sL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 2.99,
        "UploadTime": " May 15, 2017",
        "Id": 325,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 3,
        "PriceMax": 14.99,
        "ReviewItem5": 78,
        "Title": "Solene Women's Lightweight Multi Compartment Faux Leather Shoulder, Wristlet & Crossbody Bag",
        "ASIN": "B076B9YFJM",
        "ReviewItem3": 4,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zgdWNiK1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " October 17, 2017",
        "Id": 326,
        "ReviewCount": 54
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Lodis Women's Sophia Glamorous Nina Crossbody Cross Body Handbag",
        "ASIN": "B016BLKUUG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51cqE6PsQTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 24, 2016",
        "Id": 327,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Ss-Lqlhy Cute Pig Round Women's Casual Phone Pouch Small Chain Crossbody Bag Handbag",
        "ASIN": "B07P7JTZB3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41w8ANoZIgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 26, 2019",
        "Id": 329,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.35,
        "ReviewItem5": 100,
        "Title": "Men's Wallet RFID Anti-theft Card Cases Male Business Purses",
        "ASIN": "B07GZK1C92",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SUY0z28LL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.35,
        "UploadTime": " August 31, 2018",
        "Id": 341,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "UMIWE Bali Round Rattan Crossbody Bag for Women Handmade Woven Hollow Rattan Handbag Mori Straw Purse",
        "ASIN": "B07NQ3LY7C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518hEppRq7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 13, 2019",
        "Id": 342,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 7,
        "PriceMax": 0,
        "ReviewItem5": 55,
        "Title": "The Sak Casual Classics 3-in-1 Demi",
        "ASIN": "B01MRG4P4S",
        "ReviewItem3": 12,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61I83VvA9vL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 15, 2017",
        "Id": 343,
        "ReviewCount": 89
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Sling Bag Zebra Tail Animal Cool Mens Chest Shoulder Backpacks Crossbody Casual Daypack",
        "ASIN": "B07R83CWK6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eFGROssFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 2, 2019",
        "Id": 330,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 296.99,
        "ReviewItem5": 0,
        "Title": "Mary Frances Elephant Temple Embellished Crossbody Handbag",
        "ASIN": "B07DF7STHC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IGE7aMsRL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 296.99,
        "UploadTime": " May 30, 2018",
        "Id": 331,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Contacts Oil Wax Cowhide Real Leather Mens Coin Card Bag Travel Purse Wallet",
        "ASIN": "B06ZZFXDSW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513Gp6naoXL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " July 29, 2016",
        "Id": 332,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Drawstring Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 5,
        "PriceMax": 4.99,
        "ReviewItem5": 76,
        "Title": "KUUQA 2 Pcs Drawstring Backpack Bags Sports Cinch Sack String Backpack Storage Bags for Gym Traveling (Rose Red)",
        "ASIN": "B07QV4H33V",
        "ReviewItem3": 7,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qDqOj58AL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 4.99,
        "Id": 333,
        "ReviewCount": 42
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.59,
        "ReviewItem5": 0,
        "Title": "Tote Shoulder Bag Women Nylon Handbag Large Capacity Shopper Bags with Water-Resistant Pocket for Umbrella",
        "ASIN": "B075LSSD71",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CjZ2R9ZPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.59,
        "UploadTime": " September 13, 2017",
        "Id": 334,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.98,
        "ReviewItem5": 0,
        "Title": "New York & Co. Women's Metallic Tote Bag",
        "ASIN": "B07Q32QRZT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/314dqD%2BaY0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.98,
        "UploadTime": " March 27, 2019",
        "Id": 335,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 53.62,
        "ReviewItem5": 0,
        "Title": "Kipling Womens Amiel Bp Shoulder Bag",
        "ASIN": "B0184IEC8A",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EeApVtLqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 53.62,
        "UploadTime": " October 12, 2016",
        "Id": 336,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.98,
        "ReviewItem5": 80,
        "Title": "Straw Tote Handbags for Women Beach Bags Woven Straw Purses Shoulder Bags for Girls Summer Outfits",
        "ASIN": "B07CYWBK13",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51cRYKt-AfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.98,
        "UploadTime": " May 17, 2018",
        "Id": 337,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YIBANG-Bag Men's Wallet Leather Fashion Multi-Function Leather Business Clutch Men's Fashion (Color : Black, Size : S)",
        "ASIN": "B07RH6T9VH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51f9UaThExL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 339,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.95,
        "ReviewItem5": 0,
        "Title": "DALIX Gray Beach Tote Bag Personalized Gifts Women Shoulder Bags Letter A - Z",
        "ASIN": "B07FQZGQ9Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41K9Q-7Lz1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.95,
        "UploadTime": " July 21, 2018",
        "Id": 344,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 67,
        "Title": "Fashion Female Sling Shoulder Bag Crossbody Bag with Musical Instruments Background",
        "ASIN": "B01MSPTBGH",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51i2Jwb2mKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " November 22, 2016",
        "Id": 345,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 6,
        "ReviewItem2": 5,
        "PriceMax": 12.99,
        "ReviewItem5": 62,
        "Title": "Women's Short Leather Card Holder Purse Zipper Buckle Elegant Clutch Wallet",
        "ASIN": "B07NSPS5MK",
        "ReviewItem3": 11,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kAVSq%2BX3L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " January 1, 2018",
        "Id": 346,
        "ReviewCount": 180
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "SABARRY Women's Clear Clutch Bag Evening Handbags Tote Shoulder Bag",
        "ASIN": "B07FDQ5M29",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513LDwauzML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " July 11, 2018",
        "Id": 347,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40.82,
        "ReviewItem5": 0,
        "Title": "NEW Vintage PU Leather Ladies Handbags Women Messenger Bags Designer Crossbody Shoulder Bag",
        "ASIN": "B07R27RLG9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oE4QXPr7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.82,
        "UploadTime": " April 24, 2019",
        "Id": 348,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 60.53,
        "ReviewItem5": 0,
        "Title": "Liebeskind Berlin Women’s Clutchs 2d3d Bag",
        "ASIN": "B076PN992L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ou2kmzTOL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 60.53,
        "UploadTime": " September 8, 2018",
        "Id": 5568,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 2,
        "ReviewItem2": 4,
        "PriceMax": 19.99,
        "ReviewItem5": 79,
        "Title": "Fight Like a Girl Boxing Glove Tote Bag\"Dakota\" in Light Blue for Thyroid Disease Scleroderma (Assorted Colors)",
        "ASIN": "B01G94LNII",
        "ReviewItem3": 6,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Xhtp0F14L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "Id": 349,
        "ReviewCount": 178
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40.46,
        "ReviewItem5": 100,
        "Title": "Vera Bradley Change It Up Crossbody, Signature Cotton",
        "ASIN": "B078H7LFYX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61q9UK3IeLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.46,
        "UploadTime": " April 17, 2018",
        "Id": 350,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.99,
        "ReviewItem5": 0,
        "Title": "Purple Polly Pocket Heart and Bow Cross Body Bag",
        "ASIN": "B07FMBDKL1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41npHmwy-TL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.99,
        "Id": 351,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "JAGENIE Canvas Shopping Handbag Shoulder Bat Travel Tote Messenger Star Printing Bags Khaki",
        "ASIN": "B07DXGGLD3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51njr9So59L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 352,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LUANA ITALY Women's Double Zip Satchel Chestnut",
        "ASIN": "B07BXXHN4P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519aNUDvI7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 3, 2018",
        "Id": 353,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "I'd Know It I'm An Aquarius Woman Named Tammy Gift - Tote Bag With Zip",
        "ASIN": "B07C7DVX41",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Du8ASLQwL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " April 17, 2018",
        "Id": 354,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Women Clear Shopping Bag Transparent PVC Beach Handbag Youth Girls Tote Shoulder Bag Beach Candy Waterproof Large Capacity Foldable Travel Storage Bag Organizer Swimming Fitness Handbag Quick-dry",
        "ASIN": "B07CNWW5D6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FLI2su6qL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 355,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Black And White Stripe Tote Bag Female Shoulder Bags PU Leather Purse",
        "ASIN": "B07DPHMCYX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w5geHQI%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 13, 2018",
        "Id": 356,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 57.81,
        "ReviewItem5": 80,
        "Title": "Vera Bradley Iconic Triple Zip Hipster, Signature Cotton",
        "ASIN": "B07LGB9D6M",
        "ReviewItem3": 20,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jF1hfMuAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 57.81,
        "UploadTime": " February 10, 2019",
        "Id": 357,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Chala Handbag STRIPED Tote DRAGONFLY Turquoise Blue Green Vegan Leather",
        "ASIN": "B018WIUZCO",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ebKflnupL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 3, 2015",
        "Id": 358,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 7,
        "PriceMax": 9.99,
        "ReviewItem5": 62,
        "Title": "LeaLac Women Ethnic EmbroideBlue Shoulder Messenger Bag Handmade Crossbody Bag Boho Bags Canvas Handbag Phone Coin Purse Blue",
        "ASIN": "B0736NZ5W4",
        "ReviewItem3": 0,
        "ReviewItem4": 24,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514dgWH8X0L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "Id": 359,
        "ReviewCount": 42
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.95,
        "ReviewItem5": 0,
        "Title": "Ngil Quilted Cotton Medium Tote Bag 2018 Spring Collection (Classy Vine Navy)",
        "ASIN": "B07BZDMFJK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FXgW9%2BWUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " May 16, 2016",
        "Id": 362,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.06,
        "ReviewItem5": 0,
        "Title": "Nikky Embriodered Floral Design Gray Women Crossbody Cross Body Bag, One Size",
        "ASIN": "B0721NV8ML",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LGu5f2wcL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.06,
        "Id": 363,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Water Shoes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.49,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Men's and Women's Kid's Quick-Dry Water Shoes Barefoot Aqua Socks for Beach Swim Surf Yoga",
        "ASIN": "B07MR66S4X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/319Pg1VwyoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.49,
        "UploadTime": " December 28, 2018",
        "Id": 364,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "Myra Bags D-Ring Genuine Leather Crossbody Bag S-0967",
        "ASIN": "B078RCQV1W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61WIFJpxQvL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " September 4, 2014",
        "Id": 365,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 42.39,
        "ReviewItem5": 0,
        "Title": "Clarks Unisex Adults’ Treen Island Top-Handle Bag, Black (Black Leather), 7 x 18 x 23 cm (Wxhxd)",
        "ASIN": "B01KTM925M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iuATyPFyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 42.39,
        "UploadTime": " March 20, 2019",
        "Id": 388,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GCCLCF Real Leather Clutch Bags for Men Business Checkbook Handbag Credit Card Holder Large Zip Wristlet Purse Black Genuine Leather",
        "ASIN": "B07LC89W3J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gn3Xz6IUL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 366,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 85,
        "Title": "Baggallini Elizabeth Satchel Handbag",
        "ASIN": "B00Z9SDTXI",
        "ReviewItem3": 15,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LFHnsgAXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 11, 2015",
        "Id": 367,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Chloe Drew Shoulder Bag made in Italy",
        "ASIN": "B07G7CRK5R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31sbaDEpGEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 6, 2018",
        "Id": 368,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 8,
        "PriceMax": 24.96,
        "ReviewItem5": 92,
        "Title": "Black Butterfly Original Bohemian National Style Canvas Tote Shoulder Bag Top Handle Bag Womens Girls, a",
        "ASIN": "B06X9TNF85",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sSI5dDhIL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.96,
        "Id": 369,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 50,
        "Title": "Anne Klein Women's Perfect Tote",
        "ASIN": "B07KV2B74J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Q8EoZKxbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " March 3, 2019",
        "Id": 370,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Steve Madden Women's Dorinda",
        "ASIN": "B07BHNVLLY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vBBNP-OKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " September 14, 2018",
        "Id": 371,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 13,
        "ReviewItem2": 7,
        "PriceMax": 19.95,
        "ReviewItem5": 62,
        "Title": "B BRENTANO Vegan Double-Zip Pocket Crossbody Handbag Purse wih Big Tassel Accent",
        "ASIN": "B078QFD352",
        "ReviewItem3": 6,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510dvWMMs-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " December 30, 2017",
        "Id": 381,
        "ReviewCount": 105
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 2,
        "ReviewItem2": 6,
        "PriceMax": 35.99,
        "ReviewItem5": 72,
        "Title": "Women Backpack Purse Fashion Leather Large Travel Bag Ladies Shoulder Bags",
        "ASIN": "B07F81KL4H",
        "ReviewItem3": 4,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41H-hsa0r0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " July 4, 2018",
        "Id": 372,
        "ReviewCount": 81
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 145.97,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Mini Nelle Putnam Drive Purse",
        "ASIN": "B07JBMTC3G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MekLAysXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 145.97,
        "UploadTime": " October 10, 2018",
        "Id": 373,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.99,
        "ReviewItem5": 0,
        "Title": "Kipling Angie Printed Adustiable Strap Crossbody Bag ~ Dotted Bouquest",
        "ASIN": "B07QN8HJKL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eL07OZ0XL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.99,
        "UploadTime": " April 12, 2019",
        "Id": 374,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "High Quality Men's Wallet/ Card Protector/ Hot Selling Fashion Tri Fold Male Purse/ Leather Wallet: Dark Coffee/ Dark Brown",
        "ASIN": "B01N3ZMJ50",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WmmSRuKML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 386,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.3,
        "ReviewItem5": 0,
        "Title": "reTH Women's Dallas Crossbody Bag",
        "ASIN": "B07PKQFVM4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31mEvoOalIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.3,
        "UploadTime": " March 11, 2019",
        "Id": 387,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Small Vegan Leather Saddle Bag Boho Crossbody Pebble Purse Bohemian Clutch",
        "ASIN": "B07C5HLMXT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41C71MvRpLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " April 15, 2016",
        "Id": 375,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30.99,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Women's Carmen North/South Crossbody",
        "ASIN": "B07HJCRMP6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61H7UtfgnJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.99,
        "UploadTime": " November 23, 2018",
        "Id": 376,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "I'm An Executive Administrative Assistant - Fashion Zip Tote Bag",
        "ASIN": "B07GQWYVRG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sjgoKoobL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " August 22, 2018",
        "Id": 377,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 33,
        "Title": "Women Fashion Design Leather Crossbody Bag Shoulder Handbag Casual Chain Bag with Print Bee",
        "ASIN": "B07JC68BJ2",
        "ReviewItem3": 0,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61JQ0LOUtaL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "Id": 378,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 150,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Lexi Dwell Handbag, Koala",
        "ASIN": "B0797MQBWG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31RPdgBIksL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 150,
        "UploadTime": " January 23, 2018",
        "Id": 379,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Giordano Italian Made Orange Patent Leather Small Structured Handbag",
        "ASIN": "B01N91AUMP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oGGYrnuwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 11, 2016",
        "Id": 380,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.5,
        "ReviewItem5": 0,
        "Title": "Le Miel Perforated Side Pocket Tote w/Inner Bag Crossbody- Dark Blush",
        "ASIN": "B07DNRSH33",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512J8v7PzCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.5,
        "UploadTime": " July 14, 2018",
        "Id": 382,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.99,
        "ReviewItem5": 0,
        "Title": "Hynice Tote Bags Handbags Women Shoulder Top Handle Crossbody Crocodile Pattern PU leather Bag",
        "ASIN": "B07MNPWQFQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41o1-6HZEfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "UploadTime": " December 12, 2018",
        "Id": 383,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 0,
        "Title": "Star Wars Heroes & Villains Speeder Bike Club Handbag Purse",
        "ASIN": "B07FY25Z3L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5159haSrzKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 68,
        "UploadTime": " December 19, 2018",
        "Id": 384,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 19,
        "ReviewItem2": 10,
        "PriceMax": 29.99,
        "ReviewItem5": 44,
        "Title": "Duco Night Vision Glasses Polarized Wrap Around Prescription Eyewear",
        "ASIN": "B00BXXVPA2",
        "ReviewItem3": 12,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nwu37vFzL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 21, 2013",
        "Id": 385,
        "ReviewCount": 535
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YIBANG-Bag Men's Wallet Short Wallet PU Wallet Purse Men's Fashion (Color : Black, Size : S)",
        "ASIN": "B07RG35FSJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518FuapF2xL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 389,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.99,
        "ReviewItem5": 0,
        "Title": "HW Collection Western Cross Doves Faith Carry Concealed Handbag Purse and Wallet Set",
        "ASIN": "B079841BPK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JjUbXCgJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.99,
        "UploadTime": " January 17, 2017",
        "Id": 390,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.98,
        "ReviewItem5": 100,
        "Title": "Black Purse, COOFIT Handbags for Women Shoulder Bag Satchel Handbag with Detachable Strap",
        "ASIN": "B07NZ4DVZQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510Gwc8eN4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.98,
        "Id": 391,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Mokylor Cosmetic bag, Tote Bag, Felt Insert Organizer Bag Brown Large 11.86.36.3 Inches",
        "ASIN": "B07JNFNVPM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41HdBX0o4rL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " October 25, 2018",
        "Id": 392,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 41.48,
        "ReviewItem5": 34,
        "Title": "Foley + Corinna Hygge Tower Cross Body",
        "ASIN": "B07CL82LLQ",
        "ReviewItem3": 33,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4108mz-1EnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 41.48,
        "UploadTime": " September 20, 2018",
        "Id": 407,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 298,
        "ReviewItem5": 100,
        "Title": "Mary Frances First Bite Apple Red Convertible Clutch Handbag",
        "ASIN": "B007PTEKQY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EolhcJ1hL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 298,
        "UploadTime": " May 6, 2013",
        "Id": 2851,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 47.99,
        "ReviewItem5": 0,
        "Title": "ALDO Women's Okrent",
        "ASIN": "B07HKKJPZG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519FLLbcEtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 47.99,
        "UploadTime": " January 25, 2019",
        "Id": 393,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 122.19,
        "ReviewItem5": 33,
        "Title": "Cole Haan Loralie Bucket",
        "ASIN": "B06XTN3R7H",
        "ReviewItem3": 67,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41s-JiuaalL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 122.19,
        "UploadTime": " August 16, 2017",
        "Id": 394,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 13,
        "PriceMax": 15.99,
        "ReviewItem5": 55,
        "Title": "Duketea Stripe Medium Crossbody Purse, Canvas + Faux Leather Crossover Shoulder Bag",
        "ASIN": "B07CB7W6WX",
        "ReviewItem3": 9,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51867KupxOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " April 2, 2018",
        "Id": 395,
        "ReviewCount": 64
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Women's Canvas Owl Double Shoulder/Handbag/Tote Bags,Multi-style",
        "ASIN": "B0776Y6GBZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51l5b3tz%2BTL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " November 4, 2017",
        "Id": 396,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "Yoillione Women Handbag Organizer Insert with Handle,Felt Tote Purse Organizer",
        "ASIN": "B07MNM7D5T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51asqJaJcCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.98,
        "UploadTime": " December 24, 2018",
        "Id": 397,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.95,
        "ReviewItem5": 0,
        "Title": "LV Louis Vuitton Keepall 50 - Bag Base Shaper 1/16” Clear Acrylic",
        "ASIN": "B07NSGNSSR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/21Xb4P9n3ZL._US40_.jpg",
        "AcquisitionTime": 1558022400000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " March 13, 2018",
        "Id": 10590,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.43,
        "ReviewItem5": 100,
        "Title": "Pendleton Women's Canopy Coated Canvas Two-Bottle Bag",
        "ASIN": "B012U9VNGS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pRiC7-a1L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.43,
        "UploadTime": " December 21, 2015",
        "Id": 398,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 125,
        "ReviewItem5": 0,
        "Title": "Guess Handbag, G Signature Faux Leather Tote",
        "ASIN": "B07754K2WY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JE9iNpehL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 125,
        "UploadTime": " October 27, 2017",
        "Id": 399,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.35,
        "ReviewItem5": 0,
        "Title": "Esprit Accessoires Women’s 068ea1o020 Cross-Body Bag",
        "ASIN": "B07BHVTYVH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41GSQbmij3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.35,
        "UploadTime": " September 10, 2018",
        "Id": 400,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Nylon Colorblock Tote Bag",
        "ASIN": "B07P4DCMC1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31QgVcrdOgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 19, 2019",
        "Id": 401,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Sotihunt Summer Woven Bags Women Bohemia Round Crossbody Bag Rattan Woven Shoulder Handbag Summer Beach Crossbody Exquisite Straw Bag Travel",
        "ASIN": "B07PTYX72F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bWcUKcu5L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 402,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 230,
        "ReviewItem5": 0,
        "Title": "ECCO Ella Crossbody",
        "ASIN": "B07H5V3LF6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fodAbc-xL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 230,
        "UploadTime": " April 3, 2019",
        "Id": 403,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Purse Organizer Insert for LV Speedy Handbag - Fits inside Louis Vuitton Speedy 30 bag - Thick Wool Blend Felt (30, Red)",
        "ASIN": "B07NDRV7M5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TPQsiZ6tL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " January 9, 2019",
        "Id": 404,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 17,
        "ReviewItem2": 9,
        "PriceMax": 12.99,
        "ReviewItem5": 35,
        "Title": "Periea Handbag Organizer - 7 Pockets Large - Black - Tera",
        "ASIN": "B006DH511C",
        "ReviewItem3": 9,
        "ReviewItem4": 30,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iKw1btyvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " September 27, 2012",
        "Id": 405,
        "ReviewCount": 23
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 0,
        "PriceMax": 31.49,
        "ReviewItem5": 56,
        "Title": "Sleepyville Critters - Green Baby Alien Shoulder Crossbody Bag",
        "ASIN": "B013CUM3PO",
        "ReviewItem3": 11,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IU-7Qz9CL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.49,
        "UploadTime": " August 3, 2015",
        "Id": 406,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.49,
        "ReviewItem5": 50,
        "Title": "Bride to Mrs. Sparkling Script Reversible Tote, Cream/Pink",
        "ASIN": "B079F3Q4KS",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/317a1X1Bo4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.49,
        "UploadTime": " November 29, 2016",
        "Id": 408,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.9,
        "ReviewItem5": 0,
        "Title": "Shining Multi Zipper Pockets Women Cross body Bag Metallic Color Snake Print Chain Shoulder BagPurse",
        "ASIN": "B07KCB88Q1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dUS6UZQBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.9,
        "UploadTime": " November 9, 2018",
        "Id": 409,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 149,
        "ReviewItem5": 0,
        "Title": "Niarvi Women's Moon Dance Leather Handbag",
        "ASIN": "B01EKK1V7G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PQyStcWJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 149,
        "UploadTime": " April 20, 2016",
        "Id": 410,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Baggallini Womens 2 Bryant Pouch Bundle",
        "ASIN": "B07JYF8F1C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YIoe-AIML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " November 29, 2018",
        "Id": 411,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 76.99,
        "ReviewItem5": 100,
        "Title": "Calvin Klein Cora Bubble Lamb Novelty North/South Tote",
        "ASIN": "B079TP7R1T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sFQRsW0JL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 76.99,
        "UploadTime": " June 12, 2018",
        "Id": 431,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 88,
        "ReviewItem5": 0,
        "Title": "Women's Leather Ladies Shoulder Bags Totes Top Handle Bags Cross Body Bag Satchel Handbag",
        "ASIN": "B07BRRGQRM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kx4bSPuLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 88,
        "UploadTime": " March 28, 2018",
        "Id": 412,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 5,
        "PriceMax": 36.99,
        "ReviewItem5": 70,
        "Title": "Nevenka Women Patent Leather Handbags 99198",
        "ASIN": "B06XVSY4JP",
        "ReviewItem3": 10,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512KFRmeP9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.99,
        "UploadTime": " April 17, 2017",
        "Id": 413,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.9,
        "ReviewItem5": 100,
        "Title": "Round Straw Handwoven Shoulder Bag Women Cross body Bag for Summer Holiday",
        "ASIN": "B07FMR29J8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5111CT3QeSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.9,
        "UploadTime": " July 16, 2018",
        "Id": 414,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 34,
        "Title": "BTP! Skull Punk Rock Hippie Hobo Thai Cotton Sling Crossbody Bag Messenger Purse Small in Black SKS3",
        "ASIN": "B00HSJNMYC",
        "ReviewItem3": 33,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51KEHjLeOfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " August 19, 2013",
        "Id": 415,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22,
        "ReviewItem5": 0,
        "Title": "Stone Mountain Pebble 3 Bagger, Tan and Black",
        "ASIN": "B07MFBCWBW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51GEUsGbvlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22,
        "UploadTime": " January 4, 2019",
        "Id": 416,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 55,
        "ReviewItem5": 0,
        "Title": "Hello Kitty Crossbody Bag: Overalls",
        "ASIN": "B073YG4YWL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aD7OP44ML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55,
        "UploadTime": " October 26, 2017",
        "Id": 417,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.75,
        "ReviewItem5": 0,
        "Title": "Gear New Shoulder Tote Hand Bag, Cameraman Vintage Film Reel Camera Retro, 1188932GN",
        "ASIN": "B078RHJC62",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NQxDfyTcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.55,
        "UploadTime": " January 1, 2018",
        "Id": 418,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.89,
        "ReviewItem5": 0,
        "Title": "02197251 Ants Did Someone Say Picnic_14614 Pouch Purse Waterproof Black",
        "ASIN": "B07RR8CCCR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oRHWuSB1L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.89,
        "Id": 444,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 18.99,
        "ReviewItem5": 67,
        "Title": "Crossbody Bag for Women Vintage Handbag PU Leather Adjustable Strap Small Purse with Tassel",
        "ASIN": "B07K44XPJZ",
        "ReviewItem3": 7,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZtcVNUjRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " November 1, 2018",
        "Id": 419,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ALAZA Tropical Hawaiian Flowers Tote Top Handle Shoulder Bags Large Handbags for Women Ladies L",
        "ASIN": "B079GKQ2ZG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MRNnrKtsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 30, 2018",
        "Id": 420,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 6,
        "PriceMax": 22.99,
        "ReviewItem5": 76,
        "Title": "Visconti Bond BD10 Mens Black with Multi Color Soft Thin Leather Bifold Wallet",
        "ASIN": "B00CE6TKY0",
        "ReviewItem3": 6,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41e7bBxLZVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " April 17, 2013",
        "Id": 447,
        "ReviewCount": 50
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Kipling womens Creativity X Crossbody Bag",
        "ASIN": "B07CHHB412",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ks39%2BFvnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " October 30, 2018",
        "Id": 421,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.79,
        "ReviewItem5": 0,
        "Title": "Women Fashion Purses and Handbags Large Tote Bag Shoulder Bag Top Handle Satchel Purse Hobo for Ladies",
        "ASIN": "B07QR2T9LH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VaHmjzPfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.79,
        "UploadTime": " April 16, 2019",
        "Id": 422,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Desigual Bols_rotterdam Transflores. 3147. U, Women’s, Red (Carmin), 15x24.50x24 cm (b x h t) (EU)",
        "ASIN": "B06XPHBWYY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vHla%2BOC1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 5, 2018",
        "Id": 423,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Free Engraving Men Wallet Leather Small Money Purses Design Dollar Slim Purse Bag Mini Portomonee",
        "ASIN": "B07MN8QK8T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513XfvOokDL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 424,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 239,
        "ReviewItem5": 0,
        "Title": "Bag 'Ed Hardy' golden mole.",
        "ASIN": "B007P0V7G4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eK7xlO2NL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 239,
        "Id": 425,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.88,
        "ReviewItem5": 0,
        "Title": "Women handbag new canvas thick large capacity simple bag shopping bag shoulder bag",
        "ASIN": "B07JK3HTQX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Q0LJ-gaXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.88,
        "UploadTime": " October 19, 2018",
        "Id": 426,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "RHINESTONE WESTERN CONCHO HANDBAG PURSE - BROWN",
        "ASIN": "B00LP3ORS2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517vJkaknlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 11, 2014",
        "Id": 427,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 3,
        "ReviewItem2": 5,
        "PriceMax": 48.95,
        "ReviewItem5": 65,
        "Title": "Suncloud Conductor Polarized Sunglasses",
        "ASIN": "B006Y2BRHS",
        "ReviewItem3": 9,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xpcsV6UQL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 48.95,
        "Id": 428,
        "ReviewCount": 212
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.73,
        "ReviewItem5": 0,
        "Title": "Depesche TopModel 10231 Purse Velvet, Dark Red, Multi-Color",
        "ASIN": "B07GNSF56P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4104hzm-aRL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.73,
        "Id": 457,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10,
        "ReviewItem5": 0,
        "Title": "Hiigoo Women's Nylon Oxford Handbags Shoulder Bags Travel Bag Casual Totes Purses",
        "ASIN": "B075L8KV1Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aJ2JrdxGL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 10,
        "UploadTime": " September 13, 2017",
        "Id": 3273,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Women Patent Leather Handbag Casual Female Holiday Shoulder Bag Lady Travel Tote Crossbody Famous Large Top-Handle Bolsa",
        "ASIN": "B07R7MBR5C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pCELGA6OL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 28, 2019",
        "Id": 429,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.68,
        "ReviewItem5": 0,
        "Title": "Qflmy Retro Hobo Style Large Women's Canvas Casual Handbag Shoulder Bag Messenger Bag",
        "ASIN": "B06VV2KSLD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415pgN6g9WL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.68,
        "UploadTime": " February 12, 2017",
        "Id": 430,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 66,
        "Title": "Western Style Camouflage Concealed Carry Purse Buckle Country Studs Women Handbag Shoulder Bag Wallet Set",
        "ASIN": "B07DNQ6XZS",
        "ReviewItem3": 5,
        "ReviewItem4": 24,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5178uzlDhWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " June 11, 2018",
        "Id": 432,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 50,
        "Title": "MKF Hobo Crossbody Bag for Women - Satchel Shoulder Handbag - Vegan Leather Top Handle Purse Removable Strap",
        "ASIN": "B07NDMKW8X",
        "ReviewItem3": 13,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gBCPpFr5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " January 26, 2018",
        "Id": 433,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Coach Varsity Stripe File Crossbody Bag",
        "ASIN": "B01G7VL0Y0",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41c09j0UiNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 26, 2016",
        "Id": 434,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 6,
        "ReviewItem2": 6,
        "PriceMax": 148,
        "ReviewItem5": 75,
        "Title": "HOBO Rachel Tri-Fold Wallet",
        "ASIN": "B07L79VHXL",
        "ReviewItem3": 4,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iHnZDWhVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 148,
        "UploadTime": " January 16, 2019",
        "Id": 435,
        "ReviewCount": 142
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 50,
        "Title": "YALUXE Women's Cowhide Leather Purse Tote Shoulder Bag Hobo Handbag for Womens black",
        "ASIN": "B07CXJ9S4P",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NYbYVSi%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " May 8, 2018",
        "Id": 445,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.95,
        "ReviewItem5": 0,
        "Title": "gBol's Leather Crossbody Handbag for Women Organize Pack Shoulder Bag Messenger Purses",
        "ASIN": "B07KB1G6N5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41L%2BMoykWSL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 16.95,
        "UploadTime": " December 2, 2018",
        "Id": 4813,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Coin Purses & Pouches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Badiya Leather Credit Card Case Holder Wallet RFID Dad Mom to Son Daughter Best Birthday Gifts",
        "ASIN": "B07QQNVRL1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ThyR%2BzAML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " April 14, 2019",
        "Id": 436,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 385,
        "ReviewItem5": 0,
        "Title": "Womens Leather Ladies Tote Shoulder Vertical Bag Brown USA Made No. 9B",
        "ASIN": "B06ZYWTKXL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419fXaS9OQL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 385,
        "UploadTime": " April 12, 2017",
        "Id": 448,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 3,
        "PriceMax": 16.99,
        "ReviewItem5": 72,
        "Title": "Collsants Nylon Crossbody Purse for Women Travel Shoulder Bag Multi Pocket Water Resistant",
        "ASIN": "B07NY413NN",
        "ReviewItem3": 3,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oh0NKibLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " August 1, 2018",
        "Id": 449,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 75,
        "Title": "Canvas Bag, Fanspack Canvas Hobo Bag Top Handle Tote Bag Crossbody Shoulder Bag Purse Shopping Work Bag",
        "ASIN": "B07GSVBM12",
        "ReviewItem3": 13,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31JqLJl6D8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " August 24, 2018",
        "Id": 437,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 318,
        "ReviewItem5": 67,
        "Title": "Michael Kors Kellen Medium Leather Satchel",
        "ASIN": "B06X6HR9F5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LWn3E3IpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 318,
        "UploadTime": " July 7, 2016",
        "Id": 438,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "UINight Womens Travel Bags Funny Lovely Cute Sloth Portable Lightweight Handbags with Zip Bags",
        "ASIN": "B07RR7GVKX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pmSPQAypL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 439,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.97,
        "ReviewItem5": 0,
        "Title": "Jackieyoung Hollow Leaves Paris Tower Flower Print Shoulder Crossbody Messenger Bag for women",
        "ASIN": "B07D191MZL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VYN%2Br5H1L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.97,
        "UploadTime": " May 11, 2018",
        "Id": 440,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "Goodbag Boutique Women Glitter Evening Clutch Purse Shining Envelope Shoulder Bag Chain Cross Body Bag For Wedding Party Prom",
        "ASIN": "B077XXP64T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5179pFmwOrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " December 5, 2017",
        "Id": 441,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "BLUE Q SHOULDER TOTE,CELL PHONES, TOTE",
        "ASIN": "B00A1N2SJW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51o%2BO-Zg1yL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "Id": 442,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 47.99,
        "ReviewItem5": 79,
        "Title": "Mens Wristlets Clutch Bag Genuine Leather Wallets Handbag Luxury Purses",
        "ASIN": "B076P67DZM",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CX6m%2BM1pL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 47.99,
        "UploadTime": " October 22, 2017",
        "Id": 443,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Buffway Slim Minimalist Front Pocket RFID Blocking Leather Wallets for Men Women",
        "ASIN": "B07FDQC3RC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xZRj00nyL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " January 28, 2018",
        "Id": 446,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Food Dispensers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 699.95,
        "ReviewItem5": 0,
        "Title": "Rosseto EZ520 Triple Container EZ-SERV Table-Top Cereal Dispenser with Walnut Tray, 3.9 Gallon",
        "ASIN": "B00HMF0QIC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Tv2-QLhWL._SX38_SY50_CR,0,0,38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 699.95,
        "Id": 720,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 119.99,
        "ReviewItem5": 0,
        "Title": "DelleVEGA Ladie's Leather Bag Crossbody Bag Shoulder Bag",
        "ASIN": "B07KR4T6B2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31X7l1NzS1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 119.99,
        "UploadTime": " November 21, 2018",
        "Id": 450,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 70.61,
        "ReviewItem5": 0,
        "Title": "Kipling Women's Kassandra S Cross-Body Bag",
        "ASIN": "B06XPDPX4W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qR9SBQ3QL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 70.61,
        "UploadTime": " September 10, 2018",
        "Id": 451,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 47.6,
        "ReviewItem5": 100,
        "Title": "Relic by Fossil Women's Brooke Tote Handbag Purse",
        "ASIN": "B07DNYFZ8K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31axlVsetXL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 47.6,
        "UploadTime": " August 20, 2018",
        "Id": 452,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.65,
        "ReviewItem5": 0,
        "Title": "Womens Fabulous Bird Leather Wallets Credit Card Cash Holder Large Capacity Clutch Purse",
        "ASIN": "B07QDGM9NJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510VB4bbWML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.65,
        "UploadTime": " April 7, 2019",
        "Id": 453,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.5,
        "ReviewItem5": 0,
        "Title": "Chala Women's Tote Shoulder Handbags with adjustable straps-Brown (Brown Metal Tu1)",
        "ASIN": "B07386C4ZL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5166KNIMfsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.5,
        "UploadTime": " February 8, 2017",
        "Id": 454,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Christmas Plaid Oxford Fabric Saddle Bag Crossbody Messenger Shoulder Bag Purse Hand Shoulder Crossbody Bag",
        "ASIN": "B07K9SBM46",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ef2nt5R%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 8, 2018",
        "Id": 455,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.95,
        "ReviewItem5": 100,
        "Title": "CafePress Peace Love Veterinary Medicine Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00O1435OY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BUHZ1KyML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.95,
        "Id": 456,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.55,
        "ReviewItem5": 0,
        "Title": "Bonjanvye Flower Purses With Rhinestones Crystal Evening Clutch Bags",
        "ASIN": "B073Z7NM49",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61UE1A69coL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.55,
        "UploadTime": " July 16, 2017",
        "Id": 458,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "LV Louis Vuitton Tivoli GM - Bag Base Shaper 1/16” Clear Acrylic",
        "ASIN": "B07RQ3WRGZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/21Xb4P9n3ZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 12, 2018",
        "Id": 459,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "LensCovers Sunglasses - Wear Over Prescription Glasses. Size Small, Polarized",
        "ASIN": "B0061RSKTE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31F6VlrEvAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " October 31, 2011",
        "Id": 460,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 56,
        "ReviewItem2": 0,
        "PriceMax": 44.99,
        "ReviewItem5": 33,
        "Title": "Baggallini Tred Crossbody Travel Organizer Bag and Passport Holder",
        "ASIN": "B07H9DCLNG",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31BXNoIPF0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.99,
        "UploadTime": " September 12, 2018",
        "Id": 461,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 88,
        "ReviewItem5": 0,
        "Title": "Hedgren Magic Small Crossbody",
        "ASIN": "B071FHV61S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31MtZhzkuGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 88,
        "UploadTime": " August 16, 2017",
        "Id": 462,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.69,
        "ReviewItem5": 0,
        "Title": "COOKI Womens Purses and Handbags Ladies Satchel Fashion PU Leather Crossbody Handbags Designer Satchel Tote Bag Shoulder Bags on Sale Clearance",
        "ASIN": "B07C4K86PQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Yypx8BNSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.69,
        "UploadTime": " January 4, 2018",
        "Id": 463,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 3,
        "PriceMax": 24.99,
        "ReviewItem5": 80,
        "Title": "Milisente Women Flower Clutches Evening Bags Handbags Wedding Clutch Purse",
        "ASIN": "B072BW6WB3",
        "ReviewItem3": 2,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hadzb2nCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " March 19, 2017",
        "Id": 464,
        "ReviewCount": 445
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "London Fog Womens Flynn Crossbody",
        "ASIN": "B07G5HF4HW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415uELfdtyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " January 9, 2019",
        "Id": 484,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 73.5,
        "ReviewItem5": 0,
        "Title": "Hedgren Women's Pauline-Business 15.6 Cross Body Bag, New Bull Red, One Size",
        "ASIN": "B018UHO85C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sPmNr4rKL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 73.5,
        "Id": 520,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "DreamHorse Women Purse Party Clutch Shoulder Bag Handbag Slim Wallet Genuine Leather Evening Bag",
        "ASIN": "B07JR23DKQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bah8N%2BfuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " October 26, 2018",
        "Id": 465,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 225,
        "ReviewItem5": 0,
        "Title": "Eric Javits Luxury Fashion Designer Women's Handbag - St. Barth's - White/Silver",
        "ASIN": "B01AIS1XTA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MKYWO0jpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 225,
        "UploadTime": " January 12, 2016",
        "Id": 466,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Hell Bunny Black Sparkle Tippi Kiss Lock Purse Handbag top Handle",
        "ASIN": "B07PWMVX45",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41INR8zzffL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 22, 2019",
        "Id": 467,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 61.6,
        "ReviewItem5": 0,
        "Title": "ili 6516 Leather Triple Compartment Crossbody Handbag",
        "ASIN": "B071HNPX6Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NVXrRJzDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 61.6,
        "UploadTime": " May 10, 2017",
        "Id": 468,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 158.67,
        "ReviewItem5": 0,
        "Title": "Guess Women’s Hwvg6781070 Top-Handle Bag",
        "ASIN": "B071S77KBK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eh5jp8hTL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 158.67,
        "UploadTime": " February 4, 2018",
        "Id": 8424,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "Small Crossbody Bag for Women Mini Shoulder Purse and Handbag with Compartments Divides",
        "ASIN": "B07KDNRK1Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zpY%2BNcOHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " May 8, 2018",
        "Id": 469,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 329.99,
        "ReviewItem5": 0,
        "Title": "Coach Grove Tote Jasper Red Tote Handbag Bag New",
        "ASIN": "B07PQX3SZG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41j%2ByVv5tAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 329.99,
        "UploadTime": " March 15, 2019",
        "Id": 470,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 17,
        "PriceMax": 0,
        "ReviewItem5": 33,
        "Title": "The Lovely Tote Co. Women's Fashion Color Block Square Tote Shoulder Bag",
        "ASIN": "B07D7TZCJT",
        "ReviewItem3": 17,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31hbOaETliL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 23, 2018",
        "Id": 471,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "Men's Long Bifold Wallet Zipper Credit Card Slots Organizer Holder Purse Coin Pocket | Perfect Present for Men Women",
        "ASIN": "B075VNM5B9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51k7WbMMOQL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " September 22, 2017",
        "Id": 472,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 120.6,
        "ReviewItem5": 68,
        "Title": "Victorinox Werks Traveler 6.0 Shopping Tote",
        "ASIN": "B07GXJQRF1",
        "ReviewItem3": 4,
        "ReviewItem4": 24,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31k%2BwIuG4vL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 120.6,
        "UploadTime": " August 30, 2018",
        "Id": 473,
        "ReviewCount": 25
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 147.5,
        "ReviewItem5": 0,
        "Title": "Signature Organizer Shoulder Bag Color: Brown",
        "ASIN": "B004QE7S6U",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MARwrjslL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 147.5,
        "UploadTime": " March 2, 2011",
        "Id": 474,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GUESS Factory Women's Cali Croc-Embossed Bag",
        "ASIN": "B01N562IW4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416CMlz9D2L._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 14, 2017",
        "Id": 4814,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 6,
        "PriceMax": 25.99,
        "ReviewItem5": 62,
        "Title": "QZUnique Women's Summer Fashion Top Handle Cute Cat Cross Body Shoulder Bag",
        "ASIN": "B071HW6WBS",
        "ReviewItem3": 9,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TcY%2BszLUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " May 17, 2017",
        "Id": 475,
        "ReviewCount": 571
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Cute Cellphone Pouch Crossbody Shoulder Small PU Leather Sling Bag Handbag Satchel Coin Purse for Women",
        "ASIN": "B07DCN42FF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BTS3EtwKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " May 28, 2018",
        "Id": 476,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GUESS Women's Dreamville Shopper Travel Tote Bag Handbag - Mocha",
        "ASIN": "B07GK32YNX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PXIqjauqL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 514,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bafrsc Personalized Violet and Mandala Pattern Women's Shell Shape Carrying Case Organizer Bag Gift 2Pcs",
        "ASIN": "B07RNKR6PL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EMSgJLZ7L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 477,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 17,
        "PriceMax": 49.99,
        "ReviewItem5": 33,
        "Title": "Phoenix Craft Women's Leather Purse Gypsy Bag Crossbody Women Handbag 16x12x5",
        "ASIN": "B01C5OLMAU",
        "ReviewItem3": 8,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516-mIeqrmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " February 24, 2016",
        "Id": 478,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 0,
        "Title": "Nine West Crisanta Shoulder Pouch Hobo Bag, Cashmere/Platino/Milk",
        "ASIN": "B078NC3W2Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31aSTkGi6CL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 68,
        "UploadTime": " February 15, 2018",
        "Id": 479,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 137.99,
        "ReviewItem5": 100,
        "Title": "HPASS Speedy 30cm Designer Woman Organizer Handbag Damier Tote Shoulder Bag with Strap",
        "ASIN": "B07P73YP2F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31IEVUZ14qL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 137.99,
        "UploadTime": " March 1, 2019",
        "Id": 480,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30.99,
        "ReviewItem5": 0,
        "Title": "Summer Beach Straw Bag Womens Top Handle Handbag Travel Tote Purse Handwoven Hobo Bag With Purple Pom Poms Keyring",
        "ASIN": "B07QPR99SC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61EuGWEKaIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.99,
        "UploadTime": " April 15, 2019",
        "Id": 481,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.51,
        "ReviewItem5": 80,
        "Title": "Goodbag Boutique Women Sparkly Sequin Chain Tote Handbag Clutch Girl Exquisite Shoulder Crossbody Bag",
        "ASIN": "B075ZPKNTZ",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DwH7Yl0RL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.51,
        "UploadTime": " July 27, 2018",
        "Id": 482,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 135,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Stella Small Vintage Handbag, Orchid",
        "ASIN": "B0797N96W3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Ly7fPMjmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 135,
        "UploadTime": " January 22, 2018",
        "Id": 483,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "CLARA Women Basic Fashion Tote Bag Geometric Pattern Handbag Large Capacity Patent Leather Shoulder Bag",
        "ASIN": "B07DG2S9P6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iconir-VL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 1, 2018",
        "Id": 485,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Handwoven Rattan Beach Bag Straw Bali Bag Wicker Bag Natural Ata Grass Crossbody Shoulder Bag (KAMPIAL BAG)",
        "ASIN": "B07GDSR1RP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41p-w3GCJLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 13, 2018",
        "Id": 486,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Vintage Humming Bird Womens Clutch Wallet Large Wristlet Zipper Clutch Large Travel Purse",
        "ASIN": "B07Q5G21LW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41dFEHteNiL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " March 29, 2019",
        "Id": 487,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 138,
        "ReviewItem5": 75,
        "Title": "Vera Bradley Lighten Up Ultimate Gym Bag, Polyester",
        "ASIN": "B07CHQHRCL",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61YJ5nKVMLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138,
        "UploadTime": " June 13, 2018",
        "Id": 525,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "DEYYA Women Large Tote Bag African American Girls Shoulder Handbags Satchel Messenger Bags for Ladies",
        "ASIN": "B07F74B63G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41X9ISc1cXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 3, 2018",
        "Id": 488,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 147.5,
        "ReviewItem5": 100,
        "Title": "Rioni Signature (Natural) - Dome Handle Bag Stn-20001",
        "ASIN": "B008GX4MTS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514tVWqjshL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 147.5,
        "UploadTime": " April 28, 2012",
        "Id": 489,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke Pebble Grain Milly Crossbody Shoulder Bag",
        "ASIN": "B07FQP4356",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31cEenFDT2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 30, 2018",
        "Id": 490,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Cell Phone Purse Mini Crossbody Bag Smartphone Wallet Headphone Bag American Flag Patriotic USA Bald Eagle and Book",
        "ASIN": "B07KTZJQGN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eKnzhYuiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 24, 2018",
        "Id": 491,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Cat 3D Crossbody Bag, Ustyle Cute Animal Face Small Girl Purse Zipper Coin Cell Phone Wallet Single Shoulder Bag",
        "ASIN": "B07K1VPS6S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LYWgJMROL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " October 30, 2018",
        "Id": 492,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.95,
        "ReviewItem5": 0,
        "Title": "Crossbody Bag For Women With Tassel - Small & Lightweight Purse For Everyday",
        "ASIN": "B07LGHJ1DF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41q9vtPfLVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.95,
        "UploadTime": " December 18, 2018",
        "Id": 493,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 205.02,
        "ReviewItem5": 34,
        "Title": "Tuscany Leather Melissa Lady leather bag Brown",
        "ASIN": "B00KR9HQRO",
        "ReviewItem3": 33,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41na8vYatPL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 205.02,
        "Id": 494,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 79.07,
        "ReviewItem5": 0,
        "Title": "Betsey Johnson Clear Tote",
        "ASIN": "B07K8CTTVR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41o9XNAdkaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79.07,
        "UploadTime": " March 29, 2019",
        "Id": 495,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 83,
        "Title": "Carhartt Legacy Women's Tote East/West, Black",
        "ASIN": "B00GC4MGU0",
        "ReviewItem3": 6,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DG35s%2BdpL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "Id": 521,
        "ReviewCount": 35
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 17,
        "Title": "Shoulder Bag Canvas Tote Handbag Casual Work Bag Travel Bags Shopping Bag with Purse Wallet for Women Girls Ladies",
        "ASIN": "B07BFDB6XW",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gfSlS2FpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " March 26, 2018",
        "Id": 496,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Large Saddle Bag Crossbody Bags for Women Brown Flap Purses with Tassel Over the Shoulder Long Strap",
        "ASIN": "B07QTZ6LXM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41OJix%2BjKqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 18, 2019",
        "Id": 497,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Nucelle Leather Shopper Bowling Style Satchel Handbag Tote Bag W/shoulder Strap Red",
        "ASIN": "B00EG46SJ8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Y4lBBg5PL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 10, 2013",
        "Id": 591,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.65,
        "ReviewItem5": 0,
        "Title": "Women Leather Wallet Bifold Clutch Wallet Turtle Zipper Wallets",
        "ASIN": "B07R7VJ27H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oEloeRpJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.65,
        "UploadTime": " April 30, 2019",
        "Id": 498,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.45,
        "ReviewItem5": 0,
        "Title": "Women Lightweight Medium Crossbody Bag with Tassel,WEUIE Leather Shoulder Bags Handbags Messenger Bag",
        "ASIN": "B07Q2HJSD4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516rtKixKAL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.45,
        "Id": 499,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.14,
        "ReviewItem5": 0,
        "Title": "Women Japan Style Luminous Bag Geometric Bag Handbag Designer Folding Travel Makeup Bag Small Purse Design C",
        "ASIN": "B07R9QVHM4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TJQHTkdbL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.14,
        "Id": 500,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.99,
        "ReviewItem5": 0,
        "Title": "Mn&Sue Punk Motorcycle PU Leather Top Handle Boston Barrel Slouchy Hobo Satchel Convertible Doctor Purse",
        "ASIN": "B01M0UKCDQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mCeAi3HJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "UploadTime": " September 21, 2016",
        "Id": 501,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 41.26,
        "ReviewItem5": 0,
        "Title": "Jughead Jones Bag Riverdale Gift South Side Serpents Bag - Riverdale Bag Jughead Jones Accessories",
        "ASIN": "B07HHHF7QW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Tj0KGDAwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 41.26,
        "UploadTime": " September 19, 2018",
        "Id": 508,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 20,
        "ReviewItem2": 10,
        "PriceMax": 64.46,
        "ReviewItem5": 60,
        "Title": "Nine West Helda Crossbody",
        "ASIN": "B06Y4RWXCY",
        "ReviewItem3": 0,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jed%2BhhLkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.46,
        "UploadTime": " June 5, 2017",
        "Id": 509,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 63,
        "Title": "MALFURION Women's Crossbody Bag Small Phone bag Cell Phone Purse Wallet with Credit Card Slots …",
        "ASIN": "B07QLHT9V6",
        "ReviewItem3": 0,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ULmE3HjSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " April 14, 2019",
        "Id": 502,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 73.92,
        "ReviewItem5": 0,
        "Title": "Sherpani Womens Boheme",
        "ASIN": "B0743K3WFY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41I-hd4fdbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 73.92,
        "UploadTime": " July 20, 2017",
        "Id": 512,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 82,
        "Title": "Crossover Purse and Handbags Crossbody Bags for Women Soft Leather Wallet Cute Small Neatpack Bag with Pockets",
        "ASIN": "B07Q72JGDW",
        "ReviewItem3": 9,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XkF0%2BMeoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " February 13, 2019",
        "Id": 503,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 80,
        "Title": "Simply Noelle Buckle Down Crossbody Belt Bag",
        "ASIN": "B0758TJ6B6",
        "ReviewItem3": 20,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41W5as0bW4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " August 31, 2017",
        "Id": 504,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Backpacks",
        "ReviewItem1": 4,
        "ReviewItem2": 5,
        "PriceMax": 31.99,
        "ReviewItem5": 73,
        "Title": "tomtoc Durable College High School Book Bag, Travel Backpack Fits 15.6 Inch Laptop & Notebook w/Unisex, Anti-Theft Pocket, Waterproof, Lightweight & Charging Pocket Design, 22L (Grey)",
        "ASIN": "B07CYQ8QXL",
        "ReviewItem3": 4,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51cG4WIXjpL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "Id": 505,
        "ReviewCount": 110
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 87,
        "Title": "JHVYF Women Cute Plush Crossbody Bag Chic Small Shoulder Purse Cell Phone Wallet For Girls",
        "ASIN": "B076JDB37T",
        "ReviewItem3": 7,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JWuuXlWrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " October 18, 2017",
        "Id": 506,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 28.28,
        "ReviewItem5": 85,
        "Title": "Purse Organizer Insert, Felt Bag organizer with zipper, Handbag & Tote Shaper, Fit LV Speedy, Neverfull, Longchamp, Tote",
        "ASIN": "B07PRF9Z1L",
        "ReviewItem3": 4,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41C%2BfJJYziL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.88,
        "UploadTime": " April 17, 2018",
        "Id": 507,
        "ReviewCount": 46
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 52.88,
        "ReviewItem5": 0,
        "Title": "Dune Womens Bonie Cross-Body Bag",
        "ASIN": "B07C9BHNWG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YIY8elraL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52.88,
        "UploadTime": " July 1, 2018",
        "Id": 551,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.85,
        "ReviewItem5": 0,
        "Title": "Men's Holeless Leather Ratchet Click Belt - Trim to Perfect Fit (Various Styles and Colors)",
        "ASIN": "B00Q3GLB76",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pfEfcjQ7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.85,
        "UploadTime": " January 24, 2016",
        "Id": 510,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.9,
        "ReviewItem5": 0,
        "Title": "Naovio Women's Small Crossbody Bag 3D Cactus Shaped Pu Leather Shoulder Bags Purse",
        "ASIN": "B073J8SRWV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51u1w6WNaeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.9,
        "UploadTime": " July 6, 2017",
        "Id": 511,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 9,
        "ReviewItem2": 9,
        "PriceMax": 14.99,
        "ReviewItem5": 73,
        "Title": "LAORENTOU Men's Leather Wallet Short Wallets Card Holder Purse Slim Cow Leather Casual Man Wallet",
        "ASIN": "B075YVRVRJ",
        "ReviewItem3": 0,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DewE6vPML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " June 8, 2017",
        "Id": 513,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Oath_song Women's Graphic Pattern Handmade Reversible Canvas Tote Bag",
        "ASIN": "B071NF65ZV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SOkv6JUmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " April 20, 2017",
        "Id": 515,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 12.5,
        "ReviewItem5": 50,
        "Title": "Women Girls Denim Canvas Crossbody Shoulder Bag Mini Purse Wallet Card Holder Cellphone Pouch",
        "ASIN": "B01EUVP43M",
        "ReviewItem3": 0,
        "ReviewItem4": 38,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516Xy%2BSfhXL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.5,
        "UploadTime": " April 27, 2016",
        "Id": 516,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 81.65,
        "ReviewItem5": 0,
        "Title": "Betsey Johnson In A Flash",
        "ASIN": "B075H5K2HK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Wd4ENfVjL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 81.65,
        "UploadTime": " November 30, 2017",
        "Id": 517,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.99,
        "ReviewItem5": 100,
        "Title": "HAOSHIDUO Women Top Handle Satchel Handbags Shoulder Bag Tote Purse Messenger Bags",
        "ASIN": "B07PS7HF5D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410l620DtfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.99,
        "UploadTime": " March 17, 2019",
        "Id": 518,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 19.99,
        "ReviewItem5": 75,
        "Title": "Women Clutch Evening Bag Elegant Beaded Shoulder Bag Luxurious Handbag Purse",
        "ASIN": "B07CBS8YVY",
        "ReviewItem3": 0,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UNZMiULpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " December 11, 2017",
        "Id": 519,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 50,
        "Title": "UtoteBag Women Top Handle Satchel Tote bag Shoulder Bags HandBag Work Purse Crossbody Bag",
        "ASIN": "B076J7SRK3",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w422Dcp2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " October 17, 2017",
        "Id": 522,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 50,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "INC International Concepts Large Straw Pom Pom Accented Tote Bag",
        "ASIN": "B074CL34D7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519VfpI-ChL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 28, 2017",
        "Id": 523,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.9,
        "ReviewItem5": 0,
        "Title": "Small Leather Crossbody Handbags Purse For Women Black Travel Shoulder Messenger Bags",
        "ASIN": "B07D579YC9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515ZrJP2OKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.9,
        "UploadTime": " May 17, 2018",
        "Id": 524,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "POPUCT Cute Hedgehog Canvas Shoulder Bag Handbag(Hedgehog-2)",
        "ASIN": "B071HS7QSX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413eF22zusL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "Id": 526,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 103.95,
        "ReviewItem5": 0,
        "Title": "Michael Kors Jet Set MD Conve Pouchtte Crossbody Bag Misty Rose (35T8GTTU2L)",
        "ASIN": "B07DX9Z2NH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Mnf5coquL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 103.95,
        "UploadTime": " June 21, 2018",
        "Id": 527,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Crossbody Bags Saltwater Fish Girls Purse Handbags Bag",
        "ASIN": "B07HYW7BJH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VFgalZy8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 3, 2018",
        "Id": 528,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 88,
        "Title": "InterestPrint Custom Unique Leather Tote Shoulder Bag Handbag Gift for Women Girls",
        "ASIN": "B0789DHVCQ",
        "ReviewItem3": 0,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wwP-gZ%2B3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " December 15, 2017",
        "Id": 529,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 0,
        "Title": "KILAMAL Women's Leather Purses, Medium Leather Sling 3 Straps Shoulder Crossbody Bag Cute with Chain (Pink)",
        "ASIN": "B07H8ZPG8Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Rkz8b0FTL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " September 11, 2018",
        "Id": 530,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Chain Bag for Women,Casual Fashion Crossbody Shoulder Bag Classic Purse Round Head Mini Sequins Dinner",
        "ASIN": "B07RTSW2NL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Lgc4yuPPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 12, 2019",
        "Id": 531,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 91.75,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger TH Xbody Crossbody Black White Shoulder Bag Wristlet",
        "ASIN": "B07HBP58FH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413975tP87L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 91.75,
        "UploadTime": " September 13, 2018",
        "Id": 532,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 89,
        "Title": "Donna Sharp Cell Phone Crossbody Purse",
        "ASIN": "B072PQF6L4",
        "ReviewItem3": 11,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UvI7WcMVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " May 22, 2017",
        "Id": 533,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Authentic Louis Vuitton Empreinte Leather Pont-Neuf Mini Tote Cross Body Handbag Article: M41743 Noir",
        "ASIN": "B01DF2DLVE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413eWXRKLHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 9, 2016",
        "Id": 534,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.49,
        "ReviewItem5": 0,
        "Title": "Mn&Sue Designer Flap Messenger Handbag Check Plaid Crossbody Bag Women Top Handle Satchel Purses",
        "ASIN": "B078PHXYS1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510Y9PixoqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.49,
        "UploadTime": " December 28, 2017",
        "Id": 535,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.88,
        "ReviewItem5": 0,
        "Title": "MORADI Small Cellphone Purse Wallets Crossbody Shoulder Bags for Women Girls",
        "ASIN": "B07PVR6SC6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DijbmNlgL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.88,
        "Id": 536,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Top Handle Handbags Hobo Satchel Handbags Cute PU Leather Handbags for Women",
        "ASIN": "B07MFLHJ2G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZFl%2BMxeVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " January 7, 2019",
        "Id": 537,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Woman's PU Leather Crossbody Bags Single Shoulder Bags(B071)",
        "ASIN": "B07BV2G428",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413cI8C7yjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 31, 2018",
        "Id": 538,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 97,
        "ReviewItem5": 0,
        "Title": "Kate Spade Hayes Street Arla Leather Cross Body",
        "ASIN": "B07JYD6L1R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41X0z6GiD5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 97,
        "UploadTime": " November 20, 2018",
        "Id": 539,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 120.8,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Marigold Brighton Lane Black Cat Crossbody Bag Purse",
        "ASIN": "B07MSKMDBT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31CT%2B3ZedfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 120.8,
        "UploadTime": " January 9, 2019",
        "Id": 540,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.99,
        "ReviewItem5": 0,
        "Title": "Summer Beach Woven Straw Bag Handmade Shoulder Bag Retro Style with Colorful Tassels",
        "ASIN": "B07QQW3XBW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WmyYye%2BgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "UploadTime": " April 15, 2019",
        "Id": 541,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 56.99,
        "ReviewItem5": 0,
        "Title": "Women Shoulder Messenger Bag Purse Set 4 Pcs Leather Zipper Handbag Solid Shoulder Messenger Bag Purse Set",
        "ASIN": "B07PFT7DSF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41dE7wbn%2BeL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 56.99,
        "Id": 542,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 218.99,
        "ReviewItem5": 0,
        "Title": "MICHAEL MICHAEL KORS Blakely Leather Bucket Bag",
        "ASIN": "B07BH3YTDL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41HSRaxhfkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 218.99,
        "UploadTime": " August 23, 2017",
        "Id": 543,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "New Brand Fashion Women Acrylic Cute Round Leopard Print Evening Bag Woman Party Prom Handbag Causal Clutch",
        "ASIN": "B07FZWP7ZG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PU3tpe-rL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " July 7, 2018",
        "Id": 544,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Orla Kiely Croc Embosed Robin Bag",
        "ASIN": "B00GKA3BQ4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WKUZEAZWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 1, 2017",
        "Id": 545,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 8,
        "PriceMax": 21.99,
        "ReviewItem5": 78,
        "Title": "Crossbody Straw Bag, JOSEKO Womens Straw Handbag Shoulder Bag for Beach Travel and Everyday Use",
        "ASIN": "B07CCLWGDW",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517GJdtC9%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " March 26, 2018",
        "Id": 546,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "UINight Womens Travel Bags Mermaid Galaxy Shell Print Portable Lightweight Handbags with Zip Bags",
        "ASIN": "B07RP67Y5R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nl5zuI7KL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 547,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89.95,
        "ReviewItem5": 0,
        "Title": "Paul & Taylor Vintage Style Genuine Leather Handbag with Organizer 16102",
        "ASIN": "B076YMW6F5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sqQjRGRdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.95,
        "UploadTime": " October 3, 2017",
        "Id": 548,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 100,
        "Title": "MoDA Women's Mini Faux Leather Chain Decor Cross Body Handbag Wristlet Purse",
        "ASIN": "B00TT0FDOU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51miIaffynL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " February 19, 2015",
        "Id": 549,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 99.99,
        "ReviewItem5": 0,
        "Title": "BOSTANTEN Vintage Leather Handbag Designer Tote Shoulder Purse for Women",
        "ASIN": "B07QFWZ5VT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31xwc0Ek%2B7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 99.99,
        "UploadTime": " April 9, 2019",
        "Id": 550,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Coin Purses & Pouches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "TACK'S BYOB Mesh Wallet Pouch Set",
        "ASIN": "B07M75TZ56",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JoAhD1DrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " January 4, 2019",
        "Id": 552,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Cobbler Legend 2-IN-1 DESIGN Leather Wallet for Men, Zipper Purse with Removable ID Window",
        "ASIN": "B07NVKRP2C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZGkLnoMFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " February 18, 2019",
        "Id": 553,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 80,
        "Title": "Allstate Leather Women's Western Style Handbag One Size",
        "ASIN": "B00FG2K958",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eBYhw0SzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 26, 2013",
        "Id": 554,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 36.99,
        "ReviewItem5": 0,
        "Title": "Anne Klein Women's Solid Top Zip Tote, Black",
        "ASIN": "B07KV2QCGZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Dm3XJmpnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.99,
        "UploadTime": " March 15, 2019",
        "Id": 555,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.89,
        "ReviewItem5": 0,
        "Title": "Mn&Sue Summer Vacation Stylish Women's Waterproof Oxford Fabric 2pcs Top Handle Handbag Set Bag In Bag",
        "ASIN": "B071WVMYSV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TgcMRzn8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.89,
        "UploadTime": " July 30, 2016",
        "Id": 556,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sports Duffels",
        "ReviewItem1": 4,
        "ReviewItem2": 5,
        "PriceMax": 79.99,
        "ReviewItem5": 60,
        "Title": "OGIO Locker Bag",
        "ASIN": "B00083DFZG",
        "ReviewItem3": 10,
        "ReviewItem4": 21,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51D9QFJ5PAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79.99,
        "UploadTime": " March 18, 2005",
        "Id": 557,
        "ReviewCount": 404
    }, {
        "Sale": "[]",
        "Category": "",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "LaviniaLee Shoulderbag Beach Bag Straw Top-Handle Tote Handbag Large Satchel",
        "ASIN": "B07CMS27S8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VW5Dpqp7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " April 24, 2018",
        "Id": 558,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "So'each Canvas & Beach Tote Bag World's Best Grammy Ever Graphic Handbag Shoulder Bag",
        "ASIN": "B07BV2QRQ3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XK%2BA%2BX0eL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " March 31, 2018",
        "Id": 559,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "QZUnique Summer Colorful Lattice Laser Crossbody Handbag Shoulder Bag Shinny Color Tote Handbag",
        "ASIN": "B07P5RGR3V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515cSUFwtwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " February 26, 2019",
        "Id": 560,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Moroccan Straw Shopper Bag w/Leather Handles, 19\"Lx8\"Wx11\"H - Madrid",
        "ASIN": "B01N0DAHIJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WSZmI2oSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 14, 2016",
        "Id": 569,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Crossbody Bags Deer Sunset Girls Purse Handbags Bag",
        "ASIN": "B07HYXQHH5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Pt3Tc--0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 3, 2018",
        "Id": 561,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.98,
        "ReviewItem5": 0,
        "Title": "JOSEKO Men Retro Genuine Leather Smart Bluetooth Wallet Anti-Theft/Lost Purse",
        "ASIN": "B07FMV83DW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qCOuD%2B0GL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.98,
        "UploadTime": " February 6, 2018",
        "Id": 562,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 50,
        "Title": "AOCINA Medium Crossbody Bag Big Pocket Shoulder Bag Travel Bag For Women Girls",
        "ASIN": "B07M8LH8YW",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XTPSj-9dL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " December 20, 2018",
        "Id": 563,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "KYWYN Cell Phone Bag Case - Colorful Flamingo - Women Girls Small Phone Wallet Purse, Adjustable Strap Crossbody Handbags Multipurpose Phone Holder",
        "ASIN": "B07MX8S69Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41t2n6NEi6L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 564,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 100,
        "Title": "Damier Canvas Pochette Felicie Wallets Handbag Clutch Article",
        "ASIN": "B07MR64LLS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jZnrg2JvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 68,
        "UploadTime": " December 27, 2018",
        "Id": 565,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "ZOCAI Womens Hobo Shoulder Bag Soft PU Leather Top Handle Handbag Crossbody Tote Purse with Adjustable Strap",
        "ASIN": "B07MZSKXML",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51e9d%2B1vNlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " January 23, 2019",
        "Id": 566,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.95,
        "ReviewItem5": 100,
        "Title": "Handpainted Butterfly Shoulder Bag - Leather Crossbody Strap Lined Purse",
        "ASIN": "B07C9R5ZCX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51g2bh53d4L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.95,
        "UploadTime": " March 29, 2018",
        "Id": 567,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "Travelon: Anti-Theft Nylon Pod Pocket Crossbody Bag - Sapphire",
        "ASIN": "B07J4YK1B2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41S-WrF0krL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "Id": 568,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Michael Kors Logo East West Crossbody",
        "ASIN": "B07PNRPHBW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51fOiMLz0qL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 14, 2019",
        "Id": 3631,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40.99,
        "ReviewItem5": 0,
        "Title": "QTKJ Fashion Lightweight Washable Kraft Paper Environmental Protection Tote Bag Zipper Handbag With Leather Straps(Khaki)",
        "ASIN": "B07GGZ6WM6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WsPwlrUEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.99,
        "UploadTime": " August 15, 2018",
        "Id": 570,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 15.83,
        "ReviewItem5": 79,
        "Title": "Charming Tailor Clutch Purse Evening Bag Envelope Diamante and Pleated Flap Handbag",
        "ASIN": "B074M9L34P",
        "ReviewItem3": 6,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51o7axS0mrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.83,
        "UploadTime": " August 7, 2017",
        "Id": 571,
        "ReviewCount": 48
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 62.9,
        "ReviewItem5": 81,
        "Title": "Heshe Leather Handbags for Women Shoulder Tote bag Ladies Satchel Crossbody Bags (R110-Jester Red)",
        "ASIN": "B07PCMP5NY",
        "ReviewItem3": 6,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JWck55ymL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 62.9,
        "Id": 572,
        "ReviewCount": 16
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Satchel Purse",
        "ASIN": "B074798Z5V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51n4P0EL1IL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 24, 2017",
        "Id": 573,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bafrsc Personalized Mosaic Dolphin 2 Crystal Waters Women's Shell Shape Purse Travel Storage Bag Organizer Bag Gift 2Pcs",
        "ASIN": "B07RQKWDKL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51u-bkgy9lL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 574,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.81,
        "ReviewItem5": 0,
        "Title": "Nikky Trending Women's Casual Small Red Spacious Exclusive Print Shoulder Tote Bag Shoulder Bag",
        "ASIN": "B07HHLGCJP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419abf5oDtL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.81,
        "UploadTime": " September 19, 2018",
        "Id": 575,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 75,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "NAWO Leather Handbags Designer Simple Leisure Tote Shoulder Bags for Women",
        "ASIN": "B06Y5LLF3Z",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WfamifqAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 7, 2017",
        "Id": 576,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Gym Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.95,
        "ReviewItem5": 100,
        "Title": "Beach Tote - Gym Bag - Set of 3 with 2 Sizes - Mesh Urban Design for Multi Use",
        "ASIN": "B07F2DGTPG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61VbkAPauBL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.95,
        "Id": 577,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.95,
        "ReviewItem5": 0,
        "Title": "kilofly Bohemian Hippie Cloth Crossbody Shoulder Bag, Adjustable Strap",
        "ASIN": "B018HQ4OFK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517iiOLRgPL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.95,
        "UploadTime": " November 25, 2015",
        "Id": 578,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Women's Cameron Street Sarah",
        "ASIN": "B07FQQ7X5Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31OHiw8uGtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 6, 2018",
        "Id": 579,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "SHZONS Bamboo Handbag, Beach Purse Bag Half Moon Bag,Straw Woven Travel Sling Bag Shoulder Crossbody Bag for Women",
        "ASIN": "B07F8WM2K4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SzRRA825L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 580,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Three Bullett Genuine Cowhide Leather Laser Engraved Engraving Black Slimfold Mens Large Capacity Luxury Wallet Purse Minimalist Sleek and Slim Includes Credit Card Holder Organizer 14 Pockets",
        "ASIN": "B07QJ7XVHJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Di4D2-uaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " April 9, 2019",
        "Id": 581,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 22,
        "ReviewItem2": 11,
        "PriceMax": 9.99,
        "ReviewItem5": 56,
        "Title": "YaJaMa Women Leather Mini Handbags Crossbody Single Shoulder Bag Cellphone Pouch Purse",
        "ASIN": "B01DWBBWQO",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41n2GJKhnaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " April 6, 2016",
        "Id": 582,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Yoome Women Small Crossbody Bags Cute Cell Phone Purse Wallet Fits for IPhone 6 6S 7 8 Plus X XR XS Max",
        "ASIN": "B07K256SFN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410w8YAhMML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " October 31, 2018",
        "Id": 583,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.88,
        "ReviewItem5": 100,
        "Title": "Women Luminous Backpack Geometric Backpack Lingge Women Shoulder Bag Rucksack",
        "ASIN": "B07CMPQDL8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wmJxHhf4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.88,
        "Id": 584,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 297.95,
        "ReviewItem5": 0,
        "Title": "FRYE Riviana Mini Leather Tote Crossbody",
        "ASIN": "B07H4TKS2K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BWYfys2HL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 297.95,
        "UploadTime": " March 13, 2019",
        "Id": 585,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "VELEZ Womens Genuine Colombian Leather Handbag Purse | Cartera para Mujer de Cuero Colombiano",
        "ASIN": "B07DJK2GRN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QItsF9lKL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 1, 2016",
        "Id": 586,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Women's Summer Sparkle Crossbody Marrakesh Beads Crossbody Bag",
        "ASIN": "B00SOFACT2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61s9MIOripL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 16, 2015",
        "Id": 6239,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 5,
        "PriceMax": 33.99,
        "ReviewItem5": 61,
        "Title": "UTO Women Handbag PU Leather Purse Hobo Style Shoulder Bag",
        "ASIN": "B075K4KY9B",
        "ReviewItem3": 14,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xWboIom1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " September 12, 2017",
        "Id": 587,
        "ReviewCount": 85
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Rattan Shoulder Chain Bags for Women Woven Female Bucket Straw Bags Ladies Fashion Elegant HandBags",
        "ASIN": "B07RHFH8S1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mD90pZ0YL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 4, 2019",
        "Id": 588,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 61.73,
        "ReviewItem5": 0,
        "Title": "Women Evening Bag Ladies Flower Wedding Clutches Female Pink Black Clutch Purse",
        "ASIN": "B07C7TZF78",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-uVJatZiL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 61.73,
        "UploadTime": " April 17, 2018",
        "Id": 589,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Leather Crossbody Purse for Women Functional Small Travel School Crossbody Bag (black)",
        "ASIN": "B07R3W916Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LxnPdkJwL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 590,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Designer Handbag Pu Bags Handbags Women Famous Brands Shoulder Bag",
        "ASIN": "B07QBYWYZX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kfFMotI0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 3, 2019",
        "Id": 592,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 25,
        "PriceMax": 14.59,
        "ReviewItem5": 75,
        "Title": "Large Clear Cross-Body Oblong Purse",
        "ASIN": "B07453T85C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IT0ttspyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.59,
        "UploadTime": " July 21, 2017",
        "Id": 593,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40,
        "ReviewItem5": 0,
        "Title": "Black Pyramid - Pink Tear Drop Cross Body Bag",
        "ASIN": "B07RB7HTCS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31SWahjOL%2BL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40,
        "Id": 594,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ALAZA Floral Peacock Large Tote Top Handle Shoulder Bags Handbags for Women Ladies",
        "ASIN": "B079JC8Z6Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-e4UTRXjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 1, 2018",
        "Id": 595,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.86,
        "ReviewItem5": 0,
        "Title": "Aibearty Waterproof Nylon Shoulder Bag Multi Pocket Crossbody Purse",
        "ASIN": "B07PKSDD15",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Uk3WBERzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.86,
        "UploadTime": " March 11, 2019",
        "Id": 596,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 6,
        "PriceMax": 11.99,
        "ReviewItem5": 82,
        "Title": "U-Story Womens Floral Lace Satin Evening Envelope Clutch Bridal Wedding Handbag Purse",
        "ASIN": "B0725HQYH5",
        "ReviewItem3": 6,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UqbRZUBQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " May 10, 2017",
        "Id": 597,
        "ReviewCount": 17
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "Katie Loxton - Adalie Day Bag - Khaki Grey",
        "ASIN": "B01KO3UIA4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31IglEGbJML._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " March 23, 2017",
        "Id": 6282,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bduco New Elegant Leather Handbag Flower Shape Shell Crossbody Messenger Shoulder Bag Top-Handle Satchel Tote Bags",
        "ASIN": "B07F8QXXDM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4116e0ybT2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 5, 2018",
        "Id": 598,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 100,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Oguine 4pcs Women Fashion Composite Bag Handbag Wallet Shoulder Crossbody Bags",
        "ASIN": "B07MQDRGHT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412povaAl3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " January 10, 2019",
        "Id": 599,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 10,
        "ReviewItem2": 10,
        "PriceMax": 0,
        "ReviewItem5": 40,
        "Title": "Black Panther Movie Satchel Handbag",
        "ASIN": "B078XNZM79",
        "ReviewItem3": 20,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51I%2Bkt2luJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 11, 2018",
        "Id": 600,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "COACH Women's Crossbody with Quilting (F38681)",
        "ASIN": "B07MM69H26",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EXNfHxWhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 10, 2019",
        "Id": 601,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 112.86,
        "ReviewItem5": 0,
        "Title": "Vince Camuto Cory Crossbody",
        "ASIN": "B07JWGDPBW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41r%2BMpfNw2L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 112.86,
        "UploadTime": " March 27, 2019",
        "Id": 602,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.75,
        "ReviewItem5": 0,
        "Title": "Lucky Happy Gnome Crossbody Bag in Vinyl Material",
        "ASIN": "B06VVYB299",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51f7rIAVNOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.75,
        "UploadTime": " February 14, 2017",
        "Id": 603,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 100,
        "Title": "Genda 2Archer Men's Vintage Genuine Leather Long Bifold RFID Wallet Checkbook Holder",
        "ASIN": "B07588XC4Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WmagbHxuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " November 2, 2017",
        "Id": 604,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Loungefly Captain America Shield Faux Leather Crossbody Bag",
        "ASIN": "B0787M538H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WwTMbuUfL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 12, 2018",
        "Id": 605,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 75,
        "Title": "Hippie Crossbody Bag Thai Top Zip Hobo Sling Bag Cotton Jacquard cloth Handmade Bags",
        "ASIN": "B07KNT4543",
        "ReviewItem3": 12,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YWnFilNbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " December 15, 2018",
        "Id": 606,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 239.7,
        "ReviewItem5": 83,
        "Title": "Kate Spade New York Women's Jackson Street Quincy",
        "ASIN": "B07BZP4X59",
        "ReviewItem3": 17,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31PpNHTxhnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 239.7,
        "UploadTime": " September 8, 2018",
        "Id": 607,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 72,
        "Title": "Baggallini Gold International Seville Mini Black W/Sand",
        "ASIN": "B017VOTIQE",
        "ReviewItem3": 6,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YOzyPrOcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 14, 2015",
        "Id": 608,
        "ReviewCount": 32
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 165.48,
        "ReviewItem5": 0,
        "Title": "Kate Spade Patterson Drive Medium Maisie Crossbody Handbag Black/Cement",
        "ASIN": "B07PZJXLMF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uXb1HJYrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 165.48,
        "UploadTime": " March 19, 2019",
        "Id": 609,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 248,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke Pebble Grain Gingy Flap Crossbody Shoulder Bag",
        "ASIN": "B07L112R22",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31SD8501P6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 248,
        "UploadTime": " April 6, 2019",
        "Id": 610,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Beautyfronta Women Ribbons Tote PU Scarves Top-Handle Femal Shoulder Bags",
        "ASIN": "B07CNWRGT2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UfFkjyzYL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 611,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Sleepyville Critters - Chicken Crossbody Bag in Vinyl Material",
        "ASIN": "B073X5YDWL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qhZSEHuoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " July 13, 2017",
        "Id": 612,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 66.5,
        "ReviewItem5": 0,
        "Title": "Lacoste L.12.12 Concept Vertical Shopping Bag, NF1890PO, navy/iberis",
        "ASIN": "B01KH8NOK2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31k2fOsemwL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 66.5,
        "UploadTime": " May 25, 2017",
        "Id": 613,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - monkey Tote Bag 19c03",
        "ASIN": "B016RC8XDA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51QRErS9EaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " October 17, 2015",
        "Id": 614,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Harley-Davidson Women's Vintage B&S Embroidery Bucket Purse VBS6214-GRYBLK",
        "ASIN": "B07PVL3MNN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KfUcWMHoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 21, 2019",
        "Id": 615,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Frida Kahlo Bag",
        "ASIN": "B07D7K4K47",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417GUGF-YaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 22, 2018",
        "Id": 616,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.59,
        "ReviewItem5": 50,
        "Title": "Xingyue Felt Insert Bag with Multi-Pockets Handbag Organizer Purse Insert Bag",
        "ASIN": "B07KT4MXNZ",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410kDn%2B9MmL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.59,
        "UploadTime": " November 23, 2018",
        "Id": 617,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45.99,
        "ReviewItem5": 0,
        "Title": "Nite closet Victorian Handbag Gothic Purses Lolita Shoulder Bag for Women Vintage Clutch",
        "ASIN": "B07CWZ3Z75",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YjEY74LwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.99,
        "UploadTime": " May 7, 2018",
        "Id": 618,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 152.03,
        "ReviewItem5": 0,
        "Title": "Foley + Corinna Sarabi Saddle Bag",
        "ASIN": "B01N6GTM66",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51B-4xAmuJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 152.03,
        "UploadTime": " February 20, 2017",
        "Id": 619,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Daisies Flowers on Yellow Women's Boho Crossbody Bag, Sling Shoulder Purse",
        "ASIN": "B07PD2FD66",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PS4v0xctL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 5, 2019",
        "Id": 622,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.98,
        "ReviewItem5": 0,
        "Title": "Jordan Air Crossbody Bag (One Size, Gym Red)",
        "ASIN": "B07H9BB43W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Q-pQl9tqL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.98,
        "Id": 623,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Keyrings & Keychains",
        "ReviewItem1": 0,
        "ReviewItem2": 40,
        "PriceMax": 22.98,
        "ReviewItem5": 60,
        "Title": "Wallet Chain Men Twisted Rope Chain Stainless Steel Biker Key Jean Purse Chain",
        "ASIN": "B01M59IVI4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31be32ILz0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.98,
        "UploadTime": " October 9, 2016",
        "Id": 624,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 25,
        "PriceMax": 129,
        "ReviewItem5": 50,
        "Title": "Ainifeel Women's Genuine Leather Simple Everyday Purse Top Handle Handbag",
        "ASIN": "B07GDRFW9W",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31UTgs7KuJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 129,
        "UploadTime": " December 13, 2016",
        "Id": 625,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 5,
        "PriceMax": 65.85,
        "ReviewItem5": 76,
        "Title": "Tignanello Pebble Leather Heritage Crossbody Bag with Rfid",
        "ASIN": "B01MY8ILTJ",
        "ReviewItem3": 3,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aJI2BlJbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 65.85,
        "UploadTime": " January 14, 2017",
        "Id": 657,
        "ReviewCount": 37
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 55.58,
        "ReviewItem5": 0,
        "Title": "Aldo Womens Adraolla Backpack Handbag",
        "ASIN": "B071CZFY73",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Yj7SPwG4L._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 55.58,
        "UploadTime": " September 8, 2018",
        "Id": 8146,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Water Shoes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.49,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Men's and Women's Kid's Quick-Dry Water Shoes Barefoot Aqua Socks for Beach Swim Surf Yoga",
        "ASIN": "B07M6816YN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jGHy6G7NL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.49,
        "UploadTime": " December 28, 2018",
        "Id": 626,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 4,
        "PriceMax": 0,
        "ReviewItem5": 61,
        "Title": "Betsey Johnson Off the Hook Wireless Phone Bag Crossbody",
        "ASIN": "B075H5K2H7",
        "ReviewItem3": 4,
        "ReviewItem4": 23,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ZpS1Vsd7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 19, 2017",
        "Id": 627,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 87.99,
        "ReviewItem5": 0,
        "Title": "Myra Bag Camel Upcycled Canvas & Cowhide Tote Bag S-1465",
        "ASIN": "B07QH33LWB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41a7i5o-7tL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 87.99,
        "UploadTime": " April 9, 2019",
        "Id": 628,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 17,
        "PriceMax": 34.99,
        "ReviewItem5": 83,
        "Title": "Kipling womens Lynne Convertible Crossbody Bag",
        "ASIN": "B07CH5PKVX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414trZ5hZWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " October 30, 2018",
        "Id": 629,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Beezen Women Patent Leather Chain Bag Fashion Glossy Mirror Bright Shoulder Bag Crossbody Bag",
        "ASIN": "B07PQF9MD1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414yW9nFeeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 13, 2019",
        "Id": 630,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Women's Brown Paw Print with Hearts Rivet Shoulder Handbag Shoulder Bags",
        "ASIN": "B07PVM84SP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41t7xOxMgFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " March 22, 2019",
        "Id": 631,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MARY FRANCES Cocktail Time Beaded-Embroidered Crossbody Phone Bag",
        "ASIN": "B07FYWSYC2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ZV4jRxSQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 28, 2018",
        "Id": 632,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 398.89,
        "ReviewItem5": 100,
        "Title": "Disney Dooney And Bourke Pirates Of The Carribean Crossbody Purse",
        "ASIN": "B075W1NQ3F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61%2BKnOl2DuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 398.89,
        "UploadTime": " September 2, 2017",
        "Id": 1966,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 4,
        "PriceMax": 21.99,
        "ReviewItem5": 46,
        "Title": "Keyli Ladies Vintage Washed PU leather Soft and Lightweight Crossbody Purse with Braid Flap Women Shoulder Bag",
        "ASIN": "B07MTLFTKS",
        "ReviewItem3": 14,
        "ReviewItem4": 36,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418-SNuKXrL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " January 16, 2019",
        "Id": 633,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30.51,
        "ReviewItem5": 0,
        "Title": "Aldo BLACHLY",
        "ASIN": "B07CTRJM53",
        "ReviewItem3": 50,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41T69dsMU5L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.51,
        "UploadTime": " August 1, 2018",
        "Id": 634,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 184.95,
        "ReviewItem5": 0,
        "Title": "Coach Faye Leather Carryall Crossbody Shoulder Purse - #F35113",
        "ASIN": "B07NQQ17ZC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pc0FdQFwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 184.95,
        "UploadTime": " February 14, 2019",
        "Id": 635,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Zara Women Transparent pieces handbag 3310/004",
        "ASIN": "B07MTHGML8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41i1WUIwk-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 15, 2019",
        "Id": 710,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.95,
        "ReviewItem5": 0,
        "Title": "Bucket Bag Women Black-Expatrié\"Claire\" Small Handbag Tote Ladies Casual Purse",
        "ASIN": "B07GSYX9K1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31EHEq-ZoQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.95,
        "UploadTime": " September 7, 2018",
        "Id": 636,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Wonderrun Handbag Bag Storage to for Decor Satchel Tote Purse Pocket Fashion Picnic Case Food Storage Box Organizer",
        "ASIN": "B07N7M5QYB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qwMKUEcaL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 637,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.87,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Xbody Medium Crossbody Purse Black",
        "ASIN": "B00G859YH6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oOyLJBi4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.87,
        "UploadTime": " November 5, 2014",
        "Id": 638,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Canvas Tote Bag - Handbags Casual Work Bag for Women",
        "ASIN": "B07Q2D9Z7Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516EZ9FLIHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " March 26, 2019",
        "Id": 639,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 105,
        "ReviewItem5": 67,
        "Title": "Qidell Women's Genuine Leather Wristlet Handbags Top Handle Purse",
        "ASIN": "B073GST759",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hzLwvOxGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 105,
        "UploadTime": " June 28, 2017",
        "Id": 640,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 50,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Villager with Solid Interiors (Tropical Paradise with Blue Interior)",
        "ASIN": "B079G6TYK5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Bjgb5Nv3L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 50,
        "Id": 641,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Daisy Poppy Flowers Womens Clutch Wallet Large Wristlet Zipper Clutch Large Travel Purse",
        "ASIN": "B07Q4CLK73",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UfnMWXYaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " March 29, 2019",
        "Id": 642,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.17,
        "ReviewItem5": 0,
        "Title": "Mellow World Hipster Hb2808 Cross Body Bag, Brown, One Size",
        "ASIN": "B0779QSK83",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JHmHBES3L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.17,
        "Id": 643,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Womens Natalie Leather Messenger Handbag Brown Small",
        "ASIN": "B01LZHZKFF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tJiZJvO6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 2, 2016",
        "Id": 644,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 33,
        "Title": "Drawstring Bucket Bags for Women Large Crossbody Purse and Shoulder Bag Leather Fashion Backpack Purse Tote Handbag",
        "ASIN": "B073FF126L",
        "ReviewItem3": 67,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51q4dZ7d7ML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " April 16, 2018",
        "Id": 645,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "ONBLUE BL-GS 10MM Wide Purse Chain Straps for Shoulder Crossbody Bags 47\" Handbags Chain Strap Replacement Flat Shape Gold Plated Chain for Wallet Clutch Satchel Tote Bag (Set of 2 Gold,Silver)",
        "ASIN": "B077Z7S3G1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5197JCz8pvL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "Id": 646,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Celebrate Shop Women's Christmas Santa Crossbody Handbag Red",
        "ASIN": "B071Y5F8MS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YW-xPtMIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 20, 2017",
        "Id": 748,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Backpack, Women Nylon Shoulder Bag, Girls Small Travel Daypack Purse with Anti-theft Pocket, Fashion and Casual,Lightweight School Shoulder Bag",
        "ASIN": "B07RD63R7T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519F7r4RgqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 3, 2019",
        "Id": 647,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Water Shoes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.49,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Men's and Women's Kid's Quick-Dry Water Shoes Barefoot Aqua Socks for Beach Swim Surf Yoga",
        "ASIN": "B07M6816YJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31USNrLoMPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.49,
        "UploadTime": " December 28, 2018",
        "Id": 648,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Cherry Beaded Bag Woven Bag For Women Bag Causal Cute Small Tote Bag",
        "ASIN": "B07F8WZ94J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wnAlu3NWL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 649,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 50,
        "Title": "Inktastic - Little Ballerina Trio Tote Bag c62a",
        "ASIN": "B0745TZGSK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aHFN2nuJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " October 18, 2015",
        "Id": 650,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.99,
        "ReviewItem5": 0,
        "Title": "Contacts Genuine Leather Mens Secretary Checkbook Phone Holder Purse Zipper Wallet (Coffee)",
        "ASIN": "B07GKHQYWN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DT7-DRfhL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "Id": 651,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "Turelifes Top Handle Satchel Handbags Lightweight Messenger Shoulder Bag Large Tote Purse for Women",
        "ASIN": "B078R1JJM3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XEUrLM-gL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " August 1, 2018",
        "Id": 652,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 6,
        "ReviewItem2": 4,
        "PriceMax": 27.88,
        "ReviewItem5": 74,
        "Title": "Purse Organizer, Purse Insert Organizer with Handles For LV Speedy Neverfull and Hermes Birkin 30 and 35",
        "ASIN": "B07C3JKRZ7",
        "ReviewItem3": 5,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419gcWQo%2BKL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 18.88,
        "UploadTime": " January 7, 2019",
        "Id": 2949,
        "ReviewCount": 134
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30.95,
        "ReviewItem5": 100,
        "Title": "Harry Potter Hedwig Owl Crossbody Handbag",
        "ASIN": "B07F17H6W4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51M6Lpxur8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.95,
        "UploadTime": " June 25, 2018",
        "Id": 653,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.34,
        "ReviewItem5": 0,
        "Title": "Aldo Womens Edroiana Backpack Handbag",
        "ASIN": "B06ZZRV9C8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516Af%2B-qRGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.34,
        "UploadTime": " September 8, 2018",
        "Id": 654,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 364.99,
        "ReviewItem5": 100,
        "Title": "COACH Women's Mixed Leather Edie 42",
        "ASIN": "B01M4QKDGI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5184Q955R9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 364.99,
        "UploadTime": " November 17, 2016",
        "Id": 655,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Sunflower Field in Time Sunset Women's Boho Crossbody Bag, Sling Shoulder Purse",
        "ASIN": "B07PD2B7J6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414Dl8Vb9ZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 5, 2019",
        "Id": 656,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Sanrio Characters Mix Small Tote Bag : Mushroom",
        "ASIN": "B07KT7NKR8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41GYsGx0uuL._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 7846,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35,
        "ReviewItem5": 0,
        "Title": "Hiigoo Canvas Totes Daily Bag Casual Handbag Environmental Shopping Bags Shoulder Bags",
        "ASIN": "B071S17HWS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YmDgyitPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35,
        "UploadTime": " May 9, 2017",
        "Id": 658,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 138,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Ava Extra-Small Leather Crossbody in Soft Pink",
        "ASIN": "B07KWC461B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31o1gtaba-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138,
        "UploadTime": " November 26, 2018",
        "Id": 659,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 9,
        "PriceMax": 23.29,
        "ReviewItem5": 71,
        "Title": "Laurel Burch Crossbody Bag, 13.5 by 4 by 10-Inch, Blossoming Feline",
        "ASIN": "B00NTAPH92",
        "ReviewItem3": 2,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/619kZJBpNlL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.29,
        "Id": 660,
        "ReviewCount": 94
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 118,
        "ReviewItem5": 78,
        "Title": "Harveys Women's Streamline Crossbody",
        "ASIN": "B07MTJ5NM6",
        "ReviewItem3": 8,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Yid1ArKfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 118,
        "UploadTime": " February 20, 2019",
        "Id": 661,
        "ReviewCount": 49
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Shoulder Bag Sling Pack My Neighbor Totoro Handbag Cosplay Crossbody Bags",
        "ASIN": "B07QPRCY9X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51h7rOhMpdL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 662,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 4.08,
        "ReviewItem5": 0,
        "Title": "Rakkiss Womens Crossbody Bag Fashion Corduroy Shoulder Bag Solid Wild Large Capacity Messender Bag Tote Bucket",
        "ASIN": "B07Q2YMZF1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NHYdSrI0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 4.08,
        "UploadTime": " March 27, 2019",
        "Id": 663,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.77,
        "ReviewItem5": 0,
        "Title": "All-Match Korean Style Women's Fashion Large Capacity Tote Shoulder Bag Handbag",
        "ASIN": "B075MCPDP1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51fZOZT4VDL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.77,
        "UploadTime": " September 14, 2017",
        "Id": 664,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 5.1,
        "ReviewItem5": 50,
        "Title": "Voberry Women Rainbow Mini Shoulder Bag Totes Bags Messenger Bag",
        "ASIN": "B0123MOGGG",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Vq7wVjQdL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 5.1,
        "UploadTime": " July 20, 2015",
        "Id": 665,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 55.99,
        "ReviewItem5": 50,
        "Title": "CHERRY CHICK Women's Cow Leather Daily Purse Work Tote (Cocoa-605)",
        "ASIN": "B07MGQ26RZ",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Cz5xFiEuL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55.99,
        "Id": 666,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Replacement Sunglass Lenses",
        "ReviewItem1": 22,
        "ReviewItem2": 5,
        "PriceMax": 32,
        "ReviewItem5": 42,
        "Title": "Revant Replacement Lenses for Oakley Half Jacket",
        "ASIN": "B006NHROBW",
        "ReviewItem3": 12,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Y6yNUJZvL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32,
        "UploadTime": " January 31, 2014",
        "Id": 667,
        "ReviewCount": 241
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 25,
        "Title": "Steve Madden Bira Media Tote Shoulder Handbag",
        "ASIN": "B00Y5K3HRE",
        "ReviewItem3": 0,
        "ReviewItem4": 75,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wvUhU0DxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 20, 2015",
        "Id": 668,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 109.84,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Elaine Bubble Lamb Novelty Key Item Tote",
        "ASIN": "B07HYTGB15",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31iT2pGf-oL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 109.84,
        "UploadTime": " December 17, 2018",
        "Id": 788,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.48,
        "ReviewItem5": 0,
        "Title": "Canvas Hobo Bag - Vintage Large Canvas Tote Handbag for Women Top Handle Work Bag with Detachable Shoulder Strap SHY0048",
        "ASIN": "B07N41W9FK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gTXYVMr7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.48,
        "UploadTime": " January 25, 2019",
        "Id": 669,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "SUNGAIT Men's Polarized Sunglasses for Driving Fishing Golf Metal Frame UV400",
        "ASIN": "B01JGHMGDG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31ynDCn2NtL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " August 1, 2016",
        "Id": 670,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 87,
        "Title": "Carhartt Women's Cross Body Carry All, Brown",
        "ASIN": "B00GC4MINA",
        "ReviewItem3": 5,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514LFtbiDbL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "Id": 671,
        "ReviewCount": 38
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "Guess Women's Purse Handbag Arcata Crossbody Coal",
        "ASIN": "B01M1VVI3H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/318tXn3N6GL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " September 29, 2016",
        "Id": 672,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 9,
        "ReviewItem2": 4,
        "PriceMax": 38.07,
        "ReviewItem5": 73,
        "Title": "Olympia Fashion Rolling Shopper Tote - Zebra Black, 2300 cu. in.",
        "ASIN": "B004RE3SB8",
        "ReviewItem3": 5,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51881AEkLLL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.07,
        "Id": 673,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 197.52,
        "ReviewItem5": 100,
        "Title": "Kate Spade Medium Dally Laurel Way Saffiano Leather Tote Shoulder Bag Purse Handbag, Color Block Pink Black",
        "ASIN": "B07NVYMNDZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31vdTNbgyZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 197.52,
        "UploadTime": " February 18, 2019",
        "Id": 674,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ALAZA Moon Face Star Tote Top Handle Shoulder Bags Large Handbags for Women Ladies L",
        "ASIN": "B079FQK32H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519JIw5ZGNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 30, 2018",
        "Id": 675,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 0,
        "Title": "USA Handmade Fashion Doctor Bag Satchel Style\"MONSTERS HORROR MOVIES\" PATTERN & GREEN SHINY FABRIC Purse, NEW, DRB 1308-J",
        "ASIN": "B00NUBYF9S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51fgwYLkdeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 68,
        "UploadTime": " September 23, 2014",
        "Id": 685,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 4,
        "PriceMax": 0,
        "ReviewItem5": 81,
        "Title": "COACH Women's Pebbled Leather Edie 31 Shoulder Bag",
        "ASIN": "B07FKP5YQD",
        "ReviewItem3": 4,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41S0FdJe-vL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 9, 2018",
        "Id": 676,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Women's Handbags & Purses",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "BallPark Leather XL White Baseball MOM Canvas Tote Bag",
        "ASIN": "B0779DZKQR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lYlAyBYHL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 677,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 218,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke Pembrook Allison Crossbody Shoulder Bag WINE",
        "ASIN": "B0732RNT1S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ujsHSmNXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 218,
        "UploadTime": " April 23, 2018",
        "Id": 678,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 100,
        "Title": "Beast the Rat Terrier Tote Bag by Pet Studio Art",
        "ASIN": "B00GU78TL4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZW9r6tumL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " June 29, 2013",
        "Id": 679,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 67,
        "Title": "Janeyer Women's 6 Piece Lattice Tote Hobo Bag Handbag Wallet Rucksack Set",
        "ASIN": "B06XSVNG6T",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ocR6rEPJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 23, 2017",
        "Id": 690,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Wewo 6 Pcs/Set Women Handbag Canvas Satchel Bag Lady Shoulder Bag",
        "ASIN": "B07KN2PPFH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41idMdoqoIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 24, 2019",
        "Id": 680,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.5,
        "ReviewItem5": 0,
        "Title": "Chala Fat Cat Mini Crossbody Handbag - Convertible Strap, Cat Lovers Cat Mom",
        "ASIN": "B07PPBY5QS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514OHzVhgjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.5,
        "UploadTime": " March 12, 2019",
        "Id": 681,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 9,
        "PriceMax": 69.99,
        "ReviewItem5": 73,
        "Title": "Cluci Handbags for Women Clearance Leather Designer Purse Tote Crossbody Shoulder Bags Crocodile Black",
        "ASIN": "B018E805RW",
        "ReviewItem3": 0,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HFj6mRBML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "UploadTime": " September 10, 2016",
        "Id": 682,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "It's a Robotics Thing - Robot Gift - Fashion Zip Tote Bag",
        "ASIN": "B07JM9SFTL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pli6zd0cL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " October 22, 2018",
        "Id": 683,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 37.95,
        "ReviewItem5": 82,
        "Title": "Style Strategy Hobo Bag, Extra Large Size, Carries Up to 25 Lbs",
        "ASIN": "B07FXP6BRM",
        "ReviewItem3": 0,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kT9Tl819L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29,
        "UploadTime": " June 6, 2017",
        "Id": 684,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 14,
        "ReviewItem2": 4,
        "PriceMax": 17.95,
        "ReviewItem5": 63,
        "Title": "Gelante Genuine Full Grain Leather Belt Strap without Belt Buckle",
        "ASIN": "B01M0RL7U4",
        "ReviewItem3": 6,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BPLDhVv3L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.95,
        "UploadTime": " September 14, 2016",
        "Id": 686,
        "ReviewCount": 357
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "Guess Hwvy6781070, Women’s Top-Handle Bag, Black (Nero), 20x29x38 cm (W x H L)",
        "ASIN": "B07233X2DB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nBUYkw7wL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " September 10, 2018",
        "Id": 687,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 81,
        "Title": "5PCS Fashion Bag Scarf Handbag Handle Ribbon Scarf for Women's Package Band Bracelet Hair Head",
        "ASIN": "B07GVLGTLW",
        "ReviewItem3": 0,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ISGp0YdiL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " September 3, 2018",
        "Id": 688,
        "ReviewCount": 43
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 18,
        "ReviewItem2": 0,
        "PriceMax": 94.96,
        "ReviewItem5": 76,
        "Title": "Coach Outlined Zip File Crossbody",
        "ASIN": "B07DWNNKPM",
        "ReviewItem3": 6,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iL7XhRikL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 94.96,
        "UploadTime": " June 21, 2018",
        "Id": 689,
        "ReviewCount": 17
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 92,
        "Title": "Pacsafe Metrosafe LS100 3 Liter Anti Theft Shoulder Bag - Fits 7 inch Tablet",
        "ASIN": "B06Y6KM5XC",
        "ReviewItem3": 0,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Nrm%2BTRN0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " July 19, 2017",
        "Id": 691,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Big-time Straw Beach Bag, Flamingo Woven Handbag Embroidery Straw Braided Bag Holiday Woven Beach Sling Bag Tote Bag for Summer",
        "ASIN": "B07F9Y6NDL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Py9Dnj%2BOL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 692,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "GUESS Women's Bandon Cross-Body Bag",
        "ASIN": "B01EIGAE02",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31w9cuyJP%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " September 3, 2016",
        "Id": 693,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 2.94,
        "ReviewItem5": 0,
        "Title": "Rakkiss Women Shoulder Bag Retro Leather Solid Color Messenger Bag Lightweight Thin Shoulder Strap Crossbody Bag",
        "ASIN": "B07MDX3SNR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VEpG6O-%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 2.94,
        "UploadTime": " January 2, 2019",
        "Id": 694,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 395,
        "ReviewItem5": 100,
        "Title": "COACH Women's Edie 31 Shoulder Bag in Signature Leather",
        "ASIN": "B07CP2SXWK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415DqcAB56L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 395,
        "UploadTime": " September 28, 2018",
        "Id": 695,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30.99,
        "ReviewItem5": 0,
        "Title": "Rain's Pan Anime Danganronpa Monokuma Black and White Bear Short PU Bifold Wallet Purse",
        "ASIN": "B071SDRHTS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zYCVLcpxL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.99,
        "UploadTime": " May 23, 2017",
        "Id": 704,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 18,
        "ReviewItem2": 0,
        "PriceMax": 44.99,
        "ReviewItem5": 71,
        "Title": "Crossbody Bag for Women Genuine Leather Top Handle Tote Purses Vintage Satchels Handbag",
        "ASIN": "B07CT9R443",
        "ReviewItem3": 7,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51A6J4RKS5L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.99,
        "UploadTime": " May 2, 2018",
        "Id": 696,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.95,
        "ReviewItem5": 0,
        "Title": "Custom Embroidered Shoulder Tote Bag - Personalized Monogrammed Tote by Printualist",
        "ASIN": "B07HP8KVDY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NChYp4LAL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.95,
        "Id": 697,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Teacher Peach Monogram Canvas Tote Bag (11 Letters Available)",
        "ASIN": "B07FK4FQ48",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BmvJTca-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " July 12, 2018",
        "Id": 698,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "MKP Women's Satchel handbag~Stylist Structured Multi Pocket Top handle purse with Wristlet",
        "ASIN": "B07J6JGRS5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ngVWpLKWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " September 24, 2018",
        "Id": 699,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Myra Bag Adventure Begins Upcycled Canvas Wristlet Bag S-1020",
        "ASIN": "B07DQR85BW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lorzd9xIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 14, 2018",
        "Id": 700,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 114,
        "ReviewItem5": 0,
        "Title": "Rimen & Co. Genuine Leather Studded Design Décor Speedy Bag Accented with Removable Strap 150355",
        "ASIN": "B01J97GIWI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BhjC-ZHSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 114,
        "UploadTime": " July 28, 2016",
        "Id": 701,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Gucci GG Marmont Matelassé Leather Super Mini Bag Handbag Article: ‎476433 DSVRT 1000",
        "ASIN": "B01DZW52Z2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516Ry-UbqGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 8, 2016",
        "Id": 702,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "SWANKYSWANS Valena Faux Sankeskin Envelope Clutch Bag",
        "ASIN": "B07JPJ4GV7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kmpSOFfjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " November 14, 2018",
        "Id": 703,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 5,
        "ReviewItem2": 3,
        "PriceMax": 0,
        "ReviewItem5": 67,
        "Title": "Let the Fun Begin Large Nylon Tote Bag",
        "ASIN": "B0029SP3WG",
        "ReviewItem3": 8,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LqMGc8QyL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 705,
        "ReviewCount": 63
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 11,
        "ReviewItem2": 6,
        "PriceMax": 26.54,
        "ReviewItem5": 54,
        "Title": "Buxton Heiress French Purse Wallet",
        "ASIN": "B00488TTHU",
        "ReviewItem3": 13,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HXkd7fHmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.54,
        "UploadTime": " October 21, 2010",
        "Id": 706,
        "ReviewCount": 435
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45.99,
        "ReviewItem5": 83,
        "Title": "FOXER Women Leather Crossbody Bag Small Crossbody Purse Shoulder Bag Valentine's Day Gift",
        "ASIN": "B07H18J596",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NO210j5tL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.99,
        "UploadTime": " December 25, 2017",
        "Id": 707,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 178.99,
        "ReviewItem5": 0,
        "Title": "Michael Kors Portia Small EW Leather Satchel Crossbody Bag in Black",
        "ASIN": "B07CVQMQ7S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4118dzdmkHL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 178.99,
        "UploadTime": " January 4, 2018",
        "Id": 708,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "leather handbags women large bags Female woman's Shoulder Bag Ladies Messenger Crossbody Bag Totes 6017",
        "ASIN": "B077JRS2GN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51b2s7b2G-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 15, 2017",
        "Id": 709,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bumblebee Seamless Pattern Vertical Crossbody Single Shoulder Bag Lightweight Bag With Adjustable Strap Travelling Bag Unisex",
        "ASIN": "B07RB3VT2Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4135K2bhKhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 30, 2019",
        "Id": 711,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.8,
        "ReviewItem5": 100,
        "Title": "Mfeo Womens High-Capacity Interlayer Canvas Handbag Top-Handle Shoulder Bag Tote",
        "ASIN": "B07CPR9QCC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ut9RP2LOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.8,
        "UploadTime": " November 18, 2016",
        "Id": 712,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 65.6,
        "ReviewItem5": 0,
        "Title": "Jessica Simpson Ryanne Top Zip Tote",
        "ASIN": "B07B9H5WWB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zIdXFX6SL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 65.6,
        "UploadTime": " June 23, 2018",
        "Id": 713,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 100,
        "Title": "Black Mother Of The Groom Crystal Wedding Favour Tote Bags personalised bridal hen party gift bags",
        "ASIN": "B01E71CSJ8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31T0h4tbhuL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 714,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "SimpleLif Purse Buckle Twist Lock Hardware for Bag Shape Handbag DIY Turn Locks Bags Clasp",
        "ASIN": "B07PYF7YZR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41avVWYZAAL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 715,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Money Clips",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.35,
        "ReviewItem5": 0,
        "Title": "Rhodium-plated Kelly Waters Golf Bag Hinged Money Clip",
        "ASIN": "B07G717DZX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vvEr9ntXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.35,
        "UploadTime": " August 6, 2018",
        "Id": 716,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18,
        "ReviewItem5": 0,
        "Title": "Purse Collection Beautiful Traditional Designer Red Colured Polti Purse For Womens",
        "ASIN": "B07C8B979K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ywkm4BwZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18,
        "UploadTime": " April 12, 2018",
        "Id": 717,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 129.99,
        "ReviewItem5": 0,
        "Title": "Daimanbo Women Fashion Elegant Imported Real Leather Handbag",
        "ASIN": "B07C6J2B5G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sJYilLSfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 129.99,
        "UploadTime": " April 16, 2018",
        "Id": 718,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 154.34,
        "ReviewItem5": 0,
        "Title": "BREE Women’s Toulouse 2 Cross-Body Bag UK One Size",
        "ASIN": "B06XC9H8D7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417-EPttEkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 154.34,
        "UploadTime": " September 10, 2018",
        "Id": 719,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 86.99,
        "ReviewItem5": 0,
        "Title": "Yamako \"Aisibu-zome\" SFP Shoulder bag 85257 from Japan",
        "ASIN": "B07BP2MGWC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MhiCy6-qL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 86.99,
        "Id": 721,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 100,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Iconic Small Vera Tote, Denim",
        "ASIN": "B07GRBB632",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WOXxTpl6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 100,
        "UploadTime": " December 11, 2018",
        "Id": 722,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 100,
        "Title": "Claire's Club Girl's Claire's Club Starbright the Unicorn Rainbow Unicorn Sequin Purse - S",
        "ASIN": "B07HBT2881",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wQ%2BH8g9YL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " September 14, 2018",
        "Id": 723,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 12,
        "PriceMax": 39.88,
        "ReviewItem5": 25,
        "Title": "Goodbag Lady Patent Leather Handbag Satchel Tote Handbag Top Handle Bag",
        "ASIN": "B0775QBNX1",
        "ReviewItem3": 38,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bSQEP9nvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.88,
        "UploadTime": " November 3, 2017",
        "Id": 724,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 0,
        "PriceMax": 61.6,
        "ReviewItem5": 78,
        "Title": "Jessica Simpson Selena Top Zip Xbody",
        "ASIN": "B078GW24WQ",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51AtV0P8eQL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 61.6,
        "UploadTime": " February 10, 2018",
        "Id": 725,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.88,
        "ReviewItem5": 0,
        "Title": "Women Bucket Purses Hand Bag Anti Theft Crossbody Purse Zipper HoBo Designer Shoulder Bag - YONBEN",
        "ASIN": "B07GQK52M8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31CrN%2BLSVsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.88,
        "UploadTime": " August 21, 2018",
        "Id": 726,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.87,
        "ReviewItem5": 0,
        "Title": "Tom Tailor Women's Marit bag",
        "ASIN": "B079NPDZXM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YvGWusiHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.87,
        "UploadTime": " September 10, 2018",
        "Id": 727,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 629.99,
        "ReviewItem5": 0,
        "Title": "Dolce & Gabbana 100% Leather Black Women's Crossbody Bag",
        "ASIN": "B07LGDJKQB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31RELS1%2BE4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 629.99,
        "UploadTime": " November 8, 2018",
        "Id": 728,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 128,
        "ReviewItem5": 0,
        "Title": "Women's Patent Leather Litchi Grain Handbags Top Handle Bag",
        "ASIN": "B07BTPBC5J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zbV-CcF1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 128,
        "UploadTime": " December 23, 2018",
        "Id": 729,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40,
        "ReviewItem5": 0,
        "Title": "COSIMA LEONE - Bag model ANTONIETTA",
        "ASIN": "B079TTJP89",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MlD2tR06L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40,
        "UploadTime": " February 15, 2018",
        "Id": 730,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 5,
        "ReviewItem2": 2,
        "PriceMax": 17.99,
        "ReviewItem5": 79,
        "Title": "Wallet for Women Leather Designer Bifold Long Ladies Credit Card Holder Organizer Ladies Clutch",
        "ASIN": "B07D9HGHBV",
        "ReviewItem3": 4,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512OQK5BxCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " May 25, 2018",
        "Id": 731,
        "ReviewCount": 547
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 76.6,
        "ReviewItem5": 0,
        "Title": "Fiorelli Womens Archer Shoulder Bag",
        "ASIN": "B072F3NZZ7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YZTvFJ9BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 76.6,
        "UploadTime": " August 29, 2017",
        "Id": 732,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 22,
        "ReviewItem2": 0,
        "PriceMax": 89.99,
        "ReviewItem5": 67,
        "Title": "Miuco Womens Acrylic Handbag Handmade Ark Clutch Purse",
        "ASIN": "B07DK9Q4WY",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HQgXrEK2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.99,
        "UploadTime": " June 6, 2018",
        "Id": 733,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Cori Small Leather Trunk Bag - Bright Red",
        "ASIN": "B077YVCH6B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ed38kNn%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 6, 2017",
        "Id": 794,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Women Large Handbag 2pcs Tote Purse Set Top Handle Shoulder Handbag",
        "ASIN": "B07P7VCBJ2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51o79nt2iNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " February 27, 2019",
        "Id": 734,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.95,
        "ReviewItem5": 0,
        "Title": "Boho Chick Crossbody Shoulder Bag Woven Tribal Pattern",
        "ASIN": "B078YCMQBY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oZi%2B6d0XL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " January 11, 2018",
        "Id": 735,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Chicca Borse Woman Handbag with Floreal Fantasy Genuine Leather made in Italy",
        "ASIN": "B06WD854JC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Z4xfunLmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 20, 2017",
        "Id": 736,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Vince Camuto Lux Piece",
        "ASIN": "B07FKJHSQY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51r4dgZTshL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 25, 2019",
        "Id": 737,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Top Handle Satchel HandBags Shoulder Bags Tote Bags Purse",
        "ASIN": "B07M5WDPKX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zkPTRFbOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " December 25, 2018",
        "Id": 811,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 63,
        "Title": "Contacts Genuine Leather Mens Zipper Around Long Wallet Coin Clutch Purse Red-Brown",
        "ASIN": "B00V5X3A6M",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZcrW-C-JL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " January 9, 2016",
        "Id": 738,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.79,
        "ReviewItem5": 0,
        "Title": "Fabuxry Women Nylon Shoulder Bags Cross Body Handabgs Travel Purses",
        "ASIN": "B07FDZGLRQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Pt3BFGa5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.79,
        "UploadTime": " July 2, 2018",
        "Id": 739,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 135.41,
        "ReviewItem5": 0,
        "Title": "Vince Camuto Areli Tote",
        "ASIN": "B06XKM7DJ6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4102-qYoPnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 135.41,
        "UploadTime": " September 30, 2017",
        "Id": 740,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.95,
        "ReviewItem5": 0,
        "Title": "Kendall + Kylie Veronica Womens Handbag Natural",
        "ASIN": "B07DMT44QJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mJTcfWEuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.95,
        "UploadTime": " March 22, 2017",
        "Id": 741,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "TORY BURCH Britten Fold over Crossbody Bag Leather Women's Handbag (Black)",
        "ASIN": "B07DCGG1FV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zhlCHHFRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 28, 2018",
        "Id": 742,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.99,
        "ReviewItem5": 0,
        "Title": "Womens Handbags Handmade Black Acrylic Beaded Tote Bags Clutch Wedding Purse",
        "ASIN": "B07PR9NB3J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oPRzSbJ7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.99,
        "UploadTime": " March 18, 2019",
        "Id": 743,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.98,
        "ReviewItem5": 0,
        "Title": "Handbags for Women - Bageek Satchel Bag Vogue Top Handle Bag PU Leather Purses",
        "ASIN": "B078W1Q27F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OW%2BiBvKaL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.98,
        "Id": 744,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.57,
        "ReviewItem5": 0,
        "Title": "Chicca Borse, Women’s Tote Bag, Black (Nero), 39 cm (39 cm)",
        "ASIN": "B00LVVSUDG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416AmBVpgQL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 64.57,
        "UploadTime": " May 1, 2018",
        "Id": 2971,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29,
        "ReviewItem5": 0,
        "Title": "Imoshion Women's Brown-Comco Faux Leather Designer Striped Pieced Bucket Bag with Adjustable Crossbody Strap And Drawstring Closure",
        "ASIN": "B0769WC7RG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Qmz5ghd4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29,
        "UploadTime": " October 9, 2017",
        "Id": 745,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "President Trump 2020 Flag Tee Party Republican Political Election Design - Fashion Zip Tote Bag",
        "ASIN": "B07PK259NV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zL1mRo84L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " October 29, 2018",
        "Id": 746,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Alins Wide Shoulder Strap Replacement Adjustable 1.5\" Canvas Strap with Black Leather for Crossbody Bag Handbags Purse",
        "ASIN": "B07MLNYNQ4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ucBmkzW1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " January 6, 2019",
        "Id": 747,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 92,
        "Title": "Adjustable Handbag Purse Strap Replacement Strap Crossbody Strap",
        "ASIN": "B07DR8B4WT",
        "ReviewItem3": 8,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Z%2BpWTfMAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " June 14, 2018",
        "Id": 749,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 4,
        "PriceMax": 0,
        "ReviewItem5": 74,
        "Title": "Baggallini Womens Walkabout Crossbody",
        "ASIN": "B01KKCDPMC",
        "ReviewItem3": 13,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DM24kmUCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 20, 2017",
        "Id": 750,
        "ReviewCount": 23
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.97,
        "ReviewItem5": 0,
        "Title": "Jili Online 2017 Women Jute Burlap Lace Flower Wallet Wedding Cheongsam Clutch Bag Purse",
        "ASIN": "B06Y2D75TZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51utZea3Q%2BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.97,
        "UploadTime": " April 5, 2017",
        "Id": 751,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.76,
        "ReviewItem5": 0,
        "Title": "Nathan NS7702-0344-35 The Zipster Running Waist Packs, Amaranth, X-Large",
        "ASIN": "B077ZJX2C6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/311wmJ0wdbL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.76,
        "Id": 752,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 422,
        "ReviewItem5": 0,
        "Title": "Patrizia Pepe Women's 2V8470A4U8R626 Red Leather Handbag",
        "ASIN": "B07Q8CGFLY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31FSX4O6xVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 422,
        "UploadTime": " April 2, 2019",
        "Id": 753,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 46.26,
        "ReviewItem5": 0,
        "Title": "Dune Womens Etta Cross-Body Bag",
        "ASIN": "B07BJ2QW49",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41i5K5fL5IL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 46.26,
        "UploadTime": " May 2, 2018",
        "Id": 754,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Robe di Firenze Italian Made Red Organically Treated Leather Large Tote Handbag",
        "ASIN": "B01G7QX23M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DqWu9UwsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 26, 2016",
        "Id": 755,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Joqixon Canvas Crossbody Bag, Crossbody Purse for Women, Zipper Pocket Lightweight Shoulder Bag for Women",
        "ASIN": "B07PVJ8GQN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/3131zwcppoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " March 21, 2019",
        "Id": 756,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 34,
        "Title": "Double-zip Wristlet Wallet Leather Clutch Purse Cellphone Wallet with Chain Strap for Women Ladies Girls",
        "ASIN": "B07FC99Z82",
        "ReviewItem3": 33,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ufUT3XD0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " August 28, 2018",
        "Id": 757,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "LV Louis Vuitton Alma BB - Bag Base Shaper 1/8” Clear Acrylic",
        "ASIN": "B07MQ3M9T9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31c9yHEz-FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 13, 2018",
        "Id": 842,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Emporio Armani Borsa Tracolla Minidol + Aquila Womens Cross Body Bag Grey",
        "ASIN": "B07NY56C4V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51AySYsy8GL._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 8785,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.95,
        "ReviewItem5": 0,
        "Title": "CafePress - Life Isn't About Waiting For The Storm To Pass Tot - Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00QQRXXI2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mboe9zoNL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.95,
        "Id": 758,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 137,
        "ReviewItem5": 0,
        "Title": "Botkier Womens Trigger Leather Metallic Saddle Handbag Blue Small",
        "ASIN": "B01C8SM4V4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/312DhBpPIWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 137,
        "UploadTime": " March 18, 2016",
        "Id": 759,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cuff Links",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Emerald Green Swarovski Crystal Gem Stone Mens Gift Cuff links by CUFFLINKS DIRECT",
        "ASIN": "B079SJQ4Z7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51x15rd9dFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " January 26, 2018",
        "Id": 760,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Car Key Genuine Leather Bag Metal Hook Chain Holder Wallet Men",
        "ASIN": "B07GVFXJHS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BIkXSXvWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " August 27, 2018",
        "Id": 761,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 28,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 29,
        "Title": "OURBAG Men's Business Leather Zip Clutch Long Wallet Purse Credit Card Holder",
        "ASIN": "B01LXD9Q36",
        "ReviewItem3": 14,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51F4p7-MfGL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " September 29, 2016",
        "Id": 762,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Hats & Caps",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17,
        "ReviewItem5": 0,
        "Title": "MALKELIN Pantera-Logo-Dimebag-Darrell-Thrash-Metal-Metallica- menâ€s caps Band Cool Strapback Hat",
        "ASIN": "B07NQ9VPQN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5174GJmIWBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17,
        "UploadTime": " February 14, 2019",
        "Id": 763,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 126.64,
        "ReviewItem5": 0,
        "Title": "HIDESIGN Kester Women's Work Bag",
        "ASIN": "B00XCE5BVE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61gssiyt99L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 126.64,
        "UploadTime": " May 8, 2015",
        "Id": 764,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "camo mossy oak buckle gun rhinestone blue pink brown purse set",
        "ASIN": "B06XZ9MTVL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418zr5lAmoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " March 15, 2017",
        "Id": 765,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.55,
        "ReviewItem5": 0,
        "Title": "Marco Tozzi Women's 61010-21 Cross-Body Bag",
        "ASIN": "B07D7QN1QM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4177HBoJpVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.55,
        "UploadTime": " October 4, 2018",
        "Id": 766,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 100,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "QZUnique Women's PU Leather Crossbody Bag Bucket Handbag Shoulder Bag Tassel Tote Bags",
        "ASIN": "B077K1F95L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ua2YIf9rL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " November 17, 2017",
        "Id": 767,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 0,
        "PriceMax": 30.49,
        "ReviewItem5": 71,
        "Title": "NOVICA Multicolored Embroidered and Applique Cotton Blend Shoulder Bag, Tropical Paradise'",
        "ASIN": "B016P2STMW",
        "ReviewItem3": 13,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HCnJOZPPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.49,
        "UploadTime": " October 15, 2015",
        "Id": 768,
        "ReviewCount": 31
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 205.49,
        "ReviewItem5": 64,
        "Title": "Patricia Nash Camila 2 Zip Hobo",
        "ASIN": "B01MSPP4N9",
        "ReviewItem3": 18,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61H6iedYBoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 205.49,
        "UploadTime": " December 11, 2016",
        "Id": 769,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 4,
        "PriceMax": 28.99,
        "ReviewItem5": 67,
        "Title": "Handbags for women totes Hobo Shoulder Bags Tassels Stripes Top Handle Bags",
        "ASIN": "B0748FSF7N",
        "ReviewItem3": 6,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cfEI8NrKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "UploadTime": " July 26, 2017",
        "Id": 770,
        "ReviewCount": 171
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Jenele Python Embossed Pattern Faux Leather Tote Shoulder Hand Bag",
        "ASIN": "B01FIQ91UA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TKotG7tZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " May 11, 2016",
        "Id": 771,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54,
        "ReviewItem5": 0,
        "Title": "Full Grain Leather Black Men's bi-fold Wallet Excellent quality Leather Goods Handmade in Latvia Gift for Men from Tailor Riga",
        "ASIN": "B07GYXV8ST",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31OzxfjBz3L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54,
        "UploadTime": " August 30, 2018",
        "Id": 772,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 116.82,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Elaine Signature North/South Flap Over Tote",
        "ASIN": "B07HYTGB1K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VcDIb3GFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 116.82,
        "UploadTime": " January 28, 2019",
        "Id": 795,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 0,
        "Title": "Circus by Sam Edelman Courtney Satchel",
        "ASIN": "B07L8TX7XZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ymGGNkg7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " April 11, 2019",
        "Id": 2295,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hats & Caps",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.5,
        "ReviewItem5": 0,
        "Title": "Columbia Unisex Bora Bora II Booney Hat, Moisture Wicking Fabric, UV Sun Protection",
        "ASIN": "B0058YU2DS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31D643kz9eL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.5,
        "Id": 773,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 11,
        "PriceMax": 18.99,
        "ReviewItem5": 67,
        "Title": "Tassel Crossbody Bags for Women Girls Vintage Hollow Small Crossbody Purse Shoulder Bag",
        "ASIN": "B07DNV8B7C",
        "ReviewItem3": 11,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51na%2BRDvL5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " June 22, 2018",
        "Id": 774,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Base Shaper 1/8” Thick Clear Acrylic for Custom Size Handmade Crystal Clear Base Shaper Liner for Any Hand Bag Tote Purse, Handbag, Insert, Plexiglas, Plexiglass Bottom, Plastic",
        "ASIN": "B07DDKCZZ1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Vd1nxPhsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 13, 2018",
        "Id": 775,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 58.78,
        "ReviewItem5": 0,
        "Title": "RuMe Bags Aura Handbag",
        "ASIN": "B07DB87TTB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512WEh1WRkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58.78,
        "UploadTime": " June 22, 2018",
        "Id": 776,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 177.1,
        "ReviewItem5": 0,
        "Title": "Coach Women's Dark Gunmetal Dahila Mini Crossbody Carryall In Floral Rivets Leather, Style F37707",
        "ASIN": "B07C39YYCH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NAXho66FL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 177.1,
        "Id": 789,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 84,
        "Title": "Deluxe Canvas Shopping Tote Bag/Reusable Grocery Tote Bag/Colorful Tote Bag, Blue",
        "ASIN": "B0062CGM3Y",
        "ReviewItem3": 8,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41knmWv6qhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " November 1, 2011",
        "Id": 790,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 95,
        "ReviewItem5": 0,
        "Title": "Under Armour Hustle II Storm Laptop Backpack (One Size, Midnight-Navy)",
        "ASIN": "B01MCRJY6U",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gT2X430aL._SS40_.jpg",
        "AcquisitionTime": 1558022400000,
        "Price": "[]",
        "PriceMin": 95,
        "Id": 12308,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "YIICOOLY Felt Backpack Organizer Insert,Purse Organizer for Men Women Backpack Rucksack Handbag Shoulder Bag",
        "ASIN": "B07QLPTL7N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518ybb3jdrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " April 16, 2019",
        "Id": 777,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sandals",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.9,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Summer Men's Slippers Outdoor & Indoor Sandals Mix Flip Flops",
        "ASIN": "B07M9CF18P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41O%2BWISqYPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.9,
        "UploadTime": " December 28, 2018",
        "Id": 778,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Calvin Klein Key Item Raelynn Monogram Top Zip Satchel",
        "ASIN": "B079P6FK5H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51c9rYLjdhL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 10, 2018",
        "Id": 779,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 38.77,
        "ReviewItem5": 0,
        "Title": "Diamond Geometric Shopping Bag for Women Top Hanfbag Large Size Split Joint Shoulder Bag",
        "ASIN": "B0749QFGTB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Yl6eBXx5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.77,
        "UploadTime": " July 27, 2017",
        "Id": 780,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 245,
        "ReviewItem5": 100,
        "Title": "Bed Stu Women's Stevie",
        "ASIN": "B00E91B7X0",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CqEVFd4UL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 245,
        "UploadTime": " December 16, 2013",
        "Id": 2296,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 58.75,
        "ReviewItem5": 0,
        "Title": "Travel Shoulder Bag for Women, Brenice Embossed Flower Handbag Vintage Crossbody Bag",
        "ASIN": "B07GVG37VT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51m0NrJps0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58.75,
        "UploadTime": " August 27, 2018",
        "Id": 781,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.85,
        "ReviewItem5": 57,
        "Title": "The Fix Courtney O Ring Feather Cross-Body Bag",
        "ASIN": "B074CTC35Q",
        "ReviewItem3": 0,
        "ReviewItem4": 43,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410t7wqDIoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.85,
        "UploadTime": " November 14, 2017",
        "Id": 782,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Western Embroidered Boot Studded Cross Body Purse Messenger Bag",
        "ASIN": "B01GH3VL60",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-Q0V8kGbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " February 7, 2017",
        "Id": 783,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Purse Organizer Insert for LV Totally Handbag - Fits inside Louis Vuitton Totally bag - Thick Wool Blend Felt",
        "ASIN": "B07QFHKDFB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NDyNm7oqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " January 9, 2019",
        "Id": 784,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.6,
        "ReviewItem5": 0,
        "Title": "Nicole Miller New York Black Lena Crossbody Handbag",
        "ASIN": "B07259YH4Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NX4JKN3oL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.6,
        "UploadTime": " April 27, 2017",
        "Id": 785,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Diamond Geometric Shopping Bag for Women Top Hanfbag Large Size Split Joint Shoulder Bag",
        "ASIN": "B0749QQGSN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51C9k8aHzoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 27, 2017",
        "Id": 786,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.23,
        "ReviewItem5": 0,
        "Title": "Marco Tozzi Women's 61011-21 Cross-body Bag",
        "ASIN": "B07D7QN1S7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jaok6PoHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.23,
        "UploadTime": " September 8, 2018",
        "Id": 787,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Gabrine Womens Evening Envelop Bag Handbag Clutch Purse Shiny Sequins Fabric Material for Wedding Party Prom",
        "ASIN": "B077FHCWV8",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gwcDe3stL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " November 13, 2017",
        "Id": 791,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.89,
        "ReviewItem5": 0,
        "Title": "Genuine Leather Bifold Zip-around Wallet For Men Multi-Card Holder Purse Zipper Coin Pocket Wallet Men Zip Wallet（2 Bill Compartments & ID Window)",
        "ASIN": "B07QFQN84Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tNeU8AbOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.89,
        "UploadTime": " April 8, 2019",
        "Id": 792,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.24,
        "ReviewItem5": 0,
        "Title": "RGBIWCO - Women Backpack Purse Fashion Shoulder Bag Anti-theft Lightweight School Shoulder Bag",
        "ASIN": "B07R4X713D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417IOZl-JVL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.24,
        "Id": 793,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sun Hats",
        "ReviewItem1": 0,
        "ReviewItem2": 8,
        "PriceMax": 34.95,
        "ReviewItem5": 67,
        "Title": "Palmoro The Original Golf Gambler Moreno Palm Straw Sun Hat",
        "ASIN": "B01MTZW8P9",
        "ReviewItem3": 8,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JF0WgAHwL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.95,
        "UploadTime": " December 1, 2016",
        "Id": 796,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.99,
        "ReviewItem5": 0,
        "Title": "Mayshe Woven Crossbody Straw Beach Bucket Summer Fashion Vacation Women Top Handle Handbag",
        "ASIN": "B07Q1P4ZJS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iv5ASCpiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.99,
        "UploadTime": " March 19, 2019",
        "Id": 797,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.99,
        "ReviewItem5": 0,
        "Title": "Rubysports Women Fashion Claissic Hand Bags Casual Purse Satchel Tote for Work",
        "ASIN": "B01N9QHL9B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xGDdrhDdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.99,
        "UploadTime": " January 11, 2017",
        "Id": 798,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "YALUXE Women's Cowhide Leather Purse Tote Shoulder Bag Hobo Handbag black",
        "ASIN": "B07CXLFMYS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wa%2BRFQgVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 7, 2018",
        "Id": 799,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 145,
        "ReviewItem5": 0,
        "Title": "Mar Y Sol Tybee Striped Market Tote Bag Pom Pom, Natural/Navy",
        "ASIN": "B07FK4DJQF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51n3mCKb62L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 145,
        "UploadTime": " September 26, 2017",
        "Id": 800,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Bridesmaid Glitter Tote Bag - Black and Silver",
        "ASIN": "B06XYWPBFK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41a9flsPUfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " February 17, 2017",
        "Id": 801,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Women Backpack, E Ekphero Waterproof Lightweight Nylon Multi Shoulder Bag",
        "ASIN": "B07BGWTHYF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51j1zHL%2B5qL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " March 15, 2018",
        "Id": 802,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 130,
        "ReviewItem5": 0,
        "Title": "Longchamp Le Pliage Large Travel Bag",
        "ASIN": "B00UVH4Z44",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Bs%2BW45hOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 130,
        "UploadTime": " March 1, 2016",
        "Id": 803,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 23,
        "ReviewItem2": 15,
        "PriceMax": 11.99,
        "ReviewItem5": 31,
        "Title": "uxcell Women Mini Woven Crossbody Saddle Bags",
        "ASIN": "B013GAC724",
        "ReviewItem3": 23,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CcXi777BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " July 28, 2015",
        "Id": 804,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Teaching is a work of Heart Teacher Education Canvas Tote Bag",
        "ASIN": "B06Y1W9BQ8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41v%2BXSVSe1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 4, 2017",
        "Id": 805,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13,
        "ReviewItem5": 67,
        "Title": "Unisex Pro Excursion Organizer Shoulder Bag Day Pack",
        "ASIN": "B07F47FRT1",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/3128GQVmyKL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13,
        "UploadTime": " June 29, 2018",
        "Id": 824,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 16,
        "PriceMax": 35.99,
        "ReviewItem5": 50,
        "Title": "Women Real Suede Leather Small Shoulder Bag Brand Female Leisure Crossbody Handbag …",
        "ASIN": "B077HQP9LV",
        "ReviewItem3": 17,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413iY08yOXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " November 15, 2017",
        "Id": 806,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Damara Ladies Party Glitter Rhinestone Evening Clutch Purse",
        "ASIN": "B01M8FB14I",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5119L0fFElL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " October 8, 2016",
        "Id": 807,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 31.99,
        "ReviewItem5": 74,
        "Title": "Cute Women Backpack Purse PU Leather Mini Convertible Shoulder Bag Square Rucksack Handbag Purse Vintage Satchel Bags",
        "ASIN": "B07CZ5W84N",
        "ReviewItem3": 4,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VjDaoIZ5L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " May 9, 2018",
        "Id": 808,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Old Navy Faux Leather Crossbody Bag One Size-Cognac brown",
        "ASIN": "B00WBRYYWK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41l7hTfSqjL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 809,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.82,
        "ReviewItem5": 0,
        "Title": "Vintage Half Circle Straw Bag Rattan Woven Handbag Ladies Messenger Beach Bags",
        "ASIN": "B07PP5J6C5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UHwvwF5ZL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.82,
        "Id": 812,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "Womens Leather Crossbody Bag Fashion Cross Body Shoulder Bag Handbag with One Chain Strap",
        "ASIN": "B07RM25LGC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nxKLaUAJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " May 8, 2019",
        "Id": 813,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9,
        "ReviewItem5": 0,
        "Title": "Dongtu Mens Synthetic Leather Wallet Money Pockets Credit/ID Cards Holder Purse 2 Colors Wallets",
        "ASIN": "B07J4Z2DJK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Mj57N40mL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9,
        "UploadTime": " October 7, 2018",
        "Id": 814,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 230,
        "ReviewItem5": 100,
        "Title": "Kate Spade New York Reese Park Small Courtnee Quilted Leather Shoulder Bag",
        "ASIN": "B07HHFLVVS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41knnIKHa4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 230,
        "UploadTime": " January 4, 2019",
        "Id": 815,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 211.22,
        "ReviewItem5": 0,
        "Title": "Kooba Handbags Everette Convertible Cross Body",
        "ASIN": "B01CAKJYQS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41m9Dg5B4xL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 211.22,
        "UploadTime": " May 11, 2016",
        "Id": 825,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.09,
        "ReviewItem5": 0,
        "Title": "Zip Around Women Organizer Wallet PU Clutch Long Purse, Underwater Dolphin",
        "ASIN": "B07KQ15CQY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Sk9wYDk8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.09,
        "UploadTime": " November 20, 2018",
        "Id": 816,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 50,
        "Title": "LABANCA Girls Mini Shoulder Bag Pineapple Bucket Crossbody Bags Chain Drawstring Crossbody Wallet Bag Messenger Purse",
        "ASIN": "B076MDGBR2",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519RzGwtm3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " October 20, 2017",
        "Id": 817,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 6,
        "PriceMax": 26.85,
        "ReviewItem5": 50,
        "Title": "Mily Hologram Tote Shoulder Bag Lightweight Laser PU Leather Purse",
        "ASIN": "B06Y5DW3M4",
        "ReviewItem3": 11,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BE35m1qRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.85,
        "UploadTime": " March 22, 2017",
        "Id": 818,
        "ReviewCount": 18
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.95,
        "ReviewItem5": 0,
        "Title": "Hello Kitty \"Glitter Script\" Mini Purse - black, one size",
        "ASIN": "B0078VYN0W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Nf4sZbxLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.95,
        "UploadTime": " August 14, 2012",
        "Id": 819,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "Lily",
        "ASIN": "B07MDSHN4D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418sUrjR-6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " December 31, 2018",
        "Id": 820,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 197.95,
        "ReviewItem5": 0,
        "Title": "Day & Mood Women's Lee Crossbody",
        "ASIN": "B07H4P4FFF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pm69mfKoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 197.95,
        "UploadTime": " April 5, 2019",
        "Id": 821,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 4,
        "PriceMax": 46.95,
        "ReviewItem5": 74,
        "Title": "Bali Harvest Handwoven Round Woven Ata Rattan Bag Colorful Batik Linen Inside and Flower Pattern (with Genuine Leather Strap)",
        "ASIN": "B07BFTVVXG",
        "ReviewItem3": 8,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hgOIxytmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 46.95,
        "UploadTime": " March 5, 2018",
        "Id": 822,
        "ReviewCount": 51
    }, {
        "Sale": "[]",
        "Category": "Keyrings & Keychains",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 11.99,
        "ReviewItem5": 75,
        "Title": "Linsam PU Leather Plaid Key Car Wallets Car Keychain Key Holder Bag Key Purse Pouch",
        "ASIN": "B01DNYSFO2",
        "ReviewItem3": 6,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511lSxJ9FdL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " March 25, 2018",
        "Id": 823,
        "ReviewCount": 73
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 36,
        "ReviewItem5": 0,
        "Title": "djbnnbbxyl One shoulder slung Shoulder Handbag",
        "ASIN": "B07D2DWD31",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51S%2BL%2BzfTOL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36,
        "Id": 851,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.5,
        "ReviewItem5": 0,
        "Title": "Roma Leathers Gun Concealment Organizer Handbag - Cowhide Leather Pistol case, Detachable Wrist Strap Lockable YKK Zipper",
        "ASIN": "B075G1KB1Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qVfMTC06L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.5,
        "UploadTime": " September 7, 2017",
        "Id": 826,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Alyssa Faux Leather Satchel Padlock Style Shoulder Handbag",
        "ASIN": "B01FIQ8Q38",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aH3NvEP-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 11, 2016",
        "Id": 827,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "KANGOL Cotton Tote Bag for School Work Travel and Shopping Fashionable Shoulder Bag, Eco Friendly Bag Juno 0011 (Dark Navy)",
        "ASIN": "B075HCGXG2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ake%2BO5hPL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " September 9, 2017",
        "Id": 828,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.19,
        "ReviewItem5": 0,
        "Title": "Traditional Handmade Clutch Bag by Indian artists - International Women's Day collection",
        "ASIN": "B06X916MFM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eLCYOstVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.19,
        "UploadTime": " February 10, 2017",
        "Id": 829,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 330.47,
        "ReviewItem5": 0,
        "Title": "LUANA ITALY Marianne Saddle Bag",
        "ASIN": "B076BQBVPM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41utyFhAkkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 330.47,
        "UploadTime": " February 11, 2018",
        "Id": 830,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 84.99,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Turnlock Crossbody Handbag Bandana Swirl (Nomadic Flora)",
        "ASIN": "B074B39PQ4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qP4hUwmdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 84.99,
        "UploadTime": " July 27, 2017",
        "Id": 831,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.89,
        "ReviewItem5": 100,
        "Title": "Freie Liebe Women Clutches Flower Evening Handbag Chain Strap Shoulder Bag",
        "ASIN": "B07L9N6FJD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519xDnnHr5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.89,
        "UploadTime": " December 11, 2018",
        "Id": 832,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18,
        "ReviewItem5": 0,
        "Title": "DEMDACO 16 x 12.5 Inch Canvas & Leatherette Shoulder Tote Bag",
        "ASIN": "B07GC745NQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41e2Lfeq0lL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18,
        "UploadTime": " August 10, 2018",
        "Id": 833,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 318.4,
        "ReviewItem5": 0,
        "Title": "Michael Kors Ciara Studded MD Messenger Handbag bundled with Michael Kors Jet Set Travel Flat Wallet (Optic White)",
        "ASIN": "B07DK7M4Q7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sfeSvmheL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 318.4,
        "UploadTime": " October 23, 2017",
        "Id": 834,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 9,
        "PriceMax": 27.99,
        "ReviewItem5": 68,
        "Title": "Women’s Tote Purses and Handbags Bow Tie Leisure Top-Handle Cross-body Shoulder Bags",
        "ASIN": "B075CHKRR4",
        "ReviewItem3": 9,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412TRT0VO8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " September 4, 2017",
        "Id": 835,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Saint Laurent Kate Monogram YSL Tassel Faux-Crocodile Clutch Bag made in Italy",
        "ASIN": "B07GV4B381",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31xOxqrGhxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 26, 2018",
        "Id": 852,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Monster Truck Birthday Gift with Kids name Dane Boys Present - Fashion Zip Tote Bag",
        "ASIN": "B07Q9QC1J6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MlZXVrWfL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " April 2, 2019",
        "Id": 836,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 305,
        "ReviewItem5": 0,
        "Title": "MARY FRANCES Regal Beagle Beaded Puppy Dog Crossbody Handbag",
        "ASIN": "B07LFK342N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51E2wJ3No1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 305,
        "UploadTime": " December 17, 2018",
        "Id": 837,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "LeahWard Genuine Italian Suede Leather Envelope Clutch Bags Party Wedding Purse Handbag",
        "ASIN": "B06XHS3614",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-Fb9d4PlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 9, 2017",
        "Id": 838,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Damara Womens Prom Party Zipper Large Shoudler Crossbody Bag",
        "ASIN": "B073TVSFYF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41chr07feOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " July 10, 2017",
        "Id": 839,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 875,
        "ReviewItem5": 0,
        "Title": "Salvatore Ferragamo Women's Amy Small Tote",
        "ASIN": "B07DRNWSBM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31YrWoz5rmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 875,
        "UploadTime": " December 20, 2018",
        "Id": 840,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 85,
        "ReviewItem5": 0,
        "Title": "Mary Frances Anchor Yourself Beaded Nautical Theme Crossbody Phone Bag",
        "ASIN": "B07HJGR3B1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/616Y-zKE1iL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 85,
        "UploadTime": " September 20, 2018",
        "Id": 841,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Money Clips",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 127,
        "ReviewItem5": 0,
        "Title": "Polo Ralph Lauren Rugby Vintage Metal Money Clip Wallet Skull Crossbones Silver",
        "ASIN": "B076QKC77Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oURcvtb5L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 127,
        "UploadTime": " October 23, 2017",
        "Id": 843,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.95,
        "ReviewItem5": 0,
        "Title": "Native Tribal Feather Conchos Cross Body Handbags Concealed Carry Purse Country Women Single Shoulder Bag",
        "ASIN": "B07HJTWX4W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/617EjFZb3IL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.95,
        "UploadTime": " September 17, 2018",
        "Id": 844,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "YOLANDO Handbags For Women Large Vegan Leather Top Flap Tote Bag T0006 (Brown)",
        "ASIN": "B076G29D98",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ti0Hvtt9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " April 14, 2017",
        "Id": 845,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Women's Iconic Handbag, Medium, Pink Plaid",
        "ASIN": "B00BV82NUU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oLr5NnMzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " March 16, 2013",
        "Id": 846,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15,
        "ReviewItem5": 0,
        "Title": "Cross Body Bag (black)",
        "ASIN": "B07JWK4HB4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31if-S9mgjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15,
        "UploadTime": " October 18, 2018",
        "Id": 847,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.5,
        "ReviewItem5": 0,
        "Title": "SS JP Mini Black Rhinestone Wings Spiritual Messenger Bag Cross Body Cell Purse",
        "ASIN": "B077G6NK8Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gxFQH9sjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.5,
        "UploadTime": " November 14, 2017",
        "Id": 848,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.19,
        "ReviewItem5": 0,
        "Title": "Myra Bag Black & White Cowhide & Leather Handbag S-1314",
        "ASIN": "B07MTZ2G51",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mB7bZ8GTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.19,
        "UploadTime": " January 16, 2019",
        "Id": 849,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 159.99,
        "ReviewItem5": 0,
        "Title": "Kate Spade Leewood Place Mini Makayla Ladies Blue Leather Satchel PXRU7342440",
        "ASIN": "B07JPC7XG5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413JGQptYKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 159.99,
        "UploadTime": " October 25, 2018",
        "Id": 850,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tory Burch Whipstitch Logo Hobo Bag",
        "ASIN": "B0757S42X7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VpxSLA8QL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 30, 2017",
        "Id": 2317,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tory Burch Half-Moon Pebbled Leather Large Satchel (Sand Dune)",
        "ASIN": "B07DTYZR8N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41G9yARQLJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 18, 2018",
        "Id": 853,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 7,
        "PriceMax": 39.99,
        "ReviewItem5": 51,
        "Title": "S-ZONE Women's Genuine Leather Shoulder Bucket Bag Medium Crossbody Top-handle Purse",
        "ASIN": "B06XR6XT5M",
        "ReviewItem3": 7,
        "ReviewItem4": 30,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KSt34fWoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " December 30, 2016",
        "Id": 854,
        "ReviewCount": 43
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Multipurpose Leather Phone Bag / Card Case - Vintage Leather Flip Wallet - Portable Clutch (brown, 7.9\"7.5\"0.06\")",
        "ASIN": "B078RCXK15",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dnJAk-CPL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " January 1, 2018",
        "Id": 855,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 134,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Mini Kona Patterson Drive Crossbody Bag Pewter Grey",
        "ASIN": "B07KSJQZRQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ggfq7ERuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 134,
        "UploadTime": " November 1, 2018",
        "Id": 884,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 42.99,
        "ReviewItem5": 0,
        "Title": "Ladies Leather Handbag/Shoulder Bag with Detachable Adjustable Shoulder Strap. Side Buckle Design",
        "ASIN": "B00ISS73HY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pTSuzEI5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 42.99,
        "UploadTime": " March 5, 2014",
        "Id": 856,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GWQGZ The New Trend Of Portable Fashion All-Match Satchel Bag Jelly Laser Chain",
        "ASIN": "B07D39B2VV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ehmzoU83L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 15, 2018",
        "Id": 857,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.49,
        "ReviewItem5": 0,
        "Title": "Women Vintage Rattan Handbag Female Bohemian Summer Beach Straw Bags Large Tote SS3032",
        "ASIN": "B07QG8SD9S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UE3jRT%2BcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.49,
        "UploadTime": " April 4, 2019",
        "Id": 858,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 3,
        "PriceMax": 56.98,
        "ReviewItem5": 63,
        "Title": "Mother's Day Gift Women Leather Crossbody Bag Designer Quilted Shoulder Bag Small Handbag Purse for Ladies",
        "ASIN": "B073FNY6ZZ",
        "ReviewItem3": 9,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51o8kFu5ldL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 56.98,
        "UploadTime": " April 17, 2018",
        "Id": 859,
        "ReviewCount": 35
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 189.01,
        "ReviewItem5": 0,
        "Title": "Michael Kors Sloan Editor Large Leather Shoulder Bag",
        "ASIN": "B07JQPTLL2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-cluQrc4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 189.01,
        "UploadTime": " October 26, 2018",
        "Id": 860,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 4,
        "PriceMax": 36.99,
        "ReviewItem5": 69,
        "Title": "Dasein Women Satchel Handbags Purse Shoulder Bag Work Bag With Removable Shoulder Strap",
        "ASIN": "B075SSX943",
        "ReviewItem3": 5,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417jWBYTNDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.99,
        "UploadTime": " May 23, 2016",
        "Id": 861,
        "ReviewCount": 156
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 79.99,
        "ReviewItem5": 0,
        "Title": "Lug Ace 2 Convertible Travel Tote",
        "ASIN": "B07NJ5S8KT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511-LqtIGML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79.99,
        "UploadTime": " February 20, 2019",
        "Id": 891,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Awesome Medical Assistant Sarcastic Funny Saying Office Gift - Tote Bag With Zip",
        "ASIN": "B07HHYZP2G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SQMTGQ0hL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 20, 2018",
        "Id": 862,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 0,
        "Title": "iR540s Retro Sling bag Convertible to Crossbody Purse, 10.6x2.5x6.5in",
        "ASIN": "B07H551F3S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mbLHIfaZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " September 7, 2018",
        "Id": 863,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MZ Wallace Metro Pouch Graffiti Print Style Zip Bag New",
        "ASIN": "B07F6RV6CN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jOZ7%2B%2BzSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 2, 2018",
        "Id": 864,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 14,
        "ReviewItem2": 0,
        "PriceMax": 12.98,
        "ReviewItem5": 72,
        "Title": "Eyeglasses Hard Case Anti-Shock Molle System Zipper Sunglasses Pouch Sunglasses Bag Cases Eye Glasses Box Holder with Clip",
        "ASIN": "B07HVQ9NDM",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bjIUv9svL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.98,
        "UploadTime": " September 30, 2018",
        "Id": 865,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Eyewear Frames",
        "ReviewItem1": 17,
        "ReviewItem2": 7,
        "PriceMax": 12.82,
        "ReviewItem5": 58,
        "Title": "SA106 Art Nouveau Vintage Style Oval Metal Frame Eye Glasses",
        "ASIN": "B01CH8AXYU",
        "ReviewItem3": 8,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/312GFwrt0-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.82,
        "UploadTime": " March 3, 2016",
        "Id": 885,
        "ReviewCount": 279
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 89,
        "Title": "Vera Bradley Iconic Vera Tote, Signature Cotton",
        "ASIN": "B07DPT4WL1",
        "ReviewItem3": 11,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jb4OsxmtL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 24, 2018",
        "Id": 866,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 17,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 33,
        "Title": "kilofly Women Clutch Handbag Purse Hard Case, Rhinestone Crystal + Money Clip",
        "ASIN": "B01C85H6FG",
        "ReviewItem3": 17,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61WfgXUQOAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " February 26, 2016",
        "Id": 867,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "MoDA Womens Downtown Handbags Buttersoft Light Weight Satchel and Cross Body",
        "ASIN": "B0147BS9ZK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZcbM6YkbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 20, 2015",
        "Id": 868,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 2,
        "PriceMax": 22.99,
        "ReviewItem5": 78,
        "Title": "MINICAT Women RFID Blocking Small Crossbody Bags Cell Phone Purse Wallet With Credit Card Slots",
        "ASIN": "B07KP4PWWQ",
        "ReviewItem3": 5,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ffdtWzmLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " May 3, 2016",
        "Id": 869,
        "ReviewCount": 576
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.95,
        "ReviewItem5": 0,
        "Title": "Fashion Handbags for Women - FAITH WITH CRYSTALS, Small Designer Bags - 6\" X 8\" X 1\"",
        "ASIN": "B076T1R9FS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51q89zQcgkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.95,
        "UploadTime": " October 25, 2017",
        "Id": 870,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 75,
        "Title": "Hedgren Carina Crossbody Shoulder Bag, Purse with Adjustable Strap and 5 Pockets, 9 x 3.5 x 7 Inches, Womens, Periscope",
        "ASIN": "B01LHVV2XO",
        "ReviewItem3": 0,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BpOjxb2eL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "Id": 871,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Michael Kors Jet Set Travel Saffiano Leather Lace Cosmetic Travel Pouch in Black",
        "ASIN": "B07JR3MLK9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51v-RJfPOTL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 872,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 54.98,
        "ReviewItem5": 64,
        "Title": "Aldo Fiumata",
        "ASIN": "B073X24J1Y",
        "ReviewItem3": 18,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-TJdvvgfL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.98,
        "UploadTime": " October 26, 2017",
        "Id": 873,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Handmade Round Ata Rattan Bag - Boho Shoulder Straw Bag - Crossbody Purse Women",
        "ASIN": "B07K2YNF7G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51bozAiJ3iL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " November 1, 2018",
        "Id": 874,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 19,
        "ReviewItem2": 14,
        "PriceMax": 22.99,
        "ReviewItem5": 43,
        "Title": "Girls Bowknot 3-Pieces Fahsion Leather Backpack Mini Backpack Purse for Women",
        "ASIN": "B077ZS9DKS",
        "ReviewItem3": 10,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4174a4qIi-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " July 23, 2018",
        "Id": 875,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 45,
        "ReviewItem5": 78,
        "Title": "WOODIES Full Bamboo Wood Sunglasses",
        "ASIN": "B00CULUQRE",
        "ReviewItem3": 6,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Mtv3pcp-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45,
        "UploadTime": " September 26, 2013",
        "Id": 876,
        "ReviewCount": 103
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Gabrine Womens Shoulder Crossbody Bag Handbag Clutch Purse Laser Fabric for Dailywear Wedding Party(Pink)",
        "ASIN": "B07BVM29S9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51GSGw-iLCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " April 2, 2018",
        "Id": 877,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 430,
        "ReviewItem5": 0,
        "Title": "Cole Haan Bethany Woven Leather Zip Tote",
        "ASIN": "B07GQLHDYD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WqKaziKDL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 430,
        "UploadTime": " March 3, 2019",
        "Id": 878,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 120,
        "ReviewItem5": 0,
        "Title": "Love Moschino Women's Borsa Pebble Pu Top-Handle Bag",
        "ASIN": "B07LBHWFNM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mgy8fOifL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 120,
        "UploadTime": " February 11, 2019",
        "Id": 879,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 98,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke Gretta Lexi Crossbody Bag, Navy",
        "ASIN": "B015KU39J8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31tEkEAGg2L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 98,
        "UploadTime": " October 4, 2017",
        "Id": 932,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.72,
        "ReviewItem5": 80,
        "Title": "Women's Evening Chain Shoulder Bag Tailor Flower Kiss Lock Fashion Purse Clutch",
        "ASIN": "B01DF8IYPG",
        "ReviewItem3": 20,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41F1vWeyAbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.72,
        "UploadTime": " March 25, 2016",
        "Id": 880,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 54.87,
        "ReviewItem5": 50,
        "Title": "Bundle of Leather Clutch Handbag w Purse Flash Light Key Fob",
        "ASIN": "B072KG4M6K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419ypaM50LL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.87,
        "UploadTime": " June 12, 2017",
        "Id": 881,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Crossbody men Kids Activity Finding Treasure of the Pirate Themed Board Game Style Colorful Island Map Daily wallet handbag 16.5\"x14\"x6.3\" Multicolor",
        "ASIN": "B07QQWTVMG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Rv%2B95ubML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 882,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 581,
        "ReviewItem5": 0,
        "Title": "Orciani Women's B01999BLACK Black Leather Handbag",
        "ASIN": "B07QCQB478",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Z%2BJWEVOdL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 581,
        "UploadTime": " April 8, 2019",
        "Id": 883,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "BDJ Upcycling Blue Denim Jean Flap Over Messenger Crossbody Hobo Shoulder Handbag",
        "ASIN": "B016IDIGOY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61YrVYuaiJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " October 9, 2015",
        "Id": 886,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YOcheerful Women Cat Wallet, Womens Coin Purse Short Wallet Card Holders Handbag Girl Cat Wallet Black Wallet",
        "ASIN": "B07N364M8Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510Il0sx7uL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 25, 2019",
        "Id": 887,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Baggallini The New Classic Collection RFID Everyday Traveler Bagg",
        "ASIN": "B07QY3VBRN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CMOxytxPL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 18, 2019",
        "Id": 888,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 3,
        "PriceMax": 24.99,
        "ReviewItem5": 75,
        "Title": "Hand-woven Straw Large Hobo Bag for Women Round Handle Ring Toto Retro Summer Beach Straw Bag",
        "ASIN": "B07R42P6YJ",
        "ReviewItem3": 9,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51W2Z-rAdCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " May 9, 2018",
        "Id": 889,
        "ReviewCount": 32
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Atenti Betty Handbag (Romantico)",
        "ASIN": "B00IZNW45S",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hCMwNKtpL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 890,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 17,
        "PriceMax": 59.99,
        "ReviewItem5": 50,
        "Title": "YALUXE Women's Soft Real Leather Handy Hobo Style Handbag (Upgraded 2.0) Red",
        "ASIN": "B01E3NA8JW",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51z%2B9-j9J8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " January 31, 2018",
        "Id": 892,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 40,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 40,
        "Title": "DRF Women's Hobo Bag Canvas Tote Bag Shopper Large Capacity BG135 (Red)",
        "ASIN": "B00XVMRNC2",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515WKN3EUEL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "Id": 893,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 105,
        "ReviewItem5": 0,
        "Title": "Loungefly Minnie Print Cream Small Satchel Handbag Wallet Set",
        "ASIN": "B07FK7SD6X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tjQCNq9qL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 105,
        "UploadTime": " July 12, 2018",
        "Id": 894,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Connoworld - Retro Faux Leather Women Folded Wallet Purse Handbag Pouch Card Holder Clutch Key Cash Coin Bag Gift",
        "ASIN": "B07K8PTH8Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AX24QL1KL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 7, 2018",
        "Id": 906,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.9,
        "ReviewItem5": 75,
        "Title": "Ladies Cross Body Shoulder Bag Handbags XXL Large Capacity Bags for Women TOPUNDER B",
        "ASIN": "B0759FDBZP",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Lz-Bm6YnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.9,
        "UploadTime": " July 15, 2017",
        "Id": 895,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 52.14,
        "ReviewItem5": 72,
        "Title": "Solo Greenwich 15.6 Inch Tote Bag, Brown",
        "ASIN": "B016QO6AFC",
        "ReviewItem3": 5,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TTrcJULoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52.14,
        "Id": 896,
        "ReviewCount": 42
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 3,
        "PriceMax": 35.99,
        "ReviewItem5": 70,
        "Title": "InterestPrint Women's Leather Tote Shoulder Bags Handbags",
        "ASIN": "B078759L36",
        "ReviewItem3": 8,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51KQL9NFMoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " December 12, 2017",
        "Id": 897,
        "ReviewCount": 37
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Tote Bag for Women School Work Travel and Shopping",
        "ASIN": "B07KLHN1DD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vac%2BuaIPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " November 16, 2018",
        "Id": 898,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 26.99,
        "ReviewItem5": 79,
        "Title": "hotstyle Bestie 12\" Cute Mini Small Backpack Purse Travel Bag | Fits 11-inch Tablet",
        "ASIN": "B07GVC3PSV",
        "ReviewItem3": 4,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41THiwac2LL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "Id": 899,
        "ReviewCount": 678
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Lush Leather Leopard Printed Lightweight Ultra Suede Shopper Tote Bag",
        "ASIN": "B07M63RW1F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Fsk8dgtFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " December 26, 2018",
        "Id": 900,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 148,
        "ReviewItem5": 0,
        "Title": "Mary Frances Lieve Beaded Bee Crossbody Clutch Handbag",
        "ASIN": "B07LFNZ4DF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61p4oZmGxKL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 148,
        "UploadTime": " December 17, 2018",
        "Id": 1029,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "16 Pocket Purse Organizer Insert, Bag Organizer with Zipper, Handbag Organizer & Tote Shaper, fit for LV SPEEDY 30 with Handles",
        "ASIN": "B07MWZY7HT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iTZzJ196L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " January 17, 2019",
        "Id": 901,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Fashion Women Handbags Transparent Jelly Bag Chain Crossbody Bucket Bags Females Beach Bags",
        "ASIN": "B07RVH91J3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cw4qjkg9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 10, 2019",
        "Id": 902,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 0,
        "Title": "Bifold Brown Genuine Leather Large Travel Passport Holder Bag Zip Around Wallet",
        "ASIN": "B018VZVMES",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vuQvaumYL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " December 3, 2015",
        "Id": 903,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 90,
        "ReviewItem5": 100,
        "Title": "HPASS Classic Boy L-Wallet for Women",
        "ASIN": "B07PG2Y6WJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31RK0mAITgL._SX38_SY50_CR,0,0,38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 90,
        "Id": 904,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 1,
        "ReviewItem2": 1,
        "PriceMax": 34.99,
        "ReviewItem5": 92,
        "Title": "MOUNT BROWN Bifold RFID Blocking Slim Minimalist Genuine Leather Front Pocket Wallets for Men, Thin Money Clip with Pull Tab",
        "ASIN": "B07CRJXPNC",
        "ReviewItem3": 2,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MuK9ES7DL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " April 30, 2018",
        "Id": 905,
        "ReviewCount": 75
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0.38,
        "ReviewItem5": 0,
        "Title": "Vintage Women Bags,Womens Owl Print Leather Small Wallet Coin Hasp Purse Clutch Bag Card Holder Handbags Tote Bags",
        "ASIN": "B07P6RPVG3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CXxPVAhcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0.38,
        "UploadTime": " February 27, 2019",
        "Id": 907,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 34,
        "Title": "MMK Collection Fashion Women Designer Tote Handbag~Ladies Designer Satchel Handbag coin purse",
        "ASIN": "B0777JKHJK",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/216UxiLH0CL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " November 6, 2017",
        "Id": 908,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 129,
        "ReviewItem5": 100,
        "Title": "Patricia Nash Women's Venezia Crossbody",
        "ASIN": "B07FKPJ563",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vGfijPA7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 129,
        "UploadTime": " February 16, 2019",
        "Id": 909,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.8,
        "ReviewItem5": 0,
        "Title": "Mfeo Womens Multi Pocket Light Nylon Crossbody Bag Shoulder Bag Messenger Bag Purses",
        "ASIN": "B07PT9NWH4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gkYmMYKKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.8,
        "UploadTime": " March 18, 2019",
        "Id": 910,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 33,
        "PriceMax": 0,
        "ReviewItem5": 67,
        "Title": "Bamboo Panda Cotton Crossbody Bag",
        "ASIN": "B01EB4C0KI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4143yoZXKDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 20, 2016",
        "Id": 911,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.99,
        "ReviewItem5": 0,
        "Title": "Quilted Handbags for Women Metal Chain Strap Purse Shoulder Bags",
        "ASIN": "B07PLCWB6F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51paM1zAwVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.99,
        "UploadTime": " June 1, 2015",
        "Id": 933,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.57,
        "ReviewItem5": 86,
        "Title": "Embroidered Cute Mini Crossbody Bag for Women Small Handbags wristlet wallet bag Cell-phone Pouch Coin Purse",
        "ASIN": "B07F8DNFC5",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61EOkokVL3L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.57,
        "Id": 912,
        "ReviewCount": 70
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Certified Nursing Assistant - Cna Best Friend Novelty Gift - Tote Bag With Zip",
        "ASIN": "B07BMR6KCH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BLmSxjgML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " March 22, 2018",
        "Id": 913,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.95,
        "ReviewItem5": 0,
        "Title": "DAKINE Jodie Crossbody (Silverton Onyx Canvas)",
        "ASIN": "B07DMMZNB5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/613ZHnj3nxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.95,
        "UploadTime": " June 9, 2018",
        "Id": 914,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 220,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Hapak Handbag, Dwell Collection, Chestnut (Brown)",
        "ASIN": "B07G2R3DP1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31rYO3oE1SL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 220,
        "UploadTime": " July 31, 2018",
        "Id": 915,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "BESTOYARD Wedding Bags Satin Money Bag Bridal Bridesmaid Dolly Bag Handbag",
        "ASIN": "B06XK2GSXM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41X6HB787VL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 916,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 199.99,
        "ReviewItem5": 0,
        "Title": "Michael Kors Medium Black Canvas Camera Bag",
        "ASIN": "B071PFD25L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412f%2Bxmyt4L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 199.99,
        "UploadTime": " February 24, 2017",
        "Id": 926,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.99,
        "ReviewItem5": 67,
        "Title": "Crystal Clutch for Women Rhinestone Evening Bag",
        "ASIN": "B07FRR3R1W",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61J4hZpL25L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "UploadTime": " April 26, 2018",
        "Id": 917,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 788,
        "ReviewItem5": 0,
        "Title": "Valentino Orlandi Italian Designer Quilted Black Leather Bucket Drawstring Bag",
        "ASIN": "B07LCFZDL3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511DPKsd8rL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 788,
        "UploadTime": " December 12, 2018",
        "Id": 918,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "Marchome Women Hologram Pu Leather Envelope Crossbody Shoulder Bag Handbag",
        "ASIN": "B072QWMSF4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ggUAS2E2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " June 12, 2017",
        "Id": 919,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 9,
        "PriceMax": 13.99,
        "ReviewItem5": 59,
        "Title": "SBR Designs Women's Leather Cross Body Organizer Bag Red",
        "ASIN": "B00ZGUVMMY",
        "ReviewItem3": 9,
        "ReviewItem4": 23,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51KYCw1Zr3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " January 17, 2012",
        "Id": 920,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 160,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Canci Tote Bag",
        "ASIN": "B07N9WLLYL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31pS5Vt8kiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 160,
        "UploadTime": " February 1, 2019",
        "Id": 963,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "Women Sequin Tote Bag Reversible Sequin Bag Magnetic Buckle Handbag (Black)",
        "ASIN": "B07DTJGQZ1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LIOIePb4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "Id": 921,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 67.99,
        "ReviewItem5": 0,
        "Title": "Mayshe Womens Casual Style Genuine Leather Shoulder Crossbody Tote Bags Satchel Purses and Hobo Handbag",
        "ASIN": "B01N31JQWL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QWq8uXjqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 67.99,
        "UploadTime": " January 7, 2017",
        "Id": 922,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 0,
        "Title": "HUGS IDEA Cat Music Print Tote Bag Women's Fashion Handbag Travel Beach Shoulder Bags",
        "ASIN": "B07J5GCQ15",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51up3dy-UhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " October 9, 2018",
        "Id": 923,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.17,
        "ReviewItem5": 0,
        "Title": "Handmade Vintage Ethnic Pot Embroidery Design Mirror Work Round Crossbody Bag for Women (Red)",
        "ASIN": "B07HGBFPJF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hBWhC2IkL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.17,
        "Id": 924,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "Hologram Bag Crossbody Clear PVC Purse with Chain Laser Shoulder Bags for Women",
        "ASIN": "B07FTWXS6N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417fyoaM2qL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " July 24, 2018",
        "Id": 925,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40.95,
        "ReviewItem5": 0,
        "Title": "Recycled Canvas Tent Large Vintage Boho Tote Bag",
        "ASIN": "B079WBSTRK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZjzbwjXuL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.95,
        "Id": 928,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.98,
        "ReviewItem5": 0,
        "Title": "iSuperb Travel Insert Organizer Handbag Waterproof Oxford Baby Diaper Organizer",
        "ASIN": "B07CVSFQ7B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vbFzyIE5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.98,
        "UploadTime": " May 4, 2018",
        "Id": 929,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.94,
        "ReviewItem5": 0,
        "Title": "DALIX Monogram Tote Bag For Women Open Top Mint Green Personalized Letter A-Z",
        "ASIN": "B07DXJ7M3F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41HoSlLXM2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.94,
        "UploadTime": " June 22, 2018",
        "Id": 930,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "Handbag for Women 3 Compartments Faux Leather Hobo bag Multiple Pocket Shoulder bag Tote Purse",
        "ASIN": "B07R1H2BJ1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419oEqeFpbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " May 6, 2019",
        "Id": 931,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 7,
        "PriceMax": 18.99,
        "ReviewItem5": 57,
        "Title": "Mfeo Womens Casual Canvas Shoulder Bags Messenger Bags Crossbody Bag Tote Bags Handbag",
        "ASIN": "B01MFBRHGM",
        "ReviewItem3": 10,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514YDmtSolL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " October 24, 2016",
        "Id": 934,
        "ReviewCount": 313
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.76,
        "ReviewItem5": 0,
        "Title": "Women Fashion Bow Top-Handle Handbag Pu Leather Shoulder Bag Tote Purse Messenger Satchel Bags (Ivory)",
        "ASIN": "B076CHVQPW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DeHQjMfjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.76,
        "UploadTime": " October 11, 2017",
        "Id": 935,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 100,
        "Title": "Wallets for men Genuine cowhide Leather RFID Blocking Bifold with ID Window Brown",
        "ASIN": "B078HPL3TJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DLTwhcQxL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " December 18, 2017",
        "Id": 936,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 259,
        "ReviewItem5": 67,
        "Title": "MICHAEL Michael Kors Women's Marlon Shoulder Bag",
        "ASIN": "B0727XDJ8X",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JMRXjx6dL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 259,
        "UploadTime": " May 4, 2017",
        "Id": 937,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "L M51384 The capucinees Trumpet Bag for Womens Handbag Designer Fashion Single Shoulder Messager Bags -Black",
        "ASIN": "B07KVKPMH4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51bAlOaRXdL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 939,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "EvaLuLu Women's Padlock Genuine Leather Handbags with Golden Hardware",
        "ASIN": "B075965V72",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512n8je4xCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 1, 2017",
        "Id": 940,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.72,
        "ReviewItem5": 0,
        "Title": "Aeropostale Womens Neon Tote Handbag Purse",
        "ASIN": "B00D6M4KFU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mJZBVQPCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.72,
        "UploadTime": " October 14, 2013",
        "Id": 941,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "Ladies handbag new female temperament sweet lady fashion handbag crossbody shoulder bag",
        "ASIN": "B07JLQPFQ2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tKWk67FEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " October 21, 2018",
        "Id": 942,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 4.49,
        "ReviewItem5": 34,
        "Title": "Women Handbag,Todaies Fashion Women Leather Splice Handbag Women Shoulder Bag Crossbody Bag Tote Bag 2018 (30cm(L) 10cm(W) 18cm(H), Black)",
        "ASIN": "B07CN4GWJ9",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WkhSJ17sL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 4.49,
        "Id": 943,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.65,
        "ReviewItem5": 0,
        "Title": "Snow Mountain Range Wallet for Women Leather Clutch Purse Long Ladies Credit Card Holder Organizer",
        "ASIN": "B07R8ZFYYG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zWVY85nAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.65,
        "UploadTime": " April 30, 2019",
        "Id": 944,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 67,
        "Title": "BTP Women's Handmade Crochet Bag Rattan Loop Top Handles Handbags",
        "ASIN": "B07G28S986",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61eIKV3C10L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " July 26, 2015",
        "Id": 945,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Kids' Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 75,
        "Title": "Wraifa Kids Purse, Cute Cat Crossbody Bag Mini Toddler Backpack for Little Girls (Kids Purse Rose)",
        "ASIN": "B07KQ1VCDB",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZNB76A9RL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "Id": 946,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Interestprint Custom italian Marble, white and gold Classic Women Top Handbag Shoulder Bag",
        "ASIN": "B071W16Q3F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FTuZPUEaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " May 24, 2017",
        "Id": 947,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 25,
        "PriceMax": 144.5,
        "ReviewItem5": 50,
        "Title": "Corkor Bucket Bag for Women Crossbody Shoulder Handbag Non-Leather Vegan Cork",
        "ASIN": "B071Y36YF5",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51A9vPHdR3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 144.5,
        "UploadTime": " April 10, 2017",
        "Id": 948,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 6,
        "ReviewItem2": 5,
        "PriceMax": 28.99,
        "ReviewItem5": 70,
        "Title": "LEXSION Felt Insert Bag Organizer Bag In Bag For Handbag Purse Organizer Fits Speedy Neverfull",
        "ASIN": "B074YH4SFK",
        "ReviewItem3": 7,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41P23EaDZ-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.78,
        "UploadTime": " April 2, 2019",
        "Id": 949,
        "ReviewCount": 525
    }, {
        "Sale": "[]",
        "Category": "Coin Purses & Pouches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "KYOETSU Men's Japanese Shingen Pouch Bag Kinchaku Inden-Looking",
        "ASIN": "B072LVYHCY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61BV5LXLLCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " May 23, 2017",
        "Id": 950,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "SAGEBROWN The Large Morgan Bag",
        "ASIN": "B07CG99FDR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41m1y98fPzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 18, 2018",
        "Id": 951,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "Barabum Summer Beach Handwoven Straw Shoulder Hand Bag Tote Bags for Women with Handbag Decorative Scarf",
        "ASIN": "B07QNL9HY6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51yrz8E3CvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " April 1, 2019",
        "Id": 952,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.5,
        "ReviewItem5": 33,
        "Title": "Lug Flutter Crossbody Bag",
        "ASIN": "B079V86NN2",
        "ReviewItem3": 0,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419UFxyoByL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.5,
        "UploadTime": " March 3, 2018",
        "Id": 995,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 52.99,
        "ReviewItem5": 57,
        "Title": "Women Purse Handbag Vintage Genuine Leather Satchel Designer Bags",
        "ASIN": "B07H687S3B",
        "ReviewItem3": 7,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BAFntVNYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52.99,
        "UploadTime": " September 7, 2018",
        "Id": 953,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 11,
        "PriceMax": 11.99,
        "ReviewItem5": 58,
        "Title": "Noble Mount Crinkle Nylon ‘All In A Day' Tote Handbag - Black/Brown/Navy",
        "ASIN": "B009XVAKWK",
        "ReviewItem3": 12,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419W8Chh2jL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " October 25, 2012",
        "Id": 954,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 1,
        "PriceMax": 0,
        "ReviewItem5": 88,
        "Title": "Mud Pie R-Initial Canvas Tote",
        "ASIN": "B003810U1M",
        "ReviewItem3": 1,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51k02LddRML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 955,
        "ReviewCount": 87
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.5,
        "ReviewItem5": 0,
        "Title": "Chala Bohemian Cellphone Crossbody Handbag - Convertible Strap",
        "ASIN": "B07GDP86HP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vU8ssGWKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.5,
        "UploadTime": " August 13, 2018",
        "Id": 956,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 167.64,
        "ReviewItem5": 0,
        "Title": "LUHEN Woven Summer Straw Beach Bag Top Handle Casual Canework Handbag for Women",
        "ASIN": "B07QPD16KW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413fc1EWOVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 167.64,
        "UploadTime": " April 13, 2019",
        "Id": 957,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Circle White Hipster Bohemian Boho Hobo Hippie Crossbody Bag Purse BIG 37\"",
        "ASIN": "B06Y2VP533",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51AwoiSTzIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " September 27, 2016",
        "Id": 958,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 15,
        "PriceMax": 27.99,
        "ReviewItem5": 69,
        "Title": "Kemy's Women Backpack Purse Faux Leather Rucksack Bag for Ladies Small Convertible Bag Travel Handbag Black Thanksgiving Day Christmas Gifts",
        "ASIN": "B075VVDMS5",
        "ReviewItem3": 16,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YgLbk8K8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " September 23, 2017",
        "Id": 959,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 5,
        "PriceMax": 19.99,
        "ReviewItem5": 48,
        "Title": "BIG SALE- Sling Backpack, Sling Bag Small Crossbody Daypack Casual Backpack Chest Shoulder Pack for Men Women Outdoor Hiking Travel (Black-1)",
        "ASIN": "B07GY9YZ4J",
        "ReviewItem3": 11,
        "ReviewItem4": 27,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413Pz8kDlnL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "Id": 960,
        "ReviewCount": 79
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "orYANY Lucy Croco Embossed Patent Leather Black Large Hobo Tote",
        "ASIN": "B01LZRQWN8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MsQhQyL1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 13, 2016",
        "Id": 961,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 24.79,
        "ReviewItem5": 34,
        "Title": "African American Expressions - Queen Woven Tote Bag (Chenille, 17\" x 17\") WTB-03",
        "ASIN": "B06XC5HPQS",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PsKtCOrsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.79,
        "UploadTime": " February 28, 2017",
        "Id": 962,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 155,
        "ReviewItem5": 0,
        "Title": "LongChamp Women's Le Pliage Gray Club Tote Large",
        "ASIN": "B07FWDRQKR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41w3Cwx548L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 155,
        "UploadTime": " March 15, 2017",
        "Id": 1688,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 100,
        "Title": "2 Pack Portable Sunglass Zipper Pouch Felt Anti-dust Eyeglasses Bag Box Make up Purse",
        "ASIN": "B07CZ7ZVXL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BtSbg3FsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " May 9, 2018",
        "Id": 964,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Guess Women's Velvet Logo Small Duffle Bag Handbag",
        "ASIN": "B07L2R7HB1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41p14jG%2BB3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 13, 2016",
        "Id": 965,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Candy Leather 2\" Wide Purse Strap Replacement Guitar Style Colorful Canvas Adjustable 40\"- 55\" Crossbody Bag Straps for Handbags",
        "ASIN": "B07DQR3H5Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5184tQ%2BvzvL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 966,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Lovely Saint Laurent Monogram Kate with Tassel Kate Medium with Tassel in Smooth Leather Women Shoulder Bag",
        "ASIN": "B07PK5PW7K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ct4lzoVUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 7, 2019",
        "Id": 967,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Coin Purses & Pouches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 100,
        "Title": "reisenthel mini maxi loftbag black",
        "ASIN": "B01ARNNFUG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/314nJU0mbnL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "Id": 1062,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 118,
        "ReviewItem5": 92,
        "Title": "Harveys Mini Streamline Crossbody",
        "ASIN": "B074KGWNSY",
        "ReviewItem3": 4,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514MzFNkSsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 118,
        "UploadTime": " August 15, 2017",
        "Id": 968,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 60,
        "Title": "Passport Wallet Holder for Men&Women, Travel Waterproof Credit Card&Money Bag Multifunctional Family Zipper Cellphone Case",
        "ASIN": "B07CZ12CSG",
        "ReviewItem3": 20,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eUQg0NUEL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " May 9, 2018",
        "Id": 969,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 7.99,
        "ReviewItem5": 63,
        "Title": "Premium Large Chevron Zig Zag Canvas Tote Shoulder Bag Handbag - Diff Colors",
        "ASIN": "B07F8F89ML",
        "ReviewItem3": 25,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cEMz0awAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.99,
        "UploadTime": " July 4, 2018",
        "Id": 970,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 59,
        "Title": "CTM Women's Crocheted Sling Shoulder Handbag",
        "ASIN": "B00KCY04UK",
        "ReviewItem3": 6,
        "ReviewItem4": 35,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RpNAJtB4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 15, 2014",
        "Id": 971,
        "ReviewCount": 17
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20,
        "ReviewItem5": 0,
        "Title": "Shopmania canvas Printed Bifold PU Leather Purse Card Holder Wallet for men",
        "ASIN": "B079VNNRTK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ITzjEldjL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20,
        "UploadTime": " February 16, 2018",
        "Id": 1026,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 8,
        "ReviewItem2": 2,
        "PriceMax": 30,
        "ReviewItem5": 74,
        "Title": "HOJ Co. CARRYALL Mens Leather Money Clip Wallet-Strong Magnetic Front Pocket Wallet-Exterior ID Window",
        "ASIN": "B079BGXKJC",
        "ReviewItem3": 6,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5139LMISbcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30,
        "UploadTime": " January 25, 2018",
        "Id": 972,
        "ReviewCount": 50
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 298,
        "ReviewItem5": 50,
        "Title": "Michael Kors Hattie Pebble leather Handbag Moss",
        "ASIN": "B076K7G7YR",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lwuDBie-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 298,
        "UploadTime": " October 18, 2017",
        "Id": 973,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 56.24,
        "ReviewItem5": 0,
        "Title": "GUESS Factory Women's Diem Logo-Print Satchel",
        "ASIN": "B07PV6VS54",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31QKYxSq8HL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 56.24,
        "UploadTime": " March 26, 2019",
        "Id": 974,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "Women's Bucket Bag Shoulder Bag Tote Bag(Medium）",
        "ASIN": "B07PV1JLZL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xP0v0D4VL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " April 1, 2019",
        "Id": 975,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 0,
        "Title": "Summer Hobo Shoulder Purse Straw Bag for Women,Fashion Woven Crossbody Beach Bag",
        "ASIN": "B07DPNJ8X2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QMIBxv-YL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " March 10, 2019",
        "Id": 976,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 66.98,
        "ReviewItem5": 0,
        "Title": "KAANAS SALAMINA Straw Handle Basket Tote Bag",
        "ASIN": "B07H9KSQJH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/615f8k3MmHL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 66.98,
        "UploadTime": " April 24, 2019",
        "Id": 977,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.95,
        "ReviewItem5": 83,
        "Title": "Ngil Quilted Cotton Medium Tote Bag 2018 Spring Collection",
        "ASIN": "B0797FGQ4N",
        "ReviewItem3": 17,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ru1G%2BD8NL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " May 16, 2016",
        "Id": 1050,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Lx10tqy Embroidery Floral Sachet Square Lucky Bag Tassel Zipper Closure Jewelry Storage Pouch Red",
        "ASIN": "B07R1JNHM8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41M8sLRnDgL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 978,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Rebecca Minkoff Women's Jean Medium Shoulder Bag",
        "ASIN": "B07KKGBKNK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FolBAsWGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 14, 2019",
        "Id": 979,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 86,
        "Title": "Michael Kors Women's Leather Cross-Body",
        "ASIN": "B00IM5EO5M",
        "ReviewItem3": 2,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/610wfx9bbjL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 13, 2016",
        "Id": 980,
        "ReviewCount": 42
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.98,
        "ReviewItem5": 0,
        "Title": "JIRAT AMA - Handmade 100% Organic Cotton Purse - Tribal Bag Clutch Style with Thai Hmong Embroidery, Medium-Sized Embroidered Bag (N011)",
        "ASIN": "B07QVP9CDZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Ea%2BSI%2BHvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.98,
        "UploadTime": " April 22, 2019",
        "Id": 981,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Zipper Tote Bag",
        "ASIN": "B07CNDXJRT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sTgrofeSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 25, 2018",
        "Id": 982,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 124.26,
        "ReviewItem5": 100,
        "Title": "Tuscany Leather Patty - Leather convertible bag - TL141497 (Honey)",
        "ASIN": "B01L93SA3U",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Gm3bhjjJL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 124.26,
        "Id": 983,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.65,
        "ReviewItem5": 0,
        "Title": "Women Wallet Multi-card Three Fold Long Zipper Clutch Purse,Beautiful Nebula",
        "ASIN": "B07QJV483Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SHc-T%2BoLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.65,
        "UploadTime": " April 7, 2019",
        "Id": 984,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.79,
        "ReviewItem5": 50,
        "Title": "Travelon Anti-theft Boho Clutch Crossbody Cross Body Bag",
        "ASIN": "B07MMRRMBY",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JQ5jv2f9L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.79,
        "UploadTime": " January 16, 2019",
        "Id": 985,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 118,
        "ReviewItem5": 75,
        "Title": "Harveys Satchel Treecycle",
        "ASIN": "B000SZWNP2",
        "ReviewItem3": 5,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31WOnI0Sd9L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 118,
        "UploadTime": " August 7, 2007",
        "Id": 986,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 124.75,
        "ReviewItem5": 0,
        "Title": "Kipling Art S Women's Handbag",
        "ASIN": "B01LZUFDSD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bFnZ9lSPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 124.75,
        "UploadTime": " September 8, 2018",
        "Id": 987,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 75,
        "Title": "Kate Spade bay street cora crossbody",
        "ASIN": "B077NXH8TP",
        "ReviewItem3": 0,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511pWlNWgXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 21, 2017",
        "Id": 988,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 100,
        "Title": "Myra Bags Animal Print Pocket with Upcycled Canvas Crossbody Bag S-1039",
        "ASIN": "B078R5GKVW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2Buk2J7ljL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " September 4, 2014",
        "Id": 989,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 130.24,
        "ReviewItem5": 0,
        "Title": "Sam Edelman Women's Gwendolyn Tote",
        "ASIN": "B078JL4ZRY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61sQGwOwy5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 130.24,
        "UploadTime": " February 22, 2018",
        "Id": 990,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Casual Daypacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.99,
        "ReviewItem5": 0,
        "Title": "Myra Bag The Traveller Upcycled Canvas Backpack S-0828",
        "ASIN": "B07HYWBB55",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418GrQBSLyL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.99,
        "Id": 991,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 169.98,
        "ReviewItem5": 0,
        "Title": "Cambridge Satchel Women's Tassel Bag",
        "ASIN": "B079P88WLP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31tqHXT2OQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 169.98,
        "UploadTime": " February 8, 2018",
        "Id": 1051,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 81,
        "Title": "UBORSE Women's Embroidered Beaded Sequin Evening Clutch Large Wedding Party Purse Vintage Bags",
        "ASIN": "B076FWVVYF",
        "ReviewItem3": 3,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51K7XfLfNoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " October 14, 2017",
        "Id": 992,
        "ReviewCount": 57
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 3,
        "PriceMax": 23.99,
        "ReviewItem5": 65,
        "Title": "Drawstring Bucket Bags 2 Pieces Set, Artmis Women Small Cross-body Purses PU Leather",
        "ASIN": "B071RNN6Y7",
        "ReviewItem3": 9,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41J0OHJpTlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " April 27, 2016",
        "Id": 993,
        "ReviewCount": 122
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Women Genuine Leather Hobo Bag Handmade Vintage Top-handle Bags Sling Shoulder Bag for Ladies",
        "ASIN": "B07MM3VNKB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JwDIW9taL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " January 9, 2019",
        "Id": 994,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0.01,
        "ReviewItem5": 0,
        "Title": "BSGSH Women's Ladies Casual Hologram Holographic Tote Bag Summer Flash Reflactive Handbag Crossbody Shoulder Bag (Black)",
        "ASIN": "B07QDXXYRF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DnRc5UYZL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0.01,
        "Id": 2318,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 25,
        "PriceMax": 0,
        "ReviewItem5": 75,
        "Title": "ANONE Women PU Leather Handbag Chain Shoulder Bag Crossbody Bag Purse",
        "ASIN": "B07PVZ2YK7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YzyCCE1dL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 15, 2019",
        "Id": 996,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.58,
        "ReviewItem5": 0,
        "Title": "Women Transparent Clear PVC Holographic Shoulder Bag Shining Crossbody Purse Bag with Chain",
        "ASIN": "B07MZJXSNN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zhTEfwQpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.58,
        "UploadTime": " January 21, 2019",
        "Id": 997,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 238.8,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Women's Atlantic Avenue Small Libby Bucket Bag, Ginger Tea, Pink, One Size",
        "ASIN": "B07N2W8LV2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31z0KnejOBL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 238.8,
        "Id": 998,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.49,
        "ReviewItem5": 0,
        "Title": "Degohome Women's Canvas Shoulder bags Crossbody Retro Handbag Casual Tote Purses",
        "ASIN": "B07PRGKGCV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41H1qI7%2BbRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.49,
        "UploadTime": " March 19, 2019",
        "Id": 999,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Onfashion Cute Animal Shaped Shoulder Bag Hedgehog Handbag Hedgehog Clutch Purse",
        "ASIN": "B077HNS367",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51n4mehAqVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " November 14, 2017",
        "Id": 1000,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LV LOUIS VUITTON NEVERFULL MM - Bag Base Shaper 1/8” Thick Clear Acrylic",
        "ASIN": "B07L8RQSZF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31c9yHEz-FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 13, 2018",
        "Id": 1001,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "DIMPLEYA Handbag Sling Cross Body Crossbody Bags Work Daily Use Bucket Style Stylish and Compact Easy to Carry,White",
        "ASIN": "B07QWWGMVK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Q6gY4jobL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1002,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 93.94,
        "ReviewItem5": 0,
        "Title": "Lug Mini Puddle Jumper 2 Shoulder Bag",
        "ASIN": "B07F1KWMMB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51abZFWqroL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 93.94,
        "UploadTime": " July 20, 2018",
        "Id": 1003,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Louis Vuitton Favorite Shoulder Bag (MM, Damier Ebene Canvas)",
        "ASIN": "B01LY20IUM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iSRnATqeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 30, 2017",
        "Id": 1004,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Neckties",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "WANDM Men's knit tie slim skinny square necktie width 2\" washable solid colors",
        "ASIN": "B07N8GDK5V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NzmT05TDL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " January 28, 2019",
        "Id": 1027,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.43,
        "ReviewItem5": 0,
        "Title": "Charming Tailor Lace Formal Bag Elegant Wedding Clutch Purse Bridal Handbag for Women",
        "ASIN": "B07L3RRBS2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51QZe4VyTnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.43,
        "UploadTime": " December 4, 2018",
        "Id": 1005,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 93.49,
        "ReviewItem5": 0,
        "Title": "Clarks Women’s Talara Star Top-Handle Bag, Black (Black Leather), 17x32x26 Centimeters (B x H x T)",
        "ASIN": "B01KTM6IPY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ETqWaBDmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 93.49,
        "UploadTime": " May 2, 2018",
        "Id": 1006,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 66.19,
        "ReviewItem5": 0,
        "Title": "Betsey Johnson Mighty Jungle Leopard Print Bow Tote",
        "ASIN": "B0793BTDC1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wcECelchL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 66.19,
        "UploadTime": " May 18, 2018",
        "Id": 1007,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.99,
        "ReviewItem5": 0,
        "Title": "Hobo Womens Pep",
        "ASIN": "B07HDBS8FV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Qb7opsLjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.99,
        "UploadTime": " November 9, 2018",
        "Id": 1008,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 3,
        "PriceMax": 19.99,
        "ReviewItem5": 61,
        "Title": "Double Compartment Flap Pocket Crossbody Bag",
        "ASIN": "B076VXSNBJ",
        "ReviewItem3": 15,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ewbNcO3FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " February 24, 2017",
        "Id": 1009,
        "ReviewCount": 39
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 22,
        "ReviewItem2": 11,
        "PriceMax": 22.99,
        "ReviewItem5": 67,
        "Title": "Large Canvas Wristlet 6x9\", Natural Color, 100% Cotton Canvas - Pack of 12",
        "ASIN": "B01F9EE4L2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ghos%2BjI7L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "Id": 1010,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.95,
        "ReviewItem5": 25,
        "Title": "Leather Backpack Handbag",
        "ASIN": "B00ICNAHLY",
        "ReviewItem3": 50,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aHyChPPgL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.95,
        "UploadTime": " February 10, 2014",
        "Id": 1011,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.99,
        "ReviewItem5": 0,
        "Title": "STONE MOUNTAIN Black White Knots Print Crossbody Handbag",
        "ASIN": "B07CBS73H7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jxpf2kLcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "UploadTime": " April 8, 2018",
        "Id": 1012,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Crossbody Bags for Women Chain Versatile Messenger Bag Shoulder Bag Fashion Bag",
        "ASIN": "B07QQNC94B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41slF-XvHHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 11, 2019",
        "Id": 1013,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Men's Wallet Leather Multi-Function Fashion Anti-Magnetic RFID Men's Bag Men's Fashion (Color : Green, Size : S)",
        "ASIN": "B07RKH2KHP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41D6hutV0gL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1014,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 3,
        "ReviewItem2": 6,
        "PriceMax": 12.99,
        "ReviewItem5": 59,
        "Title": "Joe's USA Jumbo Tote Bag a Sturdy 10-ounce Cotton Oversized Tote Bag",
        "ASIN": "B00P8DPTHS",
        "ReviewItem3": 17,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41R7cRB6pWL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 1015,
        "ReviewCount": 34
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 127.5,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Corner Signature North/South Tote",
        "ASIN": "B077M3YYBD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41y27Ij06DL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 127.5,
        "UploadTime": " February 23, 2018",
        "Id": 1016,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "LV Louis Vuitton Lockme Backpack - Bag Base Shaper 1/16” Black Plastic",
        "ASIN": "B07PZYX1XM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410gsebXbDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 13, 2018",
        "Id": 1017,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 6,
        "PriceMax": 27.99,
        "ReviewItem5": 66,
        "Title": "Angelkiss Women's Handbag Large Double Zipper Multi Pocket Washed Shoulder bag Designer Handbags for Women",
        "ASIN": "B07CKL2LWZ",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wealwAd1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " May 4, 2018",
        "Id": 1018,
        "ReviewCount": 47
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Summer Surfboard at Beach Womens Clutch Wallet Large Wristlet Zipper Clutch Large Travel Purse",
        "ASIN": "B07Q82SN9B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zNCN57IvL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " March 29, 2019",
        "Id": 1019,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 164,
        "ReviewItem5": 0,
        "Title": "COACH F29209 ZIP SHOULDER BAG IN SIGNATURE CANVAS",
        "ASIN": "B07FRTKKT2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512plyJVi3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 164,
        "UploadTime": " July 21, 2018",
        "Id": 1020,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Round Straw Rattan Boho Bag for Women Purse Handmade Clutch Woven Handbag",
        "ASIN": "B07Q8S2KFL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hhLqZyQuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 29, 2019",
        "Id": 1021,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 61.99,
        "ReviewItem5": 0,
        "Title": "Mona B Intermix Crossbody Bag",
        "ASIN": "B07DRJR9TD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61WC62exrVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 61.99,
        "UploadTime": " August 31, 2018",
        "Id": 1022,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.79,
        "ReviewItem5": 0,
        "Title": "Women's Small Crossbody Cellphone Bag Shoulder Bag Messenger Bag Tote Bags Handbag with Chain Strap",
        "ASIN": "B07BRM9DGD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61unbVRL2SL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.79,
        "UploadTime": " April 7, 2018",
        "Id": 1023,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 81,
        "Title": "Under Armour Womens Big Wordmark Tote 2.0",
        "ASIN": "B01M7RYE6C",
        "ReviewItem3": 3,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51D9TlOhogL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 19, 2016",
        "Id": 1024,
        "ReviewCount": 38
    }, {
        "Sale": "[]",
        "Category": "Travel Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.39,
        "ReviewItem5": 100,
        "Title": "Leefun Women Clear Tote Bags Zipper Closure and Straps Great for Work Sports School",
        "ASIN": "B07M9TT97G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VzSNiCSpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.39,
        "UploadTime": " December 27, 2018",
        "Id": 1025,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 52.99,
        "ReviewItem5": 0,
        "Title": "Betsey Johnson Ginger Bread House Bag",
        "ASIN": "B07FV4WQQZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kLVw%2BWVlL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52.99,
        "UploadTime": " November 2, 2018",
        "Id": 1028,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Women Fashion Handbags Big Capacity Tote Bag Shoulder Bag Top Handle Satchel Purse",
        "ASIN": "B07P5MK72L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rN2vze03L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " February 26, 2019",
        "Id": 1030,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 17,
        "ReviewItem2": 0,
        "PriceMax": 138,
        "ReviewItem5": 33,
        "Title": "Harveys Medium Streamline Tote Black",
        "ASIN": "B00T3IMVT8",
        "ReviewItem3": 33,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lRZo7XV7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138,
        "UploadTime": " March 11, 2015",
        "Id": 1031,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 310,
        "ReviewItem5": 0,
        "Title": "'Saratoga' Large Yellow Satchel Handbag by Trina Turk",
        "ASIN": "B0157VHCY8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31%2Bh%2BBoavTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 310,
        "UploadTime": " June 6, 2015",
        "Id": 1060,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Women Soft Leather Crossbody Bags Large Slim Clutch Purse With Removable Strap",
        "ASIN": "B07DNCBLFB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31VJ83VkwTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " January 18, 2019",
        "Id": 1032,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 61.39,
        "ReviewItem5": 0,
        "Title": "COSIMA LEONE - Bag Model CERI",
        "ASIN": "B079P4G9PV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51p68fkzDPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 61.39,
        "UploadTime": " February 15, 2018",
        "Id": 1033,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Flamingo Love Chevron Women's Leather Tote Shoulder Bags Handbags",
        "ASIN": "B01CS25HJ6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Du5r5EWhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " March 10, 2016",
        "Id": 1034,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 11,
        "PriceMax": 0,
        "ReviewItem5": 59,
        "Title": "BeSafeBags Anti-Theft RFID Travel Handbag, Large, 10 Pockets and Organizer, Detachable Security Strap, by DayMakers",
        "ASIN": "B00NAHYWY0",
        "ReviewItem3": 15,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MBoZEgqAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 3, 2014",
        "Id": 1035,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Incase City Market Tote",
        "ASIN": "B01IQY7IME",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aL8lUJMYL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 19, 2016",
        "Id": 1036,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Chicca Borse Woman Handbag Twisted Fantasy in Genuine Leather Made in Italy",
        "ASIN": "B06X95L561",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51A-xwI2hoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 20, 2017",
        "Id": 1037,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Clarins Limited Edition Summer Water Proof Beach Travel Handbag Tote - Red or Lavender",
        "ASIN": "B07CN7XWYQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DkYgp5-9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 24, 2018",
        "Id": 1038,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.99,
        "ReviewItem5": 67,
        "Title": "Mn&Sue Vintage Diamond Quilted Pattern Reversible Top Handle Satchel Shell Boston Handbag Lady Purse",
        "ASIN": "B01GNX98OQ",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Hq9yb47SL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.99,
        "UploadTime": " June 5, 2016",
        "Id": 1039,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "MMK Collection Medium Size Water Wash Vegan Leather Young Lady/Women Briefcase Style Satchel with Matching Color Wallet",
        "ASIN": "B07515QZVM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IYuNIRB1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " August 21, 2017",
        "Id": 1040,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 87.21,
        "ReviewItem5": 0,
        "Title": "Fossil Women's Logan RFID Flap Wallet",
        "ASIN": "B07FL99539",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4198CzUPWWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 87.21,
        "UploadTime": " October 31, 2018",
        "Id": 1061,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 349,
        "ReviewItem5": 0,
        "Title": "COACH Womens Refined Calf Leather Selena Bond Bag",
        "ASIN": "B07D9Q3Y4J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41J5mSaCcOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 349,
        "UploadTime": " October 26, 2018",
        "Id": 1041,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 185,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Hapak Small Handbag, Dwell Collection, Allure (Blue)",
        "ASIN": "B07G2RTD6R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/3147adfdaIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 185,
        "UploadTime": " July 31, 2018",
        "Id": 1042,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 25,
        "PriceMax": 22.82,
        "ReviewItem5": 63,
        "Title": "Littlearth NHL Fold Over Crossbody Pebble",
        "ASIN": "B008SMHB36",
        "ReviewItem3": 12,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41OUCCSB1KL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.82,
        "Id": 1043,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Bags us PU Cute Crossbody Coin Purse Small Shoulder Bag Satchel Handbag for Kids Toddlers Girls",
        "ASIN": "B07JDZ3JNP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nMhqBasVL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "Id": 1044,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Geometric Glitter Evening Clutch Bag Wedding Purse Bridal Prom Handbag Party Bag (Gold)",
        "ASIN": "B07QQRK8LZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61Ko6UMerHL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1045,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Women Ladies Messenger Bags New Fashion Bag Basketball Shape",
        "ASIN": "B07P8WPKTB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31r5GzXJrHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " February 27, 2019",
        "Id": 1046,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "UINight Womens Makeup Bags Green Dot Football Portable Lightweight Handbags with Zip Bags",
        "ASIN": "B07RR8H1M2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519RCrxAxLL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 1047,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.24,
        "ReviewItem5": 100,
        "Title": "Clearance ❤ Women Bag JJLIKER Leopard Print Leather School Travel Backpack",
        "ASIN": "B07JZ96Z2M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51y96veY7TL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.24,
        "Id": 1048,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "NaRaYa Quilted Geometric Printed Navy Blue Handbag",
        "ASIN": "B07QCN273M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518Rwommq2L._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 31, 2019",
        "Id": 7010,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "WHATSHOP Bucket Bags For Women Purses and Handbags Bucket Purse Sets Earth Brown Faux Leather Pebble Grain",
        "ASIN": "B07H3SBTJ6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rkaMrinHL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "Id": 1052,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 98,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Midtown Small Tote, Performance Twill",
        "ASIN": "B07N5FQ5GH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CD6EmGy0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 98,
        "UploadTime": " March 20, 2019",
        "Id": 1053,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 9,
        "PriceMax": 11.77,
        "ReviewItem5": 54,
        "Title": "Nylon Crossbody Handbag Women Messenger Bags Shoulder Bag Famous Brands Lightweight Waterproof",
        "ASIN": "B07JVH52FY",
        "ReviewItem3": 10,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RoJftgGSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.77,
        "UploadTime": " September 6, 2016",
        "Id": 1054,
        "ReviewCount": 52
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 57,
        "Title": "FanCarry PU Leather Small Crossbody Bag Organized Travel Purse",
        "ASIN": "B07G52F72X",
        "ReviewItem3": 29,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YfWT2TcpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " December 26, 2018",
        "Id": 1055,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 119,
        "ReviewItem5": 0,
        "Title": "Faithfull the Brand Ola Circular Wicker Handbag",
        "ASIN": "B07L521SJL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31i9YmNQQNL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 119,
        "UploadTime": " December 5, 2018",
        "Id": 1056,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.99,
        "ReviewItem5": 0,
        "Title": "Roxy Into The Forest Crossbody Handbag",
        "ASIN": "B07H2DGNH3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517X0QDYQBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "UploadTime": " October 17, 2018",
        "Id": 2349,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "UINight Womens Travel Bags Colorful Hand Drawn Messy Octopus Portable Lightweight Handbags with Zip Bags",
        "ASIN": "B07RR8H1M6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fXuPtcrSL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "Id": 1057,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.79,
        "ReviewItem5": 0,
        "Title": "Mud Pie Women's Fashion Color Pop Jute Tote",
        "ASIN": "B079HFP691",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LJUo5nR8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.79,
        "UploadTime": " January 31, 2018",
        "Id": 1058,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9,
        "ReviewItem5": 0,
        "Title": "COOKI Womens Purses and Handbags Ladies Alligator Pattern Fashion PU Leather Simple Crossbody Handbags Designer Satchel Tote Bag Shoulder Bags on Sale Clearance",
        "ASIN": "B07CFWG4MB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lvSLr4KpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9,
        "UploadTime": " January 4, 2018",
        "Id": 1059,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Glasses Bag Ski Goggle Protection Bags Storage Pouch Case for Eyeglasses and Sunglasses Fit for Most Model",
        "ASIN": "B07M5J5QVN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nzrKwJTsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 20, 2018",
        "Id": 1063,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Furla Women's Linda Medium Satchel Saffiano Bag",
        "ASIN": "B00WG0NQ08",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51k2jqri2GL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 13, 2016",
        "Id": 2189,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GUESS Factory Women's Desire Logo-Embossed Crossbody",
        "ASIN": "B078JHFFQK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Cm6hwm9AL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 21, 2017",
        "Id": 7974,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 53.5,
        "ReviewItem5": 0,
        "Title": "Chala Charming Crossbody Bag with Zipper Flap Top and Metal Chain - Black (Mini Dog)",
        "ASIN": "B07KG22LYP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41euh0plyRL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 53.5,
        "UploadTime": " September 27, 2018",
        "Id": 7975,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 2,
        "PriceMax": 0,
        "ReviewItem5": 76,
        "Title": "Coach Signature File Crossbody Bag",
        "ASIN": "B0777TWK4N",
        "ReviewItem3": 4,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qbjbFaNtL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 7, 2017",
        "Id": 7976,
        "ReviewCount": 300
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 2,
        "PriceMax": 89,
        "ReviewItem5": 82,
        "Title": "Women's Vintage Genuine Soft Leather 17\" Tote Purse Multi Functional Hand Bag - The Aartisan",
        "ASIN": "B06Y2Y3S8S",
        "ReviewItem3": 8,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518g4Fdrn7L._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 89,
        "UploadTime": " April 4, 2017",
        "Id": 7977,
        "ReviewCount": 39
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - I Have. Inspirational words for those fighting Tote Bag 2b450",
        "ASIN": "B0749K4QGB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51XdxpB-InL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " July 27, 2017",
        "Id": 7978,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LassZone Cell Phone Purse Wallet Bohemian Style Canvas Small Crossbody Bags for Women Girls",
        "ASIN": "B07PZT8NM5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514ECP6%2BwYL._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 7979,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "Personalized Custom Text Floral Circle Cotton Canvas Beach Zipper Tote Bag",
        "ASIN": "B07KRMXTJ4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-qpp1veBL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " November 21, 2018",
        "Id": 7980,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 2,
        "ReviewItem2": 3,
        "PriceMax": 15.99,
        "ReviewItem5": 72,
        "Title": "RFID Wallets for Men - Real Leather Bifold Wallets - Thin & Slim RFID Blocking Security Wallet",
        "ASIN": "B07KW1YLGP",
        "ReviewItem3": 5,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NczPN8RQL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " April 10, 2018",
        "Id": 7981,
        "ReviewCount": 62
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.99,
        "ReviewItem5": 95,
        "Title": "Miuco Womens Bamboo Handbag Handmade Large Tote Bag",
        "ASIN": "B071NJF3Q8",
        "ReviewItem3": 1,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DS03MEviL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 32.29,
        "UploadTime": " April 28, 2017",
        "Id": 8029,
        "ReviewCount": 797
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 212,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke Pebble Grain Crossbody Shoulder Bag Azure Blue",
        "ASIN": "B077VTD6Z3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fuJFuJK6L._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 212,
        "UploadTime": " June 8, 2018",
        "Id": 8014,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.97,
        "ReviewItem5": 0,
        "Title": "RFID Blocking Men's Large Capacity Leather Wallet, Cowhide Clutch Purse",
        "ASIN": "B077NC53ZT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ooogGLmyL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 29.97,
        "UploadTime": " November 20, 2017",
        "Id": 8015,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 174.99,
        "ReviewItem5": 0,
        "Title": "Frye Jacqui Lace Hobo",
        "ASIN": "B0759XHC2S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JwztyKzxL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 174.99,
        "UploadTime": " April 20, 2018",
        "Id": 8016,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 109,
        "ReviewItem5": 0,
        "Title": "Cork Cross-Body Handbag Vegan Gift Brown Triangle Pocket",
        "ASIN": "B07P8JN6HT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NU0N1rMlL._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 109,
        "Id": 8017,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Tattooed Sugar Skull Sloth Cross body Shoulder Bag Handbag Purse",
        "ASIN": "B076F9RTW6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ta2DMBJ7L._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " August 11, 2017",
        "Id": 8018,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26,
        "ReviewItem5": 0,
        "Title": "Purse Collection Beautiful Floral Embroidery Gold Colour Potli Purse For Womens",
        "ASIN": "B07C61TVS8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61jRb7KPgGL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 26,
        "UploadTime": " August 23, 2017",
        "Id": 8019,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.41,
        "ReviewItem5": 0,
        "Title": "SAIERLONG New Womens Genuine Leather Handbags Tote Shoulder Bags",
        "ASIN": "B07DJ1SD2N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51St-XCKkWL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 64.41,
        "UploadTime": " October 16, 2017",
        "Id": 8020,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "Round\"Flamingo Decoupage Design/w Leather Clip\" Woven/w Genuine-Leather Strap Summer Beach Handbag",
        "ASIN": "B07J2P2C9S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BT3s6odyL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " June 1, 2018",
        "Id": 8021,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 5,
        "PriceMax": 11.99,
        "ReviewItem5": 80,
        "Title": "NIGEDU Women Clutches Crocodile Grain PU Leather Envelope Clutch Bag",
        "ASIN": "B075145397",
        "ReviewItem3": 5,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qwEJMn6rL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " August 21, 2017",
        "Id": 8022,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 100,
        "Title": "3 Compartment Multi-pocket Lightweight Vintage Stiella Supper Soft Crossbody Bag by Mia K. Farrow",
        "ASIN": "B07L5XRV8F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FdVfmDYcL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " December 6, 2018",
        "Id": 8023,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Wristlet Wallet Clutch Bag {Greta-Medium} Phone Purse Handbag Gray White Herringbone Funky Monkey Fashion",
        "ASIN": "B079GD1ZLR",
        "ReviewItem3": 33,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gSKqPeamL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " January 28, 2018",
        "Id": 8024,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 6,
        "PriceMax": 133.55,
        "ReviewItem5": 81,
        "Title": "Fossil Emma E/W Crossbody,Black,One Size",
        "ASIN": "B01KYUW1OS",
        "ReviewItem3": 0,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ntJDYj-UL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 133.55,
        "UploadTime": " October 8, 2016",
        "Id": 8025,
        "ReviewCount": 16
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 5.2,
        "ReviewItem5": 0,
        "Title": "Womens/Ladies Floral Print Woven Summer Handbag",
        "ASIN": "B01CHC1OOE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jaAdBa1ML._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 5.2,
        "UploadTime": " May 11, 2017",
        "Id": 8026,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89,
        "ReviewItem5": 0,
        "Title": "Kipling Women's Amiel Top-Handle Bag Sugar Stripes",
        "ASIN": "B01MRY86DH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51x2LRr8H1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89,
        "UploadTime": " August 12, 2015",
        "Id": 2468,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.48,
        "ReviewItem5": 0,
        "Title": "JIRAT AMA - Handmade 100% Organic Cotton Large Purse - Tribal Bag Clutch Style with Thai Hmong Embroidery, Large-Sized Embroidered Bag (N016)",
        "ASIN": "B07R5J3BYW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vYkPVDKCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.48,
        "UploadTime": " April 22, 2019",
        "Id": 1718,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89.99,
        "ReviewItem5": 0,
        "Title": "Daimanbo Women Delicate Imported Real Leather Bag",
        "ASIN": "B07C6JHBRJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JUBwgetxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.99,
        "UploadTime": " April 16, 2018",
        "Id": 1742,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 225,
        "ReviewItem5": 0,
        "Title": "Furla Brooklyn Mini Leather Drawstring Bag - Rosa",
        "ASIN": "B07L1BJ54D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ldfh-dgrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 225,
        "UploadTime": " November 30, 2018",
        "Id": 1764,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Rebecca Minkoff Chevron Quilted Small Love Crossbody",
        "ASIN": "B01MTG7NLL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ziRQUFKeL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 12, 2019",
        "Id": 1892,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32,
        "ReviewItem5": 0,
        "Title": "Women PU Leather Totes Bag Fashionable Top-handle bag Satchel Handbags Shoulder Bag",
        "ASIN": "B07DLTN72C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LwZBq2TTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32,
        "UploadTime": " December 23, 2018",
        "Id": 1686,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29,
        "ReviewItem5": 0,
        "Title": "Large Tote Bag - Multi Dog Print on Pink Canvas, Multipurpose Cotton Travel Shopper Bag",
        "ASIN": "B07JZ2GT6D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Z0M5KcWzL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29,
        "Id": 1685,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 82,
        "Title": "Crossover Purse and Handbags Crossbody Bags for Women Soft Leather Wallet Cute Small Neatpack Bag with Pockets",
        "ASIN": "B07NPMVQYJ",
        "ReviewItem3": 9,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IyIltTeiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " February 13, 2019",
        "Id": 1687,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 8,
        "PriceMax": 22.9,
        "ReviewItem5": 55,
        "Title": "Mn&Sue Stylish Women Pu Leather Vertical Utility Top Handle Handbag Business Briefcase Office Lady Purse",
        "ASIN": "B01GLA8KCM",
        "ReviewItem3": 17,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iD1lcf7gL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.9,
        "UploadTime": " June 4, 2016",
        "Id": 1689,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Miss Lulu Women Shoulder Bag Handbags Top-handle Totes Bird Flower Print Crossbody Messenger Bags",
        "ASIN": "B07CXPCLKF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Vp67HVxUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " June 22, 2017",
        "Id": 1690,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 175,
        "ReviewItem5": 50,
        "Title": "Hammitt Women's Tony Crossbody Bag",
        "ASIN": "B01N9M5LRA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CzQ7HCI9L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 175,
        "UploadTime": " June 1, 2018",
        "Id": 1691,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 168.99,
        "ReviewItem5": 0,
        "Title": "Michael Kors Sofia Large Embroidery Tote Bag Susannah Black",
        "ASIN": "B07NS98PRX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41RuHUgLI4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 168.99,
        "UploadTime": " February 15, 2019",
        "Id": 1692,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 80,
        "Title": "Myra Bag White & Brown Cowhide Shade Bag S-1171",
        "ASIN": "B07DQSP662",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Qe-x2aavL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 14, 2018",
        "Id": 1693,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 83.53,
        "ReviewItem5": 0,
        "Title": "Anna by Anuschka Women's Genuine Leather Medium Cross Body | Hand Painted Original Artwork",
        "ASIN": "B07D3J9WJL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51bs-s2voaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 83.53,
        "UploadTime": " July 25, 2018",
        "Id": 1694,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 94,
        "Title": "MICHAEL Michael Kors Womens Jet Set Organizational Travel Tote Handbag",
        "ASIN": "B06X928MSY",
        "ReviewItem3": 0,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BVmR0y1xL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 9, 2017",
        "Id": 1695,
        "ReviewCount": 34
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 33,
        "PriceMax": 28.8,
        "ReviewItem5": 67,
        "Title": "Skull And Crossbones Print Cotton Cross Body Bag",
        "ASIN": "B00U6P9OO2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41utBCeKdVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.8,
        "UploadTime": " July 22, 2015",
        "Id": 1696,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.99,
        "ReviewItem5": 100,
        "Title": "Betsey Johnson Womens Heart Handle Satchel",
        "ASIN": "B07FL59MJK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51uRALMjKVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.99,
        "UploadTime": " November 10, 2018",
        "Id": 1697,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YIBANG-Bag Men's Wallet Leather Multi-Function Clutch Men's Fashion (Color : Brown, Size : S)",
        "ASIN": "B07RJB85B5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BuPY0y2rL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1698,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.79,
        "ReviewItem5": 0,
        "Title": "Yi-Yi Canvas Tote Bag Shoulder Bag with Magnetic Buckle Inside Pocket For Women School Work Travel and Shopping",
        "ASIN": "B07PQB3RK7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41OJUntEXzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.79,
        "UploadTime": " March 18, 2019",
        "Id": 1699,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Hycurey Women's Multi Zipper Pocket Crossbody Bag Small Handbag and Purse",
        "ASIN": "B07DT92WTR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wCLy4R66L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " June 18, 2018",
        "Id": 1923,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 75.95,
        "ReviewItem5": 0,
        "Title": "Baggallini Hobo Tote Handbag Functional Pockets Crossbody (Charcoal)",
        "ASIN": "B00SZ63IQY",
        "ReviewItem3": 0,
        "ReviewItem4": 100,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Q6FzAmTSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 75.95,
        "UploadTime": " November 4, 2014",
        "Id": 1700,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Iphone Outdoor Activities Multifunctional Wallet Passport Cosmetic Bag",
        "ASIN": "B07KT4KSPH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414wLYcSDOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 23, 2018",
        "Id": 1701,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 87.09,
        "ReviewItem5": 0,
        "Title": "Royal RepubliQ Tote Bag - Cgn, Women’s Tote, Braun (Cognac), 10x41.5x31 cm (B x H T)",
        "ASIN": "B074MFVCCY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/318OfE%2B0hTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 87.09,
        "UploadTime": " December 25, 2018",
        "Id": 1702,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 139,
        "ReviewItem5": 100,
        "Title": "Qidell Women's Padlock Handbags Genuine leather Lace Padlock Purse Gold Hardware",
        "ASIN": "B07QFMD1WX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JNcaiGmPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 139,
        "UploadTime": " February 23, 2018",
        "Id": 1703,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 12,
        "PriceMax": 26.44,
        "ReviewItem5": 49,
        "Title": "Suvelle Lightweight Go-Anywhere Travel Everyday Crossbody Bag Multi Pocket Shoulder Handbag 20103",
        "ASIN": "B0106EZY1O",
        "ReviewItem3": 10,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41K0l6U-I9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.44,
        "UploadTime": " June 22, 2015",
        "Id": 1704,
        "ReviewCount": 215
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 398,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Women's Dorie Medium Bucket Bag",
        "ASIN": "B07NCBC3K6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31vD5YWsQCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 398,
        "UploadTime": " March 16, 2019",
        "Id": 1705,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Contacts Genuine Leather Coin Clutch Purse Phone Long Zipper Wallet Dark Coffee",
        "ASIN": "B00XKTBC8C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eQaJ2GO6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " May 13, 2015",
        "Id": 1717,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.95,
        "ReviewItem5": 0,
        "Title": "CafePress - Austens Land - Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00R29JAXA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AG4HGWzML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.95,
        "Id": 1719,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.8,
        "ReviewItem5": 0,
        "Title": "LA'FESTIN Leather Bucket Handbags for Ladies Classy Top Handle Bag with Cross Body Chain Strap",
        "ASIN": "B07L5GGXGZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/314gg6a5g5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.8,
        "UploadTime": " December 5, 2018",
        "Id": 1706,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 175,
        "ReviewItem5": 85,
        "Title": "Kate Spade New York Women's Jackson Street Gabriele Bag",
        "ASIN": "B07BZLVRSX",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510eO%2BHD3mL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 175,
        "UploadTime": " September 8, 2018",
        "Id": 1707,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Woven Handbag Rattan Beach Grass Tote Bag Natural Bamboo Straw Handbag European Black Red American Style",
        "ASIN": "B07R4YPW4D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aH5muhcSL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1708,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.96,
        "ReviewItem5": 0,
        "Title": "Hot Seal Women's Fashion Animals Canvas Tote Bag Shoulder Hand Bag",
        "ASIN": "B01BZYO7KS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61q1P2cHIoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.96,
        "UploadTime": " February 20, 2016",
        "Id": 1709,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Accessories",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 0,
        "Title": "WiiSHAM Multi Pocket Organizer Inset Bag With Zipper",
        "ASIN": "B07FNFLXBK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZuTn62alL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " July 4, 2018",
        "Id": 1710,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Women's EW Tote Handbag, Red/White/Blue Multi",
        "ASIN": "B007YX8TCM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61djaxuLyzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69,
        "UploadTime": " April 30, 2012",
        "Id": 1711,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 48.88,
        "ReviewItem5": 73,
        "Title": "Bamboo Handbag Straw Purse Clutch Bags Handmade Tote Beach Handbags for Women",
        "ASIN": "B076BCRVTL",
        "ReviewItem3": 9,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5171LtX0LIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 48.88,
        "UploadTime": " April 27, 2018",
        "Id": 1712,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 5,
        "PriceMax": 11.25,
        "ReviewItem5": 84,
        "Title": "Disney Frozen Elsa Pink Adjustable Strap Messenger Shoulder Cross Purse Bag",
        "ASIN": "B00PUPOSV2",
        "ReviewItem3": 3,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BTwVRyTTL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.25,
        "Id": 1713,
        "ReviewCount": 38
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.94,
        "ReviewItem5": 0,
        "Title": "giveyoulucky Men Wallet Classic Ultra-Thin long Style Soft Faux Leather Clutch Purse Credit Card Holder Brown",
        "ASIN": "B07R96RYQZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51GTOf5t-dL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.94,
        "Id": 1714,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.89,
        "ReviewItem5": 86,
        "Title": "YAAGLE PU Leather Large Totes Shoulder Bag With Removable Inside Hand Bag for Women Girls",
        "ASIN": "B01J3CTHVI",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514EJ54qpPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.89,
        "UploadTime": " October 29, 2016",
        "Id": 1715,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Eyewear Frames",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 80,
        "Title": "Firmoo Anti-Blue Light Glasses, Oversize Computer Eyewear, Women Square Eyeglass Frame",
        "ASIN": "B07QKYPB7P",
        "ReviewItem3": 20,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31aWNz6U0VL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " April 10, 2019",
        "Id": 1716,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 83,
        "Title": "Crossbody Bags for Women Teen Girls Leather Fashion Handbags Purse and Classic Medium Shoulder Bag",
        "ASIN": "B07P94HKVN",
        "ReviewItem3": 0,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51APov3yZ2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " December 4, 2018",
        "Id": 1720,
        "ReviewCount": 18
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Women Men PU Leather Steampunk Shoulder Waist Bag Thigh Holster Motorcycle Bag & Crossbody Bag",
        "ASIN": "B07QH69N6C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ieyr6-WXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 10, 2019",
        "Id": 1721,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 245,
        "ReviewItem5": 0,
        "Title": "Coach Signature Stamped Hailey Tote Shoulder 31141 Bag",
        "ASIN": "B00PT669AU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xuRoMvwhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 245,
        "UploadTime": " February 3, 2017",
        "Id": 1722,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28,
        "ReviewItem5": 0,
        "Title": "Mini Tote Bag with the Golfaholic logo",
        "ASIN": "B073VY6XKV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415pNzEBhJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28,
        "UploadTime": " July 11, 2017",
        "Id": 1723,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.98,
        "ReviewItem5": 75,
        "Title": "LUI SUI Womens Dinosaur Whale Crossbody Purse Bags Animal Cat Flamingo Chic Clutch Shoulder Bags",
        "ASIN": "B07MC2NSTY",
        "ReviewItem3": 12,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UkhBh4aEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.98,
        "UploadTime": " January 7, 2019",
        "Id": 1724,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 106.67,
        "ReviewItem5": 0,
        "Title": "GUESS Heidi Pewter Tote",
        "ASIN": "B07D8L6V44",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JTyvazYHL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 106.67,
        "UploadTime": " November 23, 2018",
        "Id": 1725,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Signare Pink Kaleidoscope Women’s Fashion Canvas Tapestry Top Handle Handbag with Detachable Strap to Convert to Shoulder Bag (Conv-Kale)",
        "ASIN": "B00W9ZQ4SQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51B06zwmMWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " April 17, 2015",
        "Id": 1726,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "AYCQ PU Leather Women Handbag Crossbody Shoulder Tote Bag Lady Hobo Satchel",
        "ASIN": "B07QMHVJY3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sTNgXIC%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 1, 2019",
        "Id": 1727,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Soccer Mama Gift for Mom Tote Bag Black 3345d",
        "ASIN": "B07KVC7STZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nd4mgMLaL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "Id": 1728,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 268.85,
        "ReviewItem5": 0,
        "Title": "Michael Kors Womens Gramercy Sm Th Satchel Top-Handle Bag Black (Black)",
        "ASIN": "B0764KQ2V3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519WVt6exwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 268.85,
        "UploadTime": " May 1, 2018",
        "Id": 1729,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Helena Crossbody Premium Crossover Bag Over the Shoulder Womens Bag by Mia K. Farrow",
        "ASIN": "B07L5SYC96",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hH0Bnp8eL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " December 6, 2018",
        "Id": 1743,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 158,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Women's Sylvia Small Dome Crossbody Bag",
        "ASIN": "B07NYB2GXY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Q72GUjOXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 158,
        "UploadTime": " February 22, 2019",
        "Id": 1744,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Smilecoco Women Adjustable Shoulder Strap Tassel Shoulder Bags Cross body Bags Small Purse",
        "ASIN": "B0759VNBTY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MhpwZe5QL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 1, 2017",
        "Id": 1745,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 53.57,
        "ReviewItem5": 100,
        "Title": "Kipling Art M, Handbag For Women 58x32x20 cm",
        "ASIN": "B07D1728CC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UiuJbQCVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 53.57,
        "UploadTime": " September 8, 2018",
        "Id": 1934,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 2,
        "PriceMax": 39.99,
        "ReviewItem5": 82,
        "Title": "YALUXE Tote for Women Leather Nylon Shoulder Bag Women's Oxford Large Capacity Work fit 15.6 inch",
        "ASIN": "B07M5F4F2H",
        "ReviewItem3": 4,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BnLFRZd3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " December 20, 2018",
        "Id": 1730,
        "ReviewCount": 485
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.4,
        "ReviewItem5": 0,
        "Title": "Rosetti Striped Janet Tote Handbag",
        "ASIN": "B07PVVPCRZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RrCXMsg7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.4,
        "UploadTime": " March 6, 2019",
        "Id": 1731,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.89,
        "ReviewItem5": 0,
        "Title": "Danger! Category 5 Hurricanes_12103 Waterproof Travel Hanging Organizer Bag Airport Airline Compliant Bag Mirror Women Girls Dark Blue",
        "ASIN": "B07RDNMS5C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iLdSFxenL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.89,
        "Id": 1732,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Chaufly Women Beach Handbags Mesh Woven Hollow Rope Cotton Casual Mini Totes Purse",
        "ASIN": "B07F5KXYV8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sSuz094DL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 30, 2018",
        "Id": 1733,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Ballerina with Bun Tote Bag 26682",
        "ASIN": "B01EX6YKJI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kVruJ5PDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " April 28, 2016",
        "Id": 1734,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Army Wife Dog Tags Cotton Canvas Tote Bag in Hot Pink - One Size",
        "ASIN": "B071L1SPPZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41s8piRvrnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 3, 2017",
        "Id": 1735,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.99,
        "ReviewItem5": 0,
        "Title": "Diophy Front Zipper Pocket Hobo with Matching Wallet 2 Pieces Set",
        "ASIN": "B07G2Q1CJK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41e4fmNaTkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.99,
        "UploadTime": " July 31, 2018",
        "Id": 1736,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "👅NIKIShop👅 Women Fashion Pineapple&Leaves Tassel Handwoven Round Rattan Bag Straw Bag Crossbody Bag",
        "ASIN": "B07QZJQYXW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RcwMKtmdL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 20, 2019",
        "Id": 1737,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Blue Bichon Frise Fabric Vertical Crossbody Single Shoulder Bag With Shoulder Girdle Cellphone Pouch Purse Wallet Unisex",
        "ASIN": "B07RB3VRPG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51t0mu9ACYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 30, 2019",
        "Id": 1738,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 165,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Iconic Ultimate Baby Bag, Denim",
        "ASIN": "B07CHXRFVD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vN11tDlVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 165,
        "UploadTime": " May 23, 2018",
        "Id": 1739,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 1450,
        "ReviewItem5": 0,
        "Title": "Prada Ibisco Pink Tessuto Nylon Saffiano Leather Trim Shopping Tote Bag 1BG253",
        "ASIN": "B07Q41L5HT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41V2GeY5-1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 1450,
        "UploadTime": " March 27, 2019",
        "Id": 1740,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "Base Shaper Clear Acrylic 1/16” Lightweight for Hermes Bags Toolbox 26 Tool Box, Tote, Handbag, Bag, Purse Insert, Plexiglas, Plexiglass Bottom, Plastic",
        "ASIN": "B07D5H4HTL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31YOQTdcosL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 13, 2018",
        "Id": 1741,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 4,
        "PriceMax": 19.99,
        "ReviewItem5": 81,
        "Title": "Small Crossbody Purse Wallet Pu Leather Bags with Bowknot Chain Strap for Women Shoulder Bag",
        "ASIN": "B072FHLVS2",
        "ReviewItem3": 0,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hGAO20nrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " May 17, 2017",
        "Id": 1746,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Pengy Mens Mature Brown Purse Casual Short Leather Wallets Males Credit Card Holder Purse",
        "ASIN": "B07R2C1HBQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mOKGPZGHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 24, 2019",
        "Id": 1747,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.5,
        "ReviewItem5": 0,
        "Title": "Santoro London Handbag Purse Poppi Loves Bear Small Animal Purse",
        "ASIN": "B07GQ4T4S7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Gch-VRXIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.5,
        "UploadTime": " August 21, 2018",
        "Id": 1748,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Passport, Credit Card Travel Crossbody Bag Ani-Theft Women Men Roomy Pockets",
        "ASIN": "B07KSZPVRW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41K1YZzCg0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 23, 2018",
        "Id": 1749,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.96,
        "ReviewItem5": 0,
        "Title": "Mily Fashion Women Girls Fringed Crochet Shoulder Bag Hollow Out Woven Tassel Bag Bohemian Beach Cross Body Bag",
        "ASIN": "B07C5CZRRC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51u%2B8hIPZOL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.96,
        "Id": 1750,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 77,
        "Title": "Women's Wallet RFID Blocking Genuine Vintage Leather Purse Credit Card Clutch Holder for Women",
        "ASIN": "B07NNTRK8S",
        "ReviewItem3": 5,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41G-fVUWKaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " February 12, 2019",
        "Id": 1751,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Funny Goldfish Oriental Koi Fish Womens Clutch Wallet Large Wristlet Zipper Clutch Large Travel Purse",
        "ASIN": "B07Q5GRR9X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41h994QQJ8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " March 29, 2019",
        "Id": 1752,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 93.5,
        "ReviewItem5": 0,
        "Title": "Coach Signature Large Double Zip Wristlet Bag Purse Khaki Petal F16109",
        "ASIN": "B07NKY1J6Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jzsrad81L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 93.5,
        "UploadTime": " February 9, 2019",
        "Id": 1893,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 26.99,
        "ReviewItem5": 74,
        "Title": "Clocolor Crystal Clutch Purses Evening Clutch Bag Rhinestone Series-Dazzling Ring Evening Bags for Wedding Party Purses",
        "ASIN": "B06Y4P15MK",
        "ReviewItem3": 5,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xx53ttYoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " April 8, 2017",
        "Id": 1753,
        "ReviewCount": 19
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 100,
        "Title": "MKF Collection Alice Structured Designer Handbag by Mia K. Farrow",
        "ASIN": "B06XT6PTCQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31NmAXJvuCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " March 23, 2017",
        "Id": 1754,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Replacement Sunglass Lenses",
        "ReviewItem1": 16,
        "ReviewItem2": 0,
        "PriceMax": 36,
        "ReviewItem5": 52,
        "Title": "Revant Replacement Lenses for Oakley Half Jacket XLJ",
        "ASIN": "B00KHYCAD4",
        "ReviewItem3": 16,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zl8Nl2QZL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36,
        "UploadTime": " January 31, 2014",
        "Id": 1755,
        "ReviewCount": 25
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Outsta 4Pcs Women Pattern Leather, Handbag+Crossbody Bag+Messenger Bag+Card Package,Fashion Handbag Shoulder Bag Purse Waterproof Casual Solid Color (Pink)",
        "ASIN": "B07G1YVVXH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pD87qVkEL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1756,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 11,
        "PriceMax": 0,
        "ReviewItem5": 45,
        "Title": "Donalworld Women Handbag Shoulder Bags Tote Purse Pu Leather Messenger Bag",
        "ASIN": "B06ZXZ316Y",
        "ReviewItem3": 11,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31fhvNf27HL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 19, 2017",
        "Id": 1757,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 227.95,
        "ReviewItem5": 0,
        "Title": "Fossil Rachel Tote Bag ,Tan",
        "ASIN": "B07NPG55PW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wJs-i4yXL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 227.95,
        "UploadTime": " April 19, 2019",
        "Id": 1758,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 3,
        "PriceMax": 39.5,
        "ReviewItem5": 71,
        "Title": "Dasein Women Fashion Handbags Tote Purses Shoulder Bags Top Handle Satchel Purse Set 2pcs",
        "ASIN": "B0791SGCNN",
        "ReviewItem3": 8,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DSGlC2ETL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.5,
        "UploadTime": " January 16, 2018",
        "Id": 1759,
        "ReviewCount": 146
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 4,
        "PriceMax": 12.95,
        "ReviewItem5": 67,
        "Title": "Tassel Accent Small Half Moon Crossbody Bag",
        "ASIN": "B073HPS177",
        "ReviewItem3": 10,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41EdinrH-UL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.95,
        "UploadTime": " June 29, 2017",
        "Id": 1760,
        "ReviewCount": 52
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors EMMY Women's Shoulder Handbag LARGE DOME SATCHEL",
        "ASIN": "B077L7Y431",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515UuKbC8kL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 18, 2017",
        "Id": 1761,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 67,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Anlydia Hologram Transparent PVC Tote Bags Laser Shoulder Bag",
        "ASIN": "B075KQ75KP",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41punE9uLuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " September 12, 2017",
        "Id": 1762,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 17,
        "PriceMax": 50,
        "ReviewItem5": 83,
        "Title": "Neverfull Style Designer Woman Organizer Handbag Tote Shoulder Shopping Bag MM Size",
        "ASIN": "B07R8XGFTH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5186geUr-wL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 50,
        "UploadTime": " April 1, 2019",
        "Id": 1765,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Messenger Bag Crossbody Bags For Girl Female Embroidery Flower Handbag Designer Velvet Shoulder Bags",
        "ASIN": "B077GVPVJX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RvWxtLZDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 15, 2017",
        "Id": 1766,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 298,
        "ReviewItem5": 0,
        "Title": "Marc Jacobs Mini Boho Grind Leather Crossbody Bag, Rhubarb",
        "ASIN": "B07NSHVL98",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vUQSlXJdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 298,
        "UploadTime": " February 15, 2019",
        "Id": 1767,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Flip-Flops",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.9,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Summer Women's Slippers Outdoor & Indoor Sandals Mix Flip Flops",
        "ASIN": "B07MCY9QKC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413hh5w2dIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.9,
        "UploadTime": " December 28, 2018",
        "Id": 1768,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 5,
        "PriceMax": 27.99,
        "ReviewItem5": 69,
        "Title": "GESU Womens Crystal Evening Clutch Bag Wedding Purse Bridal Prom Handbag Party Bag.",
        "ASIN": "B073TTHVQR",
        "ReviewItem3": 5,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61%2Bvg1G44ZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " July 9, 2017",
        "Id": 1769,
        "ReviewCount": 156
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 214,
        "ReviewItem5": 0,
        "Title": "Furla Lara Leather Crossbody Handbag",
        "ASIN": "B077666WTG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31x1pE9o5xL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 214,
        "UploadTime": " October 13, 2017",
        "Id": 1770,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45,
        "ReviewItem5": 0,
        "Title": "Roxy Desert Bloom Medium Crossbody Bag",
        "ASIN": "B07DMKP9YJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31wd20zcMDL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45,
        "UploadTime": " August 28, 2018",
        "Id": 1771,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 9,
        "PriceMax": 34.99,
        "ReviewItem5": 65,
        "Title": "Womens Extra Large Fashion Shoulder Bag Top Handle Handbag Hobo Tote Satchel Purse",
        "ASIN": "B07KX23BQY",
        "ReviewItem3": 17,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BiEgTA%2BVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " May 15, 2017",
        "Id": 1772,
        "ReviewCount": 23
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 168,
        "ReviewItem5": 0,
        "Title": "Tory Sport Women's Rexin Crossbody Bag",
        "ASIN": "B07MW8PC9Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31tMJeeWv7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 168,
        "UploadTime": " January 17, 2019",
        "Id": 1773,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 95,
        "ReviewItem5": 0,
        "Title": "Lipault - Lady Plume Tote Bag - Medium Top Handle Shoulder Handbag for Women",
        "ASIN": "B07N7SX133",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31hdWsIYcHL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 95,
        "UploadTime": " January 29, 2019",
        "Id": 1792,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.95,
        "ReviewItem5": 0,
        "Title": "CafePress HAPPINESS IS DAY W/MY COUSINS Natural Canvas Tote Bag, Cloth Shopping Bag",
        "ASIN": "B00O14DFJO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51p6HKbX8pL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.95,
        "Id": 1774,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Never Underestimate The Power Of A Texas Oba-chan - Tote Bag With Zip",
        "ASIN": "B07K7VYGHM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51J-kUkRXIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " November 6, 2018",
        "Id": 1775,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 66.36,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Fluid Small Crossbody, Women’s Cross-Body Bag, Black, 8x12x18 cm (B x H T)",
        "ASIN": "B075BLQBHF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41falGmF59L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 66.36,
        "UploadTime": " May 2, 2018",
        "Id": 1776,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 0,
        "Title": "JOSEKO Handwoven Round Rattan Bag, Retro Straw Crossbody Shoulder Bag Chic Handbag for Women Brown",
        "ASIN": "B07D77F3TM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51P1K8pw72L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " May 22, 2018",
        "Id": 1777,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 26,
        "ReviewItem2": 11,
        "PriceMax": 4.12,
        "ReviewItem5": 33,
        "Title": "Clearance Sale! ZOMUSAR Women Fashion PU Leather Zipper Small Deer Splice Handbag Shoulder Shell Bag Shiny Crossbody Tote Bag",
        "ASIN": "B07JFXJQ9N",
        "ReviewItem3": 18,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BdkvSo57L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 4.12,
        "UploadTime": " January 17, 2018",
        "Id": 1778,
        "ReviewCount": 66
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.29,
        "ReviewItem5": 66,
        "Title": "LUOEM Waist Bags Shiny PU Leather Hologram Shoulder Bag Cross-body Chest Bag for Women",
        "ASIN": "B07CH6TPDR",
        "ReviewItem3": 17,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31GX8g%2BOLgL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.29,
        "UploadTime": " April 19, 2018",
        "Id": 1779,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.27,
        "ReviewItem5": 100,
        "Title": "Myra Bag Subtle Upcycled Canvas Bag S-1267",
        "ASIN": "B07HYP92SX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sAPYiuvAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.27,
        "UploadTime": " October 2, 2018",
        "Id": 1780,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 79.95,
        "ReviewItem5": 0,
        "Title": "BG by baggallini RFID Raleigh Crossbody",
        "ASIN": "B07P158GCB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41nwGN%2BsErL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79.95,
        "UploadTime": " February 21, 2019",
        "Id": 1781,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 51.99,
        "ReviewItem5": 0,
        "Title": "Women Crossbody Purse, Brenice Vintage Genuine Leather Handbag Embossed Shoulder Messenger Bag",
        "ASIN": "B07CQLNZY5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OLADdaUGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 51.99,
        "UploadTime": " April 28, 2018",
        "Id": 1782,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 9,
        "PriceMax": 64.95,
        "ReviewItem5": 63,
        "Title": "Western Style Concealed Carry Purse Buckle Country Large Handbags Messenger Shoulder Bag Wallet Set Brown",
        "ASIN": "B079B25C3Q",
        "ReviewItem3": 16,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ak3SFNejL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.95,
        "UploadTime": " January 24, 2018",
        "Id": 1812,
        "ReviewCount": 32
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 1584,
        "ReviewItem5": 0,
        "Title": "Silvano Biagini Italian Designer Handpainted Genuine Python Leather Purse Bag w/Animale Handle",
        "ASIN": "B07P1884JB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HZmB8momL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 1584,
        "UploadTime": " February 21, 2019",
        "Id": 1783,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "SimpleLif Womens Skull Rivet Tassel Shoulder Bag Leather Punk Rock Handbag Satchel",
        "ASIN": "B07JQ5X5X5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xUozXpVZL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1784,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Yoome Women Genuine Leather Cute Small Shoulder Handbags Cross Body Clutch Lady Mini Fashion Purse",
        "ASIN": "B07KLYWGY8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AhbkmLm7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " November 16, 2018",
        "Id": 1785,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 100,
        "Title": "Mn&Sue Tartan Small Cross Body Bags Mini Bee Top Handle Satchel Round Compartment Purses for Women",
        "ASIN": "B07K4123LS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wCmbW7aTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " November 2, 2018",
        "Id": 1786,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "FCZERO HB420048 2016 PU Leather Korean Version Handbag,Dumplings Type Small Square Package",
        "ASIN": "B01DW9G888",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oTpN1HTjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 6, 2016",
        "Id": 1787,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 5,
        "ReviewItem2": 0,
        "PriceMax": 19.89,
        "ReviewItem5": 67,
        "Title": "Holeless Leather Ratchet Belts for Men 45\" - 48\" Length Cutting to fit Slide Buckle",
        "ASIN": "B07CQ2TCYW",
        "ReviewItem3": 0,
        "ReviewItem4": 28,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zYI1Jer0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.89,
        "UploadTime": " August 9, 2018",
        "Id": 1788,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.99,
        "ReviewItem5": 80,
        "Title": "Disney Parks Crossbody Bag Mickey Mouse Colorful Pop Art",
        "ASIN": "B07MH16JYQ",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pLWOSSLRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.99,
        "UploadTime": " December 26, 2018",
        "Id": 1789,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 75,
        "Title": "Miss Lulu Hobo Shoulder Bags Handbags for Women Soft PU Leather Ladies Tote Bag",
        "ASIN": "B07J5J3QMQ",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AwK2UK1NL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " October 9, 2018",
        "Id": 1790,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 7,
        "PriceMax": 59.99,
        "ReviewItem5": 59,
        "Title": "LaGaksta Mini Very Soft Italian Leather Crossbody Small Cell Phone Wallet Purse",
        "ASIN": "B00OPDGU0W",
        "ReviewItem3": 7,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415dfDrmQEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " August 11, 2016",
        "Id": 1791,
        "ReviewCount": 41
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Rose Print Small Bag by Myra Bags",
        "ASIN": "B07DSG6GMH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51E06spUF-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 16, 2018",
        "Id": 1858,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 12,
        "PriceMax": 24.95,
        "ReviewItem5": 50,
        "Title": "Business Men's Clutch bag High capacity Leather Wallet Double zipper Long Purse",
        "ASIN": "B071J3RM6C",
        "ReviewItem3": 13,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51GM%2BdzaJ8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " May 24, 2017",
        "Id": 1793,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 52,
        "ReviewItem5": 0,
        "Title": "Mona B Life is Short Tote - Live Love Create Tote",
        "ASIN": "B07NPS6TV2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/311G7w%2BixbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52,
        "UploadTime": " February 13, 2019",
        "Id": 1794,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 348,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke City Small Barlow Top Handle Bag Geranium Red",
        "ASIN": "B01BZ7M7DE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IZS8nlqbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 348,
        "UploadTime": " July 27, 2018",
        "Id": 1795,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 1,
        "ReviewItem2": 1,
        "PriceMax": 40,
        "ReviewItem5": 84,
        "Title": "HOJ Co. IVAR ID BIFOLD Money Clip Wallet-Full Grain Leather-Magnetic Front Pocket Wallet",
        "ASIN": "B073S7PLV1",
        "ReviewItem3": 4,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aMzb2qKEL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40,
        "UploadTime": " November 15, 2015",
        "Id": 1796,
        "ReviewCount": 134
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 179,
        "ReviewItem5": 0,
        "Title": "Coach Metallic Leather Chain Crossbody, Clutch, Handbag",
        "ASIN": "B077KFZ48Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UOb2sRiYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 179,
        "UploadTime": " November 17, 2017",
        "Id": 1797,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 3,
        "ReviewItem2": 4,
        "PriceMax": 17.9,
        "ReviewItem5": 82,
        "Title": "Lillian Rose 13\"x12\" Aqua Bride Tote, 13\" x 12\" x 4\"",
        "ASIN": "B00A5PL7O8",
        "ReviewItem3": 5,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jQr7BiUuL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.9,
        "Id": 1798,
        "ReviewCount": 68
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Wocharm Women Faux Suede Clutch Purse Envelope Chain Shoulder Crossbody Purse Bag",
        "ASIN": "B07QQPP5MS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pILaHDbYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 14, 2019",
        "Id": 1799,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "World Famous Landmarks Printed Canvas Tote Bag with Leather Strap WAS_29",
        "ASIN": "B013V05JLU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41g8nMKjneL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " August 13, 2015",
        "Id": 1800,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Backpacks",
        "ReviewItem1": 2,
        "ReviewItem2": 0,
        "PriceMax": 37.99,
        "ReviewItem5": 98,
        "Title": "15.6 inches Laptop Backpack Computer Cases, Convertible Business Backpack Briefcase Messenger Bag, Multi-Functional Travel Rucksack Daypack School Bookbag Handbag for Women Men Students",
        "ASIN": "B07HK7NQ5D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tjtBHE-IL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.99,
        "Id": 1801,
        "ReviewCount": 46
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 7,
        "PriceMax": 21.99,
        "ReviewItem5": 61,
        "Title": "Soft Washed PU Leather Crossbody Purse Multi Pocket Vertical Bag Shoulder Satchel for Women",
        "ASIN": "B07D7Y1N95",
        "ReviewItem3": 8,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51QKtp45MgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " December 26, 2018",
        "Id": 1802,
        "ReviewCount": 165
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Louis Vuitton Monogram Empreinte Leather Pochette Metis Handbag Article: M44018 Made in France",
        "ASIN": "B06XVSC732",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51r4qe5YEML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 26, 2017",
        "Id": 1803,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Leather Clutch Purse Wallet for Men Organizer Holder Wrist Bag Business Handbags",
        "ASIN": "B07QFVB86Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tFz3OSokL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 8, 2019",
        "Id": 1804,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Valencia Canvas Shoulder Bag",
        "ASIN": "B0764KRVVG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51W6ccvj7hL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " October 3, 2017",
        "Id": 1805,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.21,
        "ReviewItem5": 0,
        "Title": "Lewis N. Clark Secura Women’s Anti-Theft Sling Messenger Crossbody Bag W/RFID Blocking Pockets Travel Purse, Black, One Size",
        "ASIN": "B07PXBPN4Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41flhPwmEWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.21,
        "UploadTime": " March 20, 2019",
        "Id": 1806,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.75,
        "ReviewItem5": 100,
        "Title": "potato001 Women Candy Flower Clear Transparent Handbag Shoulder Vegetable Bags Beach Bag",
        "ASIN": "B07648VRNY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yFMPlpRtL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.75,
        "UploadTime": " October 3, 2017",
        "Id": 1807,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Trash Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 60,
        "Title": "Lesbin Handle-Tie Small Trash Bag, 2.6 Gallon, 100 Counts (Clear)",
        "ASIN": "B071NNCPBN",
        "ReviewItem3": 40,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41O1whqdyDL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1808,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 100,
        "Title": "Usbagtech Women Leather Shoulder Tote Handbags Designer Hobo Bag Messenger Purse With Removable Wallet",
        "ASIN": "B07K19XQHC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41y0KAz%2BPoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " August 12, 2018",
        "Id": 1809,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "LV LOUIS VUITTON LYMINGTON - Bag Base Shaper 1/16” Lightweight Clear Acrylic",
        "ASIN": "B07M9PVTYZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/21Xb4P9n3ZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 13, 2018",
        "Id": 1810,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 75.9,
        "ReviewItem5": 0,
        "Title": "Heshe Vintage Women’s Leather Handbags Shoulder Bags Totes Purses Ladies Designer Cross Body Bag",
        "ASIN": "B07BLP2BLG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51k9kkJwITL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 75.9,
        "UploadTime": " March 20, 2018",
        "Id": 1811,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Buddy Handbag Fashion Holographic Laser Shoulder Bag Geometric Envelope Clutch Chain Crossbody Purse for Women",
        "ASIN": "B07Q2Z5P5Z",
        "ReviewItem3": 0,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51t-suqHQJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " March 27, 2019",
        "Id": 1813,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.95,
        "ReviewItem5": 0,
        "Title": "Nikky Women's Soft Multiple Compartment Black Crossbody Bag Cross Body, One Size",
        "ASIN": "B007ZT7QMY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511zClsxEsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.95,
        "Id": 1814,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 1.77,
        "ReviewItem5": 0,
        "Title": "VIASA Portable Makeup Cosmetic Toiletry Travel Pouch Cosmetic Organizer Bag",
        "ASIN": "B076J7T5Z5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vc9VK5siL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 1.77,
        "UploadTime": " August 28, 2017",
        "Id": 1815,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 8,
        "ReviewItem2": 2,
        "PriceMax": 69.99,
        "ReviewItem5": 72,
        "Title": "NAWO Women Leather Handbags Designer Shoulder Tote Top-handle Purses",
        "ASIN": "B072LX42W4",
        "ReviewItem3": 8,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Wkb3xVGtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.99,
        "UploadTime": " May 24, 2017",
        "Id": 1816,
        "ReviewCount": 124
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 90,
        "Title": "Sabai Jai - Floral Embroidered Boho Clutch - Handmade Ethnic Flower Wristlet Purse",
        "ASIN": "B0755X2958",
        "ReviewItem3": 0,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51crM4%2BezCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " August 27, 2017",
        "Id": 1817,
        "ReviewCount": 48
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Sydney Love Green Golf Wristlet",
        "ASIN": "B006NWFVDA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ekyOaiSuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 13, 2012",
        "Id": 1818,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "High-end Fashion Microfiber Crossbody Bag Lush Green ridges of Carnic Alps Friuli Venezia Giulia Italy Casual, Lightweight Multi Pockets Crossbody Bag",
        "ASIN": "B07QC1JFFN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mzRLPWxzL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1819,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 99.99,
        "ReviewItem5": 0,
        "Title": "Hobo Fast Lane Shoulder Bag",
        "ASIN": "B075WBDQ68",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31LgNQiJUyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 99.99,
        "UploadTime": " January 21, 2019",
        "Id": 1820,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.95,
        "ReviewItem5": 43,
        "Title": "KAVU Saskatoon Satchel",
        "ASIN": "B07DF6J6QH",
        "ReviewItem3": 14,
        "ReviewItem4": 43,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510L3HNC7eL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 44.95,
        "UploadTime": " July 13, 2017",
        "Id": 8248,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Handbag Organizer/Make-Up Organizer with 13 Compartments",
        "ASIN": "B07F3W4W57",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41V0Yk-pmPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " June 29, 2018",
        "Id": 1821,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.69,
        "ReviewItem5": 0,
        "Title": "Nikky Women's Structured Mini Brown Boston Bag Bu Cross Body, One Size",
        "ASIN": "B071KH8R5R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51O-D-rVmDL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.69,
        "Id": 1822,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Men RFID Blocking Wallet Crazy Horse Leather Bifold Short Purse",
        "ASIN": "B07QYMD63P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51sTPdXWwFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " April 22, 2019",
        "Id": 1823,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39,
        "ReviewItem5": 0,
        "Title": "Crossbody Bag Quilted Fold-over Metallic Clutch Bag with Detachable Shoulder Strap",
        "ASIN": "B07BNVCF8Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VP-CJuxiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39,
        "UploadTime": " March 23, 2018",
        "Id": 1824,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Cell phone purse,can be used as vertical crossbody bag, water washed leather, Gray, Pink",
        "ASIN": "B07PHJY8LN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/310Xn%2B4wrPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 4, 2019",
        "Id": 1825,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Halfbye RFID Mens Wallet Deluxe Capacity Divided Bill Sections Choice of Coin Bifold Multi Card Holder Purse Card Case",
        "ASIN": "B07R4R7T6Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IsIoU6ZFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 16, 2019",
        "Id": 1826,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 4,
        "PriceMax": 45.95,
        "ReviewItem5": 73,
        "Title": "Primo Sacchi Genuine Italian Leather, Small Shoulder Bag Handbag. Includes Branded a Protective Storage Bag.",
        "ASIN": "B06XNV8PYF",
        "ReviewItem3": 8,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41celJPwiiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.95,
        "UploadTime": " March 15, 2017",
        "Id": 1827,
        "ReviewCount": 73
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "Woman Handmade Rattan Woven Round Straw Knit Summer Beach Shoulder Messenger Bag",
        "ASIN": "B07GDNPHMW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BeAwEwXbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " August 13, 2018",
        "Id": 1828,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 324.99,
        "ReviewItem5": 0,
        "Title": "Michael Kors Whitney Outlined Shoulder Bag",
        "ASIN": "B07KQQTDDS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/411EqdD6zOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 324.99,
        "UploadTime": " November 20, 2018",
        "Id": 1859,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.41,
        "ReviewItem5": 0,
        "Title": "NEW! Victoria's Secret 2017 Love Holographic Tote Bag - Black!",
        "ASIN": "B076G625X7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41l27RRjRYL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.41,
        "UploadTime": " October 13, 2017",
        "Id": 1931,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 22,
        "ReviewItem2": 16,
        "PriceMax": 23.98,
        "ReviewItem5": 41,
        "Title": "SiMYEER Women's Leather Fashion Backpack Purse Rucksack Waterproof Shoulder Bag School Casual Daypack for Ladies",
        "ASIN": "B07GD8TVP2",
        "ReviewItem3": 15,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51O6fkcXC%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.98,
        "UploadTime": " August 12, 2018",
        "Id": 1829,
        "ReviewCount": 86
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 17,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Signature Brown Coin Purse by Rioni Handbags & Luggage",
        "ASIN": "B0065SEE6M",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dhck9iumL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 1, 2011",
        "Id": 1830,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Pueri Braided Beach Bag Fashion Handwoven Bag Round Rattan Bag Women Outdoor Shoulder Summer Bag",
        "ASIN": "B07DBY3BNY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41m15BZbbeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " May 27, 2018",
        "Id": 1831,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.5,
        "ReviewItem5": 86,
        "Title": "Chala Canvas Crossbody Messenger handBags with Teal Paw Print Keyfob/Coin Purse -",
        "ASIN": "B079CP1RGK",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61s-uKt9lEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.5,
        "UploadTime": " June 21, 2017",
        "Id": 1832,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.55,
        "ReviewItem5": 0,
        "Title": "Tamaris Women Adriana Small Wallet With Flap Cross-Body Bag",
        "ASIN": "B075YN3HPD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ui9LC755L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.55,
        "UploadTime": " September 8, 2018",
        "Id": 1833,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "womens Shoulder Bag Casual Big Shoppingbags Tote Handbag Work Bag Travel Bags for Women Girls Ladies",
        "ASIN": "B07D49328W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HjbxwSaLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " May 21, 2018",
        "Id": 1834,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.48,
        "ReviewItem5": 0,
        "Title": "Danielle Nicole Marvin the Martian Crossbody",
        "ASIN": "B07BMH6GHT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hwwVqUyeL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.48,
        "UploadTime": " June 15, 2018",
        "Id": 1835,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 10,
        "PriceMax": 14.44,
        "ReviewItem5": 55,
        "Title": "Suvelle Men's Slim Genuine Leather Bifold Wallet Removable Flipout ID Window W031",
        "ASIN": "B00LAEZLRM",
        "ReviewItem3": 7,
        "ReviewItem4": 28,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51XyPGUmMiL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.44,
        "UploadTime": " June 25, 2014",
        "Id": 1836,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "Zzfab Circle Rhinestone Sparkle Bling Cross Body Bag",
        "ASIN": "B01N3XMXP1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61c7SiTDRnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " January 3, 2016",
        "Id": 1837,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.51,
        "ReviewItem5": 0,
        "Title": "RaanPahMuang Hill Tribe Stitch Colourful Woven Lines Bag Shoulder Strap",
        "ASIN": "B078NTQJ7W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416dfJRbDhL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.51,
        "UploadTime": " December 28, 2017",
        "Id": 1871,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Love Moschino Women's Borsa Pu Wristlet",
        "ASIN": "B07DL79CPQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Ezi0g9SAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 25, 2018",
        "Id": 1944,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.19,
        "ReviewItem5": 0,
        "Title": "Brenice Women Solid Multi-pockets Casual Faux Leather Crossbody Bag Purses Brown",
        "ASIN": "B07L9Z3XWX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xKLxqbqVL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.19,
        "Id": 1838,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Women's Top Handle Satchel Premium Vegan Leather Handbags Tote Purse Shoulder Bag Crossbody Bag with Removable Strap",
        "ASIN": "B076F77WX7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515AeD3A1JL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " October 13, 2017",
        "Id": 1839,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Pencil Holders",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.95,
        "ReviewItem5": 0,
        "Title": "BUMOS Multi-purpose Cotton Zipper Pen Pencil Stationery Cosmetic Makeup Pouch (Lime Green), BC3",
        "ASIN": "B01MD0LJUQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lSToTOZhL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.95,
        "Id": 1840,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 10,
        "ReviewItem2": 4,
        "PriceMax": 12.99,
        "ReviewItem5": 68,
        "Title": "Gobiger Aviator Sunglasses for Men 100% UV Protection Goggle Alloy Frame with Case",
        "ASIN": "B0713NTMBQ",
        "ReviewItem3": 7,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/3110Lc9RJaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " April 19, 2017",
        "Id": 1841,
        "ReviewCount": 184
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.99,
        "ReviewItem5": 0,
        "Title": "Qflmy Women Beach Lightweight Casual Canvas Hand Shoulder Tote Bag",
        "ASIN": "B01N5WUH45",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61UDQnQnvCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.99,
        "UploadTime": " February 4, 2017",
        "Id": 1842,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 100,
        "Title": "Wallet for Men,RFID Men's Wallet Genuine Leather Blocking First Layer-Credit Card Holder with ID Window,Anti-theft Protector,Bifold Vintage Natural Skin Purse(Coffee)",
        "ASIN": "B07BF833ML",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415HEY7YJ4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "Id": 1843,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "SimpleLif Bag Handle,DIY Replacement Repair Purse Shoulder Belt Handbag/Wood Bead Rope Bag Handles Straps",
        "ASIN": "B07PMCWLL3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41w0xzmuJTL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1844,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 403,
        "ReviewItem5": 0,
        "Title": "Patrizia Pepe Women's 2V4814A4K3R616 Red Leather Handbag",
        "ASIN": "B07Q8TD69F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31X4Qf50EnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 403,
        "UploadTime": " April 2, 2019",
        "Id": 1845,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 21,
        "ReviewItem2": 8,
        "PriceMax": 12.38,
        "ReviewItem5": 38,
        "Title": "Men's Leather ID Card Holder Zip Coin Wallet Purse Clutch Checkbook Billfold",
        "ASIN": "B01H2AGJPK",
        "ReviewItem3": 12,
        "ReviewItem4": 21,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51b-8hJkiaL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.38,
        "UploadTime": " May 27, 2016",
        "Id": 1846,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Casual Security Pack Crossbody Phone Pouch With Shoulder Strap Wallet Handbag cool Bearded Dragon Lizards animal",
        "ASIN": "B07M5K9XWM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41am5r8Th9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 21, 2018",
        "Id": 1847,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 9,
        "ReviewItem2": 4,
        "PriceMax": 70.99,
        "ReviewItem5": 64,
        "Title": "AmeriLeather Miya Tote",
        "ASIN": "B003TMJYX0",
        "ReviewItem3": 9,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51swkN730nL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 70.99,
        "UploadTime": " June 23, 2010",
        "Id": 1848,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 4,
        "ReviewItem2": 2,
        "PriceMax": 24.99,
        "ReviewItem5": 70,
        "Title": "Felt Handbag Organizer Insert for Tote Purse Fit LV Speedy Neverfull 6 Color",
        "ASIN": "B07CVBYKG9",
        "ReviewItem3": 12,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41a6FZAcjGL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " July 23, 2017",
        "Id": 1849,
        "ReviewCount": 50
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 72,
        "ReviewItem5": 33,
        "Title": "Kate Spade New York Summer Ward Place Crossbody Bag Wallet",
        "ASIN": "B07KYVQS12",
        "ReviewItem3": 0,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KbBYIq-FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 72,
        "UploadTime": " August 3, 2018",
        "Id": 1850,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "HOSPORT Hollow Beach Bucket Bag Mesh Leather Tote Bag Drawstring Handbags for Women",
        "ASIN": "B07D6S6XWQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tequD1xkL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1851,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YIBANG-Bag Men's Wallet First Layer Leather Organ Card Package Multi-Card Position Change Pocket Leather Card Holder Men's Fashion (Color : Brown, Size : S)",
        "ASIN": "B07RF5M8MZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FeIkYgC9L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1852,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 83,
        "Title": "Heavy Shoulder Straps Summer Time Print Cotton Jute Premium Beach Women Tote Bag by BB",
        "ASIN": "B07BR49V58",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aVLCkRffL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " March 27, 2018",
        "Id": 1853,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 138,
        "ReviewItem5": 100,
        "Title": "MICHAEL MICHAEL KORS Mercer Floral Embellished Pebbled Leather Smartphone Crossbody",
        "ASIN": "B07CWGVN2L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jnDymT4kL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138,
        "UploadTime": " December 2, 2017",
        "Id": 1854,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.44,
        "ReviewItem5": 60,
        "Title": "Heidi Bag Small Vintage Canvas Crossbody Shoulder Bag Fashion Checkerboard Printed",
        "ASIN": "B07F9QGPQX",
        "ReviewItem3": 0,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kbhxZRXJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.44,
        "UploadTime": " July 5, 2018",
        "Id": 1855,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 48.95,
        "ReviewItem5": 100,
        "Title": "Laurel Burch Flora Oversized Tote",
        "ASIN": "B06XTJ75LZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61IGkW5KmqL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 48.95,
        "UploadTime": " March 24, 2017",
        "Id": 1856,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Womens Cute Round Straw Shoulder Bag Embroidery Leaves Handwoven and PU Summer Beach Handbag with Removable Tassel Décor",
        "ASIN": "B07PB94S7F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w9%2B5PZ4GL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " February 27, 2019",
        "Id": 1857,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 0,
        "ReviewItem5": 64,
        "Title": "Recycled Silk Sari Bucket Bag",
        "ASIN": "B000CDBS7O",
        "ReviewItem3": 4,
        "ReviewItem4": 21,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ccxcpYbAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 17, 2005",
        "Id": 1860,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 995,
        "ReviewItem5": 0,
        "Title": "FENDI Mini Rush Clutch Evening Bag Mustard Yellow Leather Chain Cross Body Shoulder Handbag 8M0322",
        "ASIN": "B01IUENN0G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VXgmdeB8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 995,
        "UploadTime": " October 26, 2016",
        "Id": 1861,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 248,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Adele MD Dome Crossbody bundled with Michael Kors Adele Small TZ Coinpouch with ID Wallet",
        "ASIN": "B07K6ZXCT1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NmVHR%2Bw%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 248,
        "UploadTime": " October 23, 2017",
        "Id": 1862,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 5.9,
        "ReviewItem5": 0,
        "Title": "Elena De Avalor Flute Bag Official Flute Protector",
        "ASIN": "B071FQZNPZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uRdWzFNEL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 5.9,
        "Id": 1863,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.95,
        "ReviewItem5": 0,
        "Title": "Montgomery Street Blue Whale Cotton Canvas Tote Bag",
        "ASIN": "B01DEBU880",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41RuciE5GCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.95,
        "UploadTime": " March 21, 2016",
        "Id": 1864,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Watercolor Cactus and Succulent, Butterflies Women Crossbody Bag Saddle Shoulder Bag Small Purse Satchel",
        "ASIN": "B07PD2X5HT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41REWmlq%2BiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 5, 2019",
        "Id": 1865,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.95,
        "ReviewItem5": 100,
        "Title": "KAVU Ropercise Rope Sling Bag Gym Crossbody Shoulder Bag for Working Out",
        "ASIN": "B07F3GRKHY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51R0%2BKQRYOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.95,
        "UploadTime": " June 28, 2018",
        "Id": 1866,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Stigma Free Zone Mental Health Awareness Tote Bag 29dce",
        "ASIN": "B071V6QSMQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pU9PNl4dL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " April 26, 2017",
        "Id": 1867,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.29,
        "ReviewItem5": 0,
        "Title": "LUOEM 60cm Resin Bag Strap Replaement Women Handbag Strap Plastic Ladies Bag Chain with Buckles (Turquoise)",
        "ASIN": "B07D4GCR3M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nQULJSmmL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.29,
        "UploadTime": " May 17, 2018",
        "Id": 1868,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.77,
        "ReviewItem5": 0,
        "Title": "Fiorelli Womens Mia Top-Handle Bag",
        "ASIN": "B076LTRZHM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4184mIiwQ%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.77,
        "UploadTime": " May 2, 2018",
        "Id": 1869,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 50,
        "Title": "Nine West Womens Cataleya Crossbody",
        "ASIN": "B07FQV4NQD",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412hVPHjwaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " September 29, 2018",
        "Id": 1870,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.95,
        "ReviewItem5": 0,
        "Title": "Raffia Straw Box Clutch",
        "ASIN": "B06XKNLTTC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nJZnxGCJL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 44.95,
        "UploadTime": " March 12, 2017",
        "Id": 2984,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Vera Bradley Iconic 100 Handbag, Microfiber",
        "ASIN": "B07GWX8JF8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XZ0gWPiBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 11, 2018",
        "Id": 1872,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 2,
        "PriceMax": 54.98,
        "ReviewItem5": 57,
        "Title": "Travelon Anti-Theft Cross-Body Bucket Bag,One Size,Chocolate",
        "ASIN": "B07BN2LSDN",
        "ReviewItem3": 10,
        "ReviewItem4": 24,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41taNJxXwAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.98,
        "UploadTime": " March 9, 2017",
        "Id": 1873,
        "ReviewCount": 42
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 16,
        "PriceMax": 25.99,
        "ReviewItem5": 63,
        "Title": "Women Backpack Purse Waterproof Nylon Anti-theft Rucksack Lightweight Shoulder Bag Ladies Travel bags",
        "ASIN": "B07MX825Q5",
        "ReviewItem3": 11,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cTInY34jL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " January 17, 2019",
        "Id": 1874,
        "ReviewCount": 19
    }, {
        "Sale": "[]",
        "Category": "Money Clips",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 67,
        "Title": "Card Blocr Money Clip Wallet | Credit Card Holder Milled Aluminum RFID Blocking",
        "ASIN": "B07LFHZWDM",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41o7Z0iHTCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " December 16, 2018",
        "Id": 1875,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 67,
        "Title": "Damara Womens Vintage Floral Crystal Shiny Trapezoidal Evening Bag",
        "ASIN": "B016ZKW77C",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51XQMd8epzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " October 22, 2015",
        "Id": 1876,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Well-Behaved Women Seldom Make History Laurel Tote Bag 28b29",
        "ASIN": "B06X157HLB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51rZwTL8jLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " February 9, 2017",
        "Id": 1877,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "COACH YANKEE FLORAL PRINT WRISTLET CLUTCH BAG HANDBAG",
        "ASIN": "B07BD282HC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TEEdQJFNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 10, 2018",
        "Id": 1878,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "MKF Crossbody Bags for women — Adjustable Strap — Vegan Leather — Crossover Side Messenger Womens Purse Pewter",
        "ASIN": "B07FPQFVN4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mpswLwo6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " February 2, 2019",
        "Id": 1879,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 0,
        "Title": "Prettyia 2pieces Adjustable Canvas Handbag Shoulder Bag Strap Handle Replacements Bag Accessories for Purse Making 120cm",
        "ASIN": "B07DVFDR75",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aelO0RLOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " June 19, 2018",
        "Id": 1880,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 36,
        "ReviewItem5": 0,
        "Title": "Women's Vintage Fine Fibre Genuine Leather Bag Tote Shoulder Bag Handbag Model Sie",
        "ASIN": "B07DHRWW6R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Nu5F-zXZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36,
        "UploadTime": " February 14, 2018",
        "Id": 1881,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 4,
        "ReviewItem2": 7,
        "PriceMax": 18.99,
        "ReviewItem5": 67,
        "Title": "Crossbody Bag for Women Vintage Handbag PU Leather Adjustable Strap Small Purse with Tassel",
        "ASIN": "B07K4D71FV",
        "ReviewItem3": 7,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418NlIZvC0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " November 1, 2018",
        "Id": 1882,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 93.27,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Large Tote Bag Handbag Purse",
        "ASIN": "B074CLDD5V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61PPpb2aZhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 93.27,
        "UploadTime": " November 16, 2014",
        "Id": 1883,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.5,
        "ReviewItem5": 50,
        "Title": "Ladybug Patch Crossbody Bag (Sand)",
        "ASIN": "B00TBJUBTQ",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/411YbXIGZxL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.5,
        "UploadTime": " February 7, 2015",
        "Id": 1884,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.95,
        "ReviewItem5": 0,
        "Title": "Ngil Quilted Cotton Medium Tote Bag 2018 Spring Collection (Summer Water Color Navy)",
        "ASIN": "B07JCDZRGR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-5n%2B41dsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.95,
        "UploadTime": " May 16, 2016",
        "Id": 1885,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Neckties",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.98,
        "ReviewItem5": 92,
        "Title": "WANDM Men's slim skinny tie necktie width 2.4\" washable polka dot & small repeated patterns & solid colors",
        "ASIN": "B07NRD47ZV",
        "ReviewItem3": 8,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51n4Qa%2B-bBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.98,
        "UploadTime": " February 14, 2019",
        "Id": 1886,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Natural and Gold Cork Vegan Tote Bag Purse |Trending Design |Laptop Handbag| Vegan-friendly Bag | Eco-Friendly | BAG-323-A",
        "ASIN": "B07HNPK6XS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51N6C-AB-QL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 25, 2018",
        "Id": 1887,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 17,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 66,
        "Title": "Small Crossbody Purse for Women, Cellphone Purse Crossbody,Mini Travel Nylon Crossbody Bag Multi Zipper Pockets",
        "ASIN": "B07HH31WPQ",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sbfWSbPNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " September 19, 2018",
        "Id": 1888,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 60,
        "Title": "Skagen SWH0244001",
        "ASIN": "B06Y6KLVVV",
        "ReviewItem3": 0,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CQs1at%2BXL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 21, 2017",
        "Id": 1889,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.3,
        "ReviewItem5": 0,
        "Title": "reTH Women's Karter Bag",
        "ASIN": "B07MXKJL66",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31erQNbt2mL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.3,
        "UploadTime": " January 18, 2019",
        "Id": 1890,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 227.5,
        "ReviewItem5": 0,
        "Title": "PAMELA MUNSON Women's The Bea Bag",
        "ASIN": "B07KX11D7V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414EoetUMkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 227.5,
        "UploadTime": " November 27, 2018",
        "Id": 1891,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 3,
        "PriceMax": 40.99,
        "ReviewItem5": 83,
        "Title": "Women handbags Top handle Satchel bags for Ladies Set Vegan Leather purse/wallet(2 pieces set)",
        "ASIN": "B07DWJZD1L",
        "ReviewItem3": 3,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413N3lKq-iL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.99,
        "UploadTime": " June 20, 2018",
        "Id": 1894,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 185,
        "ReviewItem5": 75,
        "Title": "William Painter - The Level Titanium Polarized Sunglasses.",
        "ASIN": "B01H53DS7Q",
        "ReviewItem3": 4,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31NKBUNfeLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 185,
        "UploadTime": " June 16, 2016",
        "Id": 1895,
        "ReviewCount": 167
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 138,
        "ReviewItem5": 0,
        "Title": "Kipling Disney Alice in Wonderland Collection Medium Shopper Tea Party Tote",
        "ASIN": "B075Y3LRRZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/519YdcdbJyL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138,
        "UploadTime": " February 4, 2018",
        "Id": 1896,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 788,
        "ReviewItem5": 0,
        "Title": "Valentino Orlandi Italian Designer Shamrock Green Calfskin Leather Statement Shoulder Bag",
        "ASIN": "B01G21X5SO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ld5UjtiNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 788,
        "UploadTime": " July 17, 2018",
        "Id": 1897,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Seam Reap Medium Cheetah Print Hair on Hide Clutch Purse",
        "ASIN": "B07J5D59FJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BKMUN3GtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 8, 2018",
        "Id": 1898,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Helena Crossbody Premium Crossover Bag Over the Shoulder Womens Bag by Mia K. Farrow",
        "ASIN": "B07L5S5ZT6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WlkXK%2BsDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " December 6, 2018",
        "Id": 1899,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 7.49,
        "ReviewItem5": 0,
        "Title": "UNI COLLECTIONS CROSSBODY BAG",
        "ASIN": "B07KGJY3TD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sQSfNLv0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.49,
        "UploadTime": " November 13, 2018",
        "Id": 1900,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Cath Kidston Matt Oilcloth Mini Multi Pocket Handbag With Crossbody Strap Windflower Bunch Soft Teal",
        "ASIN": "B01MRCZYX1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hgt3aioeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 17, 2018",
        "Id": 1901,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 260,
        "ReviewItem5": 0,
        "Title": "Longchamp Women's Leather Le Pliage Cuir Crossbody Bag Khaki",
        "ASIN": "B07KPPZQV8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419ttyMbR2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 260,
        "UploadTime": " March 15, 2017",
        "Id": 1902,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "Jessica Simpson Women's Natalia Clutch Crossbody",
        "ASIN": "B07HYYQD4L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41GgPjbsFJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " April 24, 2019",
        "Id": 1911,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 6,
        "PriceMax": 19.98,
        "ReviewItem5": 61,
        "Title": "Goson Leather Shoulder or Camera Bag Handbag Unisex Travel Organizer",
        "ASIN": "B00H2Y9ASK",
        "ReviewItem3": 10,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mBZFL4GvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.98,
        "UploadTime": " December 3, 2013",
        "Id": 1912,
        "ReviewCount": 448
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "QTKJ Fashion Women Woven Straw Tote Bag Hollow Out Summer Vintage Straw Beach Bag with Beaded Handle (White)",
        "ASIN": "B07Q376JS1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41B9nDg3vCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " March 26, 2019",
        "Id": 1922,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44,
        "ReviewItem5": 67,
        "Title": "Tote bag Angelina's Palace Shoulder Bag Organizer Insert Sturdy Zipper",
        "ASIN": "B077914K1Q",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YdU8DdFhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44,
        "UploadTime": " July 11, 2017",
        "Id": 1903,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 111.99,
        "ReviewItem5": 0,
        "Title": "Versace EE1VSBBP2 E829 Grey/Blue Shoulder Bag for Womens",
        "ASIN": "B07DDSBF7C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KQufk3HsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 111.99,
        "UploadTime": " September 8, 2018",
        "Id": 1904,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 9,
        "PriceMax": 9.99,
        "ReviewItem5": 82,
        "Title": "iwill CREATE PRO Large Mesh Beach Tote Bag, Ladies Shopping Shoulder Bag, Black",
        "ASIN": "B07G976TCC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UWLBZDiVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " August 8, 2018",
        "Id": 1905,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.2,
        "ReviewItem5": 0,
        "Title": "{ Extra 10% Discount } Purse Collection Fabulous Drawstring Blue Colour Potlli With Embroidery Work Purse For Women0",
        "ASIN": "B0782WXLRY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510POsSTY%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.2,
        "UploadTime": " August 23, 2017",
        "Id": 1906,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19,
        "ReviewItem5": 0,
        "Title": "Pahajim women Canvas Handbag Shoulder Bag Cat Big Tote Bag Beach Satchel Bag",
        "ASIN": "B076J5TCTR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ssBoFRKtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19,
        "UploadTime": " October 17, 2017",
        "Id": 1907,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Artwell Women Backpack Purse Convertible Ladies Rucksack Anti-theft Travel Daypack Shoulder Bag (Brown)",
        "ASIN": "B07GDKJGGD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41St8xmQn%2BL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1908,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 38,
        "ReviewItem5": 0,
        "Title": "Purse Collection Party Wear Beaded Blue Clutch With Kundan Stone For Women's",
        "ASIN": "B0778GH8PJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Er0zx165L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38,
        "UploadTime": " August 23, 2017",
        "Id": 1909,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 88,
        "Title": "MIETTE Mini Small Purse Backpack Cute for Women, 11x10x5in",
        "ASIN": "B0773BMVL6",
        "ReviewItem3": 8,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vIzvHcR6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " November 2, 2017",
        "Id": 1910,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 2.99,
        "ReviewItem5": 0,
        "Title": "YEZIJIN Clearance! Women Small Transparent Bucket Bags Chain Bag Totes Compound Female Mini Bag 2019 New",
        "ASIN": "B07QJX9ZPM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kDy3UjcWL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 2.99,
        "Id": 1913,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Women Backpack Purse Ladies Rucksack School Shoulder Bag for Girls PU Leather/Nylon Version UTO",
        "ASIN": "B07R1HHDMV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41HNvy1S33L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " April 19, 2019",
        "Id": 1914,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 2,
        "ReviewItem2": 1,
        "PriceMax": 0,
        "ReviewItem5": 85,
        "Title": "Michael Kors Women's Bedford Top Zip Pocket Tote Bag",
        "ASIN": "B01L0X2L5W",
        "ReviewItem3": 2,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/411ueCIYUSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 26, 2016",
        "Id": 1915,
        "ReviewCount": 495
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 4,
        "PriceMax": 15.99,
        "ReviewItem5": 42,
        "Title": "Sannea Women's Soft Leather Small Crossbody Purse, Shoulder Bag",
        "ASIN": "B01FXMTR3A",
        "ReviewItem3": 12,
        "ReviewItem4": 31,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oHxplguoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " May 20, 2015",
        "Id": 1916,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 14.99,
        "ReviewItem5": 71,
        "Title": "ZIPIT Medium Shoulder Bag, Blue & Brown",
        "ASIN": "B01CEAYGKS",
        "ReviewItem3": 0,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xfyOJ5alL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "Id": 1917,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Leather New Women's Handbags Fashion Trend Handbags Ladies Personality Ladies Bag Fashion (Color : Brass, Size : M)",
        "ASIN": "B07PMK4Y6Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VlTnLh%2BeL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1918,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Skyseen Womens Snail Shape Handmade Rattan Straw Woven Clutch Purse Crossbody Bag Cellphone Pouch,Mini",
        "ASIN": "B072VBG17C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514we0sQVyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 19, 2017",
        "Id": 1919,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LIUGHGB Womens Bag Luxury Leather H Bags Shell Thread Ladies Clutch Designer Bag Sac A Main Femme Bolsas Women'stote Purse",
        "ASIN": "B07KVHCWPS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PYFbI1-WL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1920,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Leather New Women's Shoulder Bag Messenger Bag Small Fresh Wild Diagonal Bag Fashion (Color : Red, Size : S)",
        "ASIN": "B07PPNFWRG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ukjPCSZiL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1921,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 12.95,
        "ReviewItem5": 50,
        "Title": "Women's Sea life Printed Beach Bag Tote (Blue)",
        "ASIN": "B07J1QFRW2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418Nc0%2BTVJL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.95,
        "Id": 1924,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 5,
        "PriceMax": 14.99,
        "ReviewItem5": 52,
        "Title": "TianHengYi Women's Simple Dumpling Shape Nylon Cross-body Purse Shoulder Bag Lightweight Messenger Bag",
        "ASIN": "B01E8VGU96",
        "ReviewItem3": 29,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SfY17upXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " April 14, 2016",
        "Id": 1925,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LEOO Beatfull Designer Shoulder Bag for Women, Fashion Crossbody Bag Handbags with Chain",
        "ASIN": "B07PK96418",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BwSrv-hpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 9, 2019",
        "Id": 1926,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.99,
        "ReviewItem5": 86,
        "Title": "Women Vegan Ostrich Leather Handbag Tote Bag Top Handle Purse Satchel Hobo Bag 2 Handbags Set For Women",
        "ASIN": "B07JP5RVMG",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510xxooxB5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.99,
        "UploadTime": " October 24, 2018",
        "Id": 1927,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.29,
        "ReviewItem5": 0,
        "Title": "GBSELL Fashion Women Mini Leather Handbag Cross Body Shoulder Bag",
        "ASIN": "B01LD2H7E0",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mUAhgvPeL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.29,
        "UploadTime": " September 1, 2016",
        "Id": 1928,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Men's Wallet Clutch Bag Long Wallet Multi-Function Creative Hand Bag Men's Fashion (Color : Brown, Size : M)",
        "ASIN": "B07RH732KF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aBQQNdPSL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1929,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "2018 Crossbody Bags Leather Handbags Bag",
        "ASIN": "B07K8DBYFW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PlEcfGGRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 7, 2018",
        "Id": 1930,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 34.95,
        "ReviewItem5": 69,
        "Title": "Pursfection EXPANDABLE Purse Organizer - Brown/Giraffe",
        "ASIN": "B00CNV2A3O",
        "ReviewItem3": 17,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512xe49wL7L._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 34.95,
        "UploadTime": " April 22, 2014",
        "Id": 2860,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "EOURGE Women Handbags Silk Dumpling Clutch Bag With Brass Prom Clutches",
        "ASIN": "B07QX5NR6P",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qKq9sT-FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " April 19, 2019",
        "Id": 1932,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29,
        "ReviewItem5": 0,
        "Title": "Lady Couture Flap Dressy Bag by, Karen Bag",
        "ASIN": "B07CY21PN8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517ZQdtkIFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29,
        "UploadTime": " May 4, 2018",
        "Id": 1933,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LeSportsac Essential Camera Bag Crossbody, Roadtrip Vaca C",
        "ASIN": "B07B9J5N9V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-ZERAb-CL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 13, 2014",
        "Id": 1935,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 9,
        "PriceMax": 295,
        "ReviewItem5": 62,
        "Title": "Coach Peyton Signature Cora Domed Satchel - Style 24606",
        "ASIN": "B00IVCQ7RY",
        "ReviewItem3": 6,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510fQ1GF%2BUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 295,
        "UploadTime": " March 8, 2014",
        "Id": 1936,
        "ReviewCount": 34
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 208.94,
        "ReviewItem5": 50,
        "Title": "Piel Leather Large Handbag Cross Body Bag, Charcoal, One Size",
        "ASIN": "B00PBD80C6",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413ebprQkGL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 208.94,
        "Id": 1937,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 41.45,
        "ReviewItem5": 50,
        "Title": "Harry Potter Hogwarts Express Three Piece Bag Set",
        "ASIN": "B0788GTYFM",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511gW6Uj54L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 41.45,
        "UploadTime": " December 13, 2017",
        "Id": 1938,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 6,
        "ReviewItem2": 3,
        "PriceMax": 13.99,
        "ReviewItem5": 85,
        "Title": "Tote Bag - Beach Bag - Beach Tote - Large Tote Bag with Rope Handles - Rutledge & King™",
        "ASIN": "B07KB8QQJQ",
        "ReviewItem3": 6,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51viOQJ-G8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " November 8, 2018",
        "Id": 1939,
        "ReviewCount": 33
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.95,
        "ReviewItem5": 0,
        "Title": "Baggallini Phone Crossbody",
        "ASIN": "B07FBK3W85",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EXoQCNL0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " March 30, 2018",
        "Id": 1940,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 64,
        "Title": "Circue Women’s Bamboo Handle Designer Shoulder Bag PU Leather Top Handle Bag Crossbody Bag with Bee",
        "ASIN": "B07FV8W9Y9",
        "ReviewItem3": 9,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ILSfFEBbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 24, 2018",
        "Id": 1941,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "LV Louis Vuitton MONTORGUEIL GM - Bag Base Shaper 1/8” Clear Acrylic",
        "ASIN": "B07PQXRQ8C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31BpYi4JIbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " March 13, 2018",
        "Id": 1942,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Kipling Alvar Solid Crossbody Bag",
        "ASIN": "B075RFQF62",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Uu7VLo4gL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 5, 2018",
        "Id": 1943,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "EROUGE Leather Vintage Crossbody Bag With Chain for Women Designer Shoulder Clutch Bag",
        "ASIN": "B07LCG79XR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rajUwE0vL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " December 14, 2018",
        "Id": 1945,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "B.MAKOWSKY WOMEN LEATHER ADJUSTABLE SHOULDER BAG ROSE GOLD PHYNTON",
        "ASIN": "B07QJ6L8SP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tPjiT-S9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " April 9, 2019",
        "Id": 1946,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 54.99,
        "ReviewItem5": 0,
        "Title": "Vertigo Paris Darci Large Satchel Bag",
        "ASIN": "B01CGOEMD8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513iFx5ZWqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 54.99,
        "UploadTime": " March 2, 2016",
        "Id": 2027,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 100,
        "Title": "JET-SET Purse Insert Organizer | Bag Shaper | Multi-Pocket | Bag in Bag | Multipurpose Handbag : PURSETTE",
        "ASIN": "B07K484QLK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/315ZsAOW3mL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " December 7, 2018",
        "Id": 1947,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 100,
        "Title": "Organic Canvas Tote Bag",
        "ASIN": "B000I2X36S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Zby0tzH3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " August 25, 2006",
        "Id": 1948,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Purse Handbag Organizer Insert, MISIXILE Felt Bag Organizer with Handles",
        "ASIN": "B07RVKTRW4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lI0zEAupL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 13, 2019",
        "Id": 1949,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 25,
        "PriceMax": 28.98,
        "ReviewItem5": 75,
        "Title": "LIZHIGU Womens Leather Shoulder Bag Ladies Top-handle Handbag Simple Tote Bag Yellow",
        "ASIN": "B01MRDIA10",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xFoi-X2JL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.98,
        "UploadTime": " February 4, 2017",
        "Id": 1950,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "AIR JORDAN Jumpman Crossbody Bag Olive/Black/Reflective",
        "ASIN": "B07L7TM3JH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417DITlOKeL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1951,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.07,
        "ReviewItem5": 0,
        "Title": "Vintage Trifold Wallet Zip Coin Pocket Purse Cowhide Leather Wallet For Mens",
        "ASIN": "B07QJ522H1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dYS%2BBVAcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.07,
        "UploadTime": " April 9, 2019",
        "Id": 1952,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 11,
        "PriceMax": 36.95,
        "ReviewItem5": 60,
        "Title": "Desmond Cross-body Convertible Hobo Purses",
        "ASIN": "B005II6ED6",
        "ReviewItem3": 16,
        "ReviewItem4": 3,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tx8rM-tfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 36.95,
        "UploadTime": " December 8, 2018",
        "Id": 1953,
        "ReviewCount": 68
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Wishing I Was Doing Pilates Cool And Funny Gift For A Doing Pilates Lover - Tote Bag With Zip",
        "ASIN": "B07CXQJ7WX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410N1J7dqsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " May 8, 2018",
        "Id": 1954,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Clutch Evening Bag for Women Formal Classic Clutch Purse Black",
        "ASIN": "B07QW5S4W6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518UZGGg4bL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " April 16, 2019",
        "Id": 1965,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Canvas Tote Bags Japanese Cherry Blossoms Print Top Handbags Casual Shoulder Travel Bag with Zipper for Women",
        "ASIN": "B07QX58QMF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iBc3MLE7L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "Id": 1955,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 140,
        "ReviewItem5": 0,
        "Title": "Love Moschino Women's Borsa Quilted Nappa Pu Shoulder Bag",
        "ASIN": "B07F5XDQCQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31EFESYLWWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 140,
        "UploadTime": " October 17, 2018",
        "Id": 1956,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "KHGUDS New Design Genuine Leather Men Wallets Coin Pocket Zipper Real Leather Wallet With Coin Purse Male Purse",
        "ASIN": "B07QN98SX3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eTulXQrxL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1957,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.5,
        "ReviewItem5": 75,
        "Title": "Chala Bowling Tote Bag Stone Gray",
        "ASIN": "B07NKZVPJ9",
        "ReviewItem3": 8,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eqAz7ubhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.5,
        "UploadTime": " February 10, 2019",
        "Id": 1958,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Have Fun Summer Women Large Tote Top Handle Bags Shoulder Handbags",
        "ASIN": "B07G56VR7R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zOsZQMGpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 3, 2018",
        "Id": 1959,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45.99,
        "ReviewItem5": 0,
        "Title": "SUNROLAN Women's Shoulder Bag Handbag Tote Purse PU Leather Crossbody 3D Flower with Weave Handle Bags",
        "ASIN": "B07DRHTNVH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AQkA%2BSVPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.99,
        "UploadTime": " June 15, 2018",
        "Id": 1960,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 17,
        "ReviewItem2": 0,
        "PriceMax": 138,
        "ReviewItem5": 83,
        "Title": "Tommy Hilfiger Tote Bag for Women Item",
        "ASIN": "B06XRTRWFG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dOI8Ae7wL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 138,
        "UploadTime": " September 30, 2017",
        "Id": 1961,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 119.99,
        "ReviewItem5": 0,
        "Title": "Kate Spade Peggy Patterson Drive Leather Women's Small Crossbody Bag Purse Handbag, Blue Dawn",
        "ASIN": "B07P1CY25D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BPjqaxJ5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 119.99,
        "UploadTime": " February 22, 2019",
        "Id": 1962,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Roxy Make It Rock Crossbody Bag",
        "ASIN": "B071VS3YCQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51adFtUnf%2BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 16, 2017",
        "Id": 1963,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 42.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Fashion Summer Beach Palm Tree Leather Tote Shoulder Bags Handbags for Women",
        "ASIN": "B07FVL28T8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vFR3JtYkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 42.99,
        "UploadTime": " July 25, 2018",
        "Id": 1964,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.99,
        "ReviewItem5": 0,
        "Title": "Purses For Women, Womens Leather Satchel Cross Body Shoulder Messenger Bag Travel Shoulder Bags Duseedik Clearance!!",
        "ASIN": "B07D7Y1NRD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51uuyAsaCvL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.99,
        "UploadTime": " April 17, 2018",
        "Id": 1967,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Italian Made Yellow & Blue Pebbled Leather Zipper Detail Crossbody Bag by M.A.P. ITALY",
        "ASIN": "B00AG6D1IG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JoZ5hfWML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 1, 2012",
        "Id": 1968,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Toprint Animal Snake Skin Print Glasses Bag Pouch Portable Travel Zipper Light Sunglasses Case Pencil Case Cosmetic Bag",
        "ASIN": "B07P8XKYV4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514LT803fJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " February 9, 2019",
        "Id": 1969,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.95,
        "ReviewItem5": 0,
        "Title": "Harry Potter Reverse Daily Prophet Wizard Newspaper Headlines Hobo Bag Purse",
        "ASIN": "B00QNAL9QU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418TcjOeaIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.95,
        "UploadTime": " December 6, 2014",
        "Id": 1970,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 445,
        "ReviewItem5": 100,
        "Title": "Pratesi Italian Aged Leather Bucket Hobo Handbag Shoulder Bag",
        "ASIN": "B01I3CVQG8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Gqn1tT1QL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 445,
        "UploadTime": " July 12, 2016",
        "Id": 1971,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.79,
        "ReviewItem5": 50,
        "Title": "Travelon Anti-Theft Classic Small E/W Crossbody Purse",
        "ASIN": "B06XJV5BPY",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41n3lbexGsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.79,
        "Id": 1972,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger EW Shopper Tote Bag Handbag",
        "ASIN": "B07B24R8CY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NaLJ5BY9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 17, 2018",
        "Id": 1973,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 50,
        "Title": "Steve Madden Womens Bcomfyy Faux Leather Studded Hobo Handbag",
        "ASIN": "B07BHYVJCN",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41i4sbADlbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " March 16, 2018",
        "Id": 1974,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32,
        "ReviewItem5": 0,
        "Title": "Fashion Lady Women Top Handle Checker Print Chain tote Handbag Gray",
        "ASIN": "B07CCKLM2K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eXZrZAD3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32,
        "UploadTime": " April 25, 2018",
        "Id": 1975,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Bingo Daubers",
        "ReviewItem1": 3,
        "ReviewItem2": 1,
        "PriceMax": 13.75,
        "ReviewItem5": 84,
        "Title": "DAB-O-INK 3oz Bingo Daubers - Mixed Colors - 12ct",
        "ASIN": "B01C4QBW3G",
        "ReviewItem3": 3,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61nAZZmrpsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.75,
        "Id": 1976,
        "ReviewCount": 291
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Women's Ethnic Style Canvas Mini Bucket Bag Crossbody Shoulder Bag with Tassel",
        "ASIN": "B074J7FP35",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OjVx56DbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 3, 2017",
        "Id": 1977,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 0,
        "Title": "Mini Black Dahlia Tote Red Leopard",
        "ASIN": "B07DHGWWYM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5103jl4t0OL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 68,
        "UploadTime": " June 3, 2018",
        "Id": 1978,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 77,
        "Title": "Women Large Designer Top Handle Handbag Purse Tote Bag Work Bag Shopping Travel Bag",
        "ASIN": "B019XA4OCM",
        "ReviewItem3": 5,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eAvfDLgqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " April 1, 2016",
        "Id": 1979,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Fashion Trend Black Crossbody Bags for Women Clutch Bag Simple Wild Shoulder Bag",
        "ASIN": "B07NQDW3T4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Tx7wWmEqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " February 15, 2019",
        "Id": 1980,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "4 Pcs Women Printing Retro Weave Pattern Wallet Card Holder Hand Bag Shoulder Bag+Card Package",
        "ASIN": "B07R9LPXGD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FCdDq8mXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 26, 2019",
        "Id": 1981,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.95,
        "ReviewItem5": 100,
        "Title": "Peach Couture 100% Cotton Chic Summer Anchor Print Canvas Bags Beach Totes",
        "ASIN": "B01EG9LBTO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51czMUosPIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.95,
        "UploadTime": " February 3, 2017",
        "Id": 1982,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 86.1,
        "ReviewItem5": 0,
        "Title": "MelysUS New Fashion Women Artificial Leather Shoulder Bag Satchel Hobos Handbag Tote Purse Shoulder Bags",
        "ASIN": "B07R64VWWZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bG2B5q9rL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 86.1,
        "UploadTime": " April 26, 2019",
        "Id": 1983,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22,
        "ReviewItem5": 0,
        "Title": "Women Handbags Handmade Shoulder Bags Tote Soft Leather Handbags with RFID Protection",
        "ASIN": "B07DNWL23Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31ww6xtegRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22,
        "UploadTime": " June 12, 2018",
        "Id": 2224,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 303,
        "ReviewItem5": 0,
        "Title": "Le Carrie Bag Women's 191ME185EPWHI White Faux Leather Handbag",
        "ASIN": "B07RJ1V552",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AN50WtufL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 303,
        "UploadTime": " May 8, 2019",
        "Id": 1984,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wraps & Pashminas",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89.9,
        "ReviewItem5": 0,
        "Title": "Tallit Prayer Shawl Set Pomegranates with Tallit Bag Kippah Kosher Tzitzit 78\"",
        "ASIN": "B07BD2G7C1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CpMJdh5aL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.9,
        "Id": 1985,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Tignanello Voyager Conv. Leather/Suede Cross Body W/RFID Protection, Taupe/Mushroom",
        "ASIN": "B07H5SNGLK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BuqcB7LvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 6, 2018",
        "Id": 1986,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.9,
        "ReviewItem5": 100,
        "Title": "Hoxis Faux Fur Furry Crossbody Shoulder Handbag Clutch Purse with Pom Tail Keychian",
        "ASIN": "B06VW5BV8L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41w65snjNKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.9,
        "UploadTime": " February 15, 2017",
        "Id": 2029,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 59.88,
        "ReviewItem5": 73,
        "Title": "Justin West American Albino Floral Embroidery Buckle Shoulder Concealed Carry Handbag Purse",
        "ASIN": "B01NB9U74C",
        "ReviewItem3": 5,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LEhIVQQNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.88,
        "UploadTime": " November 20, 2016",
        "Id": 1987,
        "ReviewCount": 60
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 21,
        "PriceMax": 38.99,
        "ReviewItem5": 43,
        "Title": "Designer Shoulder handbag Satchel for Woman Top Purse for lady",
        "ASIN": "B0751ZWW4H",
        "ReviewItem3": 29,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41otHiBRfOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.99,
        "UploadTime": " August 22, 2017",
        "Id": 1988,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 1,
        "ReviewItem2": 2,
        "PriceMax": 19.99,
        "ReviewItem5": 76,
        "Title": "Scarleton Chic Crossbody Bag H1559",
        "ASIN": "B00JUBF9C4",
        "ReviewItem3": 8,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41efskMWJHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " February 28, 2011",
        "Id": 1989,
        "ReviewCount": 179
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "MICHAEL Michael Kors Cynthia Saffiano Leather Satchel",
        "ASIN": "B07C2XQD99",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31fDQez181L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 10, 2018",
        "Id": 1990,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 6,
        "PriceMax": 295,
        "ReviewItem5": 53,
        "Title": "COACH Women's Mercer 30 Satchel",
        "ASIN": "B01F9KJFIS",
        "ReviewItem3": 17,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41iWoJBUMqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 295,
        "UploadTime": " September 13, 2016",
        "Id": 1991,
        "ReviewCount": 17
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.59,
        "ReviewItem5": 0,
        "Title": "Beacone Adjustable Canvas Replacement Crossbody Handbag Purse Strap Shoulder Bag Strap",
        "ASIN": "B07KDC89RM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41R7ivWystL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.59,
        "UploadTime": " November 10, 2018",
        "Id": 1992,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 6,
        "ReviewItem2": 6,
        "PriceMax": 0,
        "ReviewItem5": 63,
        "Title": "BeSafeBags Anti-Theft RFID Travel Handbag, Large, 13 Pockets and Organizer, Detachable Security Strap, by DayMakers",
        "ASIN": "B00N1C1XD2",
        "ReviewItem3": 19,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31bCizLhOdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 25, 2014",
        "Id": 1993,
        "ReviewCount": 16
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Live.Love.Spoil.Grandma Tote Bag 1850d",
        "ASIN": "B014VG7DZI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AHtuiv5yL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " September 3, 2015",
        "Id": 1994,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.21,
        "ReviewItem5": 50,
        "Title": "Jessica McClintock Womens Ingrid Pleated Evening Clutch",
        "ASIN": "B078NCKX34",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61R0fFunQeL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.21,
        "UploadTime": " February 14, 2018",
        "Id": 1995,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "girl boss Cotton Canvas Tote Bag",
        "ASIN": "B07BHPBBF6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BZRgiu2oL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " March 16, 2018",
        "Id": 2030,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "Sherry Pineapple Purse Women Fruit Shaped Leather Shoulder Bag Cute Mini Cross Body Handbag",
        "ASIN": "B07K2WF3ZP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41feiUwZm-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " November 1, 2018",
        "Id": 1996,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Myra Bags Freedom Star Upcycled Canvas Tote Bag M-0932",
        "ASIN": "B078RBBKZH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cEHs72KKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 4, 2014",
        "Id": 1997,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Aishankra Geometric Lattice Woman Handbag Purse Large Shoulder Handbag Totes Purses Top Handle Satchel Bag Shopping Handbag Lady PU Laser Handbag Suitable for Everyday Dating Party,F",
        "ASIN": "B07QXCH3RD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51x9BI6MJtL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 1998,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Clara Cross-body bag in soft calf skin leather - 402 - Leather bags",
        "ASIN": "B077X1YZGN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413tveGLJgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 7, 2017",
        "Id": 1999,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 46.46,
        "ReviewItem5": 0,
        "Title": "Kipling XL BAG Canvas & Beach Tote Bag, 64 cm, 31.5 liters, Blue (Active Bl)",
        "ASIN": "B07DRLZCDQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Y3lHBGFoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 46.46,
        "Id": 2000,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 140,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Flowers Pouches Medium Camera Bag Cross Body, Denim",
        "ASIN": "B01N5GBR1F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51D2GD2oDzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 140,
        "UploadTime": " December 16, 2016",
        "Id": 2001,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Woman Round Ball Clutch Handbag Rhinestone Ring Handle Purse Evening Bag",
        "ASIN": "B075L9R549",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61M0FH9Sk1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 13, 2017",
        "Id": 2002,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 13,
        "ReviewItem2": 4,
        "PriceMax": 7.99,
        "ReviewItem5": 53,
        "Title": "grinderPUNCH American Flag Aviator Sunglasses Glasses",
        "ASIN": "B00YW6CM3Q",
        "ReviewItem3": 16,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51AJM8SnueL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.99,
        "UploadTime": " May 21, 2013",
        "Id": 2003,
        "ReviewCount": 127
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30,
        "ReviewItem5": 0,
        "Title": "Women Straw Beach Tote Bag Rainbow Handmade Straw Woven Colorful Stripe Handbag Shoulder Bag Summer Holiday Woven Bag",
        "ASIN": "B07R15242T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Z679Pb-wL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30,
        "Id": 2004,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.9,
        "ReviewItem5": 0,
        "Title": "Miche Shell (Susan) for the Popular Miche Handbag",
        "ASIN": "B002A0OT6O",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ckEDVhI2L._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 12.9,
        "Id": 6439,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Geqian1982 Purse Organizer Insert Bag in Bag Handbag Organizer with Zipper Tote Bag",
        "ASIN": "B07QRQTHC9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Pr8q85NIL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2005,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.58,
        "ReviewItem5": 0,
        "Title": "Fashion Woman Bag Leather Crossbody Bags For Women Messenger Bags Female Shoulder Handbag Crossbody",
        "ASIN": "B07KNNR3G8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417qC7x0bYL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.58,
        "UploadTime": " November 18, 2018",
        "Id": 2006,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Signare Tapestry Stylish Sling Purse Bag Crossbody Shoulder Handbag in Pug Dog (SLING-PUG)",
        "ASIN": "B07JFTBJCK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514c0KHVTaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " July 4, 2018",
        "Id": 2007,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 165,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Ville Handbag, Dwell Collection, Allure (Blue)",
        "ASIN": "B07G2PTMMW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31xVRiQP25L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 165,
        "UploadTime": " July 31, 2018",
        "Id": 2008,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 40,
        "Title": "Ladies Woven Raffia Tropical Resort Straw Tote Bag",
        "ASIN": "B00U88CHZU",
        "ReviewItem3": 10,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51p94KbvifL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 4, 2015",
        "Id": 2009,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Amamcy PU Leather Shoulder Bag Coin Purse with Tassel Mini Crossbody Satchel Handbags for Kids Girls and Woman",
        "ASIN": "B07FBCXSTQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aRWj2UWVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " July 7, 2018",
        "Id": 2010,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 275,
        "ReviewItem5": 0,
        "Title": "MILLY Astor Small Crossbody Saddle",
        "ASIN": "B01MTBZ2V5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EBtnjng-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 275,
        "UploadTime": " May 6, 2017",
        "Id": 2011,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Cartoon Owl Printed Shoulder Bag Women Large Capacity Female Shopping Bag Canvas Handbag Summer Beach Bag Lady",
        "ASIN": "B077GTYVHB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61jg6aO%2BvkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 15, 2017",
        "Id": 2012,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "M&N booth [ Genuine Leather Cowhide Crossbody Shoulder Hobo Bags ] for Women",
        "ASIN": "B07MMHL7MJ",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nLNwP42BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " September 9, 2018",
        "Id": 2013,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Love Moschino Women's Grain Pu Cross-Body Bag",
        "ASIN": "B07KCSY46N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EvqJHtRFL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 11, 2019",
        "Id": 7209,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 100,
        "Title": "KARRESLY Women's Mini Backpack Purse PU Leather Rucksack Purse Ladies Casual Shoulder Bag School Bag for Women",
        "ASIN": "B072WMDVYP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SGpRKE4YL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " June 20, 2017",
        "Id": 2028,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Enerhu Felt Insert Bag Handbag Tote Purse Organizer Pocket Bag in Bag Backpack (S 10.23\" x 5.11\" x 6.29\", Beige #1)",
        "ASIN": "B07HJ1SVBF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41EhlvpNCRL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "Id": 2014,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 165,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Brooklyn Large Camera Bag, Natural/Acorn",
        "ASIN": "B01K1RPUQA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31VzgyHZd3L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 165,
        "UploadTime": " January 12, 2017",
        "Id": 2015,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 104.98,
        "ReviewItem5": 0,
        "Title": "Michael Kors Lacey Small Camera Crossbody Bag Black White",
        "ASIN": "B07QCW88W8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BtFsOKh0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 104.98,
        "UploadTime": " April 7, 2019",
        "Id": 2016,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 150,
        "ReviewItem5": 0,
        "Title": "Dooney & Bourke Pebble Grain Lexi Crossbody Shoulder Bag",
        "ASIN": "B07H9926NS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31AVyzT4hEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 150,
        "UploadTime": " February 11, 2019",
        "Id": 2017,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bafrsc Personalized Navy Interlocked Hexagon Lattice Women's Shell Shape Carrying Case Organizer Bag Gift 2Pcs",
        "ASIN": "B07RNKR1QV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51M9uSWZEfL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2018,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "JAGENIE Women Leopard Print Handbag Shoulder Ladies Purse Messenger Satchel Shopping Tote Bag",
        "ASIN": "B07KBSNPP5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51S9lsIqeUL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2019,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 55.99,
        "ReviewItem5": 0,
        "Title": "LeSportsac Classic Small Cleo Crossbody Bag, Exclusive American Stamp Print",
        "ASIN": "B07BWSR8Y5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EGQ2zfXpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55.99,
        "UploadTime": " April 3, 2018",
        "Id": 2020,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "DKNY Elissa Medium Chain Strap Shoulder Bag",
        "ASIN": "B078YWNCCJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41B59bmzY6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 24, 2017",
        "Id": 2021,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 33,
        "PriceMax": 31.99,
        "ReviewItem5": 34,
        "Title": "Contacts Genuine Leather Long Wallet Coin Clutch Purse Wristlet Men Women Red-Brown",
        "ASIN": "B01FFNECYQ",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FYOF%2BHpKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " May 10, 2016",
        "Id": 2022,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.99,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Key Item Pebble Flap Crossbody",
        "ASIN": "B073WMT9NQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kzFhjMv9L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "UploadTime": " December 30, 2017",
        "Id": 2023,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 41.95,
        "ReviewItem5": 67,
        "Title": "Sakroots Austen Double Gusset Crossbody",
        "ASIN": "B07DDLWKPT",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51o6j-N3hjL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 41.95,
        "UploadTime": " September 1, 2018",
        "Id": 2024,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 4,
        "PriceMax": 0,
        "ReviewItem5": 73,
        "Title": "Sakroots Campus Mini",
        "ASIN": "B07HKS7FV3",
        "ReviewItem3": 3,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FAaWclGUL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 23, 2018",
        "Id": 2025,
        "ReviewCount": 70
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89.4,
        "ReviewItem5": 50,
        "Title": "Floto Women's Saddle Bag in Blue Italian Calfskin Leather - Handbag Shoulder Bag",
        "ASIN": "B0155IS5JE",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SWMLpW%2B8L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.4,
        "Id": 2026,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 136.54,
        "ReviewItem5": 0,
        "Title": "piero guidi Women's Cross-Body Bag Brown dark brown (di moro)",
        "ASIN": "B01DWNRUJ0",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51v3cbRcQpL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 136.54,
        "UploadTime": " November 13, 2018",
        "Id": 10393,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 205.99,
        "ReviewItem5": 0,
        "Title": "Ted Baker Women's Janne",
        "ASIN": "B07JK56Z41",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oW2-DakyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 205.99,
        "UploadTime": " December 1, 2018",
        "Id": 2031,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.98,
        "ReviewItem5": 0,
        "Title": "Lodis Charlotte Leather Crossbody Handbag - Black",
        "ASIN": "B07GZPFGDJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51W5MkZ0ENL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.98,
        "Id": 2032,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 95,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Lara Handbag, Vintage Collection, Black (Black)",
        "ASIN": "B07G2RKH14",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/21A-zXruC%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 95,
        "UploadTime": " July 31, 2018",
        "Id": 2033,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "Women Backpack Purse Waterproof Nylon Anti-theft Rucksack Lightweight School Shoulder Bag",
        "ASIN": "B07D28YN98",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413zsANf2oL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " May 13, 2018",
        "Id": 2034,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Daypacks & Casual Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 19.97,
        "ReviewItem5": 85,
        "Title": "NUMANNI Convertible Waterproof Antitheft Sling Bags Backpack for Women & Ladies Travel",
        "ASIN": "B06Y426P7Z",
        "ReviewItem3": 5,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41S%2Bul5g-IL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.97,
        "Id": 2035,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.94,
        "ReviewItem5": 0,
        "Title": "DALIX Personalized Shopping Tote Bag Monogram Initial Zippered Letter A-Z Fish",
        "ASIN": "B07DPD7YQT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ytCLj9KeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.94,
        "UploadTime": " June 12, 2018",
        "Id": 2036,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "JUNJIAGAO-Bags Men's Wallet Vintage Short First Layer Leather Wallet Double Zipper Coin Bag Calfskin Vertical (Color : Black, Size : S)",
        "ASIN": "B07RBVN2J1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515T8J0ZR7L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2037,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 129.89,
        "ReviewItem5": 0,
        "Title": "COACH Womens Fold-Over Crossbody Clutch in Metallic Leather",
        "ASIN": "B074KKKXVR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LZoAmEeKL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 129.89,
        "UploadTime": " December 2, 2017",
        "Id": 3551,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 50,
        "PriceMax": 10.99,
        "ReviewItem5": 0,
        "Title": "SIFINI Women Handbag Stylish Top handle Bag Shoulder Handbag Tote Bag Shopper Bag",
        "ASIN": "B076D94KGN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JnDnBc1FL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " October 12, 2017",
        "Id": 2038,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Luggage Straps",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 5.99,
        "ReviewItem5": 0,
        "Title": "Organized Travel Luggage Strap with Built-in Name ID",
        "ASIN": "B00OBY3QRU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41btDFdG%2BoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 5.99,
        "Id": 2039,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 90,
        "Title": "Selighting Women's Rhinestones Crystal Evening Bags Clutches Formal Wedding Clutch Purse Prom Cocktail Party Handbags",
        "ASIN": "B07JJSJZ25",
        "ReviewItem3": 0,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513UWbBlUZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " November 10, 2018",
        "Id": 2040,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 75,
        "Title": "Velour Evening Clutch Box Handbag, Acrylic Clutch Purse Bag, Designer Clutch Evening Bag Crossbody Shoulder Bag for Women Ladies Girls Prom Party (Black)",
        "ASIN": "B07GTLBNC7",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UlnFa3EoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "Id": 2041,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.95,
        "ReviewItem5": 0,
        "Title": "Janin Handbag Envelope Clutch Crossbody Bag with Tassel Vegan Leather",
        "ASIN": "B07R5C53FV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41y7Iz-xFyL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.95,
        "UploadTime": " April 26, 2019",
        "Id": 2042,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 268,
        "ReviewItem5": 0,
        "Title": "Disney Dooney and Bourke Aulani Duffy Bear Shopper Tote Bag Purse",
        "ASIN": "B07L4ZD7RD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DA3ZxUUAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 268,
        "UploadTime": " December 5, 2018",
        "Id": 2043,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 100,
        "Title": "Freie Liebe Women Backpack Anti-theft Purse Fashion Lightweight Travel School Shoulder Bag",
        "ASIN": "B07MKQTG51",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wjmjk6ZHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " December 27, 2018",
        "Id": 2044,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 160,
        "ReviewItem5": 0,
        "Title": "France YSL Women's Kate Tassel Leather Crossbody Bag",
        "ASIN": "B07PVNBHPT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qjaqaE8yL._SX38_SY50_CR,0,0,38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 160,
        "Id": 2045,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Men Wallet PU Leather RFID Blocking Bifold Classic Multi-Card Wallet Card Checkbook Holder Cash Purse Suit Long Wallet",
        "ASIN": "B07PQGDL5K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IdCo3stDL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 12, 2019",
        "Id": 2054,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.49,
        "ReviewItem5": 70,
        "Title": "Backpack Organizer Insert - 9 Pocket Felt Storage Travel Bag Purse Tote Shaper with Rounded Top",
        "ASIN": "B07L2JLZH2",
        "ReviewItem3": 0,
        "ReviewItem4": 30,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QViY-eYQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.49,
        "UploadTime": " April 29, 2018",
        "Id": 2046,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 20,
        "PriceMax": 0,
        "ReviewItem5": 20,
        "Title": "The Sak Womens Amberly Hobo",
        "ASIN": "B07CS8HYX1",
        "ReviewItem3": 40,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415bWcStSAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 28, 2018",
        "Id": 2047,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 148.67,
        "ReviewItem5": 0,
        "Title": "Cole Haan Jade Leather SWINGPACK Crossbody Bag",
        "ASIN": "B079SS6MMV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Klo-4MfxL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 148.67,
        "UploadTime": " August 29, 2018",
        "Id": 2057,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.92,
        "ReviewItem5": 0,
        "Title": "Women's Bucket Bags, BOLUBILUY Zipper Wild Retro Crossbody Bags Pure Color Shoulder Bags Square Tote Bags",
        "ASIN": "B07MV5BCRQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-1Ffm8tYL._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 20.92,
        "Id": 6452,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 7,
        "ReviewItem2": 3,
        "PriceMax": 9.99,
        "ReviewItem5": 72,
        "Title": "Maikun Belts For Men, Canvas Elastic Belt, Mens Womens Boys Belt With Leather Tip",
        "ASIN": "B077RWGHJX",
        "ReviewItem3": 4,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PzaeF3onL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.38,
        "UploadTime": " August 29, 2017",
        "Id": 2048,
        "ReviewCount": 311
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 56.99,
        "ReviewItem5": 0,
        "Title": "LeSportsac Kylie Crossbody Bag, Celestial",
        "ASIN": "B07N7SZ46S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TUhcZV2EL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 56.99,
        "UploadTime": " October 13, 2014",
        "Id": 2049,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Business Card Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "PU Leather Credit Card Holders Wallet Business Bank Cards Case Cardholder Purse",
        "ASIN": "B07Q9L28QF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pd5nAWkkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " April 3, 2019",
        "Id": 2050,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.48,
        "ReviewItem5": 0,
        "Title": "AFONiE Genuine Two Fronts Leather Multi-Pocket Crossbody purse bag",
        "ASIN": "B01DJYR4PC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41D6xkiN0DL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.48,
        "UploadTime": " March 29, 2016",
        "Id": 2051,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Fashion Microfiber&cowhide Zipper Round Packet Earrings Jewelry Fashion Items Match Print One Shoulder Cross-body Bags Handbag Small Round Wallet Circle Purse Clutch",
        "ASIN": "B07HNF52NG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DkAcbQOsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 26, 2018",
        "Id": 2052,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 129.26,
        "ReviewItem5": 0,
        "Title": "Liebeskind Berlin Women’s Miramar Sporty Shoulder Handbag, 13 x 32 x 43 cm (W x H x D)",
        "ASIN": "B06Y3JW7FM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413Rv3XUNjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 129.26,
        "UploadTime": " February 22, 2019",
        "Id": 2053,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.2,
        "ReviewItem5": 0,
        "Title": "{ Extra 10% Discount } Purse Collection Beautiful Drawstring Rani Colour Potlli With Lace Work Purse For Women's",
        "ASIN": "B077B42V68",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BF3vw-oxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.2,
        "UploadTime": " August 23, 2017",
        "Id": 2190,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.79,
        "ReviewItem5": 100,
        "Title": "Mens Genuine Leather Zipper Wallet RFID Blocking Bifold Secure Zip Around Wallets Multi Credit Card Holder Purse",
        "ASIN": "B07P1NFY4B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UF56PxIIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.79,
        "UploadTime": " February 24, 2019",
        "Id": 2055,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Gene Brushstroke Multi Clutch Handbag",
        "ASIN": "B00HDK7FDA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51kJoSseCPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 17, 2013",
        "Id": 2056,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 0,
        "Title": "Classic Clutch Metal Zipper Wallet Leather Long Wallet Card Holder Purse Handbag for Men and Women-Coffee",
        "ASIN": "B07CH8XVHG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iaeKzmBIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " April 18, 2018",
        "Id": 2058,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 75,
        "ReviewItem5": 0,
        "Title": "Hedgren Women's Triangular Small Crossbody",
        "ASIN": "B07D9N77YG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31HBoUMl0fL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 75,
        "UploadTime": " August 4, 2018",
        "Id": 2059,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Small Crossbody Vintage Flower Bird Draw Cell Phone Purse Mini shoulder Bag Leather Wallets Pouch for Women Girls",
        "ASIN": "B07QJ9R3CJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51G4GzTX7YL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 10, 2019",
        "Id": 2060,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Women",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 32.99,
        "ReviewItem5": 72,
        "Title": "VOSTOR Straw Handbag for Women Summer Beach Straw Handbag Wooden Ring Tote Crossbody Shoulder Bag With Leather Strap",
        "ASIN": "B07DK72KF6",
        "ReviewItem3": 14,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w3aQ9MXkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.99,
        "UploadTime": " February 21, 2019",
        "Id": 2061,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "Nine West Womens Jabbez Shoulder",
        "ASIN": "B07L6KRNXV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41NkcOR8hpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " January 13, 2019",
        "Id": 2062,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Thirty One Top-A-Tote 4018 Black",
        "ASIN": "B00FUMWQO6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31b3bh4DPjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 12, 2013",
        "Id": 2063,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 87.99,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Lane Nylon Triple Compartment Tote",
        "ASIN": "B07KKT55NH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/319MzpK3ckL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 87.99,
        "UploadTime": " February 1, 2019",
        "Id": 2064,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "VIccoo Shoulder Bag, Women Handbag Shoulder Bags Tote Purse Messenger Hobo Satchel Bag Crossbody - Cameo",
        "ASIN": "B07QS1MZKK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51c9oWKSbxL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2084,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 299.97,
        "ReviewItem5": 0,
        "Title": "ZIMBELMANN ANCAROLIN Genuine Nappa Leather Top-handle Cross Body Shoulder Bag",
        "ASIN": "B008GS9V6W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51P8s9dHRfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 299.97,
        "UploadTime": " January 10, 2015",
        "Id": 2065,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.95,
        "ReviewItem5": 0,
        "Title": "Crossbody Handbag for Women - CRISS CROSS WESTERN GUNS, Small Designer Bags - BROWN, 6\" x 8\" x 1\"",
        "ASIN": "B077JYB3HC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RxKPQZFXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.95,
        "UploadTime": " November 17, 2017",
        "Id": 2066,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wristlets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Sea Bags Recycled Sail Cloth Anchor Bucket Bag Navy",
        "ASIN": "B01E7UJ7KW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31-0ZXYnS3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 26, 2018",
        "Id": 2067,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "BTP! Thai Tribal Hmong Striped Ethnic Cotton Sling Crossbody Bag Shoulder Bags Handmade Ikat Top Zip Outside Pocket",
        "ASIN": "B07J171JT3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UVIjvTA-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " October 4, 2018",
        "Id": 2068,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 144.99,
        "ReviewItem5": 100,
        "Title": "COACH Women's Chelsea Crossbody",
        "ASIN": "B074KHWDDJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51GJhxDM1oL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 144.99,
        "UploadTime": " December 1, 2017",
        "Id": 2069,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Men’s Clutch Bag Handbags Wallets Business Organizer Purse",
        "ASIN": "B07GXBWNF1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31J%2Bv64d0sL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " August 21, 2018",
        "Id": 2070,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 13,
        "PriceMax": 23.8,
        "ReviewItem5": 43,
        "Title": "Buxton Double Flap Mini Cross Body Bag",
        "ASIN": "B003E76MCG",
        "ReviewItem3": 17,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41--MJq3NoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.8,
        "UploadTime": " February 15, 2005",
        "Id": 2071,
        "ReviewCount": 206
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "ALDO Women's Pounce",
        "ASIN": "B07HKH7GLY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41t8W-M-nhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " December 21, 2018",
        "Id": 2072,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 16.79,
        "ReviewItem5": 67,
        "Title": "Original Camera Design Women Crossbody Bag Cute Girl Phone Bag Adorable Fanny Pack Party Purse -Sibalasi",
        "ASIN": "B07M638NJR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412G81PGzQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.79,
        "UploadTime": " December 26, 2018",
        "Id": 2085,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Drawstring Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 2,
        "PriceMax": 27.5,
        "ReviewItem5": 75,
        "Title": "Legendary Drawstring Gym Bag - Waterproof | For Sports & Workout Gear | XL Capacity | Heavy-Duty Sackpack Backpack",
        "ASIN": "B01MS6WFTD",
        "ReviewItem3": 4,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pkbJ8dB2L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.5,
        "UploadTime": " January 12, 2017",
        "Id": 2073,
        "ReviewCount": 358
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 57.5,
        "ReviewItem5": 0,
        "Title": "sugar skull day of the dead embroidery gun concealed carry handbag purse set",
        "ASIN": "B0767N2LD7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514TM2zkTJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 57.5,
        "UploadTime": " January 17, 2017",
        "Id": 2074,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 0,
        "Title": "Fish Scales Green Nautical Glasses Case Women Men Eyeglasses Bag Pencil Case Pouch",
        "ASIN": "B07PQWCCCG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41o5cXRBwuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " March 15, 2019",
        "Id": 2075,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 139,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Mott Mini Pebbled Leather Crossbody 32T8GF5C0L-187",
        "ASIN": "B07C2YNV6V",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lgtwkRGSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 139,
        "UploadTime": " August 3, 2018",
        "Id": 2076,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 32.99,
        "ReviewItem5": 0,
        "Title": "Victoria's Secret Packable Travel Weekender Tote Bag",
        "ASIN": "B07K1CW16X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Llim95KQL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 32.99,
        "Id": 2077,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 79,
        "ReviewItem5": 0,
        "Title": "Nine West TERESKA Crossbody",
        "ASIN": "B07QCLN9T3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ebCCEuvAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 79,
        "UploadTime": " March 23, 2019",
        "Id": 2078,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Tactical Bags & Packs",
        "ReviewItem1": 9,
        "ReviewItem2": 8,
        "PriceMax": 49.99,
        "ReviewItem5": 62,
        "Title": "NPUSA Mens Large 26\" Duffel Duffle Military Molle Tactical Gear Shoulder Strap Travel Bag",
        "ASIN": "B00UV3T2Z0",
        "ReviewItem3": 9,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51l46brrWHL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.5,
        "Id": 2079,
        "ReviewCount": 281
    }, {
        "Sale": "[]",
        "Category": "Keyrings & Keychains",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Genuine Leather Car Key Case Chain Holder Dual-use Zipper Key Bag Wallet Gift Brown",
        "ASIN": "B01MFGJY75",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VABNYrevL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2080,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 328,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Reagan Large Leather Satchel",
        "ASIN": "B07CLP6FVF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fkSH%2Bj90L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 328,
        "UploadTime": " April 23, 2018",
        "Id": 2081,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 734,
        "ReviewItem5": 0,
        "Title": "Stella Mccartney Women's 570301W85188517 Multicolor Cotton Handbag",
        "ASIN": "B07R4R658F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516diinzTbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 734,
        "UploadTime": " April 24, 2019",
        "Id": 2082,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29,
        "ReviewItem5": 0,
        "Title": "Large Tote Bag - Multi Dog Print on Mint Canvas, Multipurpose Cotton Travel Shopper Bag",
        "ASIN": "B07JV7KT9K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QbqiO9yFL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29,
        "Id": 2083,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 3,
        "PriceMax": 19.98,
        "ReviewItem5": 87,
        "Title": "Purse King Lily Cross Body Bag",
        "ASIN": "B01ISRDKIU",
        "ReviewItem3": 0,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517ALCEL%2BtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.98,
        "UploadTime": " July 21, 2016",
        "Id": 2145,
        "ReviewCount": 30
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 47.99,
        "ReviewItem5": 0,
        "Title": "Women's Premium Genuine Leather Organizer Purse Ladies Crossbody Shoulder Bag",
        "ASIN": "B07N8CVQY6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SctB5TU9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 47.99,
        "UploadTime": " January 30, 2019",
        "Id": 2086,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 3,
        "PriceMax": 22.99,
        "ReviewItem5": 73,
        "Title": "Scarleton Casual Double Zipper Crossbody Bag H1820",
        "ASIN": "B07KWL8J47",
        "ReviewItem3": 8,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41d5zeu4pLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " February 27, 2011",
        "Id": 2087,
        "ReviewCount": 555
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.59,
        "ReviewItem5": 91,
        "Title": "Myra Bags Bicycle Upcycled Canvas Tote Bag S-0935",
        "ASIN": "B078RBR8VY",
        "ReviewItem3": 0,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CinBvTXCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.59,
        "UploadTime": " September 4, 2014",
        "Id": 2088,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "SNUGRUGS Womens Genuine Soft Leather Make Up Case/Bag",
        "ASIN": "B06XGCVN94",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Lp1eY1KpL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " March 7, 2017",
        "Id": 2100,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 47.99,
        "ReviewItem5": 100,
        "Title": "A81.Disney Mickey Mouse Women Cartoon Tassel Cross Body Shoulder Bag",
        "ASIN": "B079XSTXYQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51t6aeH%2B7sL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 47.99,
        "UploadTime": " December 27, 2017",
        "Id": 2089,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.42,
        "ReviewItem5": 0,
        "Title": "Nautica Close Reach Flap Buckle Adjustable Crossbody",
        "ASIN": "B07J3F5SJ9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41b9DXpQnBL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.42,
        "UploadTime": " November 19, 2018",
        "Id": 2090,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 40,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 20,
        "Title": "Oct17 Fashion Lady Full Zipper Women Wallet Clutch Long Purse Card Holder Handbag",
        "ASIN": "B01NAL26ZD",
        "ReviewItem3": 0,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41J2eZ1wI%2BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 20, 2016",
        "Id": 2091,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 20,
        "ReviewItem2": 0,
        "PriceMax": 74,
        "ReviewItem5": 60,
        "Title": "Victoria's Secret New 2015 Christmas Tote Bag",
        "ASIN": "B018UJ49PY",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417o9erjxLL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 74,
        "Id": 2092,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 1,
        "PriceMax": 0,
        "ReviewItem5": 81,
        "Title": "Under Armour Women's Big Logo Tote",
        "ASIN": "B018HJ42RM",
        "ReviewItem3": 5,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41I0RdE17cL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 29, 2015",
        "Id": 2093,
        "ReviewCount": 62
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Property Of A Hot Mechanical Engineer Gift For Husband Wife Job - Tote Bag With Zip",
        "ASIN": "B07CXPCQYZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419DWTKZqML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " May 8, 2018",
        "Id": 2094,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Embroidered Tote Hippie Bag Top Handle Multipurpose Indian Ethnic HandBag Purse",
        "ASIN": "B076BSG3FY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418qWNkKCIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " October 9, 2017",
        "Id": 2095,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 109.99,
        "ReviewItem5": 77,
        "Title": "COACH Women's Crossgrain Large Street Tote",
        "ASIN": "B07NCCP924",
        "ReviewItem3": 8,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Q9acTAKjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 109.99,
        "UploadTime": " April 18, 2019",
        "Id": 2096,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.98,
        "ReviewItem5": 0,
        "Title": "dDanke Handwoven Round Rattan Bag Straw Bag Shoulder Leather Straps Natural Chic Handbag Shoulder Beach Tote Bags",
        "ASIN": "B07FQMF583",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51N2R5rnZ2L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.98,
        "Id": 2097,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Straw Bags for Women, Hand-woven Straw Large Hobo Summer Beach Bag Round Handle Ring Toto Retro Rattan Bag",
        "ASIN": "B07QL22VC9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51B3EpEHsWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " April 11, 2019",
        "Id": 2098,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "Mens Leather Wallets, Minimalist Front Pocket RFID Biflod Leather Purse, Best Birthday Gifts for your Son",
        "ASIN": "B07MZ37TVS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xnQCmPmcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " January 21, 2019",
        "Id": 2099,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.83,
        "ReviewItem5": 0,
        "Title": "Donalworld Women Vintage Hard PU Leather Top-handle Bag",
        "ASIN": "B0106AH7AY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wP5FSMEbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.83,
        "UploadTime": " June 22, 2015",
        "Id": 2101,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.29,
        "ReviewItem5": 0,
        "Title": "Moorfowl Fashion Checkered Handbag for Women Ladies Shopping Travel Tote Shoulder Bag PU Leather Purse Messenger Bag",
        "ASIN": "B07QGVHPK2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512BcQNUZ1L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.29,
        "Id": 2102,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 100,
        "Title": "Herschel Supply Co. Cruz Cross Body Bag",
        "ASIN": "B07DYKKN81",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JDuUZiE0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " December 7, 2018",
        "Id": 2103,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 63.98,
        "ReviewItem5": 100,
        "Title": "Kipling Sally Handbag",
        "ASIN": "B01ICFACNE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41dg-1aL9UL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 63.98,
        "UploadTime": " July 12, 2016",
        "Id": 2104,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens PU Leather Fringe Tassel Shoulder Bag Casual Handbag Crossbody Bag Envelope Bag",
        "ASIN": "B07M8CYDBC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41j1OKnDEiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 20, 2018",
        "Id": 2105,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "Nine West Fringe Flap Clutch Purse With Optional Shoulder Strap",
        "ASIN": "B07G6WRP9D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AHDnN%2BkUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " August 5, 2018",
        "Id": 2106,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 336.5,
        "ReviewItem5": 0,
        "Title": "Porter Original One Shoulder Bag Yoshida Kaban NV (navy)",
        "ASIN": "B00D1J3JSW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31RCqD969LL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 336.5,
        "UploadTime": " April 9, 2014",
        "Id": 2146,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.98,
        "ReviewItem5": 0,
        "Title": "Premium Large PU Leather Studded Front Flap Clutch Bag Handbag - Diff Colors",
        "ASIN": "B01MTMJGDX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511wqbdeJoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.98,
        "UploadTime": " November 13, 2016",
        "Id": 2281,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 11,
        "PriceMax": 0,
        "ReviewItem5": 78,
        "Title": "Saking Multifunction Zipper Waterproof Small Crossbody Bags Cell Phone Purse Wallet For Women",
        "ASIN": "B079FM7P11",
        "ReviewItem3": 11,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41vx1Hrg6rL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 29, 2018",
        "Id": 2107,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89.99,
        "ReviewItem5": 83,
        "Title": "Kipling New Shopper Large Tote",
        "ASIN": "B01N4UX3IV",
        "ReviewItem3": 0,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41RoML3TbiL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.99,
        "UploadTime": " February 2, 2017",
        "Id": 2108,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Ohio Travel Bag Handbag/Purse Light with Automatic Light Sensor - Motion Activated Purse Light",
        "ASIN": "B07Q5KDKY6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/315upYjJi4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 27, 2019",
        "Id": 2109,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Grain Elevator Operator I Do Precision Guesswork Gift - Tote Bag With Zip",
        "ASIN": "B07C27SL41",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51e17v6qkpL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " April 9, 2018",
        "Id": 2110,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12,
        "ReviewItem5": 0,
        "Title": "Lightweight Clutches Small Crossbody Bag with Tassel Coin Purses Magnetic Lock",
        "ASIN": "B07M7NC9BB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41e9i6cdH9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12,
        "UploadTime": " January 8, 2019",
        "Id": 2111,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 57,
        "Title": "Womens Ladies Handbag Drawstring Bucket Bag Coin Purses Key Bags Cash Money Phone Pouches",
        "ASIN": "B078YQSTX7",
        "ReviewItem3": 14,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51n12AXENPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " January 12, 2018",
        "Id": 2112,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 6,
        "PriceMax": 11.99,
        "ReviewItem5": 56,
        "Title": "Dasein Women Evening Envelope Handbag Party Prom Clutch Purse Shoulder Cross Body Bag",
        "ASIN": "B07CBVS917",
        "ReviewItem3": 12,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61z095VF16L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " November 26, 2016",
        "Id": 2113,
        "ReviewCount": 179
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 59.56,
        "ReviewItem5": 25,
        "Title": "Ban.do Everything Tote Bag, Rose Gold/Neon Pink",
        "ASIN": "B00SD7LFCO",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31UueRRlqqL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.56,
        "Id": 2114,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 30.99,
        "ReviewItem5": 0,
        "Title": "Steve Madden Rumi Multi Colored Woven GEOMTRIC Pattern Beach Tote with Zipper Pouch",
        "ASIN": "B078KCG2GS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61BXpsCvqhL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30.99,
        "UploadTime": " March 13, 2018",
        "Id": 2115,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 310,
        "ReviewItem5": 0,
        "Title": "Furla Elle Rock Studded M Leather Tote Bag, Gloss Pink",
        "ASIN": "B00OZZ11Q8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417pqhfVO6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 310,
        "UploadTime": " May 28, 2014",
        "Id": 2116,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 148,
        "ReviewItem5": 0,
        "Title": "Marc Jacobs Nylon Medium Tote Bag, Blue Print Multi",
        "ASIN": "B07CQCPS1L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nHLibj9OL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 148,
        "UploadTime": " April 27, 2018",
        "Id": 2117,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39,
        "ReviewItem5": 0,
        "Title": "Nikky Top Handle Gray Tote Bag, Spacious Compartment, Decorative Tassel Travel Shoulder Bag",
        "ASIN": "B07JKPJ3ZJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41oh9iOx4gL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39,
        "UploadTime": " October 19, 2018",
        "Id": 2118,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 236.73,
        "ReviewItem5": 0,
        "Title": "Vince Camuto Indra Tote",
        "ASIN": "B07JGVMXMV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51x0FPt1Q1L._SR38,50_.jpg",
        "AcquisitionTime": 1558022400000,
        "Price": "[]",
        "PriceMin": 236.73,
        "UploadTime": " March 26, 2019",
        "Id": 10822,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.01,
        "ReviewItem5": 0,
        "Title": "Felice Women Girls Fringe Messenger Cross-Body Bag Denim Shoulder Bag Handbag Top Handle Tote Satchel",
        "ASIN": "B0771FCMYR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PkLtWbIBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.01,
        "UploadTime": " October 31, 2017",
        "Id": 2119,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 264.99,
        "ReviewItem5": 75,
        "Title": "COACH Womens Signature Crossbody Carryall",
        "ASIN": "B01F9LH9UI",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51NWy7fT-cL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 264.99,
        "UploadTime": " June 3, 2016",
        "Id": 2120,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 63,
        "Title": "Marchome Women Pu Leather Holographic Mermaid Scales Crossbody Handbag Shoulder Bag",
        "ASIN": "B071L3Z64J",
        "ReviewItem3": 0,
        "ReviewItem4": 37,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JHK3dcg4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " May 5, 2017",
        "Id": 2121,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 95,
        "Title": "Dazzling Hand Sequined Baguette Style Evening Clutch Purse w/Detachable Chains",
        "ASIN": "B00F7SL1V2",
        "ReviewItem3": 0,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51asqQWIuQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " September 15, 2013",
        "Id": 2122,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 120,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Women's Vegan Nole Nylon Crossbody Bag",
        "ASIN": "B07JYCLMK4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31WGTF0aHbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 120,
        "UploadTime": " October 27, 2018",
        "Id": 2123,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.98,
        "ReviewItem5": 0,
        "Title": "Van Caro Womens Quilted Tassel Belt Bag Crossbody Shoulder Chain Purse 2-Way Belt Bag",
        "ASIN": "B07KQRG9ZY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WYfEtZptL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.98,
        "Id": 2124,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 1,
        "ReviewItem2": 2,
        "PriceMax": 0,
        "ReviewItem5": 76,
        "Title": "Leather Wallets for Women - RFID Blocking clutch purses for women by Rustic Town",
        "ASIN": "B01HV7G9Z4",
        "ReviewItem3": 5,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lYRRvKf3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 2, 2016",
        "Id": 2125,
        "ReviewCount": 97
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 18,
        "ReviewItem2": 9,
        "PriceMax": 5.99,
        "ReviewItem5": 49,
        "Title": "JET-BOND XB001 Multi-Pocket Handbag Organizer Purse Insert Liner Pouch Medium Size with Handles Many Pockets",
        "ASIN": "B07J67KT7M",
        "ReviewItem3": 10,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41C2EHVp2CL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 5.99,
        "UploadTime": " August 12, 2016",
        "Id": 2126,
        "ReviewCount": 523
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 12,
        "PriceMax": 34.98,
        "ReviewItem5": 53,
        "Title": "Convertible Back Pack Purse, Mid Size Tear Drop Shoulder Bag, Backpack, Sling Bag. Genuine Leather (Dark Brown)",
        "ASIN": "B0051UO2MQ",
        "ReviewItem3": 9,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Axqg5VnQL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.98,
        "Id": 2155,
        "ReviewCount": 138
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 8,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 77,
        "Title": "Women Girls Evening Party Acrylic Transparent Glitter Sequins Clutch Box Purse Bag Wedding Handbags",
        "ASIN": "B07FJMS3VD",
        "ReviewItem3": 0,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZK%2BmzgYsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " July 8, 2018",
        "Id": 2127,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.87,
        "ReviewItem5": 0,
        "Title": "VG Women Handwoven Round Handbag Tassel Straw Bag Ring Top-Handle Crossbody Bag",
        "ASIN": "B07GT18NGB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41P4J84Sn%2BL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.87,
        "Id": 2128,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 88,
        "ReviewItem5": 0,
        "Title": "Hedgren Metro Crossbody Bag, Organizer, Rfid, Tablet Pocket, Leash Cross Body Bag",
        "ASIN": "B07J3PL9PX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41O9AcoMJML._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 88,
        "UploadTime": " November 18, 2018",
        "Id": 2129,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 61.5,
        "ReviewItem5": 0,
        "Title": "Charming Convertible Hobo/xbody Bag (Pink)",
        "ASIN": "B07453SPZM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41LWKCjXORL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 61.5,
        "UploadTime": " July 22, 2017",
        "Id": 2130,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25,
        "ReviewItem5": 60,
        "Title": "Crossbody Bag",
        "ASIN": "B072T2VK9R",
        "ReviewItem3": 0,
        "ReviewItem4": 40,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51j5wKAfdgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25,
        "UploadTime": " June 18, 2017",
        "Id": 2131,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 33,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 67,
        "Title": "TianHengYi Girls Casual Small Nylon Cross-body Shoulder Bag Multi Pockets Lightweight Handbags & Purses",
        "ASIN": "B01ET37JAM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ham5RA-mL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " April 30, 2016",
        "Id": 2132,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39,
        "ReviewItem5": 0,
        "Title": "Laorentou Zipper Around Cross Body Leather Bag One Shoulder Prime Clutch Purses for women",
        "ASIN": "B07MQZ7TYV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41u8Dm7gTmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39,
        "UploadTime": " December 25, 2018",
        "Id": 2133,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 38.99,
        "ReviewItem5": 50,
        "Title": "G-AVERIL 2018 NEW Womens Red Handbags Ladies Top Handle Bags Patent Leather Stylish Tote Shoulder Bags Purse",
        "ASIN": "B07C15ZB94",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4151K1GOxeL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.99,
        "Id": 2134,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 57.95,
        "ReviewItem5": 0,
        "Title": "Leather Zipper Cross-body Handbag (Gray/Red/Black)",
        "ASIN": "B00MNS74AQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-od1XPeeL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 57.95,
        "UploadTime": " August 12, 2014",
        "Id": 2135,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 5,
        "ReviewItem2": 9,
        "PriceMax": 11.99,
        "ReviewItem5": 57,
        "Title": "Women Zipper Wallet Owl Wallet Purse Canvas Phone Card Holder with Coin Pocket and Strap",
        "ASIN": "B074C84QJW",
        "ReviewItem3": 11,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515z5KMLqcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " August 11, 2017",
        "Id": 2136,
        "ReviewCount": 142
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Glitter Clutch Purse Beaded Evening Bag Handbag for Bridal Wedding Party (Silver)",
        "ASIN": "B07QRRQZ2S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MoOYkO6-L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2137,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 83.08,
        "ReviewItem5": 100,
        "Title": "Lug Women's Jamboree Shoulder Bag, Brushed Black, One Size",
        "ASIN": "B079B965N4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uBuxnGbML._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 83.08,
        "Id": 2138,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Kooba Belize Tote Bag - Leather",
        "ASIN": "B07FZTRTHM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41F%2B%2BvVMucL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2139,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 154.5,
        "ReviewItem5": 100,
        "Title": "Corkor Vegan Backpack Purses for Women| Cruelty Free Cork Handbag",
        "ASIN": "B071KCG5M7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iWxHbveCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 154.5,
        "UploadTime": " June 14, 2017",
        "Id": 2140,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.56,
        "ReviewItem5": 0,
        "Title": "Women's Leather Handbag Purse Large Capacity Hardware Zipper Top Handle Shoulder Tote Satchel Bag For Shopping,Travel,Work (Red)",
        "ASIN": "B07N4FVWGM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rQ94k54-L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.56,
        "Id": 2141,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.5,
        "ReviewItem5": 0,
        "Title": "Chala Womens' Canvas Patch Crossbody Handbag \"Boston Terrier\" - Sand",
        "ASIN": "B075NPTHP8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CEodDHY2L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.5,
        "UploadTime": " March 5, 2018",
        "Id": 2142,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Fantastic Handicraft Indian Clutch/Purse/Hand Holding for Women & Girls",
        "ASIN": "B07MZZJQ2W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517SkrZ6d6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " May 8, 2018",
        "Id": 2143,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "Vislu Simple and Leisure Style Leather Work Tote Shoulder Bag",
        "ASIN": "B07MW2LZL4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41VEQCkvyXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " January 16, 2019",
        "Id": 2144,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 169.28,
        "ReviewItem5": 100,
        "Title": "Piel Leather Top-Zip Shoulder Bag Cross Body Hobo, Honey, One Size",
        "ASIN": "B00OMB7L82",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UjETR9zVL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 169.28,
        "Id": 2147,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Kipling Womens Zamor Cross-Body Bag",
        "ASIN": "B0123ZSCYK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510N7X3JbCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 20, 2016",
        "Id": 2148,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17,
        "ReviewItem5": 0,
        "Title": "NS ? (25 5/18) LM Las Vegas Tote Bag Canvas Neon Sign Black With Copyrighted Las Vegas Magnet",
        "ASIN": "B0181EE6ZQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31nSkyKT8PL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17,
        "Id": 2149,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 8,
        "PriceMax": 0,
        "ReviewItem5": 77,
        "Title": "Vera Bradley Womens Villager",
        "ASIN": "B01BG0F1XI",
        "ReviewItem3": 0,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510PbwiJPzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 3, 2016",
        "Id": 2592,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 100,
        "Title": "Signare Women’s Red and White Tapestry Top Handle Handbag with Detachable Strap to Convert to Shoulder Bag with Poppy Flower (CONV-POP)",
        "ASIN": "B00HOSOVHO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xTabcrHkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " January 4, 2014",
        "Id": 2150,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "Leather Bucket Bag Crossbody Shoulder Bag with Adjustable Strap Messenger Clutch Purse Pocket Bag Satchel Bag (Brown)",
        "ASIN": "B07R17BZ17",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RyPhTl2SL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "Id": 2151,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.98,
        "ReviewItem5": 0,
        "Title": "Brenice Faux Leather Multi-Pockets Shoulder Bag Crossbody Bag for Women",
        "ASIN": "B07PKVWLG7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417CqLq5w0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.98,
        "UploadTime": " March 7, 2019",
        "Id": 2152,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 38.95,
        "ReviewItem5": 71,
        "Title": "Italian Suede Leather Hand Made Envelope Design Clutch, Wrist, Shoulder or Crossbody Bag. Branded Protective Storage Bag",
        "ASIN": "B00VC75UEG",
        "ReviewItem3": 0,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rYwExJ5GL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.95,
        "UploadTime": " August 16, 2016",
        "Id": 2153,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.79,
        "ReviewItem5": 0,
        "Title": "FOXER Women Genuine Leather Crossbody Bag Small Purse Casual Leather Shoulder Bag",
        "ASIN": "B07L4HTRQX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tEThCGarL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.79,
        "UploadTime": " August 8, 2018",
        "Id": 2154,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 97.58,
        "ReviewItem5": 0,
        "Title": "Picard Berlin, Women’s Shoulder Bag, Blue (Ozean), 16x7x18 cm (B x H T)",
        "ASIN": "B007VN2ZIY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41muvuPQGBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 97.58,
        "UploadTime": " September 10, 2018",
        "Id": 2177,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ACTLURE Women Genuine Leather Crossbody Shoulder Purse Chain Link Handbag",
        "ASIN": "B07PXJ99VB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41tY8r9lTsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 21, 2019",
        "Id": 2156,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.76,
        "ReviewItem5": 0,
        "Title": "Kipling Women's Shopper C Tote",
        "ASIN": "B07DKB2L28",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-XcTxKszL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.76,
        "UploadTime": " December 25, 2018",
        "Id": 2157,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.64,
        "ReviewItem5": 0,
        "Title": "Beauty and The Beast Non-Woven Bag (S) 1 [Contains 9 Manufacturer Retail Unit(s) Per SKU# Beaute",
        "ASIN": "B075Y1MBHF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31jV1BeN2rL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.64,
        "Id": 2158,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Lily Munster Bat Shaped Handbag",
        "ASIN": "B072JP712F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51bHB8A6KoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " June 3, 2017",
        "Id": 2159,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 100,
        "Title": "Simple Classic Everyday Hobo Handbag Female Women Shoulder-to-Crossbody Hobo Bag Jack and Sally Pattern",
        "ASIN": "B015F6QPI4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lVk5FuO0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26.99,
        "UploadTime": " September 12, 2015",
        "Id": 2160,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 395,
        "ReviewItem5": 0,
        "Title": "Marc Jacobs Women's Nomad Grommet Small Nomad Saddle Bag",
        "ASIN": "B01M0N4O49",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BVPVnNz-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 395,
        "UploadTime": " November 23, 2016",
        "Id": 2161,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 100,
        "Title": "Justin West Buckle Floral Embroidered Studded CCW Concealed Carry Shoulder Purse Handbag",
        "ASIN": "B07CKP44X9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ndvV7DqEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " March 16, 2018",
        "Id": 2162,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "JUNJIAGAO-Bags Men's Wallet Card Package Fashion Short Wallet PU Leather (Color : Black, Size : S)",
        "ASIN": "B07RBVXS2Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bPj0i6XdL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2163,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 99,
        "ReviewItem5": 0,
        "Title": "Kipling Disney's Jungle Book Veni Crossbody Bag",
        "ASIN": "B07CKJQMXV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51bICL9%2BuOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 99,
        "UploadTime": " August 11, 2018",
        "Id": 2164,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "4pcs/1set Solid bags for Women Female Handbags & Crossbody Bags & Women Leather shop bag",
        "ASIN": "B07QQ19LCY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41hIMizkXfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 17, 2019",
        "Id": 2165,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 20,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 60,
        "Title": "Stylesty Fashion Womens Shopping Shoulder Tote Bag, Designer PU Leather Handbag",
        "ASIN": "B07GJJLWNS",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wicFJP5ZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " August 16, 2018",
        "Id": 2166,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.99,
        "ReviewItem5": 0,
        "Title": "DENER❤️ Women Ladies Girls Leather Shoulder Crossbody Bag,Designer Bags Handbags Satchel Bags Travel Bags Carryon Bags",
        "ASIN": "B07L5R4BCJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wXWvhXBSL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.99,
        "UploadTime": " December 5, 2018",
        "Id": 2167,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 4,
        "PriceMax": 15.99,
        "ReviewItem5": 81,
        "Title": "Blue Red Hobo Cotton Sling Cross Body Messenger Shoulder Bag Hippie Boho Bohemian Light Roomy Spacious",
        "ASIN": "B01LZZXXWV",
        "ReviewItem3": 5,
        "ReviewItem4": 3,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Hy5E1DpDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "UploadTime": " October 1, 2016",
        "Id": 2168,
        "ReviewCount": 89
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 720,
        "ReviewItem5": 0,
        "Title": "MCM Women's TRISHA Cognac Brown Suede Leather Small Crossbody Bag MWS8STS94CO001",
        "ASIN": "B07RMKQFWJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41q4hnNu7JL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 720,
        "UploadTime": " May 9, 2019",
        "Id": 2169,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 13,
        "ReviewItem2": 7,
        "PriceMax": 0,
        "ReviewItem5": 80,
        "Title": "Michael Kors Signature Fulton EW Crossbody Bag PVC Vanilla",
        "ASIN": "B01N7582EF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513z8QqnjkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 15, 2016",
        "Id": 2225,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Shoes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.6,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Men's Fashion Comfort Slide Sandal Anti-Slip Slippers",
        "ASIN": "B07M8ZPB3D",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31dsj3C2i3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.6,
        "UploadTime": " December 28, 2018",
        "Id": 2170,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 179.99,
        "ReviewItem5": 0,
        "Title": "Michael Kors Ciara Saffiano Large Top Zip Satchel Crossbody Scarlet Red",
        "ASIN": "B07LDYW8JM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Gqqt11xGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 179.99,
        "UploadTime": " December 17, 2018",
        "Id": 2171,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 82.8,
        "ReviewItem5": 0,
        "Title": "Kipling womens Art Handbag",
        "ASIN": "B07CH5PP3K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Sl6x1mnZL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 82.8,
        "UploadTime": " October 24, 2018",
        "Id": 2172,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Four Zipper Crossbody Flower Purse - Handmade in Guatemala (Patterns And Colors May Vary Slightly)",
        "ASIN": "B07P5TJ1H1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51YVH%2BXJ0GL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " February 27, 2019",
        "Id": 2173,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Double Zipper Phone Bag Vintage Leather Clutch Wallet Male Purses Men's Wallets",
        "ASIN": "B07GV3X4T2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WTgi8A43L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 25, 2018",
        "Id": 2174,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Wallet For Men Women Slimline Ultra Thin Mini Small Male Female Zipper Coin Purse Compact Money Bag",
        "ASIN": "B07QQWTZYF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31ZjLPakYFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 16, 2019",
        "Id": 2175,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Replacement Sunglass Lenses",
        "ReviewItem1": 19,
        "ReviewItem2": 8,
        "PriceMax": 19.99,
        "ReviewItem5": 50,
        "Title": "FLAK 2.0 XL Replacement Lenses by SEEK OPTICS to fit OAKLEY Sunglasses",
        "ASIN": "B018V1SRK4",
        "ReviewItem3": 9,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31mg3AJFMcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " December 3, 2015",
        "Id": 2176,
        "ReviewCount": 114
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 17,
        "ReviewItem2": 9,
        "PriceMax": 27.99,
        "ReviewItem5": 48,
        "Title": "KISS GOLD(TM) Women's Designer Canvas Totes Crossbody Shoulder Bag",
        "ASIN": "B01IR7S01S",
        "ReviewItem3": 9,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RNPnbZ-0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " July 20, 2016",
        "Id": 2178,
        "ReviewCount": 23
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 70.95,
        "ReviewItem5": 0,
        "Title": "The Cambridge Satchel Company Push Lock Womens Handbag Grey",
        "ASIN": "B07FYY9D1B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51vH%2BNr8JWL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 70.95,
        "UploadTime": " July 24, 2018",
        "Id": 2226,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20.99,
        "ReviewItem5": 0,
        "Title": "reisenthel Shoulderbag S, Small Zippered Carryall with Adjustable Cross-body Strap",
        "ASIN": "B07KCG2NNG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31DB2IZOMcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20.99,
        "UploadTime": " March 15, 2019",
        "Id": 2228,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 4,
        "PriceMax": 19.99,
        "ReviewItem5": 56,
        "Title": "Small Crossbody Bag Cell Phone Purse Wallet with Shoulder Strap For Women Girls",
        "ASIN": "B07HDZY8NG",
        "ReviewItem3": 11,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Dp8YZy1pL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " June 5, 2018",
        "Id": 2179,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 13,
        "ReviewItem2": 7,
        "PriceMax": 23.97,
        "ReviewItem5": 54,
        "Title": "Daisy Rose Colorful Clutch- Straw Handbag with Vegan Leather Handles and Pom Poms",
        "ASIN": "B07D66NHYL",
        "ReviewItem3": 13,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mWODczHoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.97,
        "UploadTime": " July 24, 2017",
        "Id": 2180,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Loungefly X Disney Stitch & Scrump 2-Sided Tote Bag",
        "ASIN": "B01N9EQQ6O",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ySYyojJkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 6, 2016",
        "Id": 2181,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 14,
        "PriceMax": 49.61,
        "ReviewItem5": 29,
        "Title": "Travelon Anti-theft Courier Bucket Hobo Travel Purse, Navy",
        "ASIN": "B078XXN199",
        "ReviewItem3": 29,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cj4dFC%2BoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.61,
        "Id": 2182,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "LONI Women's synthetic Cute Clutch Bag",
        "ASIN": "B01BYWAWM8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31D%2BNS1maUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " June 9, 2016",
        "Id": 2183,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 30,
        "ReviewItem2": 5,
        "PriceMax": 0,
        "ReviewItem5": 45,
        "Title": "Under Armour Women's All Day Crossbody Backpack",
        "ASIN": "B072BY2CPR",
        "ReviewItem3": 5,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51aw-VW-rIL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 17, 2017",
        "Id": 2184,
        "ReviewCount": 20
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 99.99,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Reese Mercury E/w Tote",
        "ASIN": "B073WMXFTG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41DCBNaCdcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 99.99,
        "UploadTime": " November 2, 2017",
        "Id": 2185,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 317,
        "ReviewItem5": 0,
        "Title": "Pinko Women's 1P21ayy5eui09 White Leather Shoulder Bag",
        "ASIN": "B07PQMYD72",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/311RkL6rpPL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 317,
        "Id": 2186,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Reusable Grocery Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 80,
        "Title": "Signare Womens Fashion Tapestry Shopper Bag Shoulder Bag",
        "ASIN": "B01GQHNYEY",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/6175OjLVQiL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " June 7, 2016",
        "Id": 2187,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26,
        "ReviewItem5": 50,
        "Title": "High Fashion Solid Tote Bag - Personalization Available",
        "ASIN": "B075DK5N91",
        "ReviewItem3": 17,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PeQGxqtwL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 26,
        "Id": 2188,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 75,
        "Title": "Nine West Women's Efren Crossbody",
        "ASIN": "B07L6L64ZC",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yW1FppWQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " January 13, 2019",
        "Id": 2191,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 6,
        "PriceMax": 24.99,
        "ReviewItem5": 57,
        "Title": "JUMENG Fashion Mini Backpacks for Women Girls Nylon Small Shoulder Bag Waterproof",
        "ASIN": "B07PGNJCQJ",
        "ReviewItem3": 9,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Wqjz3DlDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " October 31, 2017",
        "Id": 2192,
        "ReviewCount": 68
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 48.99,
        "ReviewItem5": 67,
        "Title": "Lug",
        "ASIN": "B07N258VN8",
        "ReviewItem3": 11,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hT1vyYyLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 48.99,
        "UploadTime": " February 13, 2019",
        "Id": 2193,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Logo Satchel Bag Handbag Purse - Brown / Beige",
        "ASIN": "B00T72HPT6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51%2BEVH8hs1L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 15, 2014",
        "Id": 2194,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 368,
        "ReviewItem5": 0,
        "Title": "MICHAELL Michael Kors Greenwich Saffiano Leather Large Grab Bag, Fuschia/Luggage",
        "ASIN": "B00ZPVO2IU",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51A3pl0dahL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 368,
        "UploadTime": " June 15, 2015",
        "Id": 2195,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 197.49,
        "ReviewItem5": 0,
        "Title": "COACH Womens Bowery Crossbody with Floral Bloom Print",
        "ASIN": "B076VMFDD2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413pUgFinVL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 197.49,
        "UploadTime": " April 19, 2018",
        "Id": 2196,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 170.51,
        "ReviewItem5": 0,
        "Title": "Time's Arrow Orion Crossbody",
        "ASIN": "B0762PWRF3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zSle6X8eL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 170.51,
        "UploadTime": " March 1, 2018",
        "Id": 2197,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "COACH Womens Pebbled Leather Turnlock Chain Tote 27",
        "ASIN": "B07144LQSC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EYPszc5zL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 1, 2017",
        "Id": 2198,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Shoulder Bags with Chain Straps for Women Mini Quilted Waist Bag Fashion Round Bag Quilted Chest Bag with Chain",
        "ASIN": "B07KWLPQ6W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-ulT4VWEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 27, 2018",
        "Id": 2199,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 20,
        "ReviewItem2": 0,
        "PriceMax": 55,
        "ReviewItem5": 60,
        "Title": "Ainifeel Women's Genuine Leather Quilted Wallet Billfold Cell Phone Wallet With Chains",
        "ASIN": "B07D7WZ6H7",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qBFXftf2L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55,
        "UploadTime": " November 21, 2016",
        "Id": 2200,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Womens Kitty Cat Crossbody Handbag Mini Clutch Embroidered Design Purse",
        "ASIN": "B07QMYH979",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Wk8lI7EPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " April 11, 2019",
        "Id": 2201,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 13,
        "PriceMax": 16.95,
        "ReviewItem5": 75,
        "Title": "Front Half-moon Zipper Pocket Small Crossbody Bag",
        "ASIN": "B07D4QX6CD",
        "ReviewItem3": 0,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51i%2BG1v3ozL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.95,
        "UploadTime": " May 17, 2018",
        "Id": 2406,
        "ReviewCount": 16
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 30,
        "ReviewItem5": 72,
        "Title": "Western Handbag - Multi-Colored Serape Fabric Textured Stitched Cactus Concealed Carry Crossbody Bag",
        "ASIN": "B0725KSP6Q",
        "ReviewItem3": 7,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XVINC5njL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 30,
        "UploadTime": " May 12, 2017",
        "Id": 2202,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MaxFox Women Diagonal Crossbody Bag Femal Korean Version Shoulder Bags Strap Chest Pack Tote bag (F)",
        "ASIN": "B07F36DKYF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5124ZrypxSL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2203,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 3,
        "PriceMax": 174.95,
        "ReviewItem5": 87,
        "Title": "FRYE Campus Rivet Crossbody Leather Handbag",
        "ASIN": "B0759P9CJX",
        "ReviewItem3": 3,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51uWrL9PchL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 174.95,
        "UploadTime": " February 8, 2018",
        "Id": 2204,
        "ReviewCount": 31
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MICRO MINI BENNETT SATCHEL WITH CROSS STITCH FLORAL PRINT",
        "ASIN": "B07B86CZ31",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41op-TywcBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 5, 2018",
        "Id": 2205,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 67.69,
        "ReviewItem5": 0,
        "Title": "Tokidoki Watercolor Paradise Crossbody Bag in Blue/Muti",
        "ASIN": "B07NXYNBMM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xV9TJquKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 67.69,
        "UploadTime": " February 21, 2019",
        "Id": 2206,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 2,
        "ReviewItem2": 0,
        "PriceMax": 29.95,
        "ReviewItem5": 80,
        "Title": "Overbrooke Reversible Quilted Tote Bag - Premium Fabric Womens Shoulder Tote",
        "ASIN": "B06XP4ZVM1",
        "ReviewItem3": 7,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41fktvcf49L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " March 15, 2017",
        "Id": 2207,
        "ReviewCount": 54
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 84.99,
        "ReviewItem5": 0,
        "Title": "Rebecca Minkoff Biker Mini Doctor Bag Ladies Small Leather Satchel HF17EDBX14",
        "ASIN": "B07C3Z8ZPD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eE4y6bWrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 84.99,
        "UploadTime": " April 11, 2018",
        "Id": 2208,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Newsboy Caps",
        "ReviewItem1": 4,
        "ReviewItem2": 10,
        "PriceMax": 12.99,
        "ReviewItem5": 61,
        "Title": "VOBOOM Cotton Washing Flat Cap Cabbie Hat Gatsby Ivy Irish Hunting Newsboy",
        "ASIN": "B01N4VPX97",
        "ReviewItem3": 10,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ijwX07ZFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " February 5, 2017",
        "Id": 2209,
        "ReviewCount": 97
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 369,
        "ReviewItem5": 0,
        "Title": "Marc by Marc Jacobs Washed Up Mini Nash Cross Body Bag",
        "ASIN": "B00MXX39QE",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PA1swGjoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 369,
        "UploadTime": " September 16, 2014",
        "Id": 2210,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.69,
        "ReviewItem5": 0,
        "Title": "Disney Beauty & The Beast Handbag Travel Tote, 19 cm, White",
        "ASIN": "B076VTZW34",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41dAfUdtJgL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.69,
        "Id": 2211,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 0,
        "Title": "Women Small Crossbody Bag, Cute Pouch Tassel Cell Phone Purse Smartphone Wallet Shoulder Bag for Girls",
        "ASIN": "B07M7Z7PF7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SYZ41yDXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " January 12, 2019",
        "Id": 2212,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 1,
        "ReviewItem2": 7,
        "PriceMax": 0,
        "ReviewItem5": 64,
        "Title": "WongSinTong Lovely Canvas Purses and Handbags for Women,Large Capacity Tote Shoulder Bags with Zipper and Pockets",
        "ASIN": "B01EG6T0HW",
        "ReviewItem3": 8,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oktJweXYL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 18, 2016",
        "Id": 2223,
        "ReviewCount": 106
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 77.08,
        "ReviewItem5": 0,
        "Title": "Liebeskind Berlin Women's Pouchm Daddy5 Cross-Body Bag",
        "ASIN": "B076PMV9WH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Q%2BVOI4zbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 77.08,
        "UploadTime": " May 18, 2018",
        "Id": 2227,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "Aimeio Cute Printed Canvas Crossbody Purse Handbag Small Shoulder Bag Make Up Pouch for Women Girls",
        "ASIN": "B07MQ8S18T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Qsz1FmBkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " January 8, 2019",
        "Id": 2213,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Vote Bernie Sanders 2020 Tote Bag 33b0e",
        "ASIN": "B07MX3T3FK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513vkRYHRYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " January 18, 2019",
        "Id": 2214,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.95,
        "ReviewItem5": 100,
        "Title": "Chala Canvas CARRYALL Tote Shoulder Handbag with Leather Playful Animal Print",
        "ASIN": "B00H7OPZYS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512U7t7s9ML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.95,
        "UploadTime": " December 10, 2013",
        "Id": 2215,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Unisex Small Crossbody Bag Cell Phone Purse Wallet Headphone Bag pink hippy sugar skulls butterflies",
        "ASIN": "B07KTZQHQ1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51TJOkOcEjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 24, 2018",
        "Id": 2216,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Coach Leather Elle Crossbody Hobo Purse in Saddle Brown - #F31399",
        "ASIN": "B07L36JR8K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SRG-qYZfL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 3, 2018",
        "Id": 2217,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 82.39,
        "ReviewItem5": 50,
        "Title": "Piel Leather Double Handle Handbag, Saddle, One Size",
        "ASIN": "B002G147MS",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XU59bmU4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 82.39,
        "Id": 2218,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.99,
        "ReviewItem5": 100,
        "Title": "Portable Multi-Functional Insert Handbag Organizer Management Gadget Accessory Purse Organizer (Black)",
        "ASIN": "B0751H3WF3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517Nc4HMXZL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.99,
        "UploadTime": " August 22, 2017",
        "Id": 2219,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.89,
        "ReviewItem5": 0,
        "Title": "TENDYCOCO Man waist bag leather waist pouch hip bum pack for outdoor travel mountain climbing trip",
        "ASIN": "B07QTPCSB8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413ODYbdIjL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.89,
        "UploadTime": " April 17, 2019",
        "Id": 2220,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 3,
        "PriceMax": 17.98,
        "ReviewItem5": 64,
        "Title": "Women Backpack Shoulder Purse Black Rucksack Casual Daypack School Bags",
        "ASIN": "B07MVRM61T",
        "ReviewItem3": 5,
        "ReviewItem4": 28,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AntWdVHNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.98,
        "UploadTime": " August 31, 2018",
        "Id": 2221,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Women's Brown Paw Print with Hearts Rivet Shoulder Handbag Shoulder Bags",
        "ASIN": "B07PXQ9R99",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4149rM6%2B5pL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " March 22, 2019",
        "Id": 2222,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 119.29,
        "ReviewItem5": 0,
        "Title": "Tuscany Leather Luna Leather handbag Mustard",
        "ASIN": "B07R6NL5HM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31TAZGAG1nL._SS40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 119.29,
        "Id": 8249,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Restyle Gothic Shoulder Bag Satchel O-Ring Harness Punk Handbag",
        "ASIN": "B076PHPFMH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51lBfdN3pkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 23, 2017",
        "Id": 2229,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tequila Bottle Sparkling Hologram Glitter Cosplay Crossbody Bag Handbag",
        "ASIN": "B01N0Q3O0C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51K%2BmYGVcGL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2230,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 99.99,
        "ReviewItem5": 0,
        "Title": "Kipling Womens Sunita Cross-Body Bag",
        "ASIN": "B0184IBXFA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PTcxPkUbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 99.99,
        "UploadTime": " July 15, 2016",
        "Id": 2231,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Wizards of Waverly Place Starring Selena Gomez - Triple Compartment Shoulder Bag",
        "ASIN": "B004LPJ87Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RNmwSUCgL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 1, 2011",
        "Id": 2232,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.87,
        "ReviewItem5": 0,
        "Title": "Tom Tailor Women’s Amalia Cross-Body Bag",
        "ASIN": "B074G3V1NY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Ar8gK5P9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.87,
        "UploadTime": " March 28, 2018",
        "Id": 2233,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 7,
        "PriceMax": 18.9,
        "ReviewItem5": 60,
        "Title": "Straw Rattan Women Tote Summer Beach Shoulder Handbag Medium Size 17.8''x12.6\"x5.1\"",
        "ASIN": "B00LZPT86G",
        "ReviewItem3": 5,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51u7wkBmKBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.9,
        "UploadTime": " July 21, 2014",
        "Id": 2234,
        "ReviewCount": 147
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 4,
        "ReviewItem2": 3,
        "PriceMax": 18.99,
        "ReviewItem5": 74,
        "Title": "WYuZe 2 Pack Nylon Belt Outdoor Military Web Belt 1.5\" Men Tactical Webbing Belt",
        "ASIN": "B0799PFJ6L",
        "ReviewItem3": 5,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511Lc%2BznFkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " November 16, 2018",
        "Id": 2235,
        "ReviewCount": 990
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 7,
        "PriceMax": 22.99,
        "ReviewItem5": 75,
        "Title": "Neverout Crossbody Cell Phone Purse for Women Cow Leather Bag with Tassel NP2063",
        "ASIN": "B07FFMFN1W",
        "ReviewItem3": 11,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MZGtRAPzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " July 11, 2018",
        "Id": 2236,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 2.92,
        "ReviewItem5": 0,
        "Title": "Men'S Long Solid Color Wallet Men'S Wallet Leather Simple Purse Huge Capacity Wallet Multi-Card Position Moneybag",
        "ASIN": "B07R6Q97T7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51f25N2rk2L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 2.92,
        "UploadTime": " April 29, 2019",
        "Id": 2237,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Mother of the Bride with bouquet Tote Bag 331db",
        "ASIN": "B07J1X3MYN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OWCDNJNML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " October 4, 2018",
        "Id": 2259,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 15.97,
        "ReviewItem5": 88,
        "Title": "Key Case Wallet Holder, Genuine Leather Mens Keychian Ring, Pocket Car Fob Organizer Cover 6 Hooks Handmade Personalized",
        "ASIN": "B07HGT2LVB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KbAFCdGyL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 15.97,
        "UploadTime": " March 25, 2019",
        "Id": 6526,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Contacts RFID Blocking Genuine Leather Mini Money Clip Card Coin Holder Purse Wallet",
        "ASIN": "B07DW1TC5L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513Lw%2BzgdoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 7, 2018",
        "Id": 2238,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 100,
        "Title": "Justin West Fleur De Lis Angel Wings Concealed Carry Handbag Purse",
        "ASIN": "B019ZZOBLO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61c%2B2F9dkKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " December 30, 2015",
        "Id": 2239,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.9,
        "ReviewItem5": 0,
        "Title": "ZEN - Men & Women Clutch Bag Wallet PU Leather Lattice Handbag Envelope Business Organizer Purse",
        "ASIN": "B07CJQZVLX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41HTkUjuDpL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.9,
        "UploadTime": " April 20, 2018",
        "Id": 2240,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Monique Women Solid Color Drawstring Bucket Bag Mini Shoulder Bag Cross-body Bag Purse",
        "ASIN": "B07B9R6BRK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ibI2ZOpXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " March 7, 2018",
        "Id": 2241,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 298,
        "ReviewItem5": 67,
        "Title": "Tory Burch Women's Robinson Small Tote",
        "ASIN": "B0789SQ2RN",
        "ReviewItem3": 0,
        "ReviewItem4": 33,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ERNabLmAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 298,
        "UploadTime": " June 20, 2018",
        "Id": 2242,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 8,
        "PriceMax": 24.99,
        "ReviewItem5": 69,
        "Title": "Animal Small Vegan Cross Body Handbag -Wearable Art - From My Original Paintings",
        "ASIN": "B071S4K27Z",
        "ReviewItem3": 8,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41X6XpwDiQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " December 31, 2011",
        "Id": 2243,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 90,
        "Title": "Camouflage Cross Wings Western Style Concealed Carry Purse Country Handbag Women Shoulder Bag Wallet Set",
        "ASIN": "B07DN63PS2",
        "ReviewItem3": 5,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61nmiZEUiEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " January 3, 2018",
        "Id": 2244,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 20,
        "ReviewItem2": 20,
        "PriceMax": 0,
        "ReviewItem5": 60,
        "Title": "Rebecca Minkoff Love Crossbody",
        "ASIN": "B01N49ECBA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YxRxn2Z0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 16, 2017",
        "Id": 2245,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 178,
        "ReviewItem5": 75,
        "Title": "Vince Camuto Alesi Crossbody",
        "ASIN": "B01MZCPHTR",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51rS%2BW9ObQL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 178,
        "UploadTime": " June 23, 2017",
        "Id": 2246,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "CLEAR PVC - TOTE - PU LEATHER TRIM ACCENT W/FOLD DOWN LOCK",
        "ASIN": "B01KEKUEJW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zUaszr72L._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 14, 2016",
        "Id": 3970,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "HyFanStr Sturdy Felt Handbag Organizer, Tote Purse Organizer Insert with Double Handles and KeyChain",
        "ASIN": "B07MHK5SPG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ZZx-l7ZNL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " January 2, 2019",
        "Id": 2247,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "YIBANG-Bag Men's Wallet Leather Organ Card Package Two-Layer Leather Card Holder Multi-Function Large Capacity Card Holder Men's Fashion (Color : Black, Size : M)",
        "ASIN": "B07RKFZNZ9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CfpzBY9KL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2270,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 125,
        "ReviewItem5": 0,
        "Title": "Women Genuine Leather Handbags Luxury Designer Handbags Top-handle Bags Embossed Crocodile Cowhide",
        "ASIN": "B07DGPK91S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61mSQqtQ1vL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 125,
        "UploadTime": " June 2, 2018",
        "Id": 2248,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 78.79,
        "ReviewItem5": 0,
        "Title": "Tous Women’s 795790010 purse",
        "ASIN": "B07MMBSNT9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41%2BHy1sOMFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 78.79,
        "UploadTime": " February 27, 2019",
        "Id": 2249,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 63,
        "Title": "FRYE Melissa Whipstitch Mini Saddle Crossbody Bag",
        "ASIN": "B06WP27X72",
        "ReviewItem3": 37,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51W74Pb4sCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 12, 2017",
        "Id": 2250,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 9,
        "ReviewItem2": 2,
        "PriceMax": 29.99,
        "ReviewItem5": 67,
        "Title": "HNA Classic Multi Color Striped Top Handle Tote Bag",
        "ASIN": "B07FSSYHWF",
        "ReviewItem3": 7,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PV8gamP5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " July 23, 2018",
        "Id": 2251,
        "ReviewCount": 45
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "The Best Kind Of Mom Raises An Occupational Therapist - Tote Bag With Zip",
        "ASIN": "B07PKCRQ4S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41S9WoTjN6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 9, 2019",
        "Id": 2252,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 350,
        "ReviewItem5": 0,
        "Title": "Coach Poppy Liquid Gloss Slim Tote Shoulder Bag Magenta 19830",
        "ASIN": "B00CO23Q4E",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ujfS8E83L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 350,
        "UploadTime": " December 29, 2012",
        "Id": 2253,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Women Purses and Handbags Shoulder Bags 2pcs Set Crossbody Top Handle Tote bag Ladies Satchel Zipper Leather Wallets Gifts",
        "ASIN": "B07LF9LHH6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-t9Rb8I-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " December 17, 2018",
        "Id": 2254,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Gianni Chiarini Italian Made Beige Pebbled Leather Large Carryall Tote Bag with Pocket",
        "ASIN": "B071XRWVNC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EM7AIUISL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 15, 2017",
        "Id": 2255,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 0,
        "Title": "iwish Womens Lace Paisley Floral Bridal Clutch Purses with Rhinestones For Wedding Bridemaid",
        "ASIN": "B07MCGSB87",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ptHzi90IL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " January 10, 2019",
        "Id": 2256,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 140,
        "ReviewItem5": 89,
        "Title": "Lole Women’s Lily Tote Bag",
        "ASIN": "B078T5NMKS",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Zh7dcO70L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 140,
        "Id": 2257,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 82.99,
        "ReviewItem5": 0,
        "Title": "London Fog Avery Top Handle Handbag, Orange Floral",
        "ASIN": "B017DVXD5C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51qLuPbaJpL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 82.99,
        "UploadTime": " October 30, 2015",
        "Id": 4001,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 100,
        "Title": "Crossbody Bags for Women Shoulder Bag Purse Satchel and Tote",
        "ASIN": "B07D9Z4HD3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41roEUnOl9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " May 25, 2018",
        "Id": 2258,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GAOPENG Men's Leather bi-fold Clutch/high-Capacity Zipper Purse/Black and Brown to Choose from,Brown",
        "ASIN": "B07Q6VY2S6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EbMC6g0bL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2260,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Kids womens bag purse crossbody handbag with Butterfly fashion by Candy Couture USA",
        "ASIN": "B074M3X3H1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51yrGjbh-sL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 6, 2017",
        "Id": 2261,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 50,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "MICHAEL Michael Kors Jet Set Travel Large Drawstring Tote and Wristlet Set",
        "ASIN": "B07HPD41YK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Lu43qOPhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 23, 2017",
        "Id": 2262,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 294.5,
        "ReviewItem5": 0,
        "Title": "Mary Frances Peppermint Candy Handbag",
        "ASIN": "B013PWLSDC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/617ifSN9uvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 294.5,
        "UploadTime": " August 10, 2015",
        "Id": 2263,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.9,
        "ReviewItem5": 80,
        "Title": "Crossbody Shoulder Bag,Messenger Bag Handbag with Double Zipper for Women Lady Girls by Ubags",
        "ASIN": "B07DP4X6WH",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/314oUuc8NsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.9,
        "UploadTime": " June 12, 2018",
        "Id": 2264,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 368,
        "ReviewItem5": 0,
        "Title": "Kate Spade New York Reese Park Courtnee Quilted Leather Shoulder Bag",
        "ASIN": "B07MN9JT3M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414XPYdFOxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 368,
        "UploadTime": " December 29, 2018",
        "Id": 2265,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Straw Hand Bag Women Handwoven Summer Beach Clutches Bags Straw Braided Travel Shoulder Bag Evening Bags",
        "ASIN": "B07DX15S5C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dX9t--PRL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " June 21, 2018",
        "Id": 2266,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 0,
        "Title": "Ladies Italian Designer Handbag Soft Faux Suede Envelope Evening Clutch Bag",
        "ASIN": "B00OOOPGMA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410OH-jcL8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " May 13, 2015",
        "Id": 2267,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Crossbody Bags USA Flag Girls Cute Shoulder Bag",
        "ASIN": "B07JGYDG4M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415k%2B1LfB7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 17, 2018",
        "Id": 2268,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Rain's Pan Anime Fate Zero/Fate Stay Night Saber Cosplay Long PU Bifold Wallet Purse Card Holder Unisex",
        "ASIN": "B076Q5GDV5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518B94UbPsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 23, 2017",
        "Id": 2269,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "CIFFOST Vintage Canvas Shoulder Bag Women Handbag",
        "ASIN": "B07HJ14Z6K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Q8kg6b6qL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2271,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.82,
        "ReviewItem5": 0,
        "Title": "Miche Mary Shell for Big Bag",
        "ASIN": "B0058W3VI8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416-GywgOEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.82,
        "UploadTime": " June 30, 2011",
        "Id": 2272,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.98,
        "ReviewItem5": 80,
        "Title": "A+ Handmade Fashion Metallic Handbag Beaded Cross Body Bag Long Shoulder Strap: ZH9931-PR",
        "ASIN": "B00ODIP4BK",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/616Fx8QMLgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.98,
        "UploadTime": " September 29, 2014",
        "Id": 2273,
        "ReviewCount": 5
    }, {
        "Sale": "[]",
        "Category": "Baseball Caps",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.9,
        "ReviewItem5": 0,
        "Title": "Flexfit Cap Carrier Bag Black Kappen Tragetasche Hartschalenkoffer One Size",
        "ASIN": "B01NA7J6IW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41o8f6WFHbL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.9,
        "UploadTime": " January 28, 2017",
        "Id": 2274,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 50,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "Lustear Women’s Shoulder Bags Top Handle Handbag for Ladies",
        "ASIN": "B07418SQXP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418VDxWDs5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " July 18, 2017",
        "Id": 2275,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Genuine Leather Wallet Slim Men Wallet Multi-Card Bifold Wallet(Brown,Vertical)",
        "ASIN": "B07PJNY91B",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Ocwcla%2BNL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " March 4, 2019",
        "Id": 2276,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 286.83,
        "ReviewItem5": 91,
        "Title": "Michael Kors Women's Raven Tote",
        "ASIN": "B01MTMNSPA",
        "ReviewItem3": 2,
        "ReviewItem4": 3,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41C4xMu7DaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 286.83,
        "UploadTime": " November 14, 2016",
        "Id": 2277,
        "ReviewCount": 59
    }, {
        "Sale": "[]",
        "Category": "Coin Purses & Pouches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Undertale Sans And Papyrus Toriel Asgore Coin Purse Wallet Handbag",
        "ASIN": "B01M62BS7W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51k9wWmGIoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 11, 2016",
        "Id": 2278,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 20,
        "ReviewItem5": 0,
        "Title": "Sulida Women’s Sweet Lovely Boho Stripe Knitted Straw Shoulder Bag Clutch Handbag",
        "ASIN": "B00TFB4RU4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41M38X0GCeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 20,
        "UploadTime": " February 10, 2015",
        "Id": 2279,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 429,
        "ReviewItem5": 0,
        "Title": "Luana Anais Leather Shoulder Bag White",
        "ASIN": "B01LFF0JAY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31YwQ8ECcjL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 429,
        "UploadTime": " September 2, 2016",
        "Id": 2280,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 28,
        "ReviewItem2": 12,
        "PriceMax": 55,
        "ReviewItem5": 28,
        "Title": "Bellroy All Conditions Wallet",
        "ASIN": "B01JKYBEEW",
        "ReviewItem3": 16,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41o8K1HVSoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 55,
        "UploadTime": " August 3, 2016",
        "Id": 2282,
        "ReviewCount": 25
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.95,
        "ReviewItem5": 0,
        "Title": "Pearla Mermaids Handbag",
        "ASIN": "B07GZ4S1W3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EUtENQtIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.95,
        "UploadTime": " August 30, 2018",
        "Id": 2283,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Eyeglass Cases",
        "ReviewItem1": 30,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 50,
        "Title": "2 Pack Eyeglass Case Pouch, Portable Soft Felt Sunglasses Case Zipper Ultra Light Thicken Inside Glasses Makeup Storage Pouch",
        "ASIN": "B076ZFHYV6",
        "ReviewItem3": 0,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51-7%2B-OVWoL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " May 18, 2017",
        "Id": 2284,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Western Antique Tooled Embroidered and Rhinestone Cross Angel Wings Wallet Purse for Women Crossbody",
        "ASIN": "B0762GLCFT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51taNYtoUbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 29, 2017",
        "Id": 2285,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25,
        "ReviewItem5": 0,
        "Title": "Crossbody Bag kpop Mamamoo 482",
        "ASIN": "B077H27FK3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51xa88yUDYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25,
        "UploadTime": " November 14, 2017",
        "Id": 2286,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 38.99,
        "ReviewItem5": 78,
        "Title": "Maya Karis Purse Designer Bag for Women, Twist-Lock Lady Satchel w/Pouch Teen Girl Summer Bag 7581 CF",
        "ASIN": "B07D8RL22V",
        "ReviewItem3": 22,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5148odrbMsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.99,
        "UploadTime": " May 24, 2018",
        "Id": 2287,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bag-a-vie Purse Pillow Handbag Shapers for Chanel Hermes Louis Vuitton Bags - 4 Pack (Champagne)",
        "ASIN": "B07QC7ZW6C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31CTJlyUrgL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 27, 2018",
        "Id": 2288,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 2,
        "PriceMax": 40.99,
        "ReviewItem5": 81,
        "Title": "Sakroots Artist Circle Basic Cross Body Bag",
        "ASIN": "B078J2VY2X",
        "ReviewItem3": 5,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UCyrOAanL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.99,
        "UploadTime": " January 29, 2018",
        "Id": 2289,
        "ReviewCount": 250
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 3,
        "PriceMax": 29.99,
        "ReviewItem5": 59,
        "Title": "Rattan Bag, GraceFINE Round Hand Woven Ata Rattan Crossbody Bags, Rattan Purse for Women",
        "ASIN": "B07NQ943JJ",
        "ReviewItem3": 14,
        "ReviewItem4": 19,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Bg2t4a-KL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " April 18, 2018",
        "Id": 2290,
        "ReviewCount": 37
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 1,
        "ReviewItem2": 4,
        "PriceMax": 34.95,
        "ReviewItem5": 78,
        "Title": "KAVU Women's Keepalong Bag",
        "ASIN": "B07FHK45WN",
        "ReviewItem3": 4,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mtdnieHcL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.95,
        "UploadTime": " December 24, 2014",
        "Id": 2291,
        "ReviewCount": 110
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 50,
        "PriceMax": 184.99,
        "ReviewItem5": 50,
        "Title": "FRYE Jacqui Hobo Leather Shoulder Bag",
        "ASIN": "B0759Z2GY1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/411MO1o7oRL._SR38,50_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 184.99,
        "UploadTime": " February 9, 2018",
        "Id": 4002,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 100,
        "Title": "Geometric Luminous Purses and Handbags for Women Holographic Reflactive Crossbody Bag 3pcs Set",
        "ASIN": "B07QT852CZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VyJz08FoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " April 16, 2019",
        "Id": 2292,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.98,
        "ReviewItem5": 0,
        "Title": "A+ Authentic Straw Top Handle Fashion Handbag with 2 Tone Design and Wood Handle and Zipper Closure: FM1243-",
        "ASIN": "B077W5Y548",
        "ReviewItem3": 50,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tnPi-MRhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.98,
        "UploadTime": " December 1, 2017",
        "Id": 2293,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Minions Cross Body Shoulder Bag Set of 3",
        "ASIN": "B01AF5M78C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FQfRYaCYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 1, 2017",
        "Id": 2294,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Custom Print Saddle Bag Sharks Crossbody Messenger Shoulder Bag Purse",
        "ASIN": "B07HMMHZRS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gVqBnuRJL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 25, 2018",
        "Id": 2297,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Thai Hippie Hobo Sling Crossbody Shoulder Bag Purse Handmade Zip Peacock Pattern Cotton Gypsy Boho Messenger Medium",
        "ASIN": "B07H1GSV6R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uBiSJae7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " September 1, 2018",
        "Id": 2298,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 7,
        "PriceMax": 14.99,
        "ReviewItem5": 86,
        "Title": "Tribe Azure Women Fashion Hobo Floral Shoulder Bag Monk Canvas Sling Tote Handbag Crossbody Summer Boho",
        "ASIN": "B06Y6P1G7H",
        "ReviewItem3": 0,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51nP5mgkMlL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " April 10, 2017",
        "Id": 2299,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Gladdon Lightweight Medium Crossbody Bag with Tassel For Women",
        "ASIN": "B07KG4ZWHD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51VasNwYsRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " November 13, 2018",
        "Id": 2300,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 90,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Women's Lianna Nylon Handbag in Navy",
        "ASIN": "B076YMN5LP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sv4z4yfpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 90,
        "UploadTime": " October 28, 2017",
        "Id": 2301,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.89,
        "ReviewItem5": 0,
        "Title": "WILLTOO Women Sequins Leather Shoulder Bags, Gril Fashion Messenger Handbags Satchel Tote Bag Fashion Crossbody Bag",
        "ASIN": "B07BZMFXGR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51A2m4FEDvL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.89,
        "UploadTime": " April 3, 2018",
        "Id": 2302,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Layne",
        "ASIN": "B07G47XJDX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41A3Vxz50WL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 27, 2018",
        "Id": 2303,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 11,
        "PriceMax": 19.19,
        "ReviewItem5": 42,
        "Title": "Womans Designer Faux Leather Handbag– styled tote, shoulder, cross-body, handbag bucket bag",
        "ASIN": "B076B979DT",
        "ReviewItem3": 16,
        "ReviewItem4": 26,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5139u2cxvbL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 19.19,
        "UploadTime": " October 9, 2017",
        "Id": 8260,
        "ReviewCount": 19
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Cell Phone Bags Simple Small Crossbody Bags Casual Ladies Flap Shoulder Bag Green",
        "ASIN": "B07RM1THYM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41liYJ80aKL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 8, 2019",
        "Id": 2304,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "COACH MINI EMMA SATCHEL",
        "ASIN": "B07J5S4BL3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51dLwxfoOhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 9, 2018",
        "Id": 2305,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 134.55,
        "ReviewItem5": 0,
        "Title": "Cole Haan Cassidy Camera Bag",
        "ASIN": "B076QQZ3DR",
        "ReviewItem3": 0,
        "ReviewItem4": 100,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RDYLslDNL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 134.55,
        "UploadTime": " March 15, 2018",
        "Id": 2306,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "NICOLE&DORIS Tote Handbag Crossbody Shoulder Bag Women Messenger Bag Purse PU Leather",
        "ASIN": "B0732P2HG8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31Q3tz6EKHL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " June 18, 2017",
        "Id": 2307,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "furla Handbag Alba M",
        "ASIN": "B07Q37F31Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41crzDmAPZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 28, 2019",
        "Id": 2308,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 44.32,
        "ReviewItem5": 0,
        "Title": "Black Gothic Skull Carbon Fiber Look Crossbody Handbag",
        "ASIN": "B077JJP27M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BAGipDgEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.32,
        "UploadTime": " October 30, 2017",
        "Id": 2375,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 7,
        "PriceMax": 17.99,
        "ReviewItem5": 40,
        "Title": "QZUnique Women's Summer Straw Bucket Tote Bag Straw Woven Handbag Tassel Shoulder Bag",
        "ASIN": "B07CN2WJ5K",
        "ReviewItem3": 27,
        "ReviewItem4": 20,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41eNaV3%2BJFL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " April 25, 2018",
        "Id": 2309,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.9,
        "ReviewItem5": 0,
        "Title": "IBLUELOVER Shower Caddy Tote Felt Insert Purse Organizer Multi Pocket Bag in Bag Handbag Toiletry and Bath Organizer",
        "ASIN": "B07DN8N1TM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51powP01RoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.9,
        "Id": 2310,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.94,
        "ReviewItem5": 0,
        "Title": "DALIX Initial Tote Bag Personalized Monogram Blue Antique Fish Zippered Top Bold Letter - H",
        "ASIN": "B07MDYVKJX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mYB9I14pL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.94,
        "Id": 2311,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 229.9,
        "ReviewItem5": 0,
        "Title": "Michael Kors Sloan Large Quilted Chain Shoulder Bag",
        "ASIN": "B079GPHW6F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51F-lyw8ixL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 229.9,
        "UploadTime": " January 29, 2018",
        "Id": 2312,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.99,
        "ReviewItem5": 0,
        "Title": "ZOCAI Shoulder Bags Purse PU Leather Large Hobo Handbag with Small Crossbody Bag for Women 2 Pieces Set",
        "ASIN": "B07KG4ZWST",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QtTuTzhIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.99,
        "UploadTime": " November 13, 2018",
        "Id": 2313,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 75,
        "Title": "Genuine Leather Handbag Satchel Purse Shoulder Cross Body Vintage Hobo Leisure City Shopping Bag Women Brown",
        "ASIN": "B073B5K65T",
        "ReviewItem3": 13,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41YvvnyXNQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " June 26, 2017",
        "Id": 2342,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 12.99,
        "ReviewItem5": 73,
        "Title": "Abaddon Crossbody Bags Canvas Small Cute Cell Wallet Bag Phone Purse with Shoulder Strap coin purse",
        "ASIN": "B0796X6QP1",
        "ReviewItem3": 9,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pyb5UCivL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " October 16, 2017",
        "Id": 2314,
        "ReviewCount": 124
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 3.29,
        "ReviewItem5": 0,
        "Title": "Grey990 Men's Slim Faux Leather Wallet Credit Card Holder Pocket Money Bag Coin Purse Black",
        "ASIN": "B07QY9GRB1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41GuXVl9NWL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 3.29,
        "Id": 2315,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 89,
        "ReviewItem5": 0,
        "Title": "Vera Bradley Hadley Crossbody",
        "ASIN": "B071L8BQW3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515MlqKuPqL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89,
        "UploadTime": " October 31, 2017",
        "Id": 2316,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "SHZONS Womens Transparent PVC Jelly Shoulder Bag Tote Alphabet Waterproof Bag",
        "ASIN": "B07PRR17SJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41wximZdboL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2319,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 22,
        "ReviewItem2": 11,
        "PriceMax": 35.99,
        "ReviewItem5": 45,
        "Title": "Pinprin Purses and Handbags for Women Soft Leather Tote Bags Top Handle Purse Crossbody Satchel Shoulder Bags",
        "ASIN": "B07JR9CHB2",
        "ReviewItem3": 0,
        "ReviewItem4": 22,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51WxTSdc0ML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " October 26, 2018",
        "Id": 2320,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.19,
        "ReviewItem5": 0,
        "Title": "Traditional Handmade Clutch Bag by Indian artists - Mother's Day collection",
        "ASIN": "B06X6GBY32",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/616Bac01itL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.19,
        "Id": 2321,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Rurah Fashion Women Retro shoulder bag Shoulder Top Handle Handbags Tote Bag Ladies Purses,gray",
        "ASIN": "B0753FMD1N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51eaEgjg9-L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2322,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Accessories",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "GD-fashion Juventus Fans Backpack-Kids Juventus School Bookbag Laptop Bag-Backpack for Travel,Outdoor",
        "ASIN": "B07PD22FDY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51tTqR05H6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 4, 2019",
        "Id": 2323,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 79,
        "Title": "Womens Crossbody Swingpack Bag (Pink Butterfly)",
        "ASIN": "B01M5JJSGJ",
        "ReviewItem3": 7,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51pjfRANzML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " November 2, 2016",
        "Id": 2324,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49,
        "ReviewItem5": 0,
        "Title": "Nine West Samira Crossbody",
        "ASIN": "B079C7LPGY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XTrke9KpL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49,
        "UploadTime": " April 6, 2018",
        "Id": 2343,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 51.18,
        "ReviewItem5": 100,
        "Title": "Steve Madden BTEENIE2",
        "ASIN": "B07FK6S1KG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wnaCR0vbL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 51.18,
        "UploadTime": " November 5, 2018",
        "Id": 8463,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.96,
        "ReviewItem5": 0,
        "Title": "Baggallini Horizon Water Resistant Crossbody Wristlet Purse Light Bundle",
        "ASIN": "B07DXB33W7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61egD8rqakL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.96,
        "UploadTime": " June 21, 2018",
        "Id": 2325,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 100,
        "Title": "Fanrich Woman Fashion Flamingo Reversible Sequin Tote Bag PU Leather Glitter Paillette Handbag",
        "ASIN": "B07KLMPVJQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BdQ-4daEL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "UploadTime": " November 15, 2018",
        "Id": 2326,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 6.99,
        "ReviewItem5": 0,
        "Title": "Flowertree Women's Deer & Floral Print Canvas Tote Shopping Bag",
        "ASIN": "B071LPFP3S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ENhzqrlML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 6.99,
        "UploadTime": " May 24, 2017",
        "Id": 2482,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 1,
        "ReviewItem2": 3,
        "PriceMax": 0,
        "ReviewItem5": 83,
        "Title": "Vera Bradley Iconic Vera Tote, Signature Cotton",
        "ASIN": "B07GWVWM38",
        "ReviewItem3": 6,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51jMlBk1lUL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 25, 2019",
        "Id": 2327,
        "ReviewCount": 106
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 260,
        "ReviewItem5": 0,
        "Title": "Longchamp Women's Leather Le Pliage Cuir Crossbody Bag Burgundy",
        "ASIN": "B07KPPKL3T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/317UI2YcPML._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 260,
        "UploadTime": " March 15, 2017",
        "Id": 2328,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.42,
        "ReviewItem5": 100,
        "Title": "Miche Classic Bag Shell Orange Sheila",
        "ASIN": "B00AOVT3O4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61G%2BH51pKXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.42,
        "UploadTime": " December 16, 2012",
        "Id": 2329,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0.88,
        "ReviewItem5": 0,
        "Title": "Clearance Sale! ZOMUSA Women Girls Lady Fashion Casual Colorful Sequins Handbag Bag Clutch Bag Wallet",
        "ASIN": "B0799L64Z4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514tNzel60L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0.88,
        "UploadTime": " January 24, 2018",
        "Id": 2330,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 29,
        "PriceMax": 0,
        "ReviewItem5": 43,
        "Title": "Top Handle Satchel Handbags, JOSEKO Women Retro Tote Bags Leather Crossbody Bags Large Capacity",
        "ASIN": "B079RKVRP6",
        "ReviewItem3": 14,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511fGZ3OedL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 12, 2018",
        "Id": 2331,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 58.25,
        "ReviewItem5": 75,
        "Title": "Jessica Simpson Steffi Xbody",
        "ASIN": "B07B9J88HL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51BVPR5tXwL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58.25,
        "UploadTime": " June 29, 2018",
        "Id": 2332,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Reusable Grocery Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 17.99,
        "ReviewItem5": 0,
        "Title": "Asta the Airedale Terrier Eco Friendly Tote Bag",
        "ASIN": "B017OBXYBE",
        "ReviewItem3": 33,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wnMByzuNL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 17.99,
        "Id": 2344,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.5,
        "ReviewItem5": 0,
        "Title": "Zzfab Soft Leather Cross Body Bag",
        "ASIN": "B0184O2BIW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41mL-TlIpXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.5,
        "UploadTime": " November 16, 2015",
        "Id": 2345,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 75,
        "Title": "Visconti RB43 Multi Colored Large Trifold Soft Leather Ladies Wallet & Purse",
        "ASIN": "B00AIOSAEQ",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pN8yWIJVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " January 9, 2012",
        "Id": 2407,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 5,
        "ReviewItem2": 2,
        "PriceMax": 16.99,
        "ReviewItem5": 74,
        "Title": "Felt Fabric Purse Handbag Organizer Insert Bag for Tote Bag Handbag",
        "ASIN": "B0774RV6ZK",
        "ReviewItem3": 9,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51uea4QPQAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " November 3, 2017",
        "Id": 2333,
        "ReviewCount": 84
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Trolax Luxury Men Leather Zipper Wallet Large Business Purse Card Cellphone Holder [Brown]",
        "ASIN": "B07H96SFXT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PYdjBtQnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " September 12, 2018",
        "Id": 2376,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.6,
        "ReviewItem5": 50,
        "Title": "Women Large Shoulder Bag Handbag Cross-body Bags Cheap Colors for Girl by TOPUNDER ZE",
        "ASIN": "B075L7VPD8",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51laMmTRfkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.6,
        "UploadTime": " August 7, 2017",
        "Id": 2334,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 64.35,
        "ReviewItem5": 0,
        "Title": "Kipling SYRO K13163 511 bag night blue",
        "ASIN": "B004CJ8FB6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/4179touZN3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.35,
        "UploadTime": " December 3, 2013",
        "Id": 2335,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 14,
        "ReviewItem2": 0,
        "PriceMax": 25.09,
        "ReviewItem5": 43,
        "Title": "AMJ Multi-Hobo Bags Crossbody Bags for Women Nylon Travel Messenger Bag Handbag Shoulder Bag",
        "ASIN": "B07MNHTY4K",
        "ReviewItem3": 0,
        "ReviewItem4": 43,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413WyYr7PAL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.09,
        "UploadTime": " December 24, 2018",
        "Id": 2336,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 88,
        "Title": "Augbunny 12oz Canvas Zipper Shoulder Grocery Tote Handbag Adjustable Handle With Inside Pocket 2-pack",
        "ASIN": "B01EODHFPQ",
        "ReviewItem3": 12,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415wnO-UOQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " April 23, 2016",
        "Id": 2337,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "London Fog Ruby Top Zip Crossbody-Rose",
        "ASIN": "B07G5J1SQG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WK3OQ2T-L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 25, 2019",
        "Id": 2338,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.47,
        "ReviewItem5": 0,
        "Title": "Tom Tailor Women's Polina bag",
        "ASIN": "B079NXNHJB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BiaKLKAhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.47,
        "UploadTime": " September 10, 2018",
        "Id": 2339,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12,
        "ReviewItem5": 0,
        "Title": "Personalized Photo Wallet Custom Picture Engraved Long Wallets Leather Purse Billfold for Men/Dad Handmade Father's Day Gifts",
        "ASIN": "B07QXVNRJZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zmGqXrXOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12,
        "UploadTime": " April 24, 2019",
        "Id": 2340,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.99,
        "ReviewItem5": 0,
        "Title": "Victoria's Secret VS Tote Bag Black and Gold Striped",
        "ASIN": "B07GM5N3W1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yFeo12sCL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.99,
        "UploadTime": " May 25, 2018",
        "Id": 2341,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Sunglasses",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "SunCloud Polarized Optics Mens Stand",
        "ASIN": "B07MVJPLM8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31n-vs6%2BQOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " January 16, 2019",
        "Id": 2403,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 4,
        "ReviewItem2": 5,
        "PriceMax": 25.99,
        "ReviewItem5": 50,
        "Title": "Women Shoulder Bags Side Purse Cross Body with Zipper",
        "ASIN": "B079NHXCXK",
        "ReviewItem3": 9,
        "ReviewItem4": 32,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41w4P%2BcNtGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " February 6, 2018",
        "Id": 2346,
        "ReviewCount": 22
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 92.99,
        "ReviewItem5": 57,
        "Title": "Fossil Finley Shoulder Bag",
        "ASIN": "B078216MJR",
        "ReviewItem3": 14,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418e03Rks7L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 92.99,
        "UploadTime": " March 22, 2018",
        "Id": 2347,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.95,
        "ReviewItem5": 0,
        "Title": "Star Wars BB-8 (BB8) Mini Satchel Purse Force Awakens Womens Hand Bag",
        "ASIN": "B077PQRZ4G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CD3TCVY6L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.95,
        "UploadTime": " November 23, 2017",
        "Id": 2348,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.63,
        "ReviewItem5": 0,
        "Title": "Luxury Handbag For Women Famous Designer Lock Handbag Leather Ladies Tote Clutch",
        "ASIN": "B07MHRLMHY",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41f7s4zBJdL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.63,
        "UploadTime": " January 4, 2019",
        "Id": 2350,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cold Weather Gloves",
        "ReviewItem1": 1,
        "ReviewItem2": 4,
        "PriceMax": 19.99,
        "ReviewItem5": 78,
        "Title": "Winter Magic Gloves, 12 Pairs Stretchy Warm Knit Bulk Pack Mens Womens, Wholesale",
        "ASIN": "B077956213",
        "ReviewItem3": 6,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41EONEg1kLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " October 30, 2017",
        "Id": 2351,
        "ReviewCount": 81
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 25,
        "Title": "SANNOVO Animal Canvas Reusable Tote Bag Women Shopping Tote Bags Book Bags",
        "ASIN": "B07LGT62R9",
        "ReviewItem3": 0,
        "ReviewItem4": 75,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418%2Bf-Nj4GL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " December 19, 2018",
        "Id": 2352,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 20,
        "ReviewItem2": 10,
        "PriceMax": 23.99,
        "ReviewItem5": 30,
        "Title": "ZOCAI Travel Backpack Purse for Women PU Washed Leather Ladies Rucksack Crossbody Shoulder Bag Versatile Tote Handbag",
        "ASIN": "B07JQ5X25W",
        "ReviewItem3": 10,
        "ReviewItem4": 30,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41GGKZjgBhL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " October 26, 2018",
        "Id": 2353,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.15,
        "ReviewItem5": 0,
        "Title": "Lime Green Cowgirl Fashion Purse",
        "ASIN": "B00MNSK1SS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51a1M-sQEXL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.15,
        "UploadTime": " August 12, 2014",
        "Id": 2354,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.85,
        "ReviewItem5": 0,
        "Title": "PAPAYA SHOP Elephant Shoulder bags Hippie Hobo Crossbody Messenger Bohemian Olive Green",
        "ASIN": "B01LVU80SO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51IwyqRBbdL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.85,
        "Id": 2355,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 15,
        "ReviewItem2": 15,
        "PriceMax": 21.99,
        "ReviewItem5": 23,
        "Title": "Keyli Ladies Vegan PU leather Multi Pockets Crossbody Purse with Organizer Function Shoulder Bag",
        "ASIN": "B07MTLMF4Z",
        "ReviewItem3": 16,
        "ReviewItem4": 31,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Qjq84Y4mL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " January 14, 2019",
        "Id": 2356,
        "ReviewCount": 13
    }, {
        "Sale": "[]",
        "Category": "Fashion Backpacks",
        "ReviewItem1": 3,
        "ReviewItem2": 5,
        "PriceMax": 0,
        "ReviewItem5": 76,
        "Title": "Diophy PU Leather Fashion Backpack with Zipper Pockets on Both Side Womens Purse Handbag AB-052",
        "ASIN": "B07H4VG7LJ",
        "ReviewItem3": 3,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uNJ14BMPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 31, 2018",
        "Id": 2357,
        "ReviewCount": 63
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "western convertible rhinestone cross body trifold clutch mini messenger bag",
        "ASIN": "B0738QX8TV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51prT46NKbL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " June 25, 2017",
        "Id": 2358,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "I'm silently judging your font choice Cotton Canvas Tote Bag",
        "ASIN": "B079ST6J5L",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TAbd5owKL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " February 13, 2018",
        "Id": 2359,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 0,
        "Title": "Coach Pebbled Leather Quinn Crossbody - Cranberry",
        "ASIN": "B016119TCQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51H1OtmRJwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " October 1, 2015",
        "Id": 2360,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.88,
        "ReviewItem5": 0,
        "Title": "YONBEN Canvas Shoulder Tote Bag for Women, Crossbody Bag for Girls",
        "ASIN": "B07DXHTS6F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31xZlr-7h-L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.88,
        "UploadTime": " August 23, 2018",
        "Id": 2361,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Toping Fine handbags Women Messenger Bag Chain Crossbody bags Snake PU leather brand designer bags ladies",
        "ASIN": "B073WSYDRG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51elhHzpvGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 13, 2017",
        "Id": 2362,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 5,
        "PriceMax": 0,
        "ReviewItem5": 71,
        "Title": "Kate Spade New York Laurel Way Evangelie Saffiano Leather Shoulder Bag Satchel",
        "ASIN": "B07BNQG1Q5",
        "ReviewItem3": 8,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/418eF15z7DL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 23, 2018",
        "Id": 2363,
        "ReviewCount": 62
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 52.99,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Womens Hayden Tote",
        "ASIN": "B07HJCW58G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gWhYd5bUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 52.99,
        "UploadTime": " January 3, 2019",
        "Id": 2364,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 3,
        "PriceMax": 0,
        "ReviewItem5": 83,
        "Title": "kate spade new york Cedar Street Maise Satchel",
        "ASIN": "B00MXQAD9C",
        "ReviewItem3": 4,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kIAhr6QcL._SR38,50_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 8, 2014",
        "Id": 5043,
        "ReviewCount": 413
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.99,
        "ReviewItem5": 0,
        "Title": "Anne Klein Womens Soft Folds Satchel",
        "ASIN": "B07FQNTWTC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41X6TW-t0QL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.99,
        "UploadTime": " September 16, 2018",
        "Id": 2365,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 114.99,
        "ReviewItem5": 0,
        "Title": "Cole Haan Womens Harlow Tote",
        "ASIN": "B07DB8ZSBZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415tMxynkhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 114.99,
        "UploadTime": " October 25, 2018",
        "Id": 2377,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 21,
        "ReviewItem2": 8,
        "PriceMax": 22.99,
        "ReviewItem5": 42,
        "Title": "TianHengYi Womens Candy Colors Faux Leather Top-handle Handbag Shoulder Bag with Removable Long Strap",
        "ASIN": "B01EV7BT48",
        "ReviewItem3": 8,
        "ReviewItem4": 21,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41pAqnARjxL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " April 27, 2016",
        "Id": 2387,
        "ReviewCount": 24
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 100,
        "Title": "Dewest women’s Fashion Checkered Wallet, Classic Design Purse Polyurethane Leather, Phone Clutch Handbag Wristlet with Zipper",
        "ASIN": "B07PQW49CS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51p9KUvj6eL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " March 14, 2019",
        "Id": 2366,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 8,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 67,
        "Title": "DELUXITY Top Handle Clutch Crossbody Purse with Removable Chain Strap",
        "ASIN": "B0756M2GZT",
        "ReviewItem3": 8,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wd20S9H%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " August 28, 2017",
        "Id": 2367,
        "ReviewCount": 12
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Colorful Sharks Shoulder Bags Large Handle Ladies Handbag",
        "ASIN": "B07HP17KY9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SspSHO3tL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " September 26, 2018",
        "Id": 2368,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.85,
        "ReviewItem5": 0,
        "Title": "Large Canvas Beach Shoulder Bag Mom's Tote Bag Top Zipper Closure Striped Handbag, Navy",
        "ASIN": "B07QZQTVBC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41RlDaFeRsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.85,
        "Id": 2369,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 100,
        "Title": "Handmade Antique Silk Clutch Wristlet Indian Made Purse Organza Bag with Ethnic design Wedding Gift Pouch (Set of two)",
        "ASIN": "B078FY84FM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SO%2BKJfFsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " April 10, 2017",
        "Id": 2370,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 179,
        "ReviewItem5": 0,
        "Title": "Coach Bennett Mini In Signature Black Leather Satchel",
        "ASIN": "B07P5H1CW1",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cZt5kUvLL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 179,
        "UploadTime": " February 25, 2019",
        "Id": 2371,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 10,
        "ReviewItem2": 13,
        "PriceMax": 13.99,
        "ReviewItem5": 61,
        "Title": "Forestfish PU Leather Women Tote Bag Handbags Satchel Bags for Work Travel",
        "ASIN": "B07BLLBMPM",
        "ReviewItem3": 8,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zX%2BFw2wQL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " November 20, 2017",
        "Id": 2372,
        "ReviewCount": 51
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 33,
        "Title": "Noble Mount Weave Texture Enchanted Tote Handbag",
        "ASIN": "B00DJCQGBS",
        "ReviewItem3": 0,
        "ReviewItem4": 67,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gcuGXW8BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " June 21, 2013",
        "Id": 2373,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Coach Signature Canvas Casey Tote Handbag",
        "ASIN": "B07GRS82NJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OUkhGQ3OL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 22, 2018",
        "Id": 2404,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 4,
        "ReviewItem2": 0,
        "PriceMax": 118,
        "ReviewItem5": 87,
        "Title": "Harveys Seatbelt Bag Women's Satchel",
        "ASIN": "B07MTHTRT1",
        "ReviewItem3": 0,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41p3jeSRHrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 118,
        "UploadTime": " March 14, 2019",
        "Id": 2374,
        "ReviewCount": 23
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "Women Wallet Multi-card Two Fold Long Zipper Clutch Purse,Beautiful Tail Pattern",
        "ASIN": "B07MNKBRBB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41T4bAujGSL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " December 25, 2018",
        "Id": 2378,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Toping Fine handbags Women Messenger Bag Chain Crossbody bags Snake PU leather brand designer bags ladies",
        "ASIN": "B073WS3WLR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51ZgXrxbX5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 13, 2017",
        "Id": 2379,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 41.99,
        "ReviewItem5": 0,
        "Title": "Myra Bag White & Cocoa Upcycled Canvas & Cowhide Crossbody Bag S-1425",
        "ASIN": "B07QH33K3Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TAaR1kYaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 41.99,
        "UploadTime": " April 9, 2019",
        "Id": 2380,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 9,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 76,
        "Title": "TIE DYE Bohemian Hipster Hobo Boho Hippie Crossbody Bag Purse White Tone 39\"",
        "ASIN": "B07GL2RHRT",
        "ReviewItem3": 5,
        "ReviewItem4": 10,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Y2r4PbD4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " January 28, 2017",
        "Id": 2381,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "JAGENIE Nylon Small Crossbody Bags Waterproof Shoulder Bag Satchels Cell Phone Wallet Purse Bag for Women",
        "ASIN": "B07KBZ2TK7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Hkx68rf-L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2382,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 140,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Reiti Vintage Handbag, White",
        "ASIN": "B0797QGV3Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31bNv0h3BzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 140,
        "UploadTime": " January 22, 2018",
        "Id": 2383,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "AMHDV Women Leather Tassel Tote Bags, Large PU Shoulder Handbags - 2019 New Fashion 2 Colors Tote Bag",
        "ASIN": "B07QB3VY98",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31zikjTmUuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " May 5, 2019",
        "Id": 2384,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Liberty Bags Recycled Large Tote With Zipper (Red) (One)",
        "ASIN": "B0014SEJ90",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31DmeTqSxCL._SR38,50_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " July 26, 2005",
        "Id": 5044,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 4,
        "PriceMax": 21.99,
        "ReviewItem5": 76,
        "Title": "Functional Multi Pockets Lightweight Medium Crossbody Bags Purses for Women Double Zipper Shoulder Messenger Bag with Tassel",
        "ASIN": "B07M7H6ZVQ",
        "ReviewItem3": 12,
        "ReviewItem4": 8,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41S82IJitYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " November 21, 2018",
        "Id": 2385,
        "ReviewCount": 25
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 9,
        "ReviewItem2": 5,
        "PriceMax": 8.99,
        "ReviewItem5": 63,
        "Title": "Basic Leather Checkbook Cover",
        "ASIN": "B07F7K9218",
        "ReviewItem3": 6,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51U%2BfbFGtOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " July 9, 2015",
        "Id": 2386,
        "ReviewCount": 225
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Men's Wallet Leather Card Bag Short Wallet with Zipper Men's Fashion (Color : Blue, Size : S)",
        "ASIN": "B07RKG2SPM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41SCVPqJWmL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2483,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 0,
        "Title": "KMGT Fashion Waterproof Clear Handbag For Women Top Handle Shoulder Bag With Transparent Purse",
        "ASIN": "B07FCL8M8Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417Hhputd9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " July 9, 2018",
        "Id": 2388,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Bella Taylor Ring Around Purse",
        "ASIN": "B07F5P4VNX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41UvD0f6v5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " June 30, 2018",
        "Id": 2389,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "Save The Chubby Unicorns Cotton Canvas Tote Bag",
        "ASIN": "B07JMZ6R22",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/314P-a3x2HL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " October 23, 2018",
        "Id": 2390,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 2,
        "PriceMax": 16.99,
        "ReviewItem5": 72,
        "Title": "Womens Small Crossbody Bags Cell Phone Wallet Purse Bag for Women by TENXITER",
        "ASIN": "B077NX931Z",
        "ReviewItem3": 5,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WbC27rxdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " September 25, 2017",
        "Id": 2391,
        "ReviewCount": 215
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 26.99,
        "ReviewItem5": 0,
        "Title": "iBaste_S Womens Transparent PVC Jelly Package Candy Color Shoulder Bag Casual Tote Handbag Girls Alphabet Messenger Crossbody Travel Luggage Fashion Evening Gift Bag",
        "ASIN": "B07NW9TJD8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31xp0mnVTBL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "Id": 2392,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 378,
        "ReviewItem5": 0,
        "Title": "Furla Women's Metropolis Mini Crossbody Bag",
        "ASIN": "B07RF8YMYC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/312W7AifSwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 378,
        "UploadTime": " May 3, 2019",
        "Id": 2393,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Tommy Hilfiger Women's Tashia Tote",
        "ASIN": "B07L1LLDBM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JshMM2C%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 9, 2019",
        "Id": 2405,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 4,
        "PriceMax": 39.99,
        "ReviewItem5": 88,
        "Title": "cuero 14 Inch Leather Crossbody Satchel Ladies Purse Women Shoulder Bag Tote Travel Purse Genuine Leather",
        "ASIN": "B07GYN4XQH",
        "ReviewItem3": 4,
        "ReviewItem4": 4,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517KfhtQG7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " January 9, 2016",
        "Id": 2394,
        "ReviewCount": 25
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 89.95,
        "ReviewItem5": 83,
        "Title": "Sherpani RFID Soleil LE Anti-theft Tote/Backpack/Crossbody",
        "ASIN": "B0743JLDKP",
        "ReviewItem3": 7,
        "ReviewItem4": 6,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51f%2Bnr0%2BijL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 89.95,
        "UploadTime": " July 20, 2017",
        "Id": 2395,
        "ReviewCount": 53
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Women Top Handle Satchel Handbags Messenger Shoulder Bag for Women Top Purse Tote Bag",
        "ASIN": "B077JWFJSJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Qe5FOI9yL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 17, 2017",
        "Id": 2396,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 249,
        "ReviewItem5": 50,
        "Title": "FRYE Harness Stud Bucket Hobo Leather Handbag",
        "ASIN": "B01K11GQQE",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41B9cqbD05L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 249,
        "UploadTime": " November 17, 2016",
        "Id": 2397,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 0,
        "Title": "Funny Design Canvas Tote Bag Handbag Purse for Women",
        "ASIN": "B07FGX15XG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Wwk4orORL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " June 1, 2018",
        "Id": 2398,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 5,
        "ReviewItem2": 4,
        "PriceMax": 69.99,
        "ReviewItem5": 71,
        "Title": "BOSTANTEN Women's Leather Designer Handbags Tote Purses Shoulder Bucket Bags",
        "ASIN": "B07KYFRN21",
        "ReviewItem3": 6,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41cjXDfKo3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "UploadTime": " December 21, 2018",
        "Id": 2399,
        "ReviewCount": 456
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Ethnic Gypsy Owl Embroidered Patchwork Cotton Handmade Shoulder Crossbody Bag Boho No5",
        "ASIN": "B01M1EM2YJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xYFiAcxuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 14, 2016",
        "Id": 2400,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "WSQ Premium Nylon Phone Purse Small Crossbody Bag Compatible with iphone 6/7/8,X/XS/XR,8+, Galaxy S8/S9, Note 9/8/5/4/3,J7",
        "ASIN": "B07K4ZNPY7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sXicnHO5L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " September 27, 2018",
        "Id": 2401,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Designer NEW Fashion Crocodile Tote Bags Handbag Women Famous PU Leather A804",
        "ASIN": "B077GTNWPB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513Yy1bnkAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 15, 2017",
        "Id": 2402,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 49.99,
        "ReviewItem5": 0,
        "Title": "Harley-Davidson Women's Snake Charmer Leather Hip Bag w/Strap HDWBA11284-BLK",
        "ASIN": "B072KFLVX2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gSPMrTLyL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 49.99,
        "UploadTime": " June 12, 2017",
        "Id": 2408,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.9,
        "ReviewItem5": 0,
        "Title": "Comeco Sleepyville Critters Halloween Frankenstein Crossbody Bag",
        "ASIN": "B07QZZWGBX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yunCVxHoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.9,
        "UploadTime": " October 5, 2018",
        "Id": 2409,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 0,
        "Title": "Women Round Straw Beach Bag Summer Bag Circle Woven Handmade Shoulder Purse",
        "ASIN": "B07NW9RDBR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61Q-DDuCO0L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " February 19, 2019",
        "Id": 2410,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.98,
        "ReviewItem5": 0,
        "Title": "Remikstyt Womens Crossbody Bag Faux Leather Shoulder Strap Casual Handbag",
        "ASIN": "B07QWXTPBV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31wWiUUm42L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.98,
        "UploadTime": " April 18, 2019",
        "Id": 2411,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Newsboy Caps",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.89,
        "ReviewItem5": 73,
        "Title": "WITHMOONS Denim Cotton Newsboy Hat Baker Boy Beret Flat Cap KR3613",
        "ASIN": "B06X9X7QBY",
        "ReviewItem3": 9,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51MR84jB71L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.89,
        "UploadTime": " February 24, 2017",
        "Id": 2484,
        "ReviewCount": 11
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 5,
        "ReviewItem2": 4,
        "PriceMax": 18.99,
        "ReviewItem5": 69,
        "Title": "Fabuxry Crossbody Handbag for Women Organize Pack Shoulder Bag Messenger Purses",
        "ASIN": "B078YS7692",
        "ReviewItem3": 6,
        "ReviewItem4": 16,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zpAjnsxQL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " March 1, 2017",
        "Id": 2412,
        "ReviewCount": 222
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Men's Wallet Cowhide Leather Light Leather Short Wallet Vintage Leather Men's Bag Men's Fashion (Color : Black, Size : S)",
        "ASIN": "B07RQ41XW2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FKPDpi0jL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2413,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 15.99,
        "ReviewItem5": 0,
        "Title": "Pensenion Felt Bag Organizer Multi-Pocket Cosmetic Makeup Handbag Purse Insert Organizer Tidy Travel Bag for Women Girls Ladies, Beige-L",
        "ASIN": "B07GYPZ9MH",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ynBjR0TqL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 15.99,
        "Id": 2414,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 183,
        "ReviewItem5": 0,
        "Title": "Anna by Anuschka Leather Hand Painted Satchel Handbag & Purse Holder Bundle-",
        "ASIN": "B07D5ZR8G3",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zSli987%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 183,
        "UploadTime": " May 19, 2018",
        "Id": 2415,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 129,
        "ReviewItem5": 0,
        "Title": "Michael Michael Kors Jet Set Travel Large East/West Leather Crossbody",
        "ASIN": "B07DRMM7ZK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5123La238CL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 129,
        "UploadTime": " August 20, 2018",
        "Id": 2416,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Flip-Flops",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.9,
        "ReviewItem5": 0,
        "Title": "MISTMANIA Summer Women's Slippers Outdoor & Indoor Sandals Mix Flip Flops",
        "ASIN": "B07M9CF6WP",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41PR%2BYeyRdL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.9,
        "UploadTime": " December 28, 2018",
        "Id": 2426,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Luggage",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 149.99,
        "ReviewItem5": 100,
        "Title": "YETI Camino Carryall 35, All-Purpose Utility, Boat and Beach Tote Bag, Durable, Waterproof",
        "ASIN": "B07NJ5H1QD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41J3CVtlRpL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 149.99,
        "Id": 2417,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 0,
        "PriceMax": 44.99,
        "ReviewItem5": 79,
        "Title": "Boho striped canvas satchel bags tote handbags and shoulder purses",
        "ASIN": "B07L54PCCY",
        "ReviewItem3": 7,
        "ReviewItem4": 7,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51iIlWrmKkL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 44.99,
        "UploadTime": " May 10, 2018",
        "Id": 2418,
        "ReviewCount": 28
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.99,
        "ReviewItem5": 0,
        "Title": "Nodykka Women Tote Satchel Top Handle Bag Business Casual Leather Shoulder Hobo Handbags",
        "ASIN": "B077YB5RLM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41e3JlWOueL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.99,
        "UploadTime": " December 6, 2017",
        "Id": 2480,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Louis Vuitton Shoulder Cross Body Handbag Bag M43624 Blanche BB Monogram Empreinte leather",
        "ASIN": "B01D9Q37JW",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/517YGYudQqL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 9, 2016",
        "Id": 2419,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 58,
        "ReviewItem5": 0,
        "Title": "Hedgren Eye, Crossbody Shoulder Bag, Rfid Blocking Purse Cross Body Bag",
        "ASIN": "B077DN6ZLJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41KGBXE0TnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58,
        "UploadTime": " August 3, 2018",
        "Id": 2420,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.4,
        "ReviewItem5": 0,
        "Title": "Hyuniture Waist Bag Couple Bag Fashion Hip Hop Casual Letter Truncated Shoulder Wallet",
        "ASIN": "B07PWFQLCG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Gs0KkYQ1L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.4,
        "Id": 2421,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Montana West Womens Concealed Carry Tote Crossbody Purse Concho Collection Tassle MW762G-8575",
        "ASIN": "B07KQRQZWD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51bMCCFvQtL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 21, 2018",
        "Id": 2422,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 75,
        "Title": "Flip Folio Wallet Purse Phone Holder Premium Card Money Pocket Cover Smartphone",
        "ASIN": "B075NT58D5",
        "ReviewItem3": 25,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51r3yvAl1IL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " September 15, 2017",
        "Id": 2423,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Belts",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 129.89,
        "ReviewItem5": 0,
        "Title": "Men's pockets Leather belt mobile phone bag With shoulder straps First layer leather multifunction",
        "ASIN": "B07NXPRF8K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/511mog8GoRL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 129.89,
        "Id": 2424,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Accessories",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Josephine Osthoff Men's LEATHER Travel Bag - Black - Brustbeutel",
        "ASIN": "B00E9XIJ20",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41EolhMDNPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 29, 2014",
        "Id": 2425,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 72,
        "Title": "baggallini RFID Harmony Medium Hobo Crossbody Commuter Bag",
        "ASIN": "B01C0HROIG",
        "ReviewItem3": 11,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DaVozZcSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " February 20, 2016",
        "Id": 2428,
        "ReviewCount": 18
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Roberto Cavalli Light Pink Grained Leather Bowler Handbag~RTL$1450",
        "ASIN": "B07JK3HZXB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31mYO-kTMWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 19, 2018",
        "Id": 2429,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 98,
        "ReviewItem5": 100,
        "Title": "Coach N/S Logo Crossbody - Silver/Khaki/True Red",
        "ASIN": "B013FM0OWI",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51UIAm22o7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 98,
        "UploadTime": " November 30, 2015",
        "Id": 2485,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Unisex Small Crossbody Bag Cell Phone Purse Wallet Headphone Bag Hawaiian Coast Plam Tree",
        "ASIN": "B07KS82K2J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41XxiyTaJPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 22, 2018",
        "Id": 2430,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 109,
        "ReviewItem5": 83,
        "Title": "Brother ScanNCut CATOTER ScanNCut Tote Bag - Red Mass",
        "ASIN": "B00NQBDAVQ",
        "ReviewItem3": 4,
        "ReviewItem4": 9,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510HvPrAvoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 109,
        "Id": 2431,
        "ReviewCount": 87
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 8,
        "ReviewItem2": 0,
        "PriceMax": 38.89,
        "ReviewItem5": 69,
        "Title": "IKEPOD Italy Leather Slim RFID Hide Men Compact Bifold Wallet Billfold - 5 Color",
        "ASIN": "B01F6NSSRW",
        "ReviewItem3": 11,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41WR1j1gewL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38.89,
        "UploadTime": " May 5, 2016",
        "Id": 2432,
        "ReviewCount": 26
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 56.99,
        "ReviewItem5": 0,
        "Title": "LeSportsac Ombre Cheetah Small Cleo Crossbody Bag",
        "ASIN": "B07BXB6Y1T",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61SVl8IgpYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 56.99,
        "UploadTime": " April 3, 2018",
        "Id": 2433,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 124.95,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Coleen Vegan Leather Novelty Logo Tote",
        "ASIN": "B07KKVD1HD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31DF7RBv6uL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 124.95,
        "UploadTime": " February 20, 2019",
        "Id": 2434,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ALLHM Women's Canvas Shoulder Trends Handbags Casual Beach Vacation Weekend Bag Crossbody Bag Multi-Pocket Capacity (Color : Blue, Size : OneSize)",
        "ASIN": "B07MPNTHGX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wVQAFhcvL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2435,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 3,
        "PriceMax": 27,
        "ReviewItem5": 73,
        "Title": "Travelon Women's Anti-Theft Heritage Small Crossbody Cross Body Bag",
        "ASIN": "B06XC1THV5",
        "ReviewItem3": 5,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51p4htiPfeL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27,
        "UploadTime": " April 20, 2017",
        "Id": 2436,
        "ReviewCount": 159
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Vera Pelle Handbags Italian Real Leather Cross Body Bag Women Fashion Purses Ladies Handbag Genuine (Grey Plain)",
        "ASIN": "B072KWC6V5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415xjZO9CoL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2437,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Signature Natural Tulip Tote",
        "ASIN": "B0085OAYYA",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Yo4j0JmEL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 23, 2012",
        "Id": 5045,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 0,
        "ReviewItem5": 77,
        "Title": "BMC Women's Fashion Handbag Oversized Envelope Clutch w/ 2 Detachable Straps",
        "ASIN": "B014LPWLCE",
        "ReviewItem3": 6,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51wo%2B99PMAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 28, 2015",
        "Id": 2438,
        "ReviewCount": 119
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.39,
        "ReviewItem5": 0,
        "Title": "Carolyn Tapestry UR-GO Bag",
        "ASIN": "B078GYW6LX",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51CvpvZJgPL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.39,
        "UploadTime": " December 18, 2017",
        "Id": 2439,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "Prestige Medical Fashion Tote Bags, Ribbons and Hearts Black, 12.2 Ounce",
        "ASIN": "B01BJ9BKCC",
        "ReviewItem3": 50,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zL4PE3SpL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2440,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 328,
        "ReviewItem5": 71,
        "Title": "Marc by Marc Jacobs Too Hot To Handle Satchel",
        "ASIN": "B00S6G001Y",
        "ReviewItem3": 0,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31qoZuR3owL._US40_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 328,
        "UploadTime": " January 13, 2015",
        "Id": 7730,
        "ReviewCount": 7
    }, {
        "Sale": "[]",
        "Category": "ID Cases",
        "ReviewItem1": 4,
        "ReviewItem2": 2,
        "PriceMax": 24.99,
        "ReviewItem5": 78,
        "Title": "SERMAN BRANDS RFID Blocking Wallet Slim Bifold - Genuine Leather Minimalist Front Pocket Wallets for Men with Money Clip",
        "ASIN": "B01GGG7PQS",
        "ReviewItem3": 2,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41c-rklLzqL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " June 1, 2016",
        "Id": 2441,
        "ReviewCount": 51
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Transparent Messenger Bag Clear Shoulder Bag Crossbody Tote Bag Clutch Bag Clutch Purse for Women (Skyblue)",
        "ASIN": "B07R5W11TT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SCtW5W2mL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "Id": 2442,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Kenneth Cole Reaction Modern Storage Camera Bag",
        "ASIN": "B01N2T8LKZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DOFZneATL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 15, 2017",
        "Id": 2443,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 18.32,
        "ReviewItem5": 100,
        "Title": "WilliamPOLO Mens Wallet Genuine Leather Front Pocket Money Clip Slim Purse",
        "ASIN": "B07MFH15X7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41f0FlV1q3L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.32,
        "UploadTime": " January 6, 2019",
        "Id": 2444,
        "ReviewCount": 3
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Striped Cross Body Purse For Women Shoulder Bag Messenger Totes Canvas Handbags",
        "ASIN": "B07HFSN6J6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51yDL2yG3dL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 21, 2016",
        "Id": 2445,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 24.99,
        "ReviewItem5": 0,
        "Title": "Memoryee Bifold RFID Blocking Genuine Leather Short Money Clip Credit Card Holder Zipper Purse Wallet with Keyring",
        "ASIN": "B07M7C1FYQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41M%2BVjQeB9L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " January 8, 2019",
        "Id": 2446,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Satchels",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.99,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Womens Novelty Organizational Satchel",
        "ASIN": "B07LDFP5P9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/513HPYoW5UL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.99,
        "UploadTime": " January 16, 2019",
        "Id": 2491,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Evening Bags",
        "ReviewItem1": 2,
        "ReviewItem2": 0,
        "PriceMax": 29.98,
        "ReviewItem5": 91,
        "Title": "Dexmay Large Rhinestone Crystal Clutch Evening Bag Women Clutch Purse for Cocktail Prom Party",
        "ASIN": "B072KD7DPH",
        "ReviewItem3": 2,
        "ReviewItem4": 5,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61UN97qQnsL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.98,
        "UploadTime": " June 19, 2017",
        "Id": 2481,
        "ReviewCount": 60
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.99,
        "ReviewItem5": 0,
        "Title": "Women Leather Small Crossbody Bag Cell Phone Pouch Purse Wallet Shoulder Bag,7.5 Inches",
        "ASIN": "B07MZQJG5J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gTno19AIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.99,
        "UploadTime": " January 25, 2019",
        "Id": 2447,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 80.99,
        "ReviewItem5": 0,
        "Title": "Lodis Audrey RFID Vicky Convertible Crossbody Clutch",
        "ASIN": "B078KRQ41Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yc%2B4NcSnL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 80.99,
        "UploadTime": " June 15, 2018",
        "Id": 2448,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "MICHE Demi Bag Shell - Ana",
        "ASIN": "B00CS97YXM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413CpAWL2TL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2449,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Small GRAIN Calfskin Leather Rockstud Crossbody Bag Valentino/bag",
        "ASIN": "B07Q812N3G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kWgXvAOoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 31, 2019",
        "Id": 2450,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 4,
        "ReviewItem5": 0,
        "Title": "Perman Womens Girls Space Bale Cotton Totes Zip Handbag Feather Down Waterproof Shoulder Bag",
        "ASIN": "B01BR8GJ8K",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Sz2FrtjmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 4,
        "UploadTime": " February 14, 2016",
        "Id": 2451,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 95,
        "ReviewItem5": 0,
        "Title": "Guess Handbag top handle SV672105 Arthur Coal",
        "ASIN": "B077GFHZ8Q",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DSs9oMWIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 95,
        "UploadTime": " November 14, 2017",
        "Id": 2452,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 19,
        "ReviewItem2": 9,
        "PriceMax": 0,
        "ReviewItem5": 38,
        "Title": "Mengsha's Transparent Fashionable Clear Crossbody Shoulder Bag Purse",
        "ASIN": "B01FZTQNG0",
        "ReviewItem3": 5,
        "ReviewItem4": 29,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31k-vn96aRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 21, 2016",
        "Id": 2453,
        "ReviewCount": 21
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "MKF Small Crossbody Cell Phone Wallets for Women - Purse with Shoulder Strap - Vegan Leather Cell Phone Bag Case",
        "ASIN": "B07JR3FVP9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41bEY5lJaaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " October 26, 2018",
        "Id": 2454,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 22.99,
        "ReviewItem5": 0,
        "Title": "Womens handbags, Ephraim Shoulder Handbags for Women Tote Bag Designer Handbags for Women",
        "ASIN": "B07CGDSTZF",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41OFLuAJKBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 22.99,
        "UploadTime": " April 18, 2018",
        "Id": 2455,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Sun Kea Fashion Women Snakeskin Tote Handbag Ladies Convertible Tassel Shoulder Bag Crossbody Purse",
        "ASIN": "B07QT94L9G",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51JK34raxDL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " April 16, 2019",
        "Id": 2456,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "JJLIKER Women Leather Handbags Top Handle Totes Wallet Fashion Messenger Bag Shoulder Satchels Pack",
        "ASIN": "B07N8XGJ7C",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51F1NasUtpL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "Id": 2457,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 295,
        "ReviewItem5": 0,
        "Title": "Rebecca Minkoff Astor Saddle Shoulder Bag",
        "ASIN": "B018TQX1RK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Kduih-n8L._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 295,
        "UploadTime": " May 10, 2016",
        "Id": 2458,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 98.92,
        "ReviewItem5": 0,
        "Title": "Calvin Klein Le4 Duffle, Women’s Handbag, Schwarz (Black), 17 x 22 33 cm (wxhxd)",
        "ASIN": "B06Y31LPBG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gBqf09%2B7L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 98.92,
        "UploadTime": " May 2, 2018",
        "Id": 2459,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 50,
        "PriceMax": 19.99,
        "ReviewItem5": 50,
        "Title": "Vanilo Women Multifunction Travel Tidy Storage Purse Insert Handbag Organizer",
        "ASIN": "B07JFW2VKC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/516j49mXaQL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " October 16, 2018",
        "Id": 2460,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 4,
        "PriceMax": 14.99,
        "ReviewItem5": 66,
        "Title": "Collsants Small Crossbody Purse Mini Nylon Travel Shoulder Bag Multi Zipper Pockets",
        "ASIN": "B07KK1BH1G",
        "ReviewItem3": 6,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51EiiFE2QBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " May 29, 2018",
        "Id": 2461,
        "ReviewCount": 53
    }, {
        "Sale": "[]",
        "Category": "Ski Bags",
        "ReviewItem1": 3,
        "ReviewItem2": 6,
        "PriceMax": 64.99,
        "ReviewItem5": 58,
        "Title": "High Sierra Padded Ski Bag for Single Pair of Skis (Up to 185cm) - Black",
        "ASIN": "B003R50BEK",
        "ReviewItem3": 10,
        "ReviewItem4": 23,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31u53-SG0GL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 64.99,
        "Id": 2462,
        "ReviewCount": 101
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 100,
        "Title": "Western Style Cowgirl Fringe Concealed Purse Conchos Totes Country Women Handbag Shoulder Bags Wallet Set",
        "ASIN": "B07MLV2PXJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510GhG5UgvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " March 12, 2018",
        "Id": 2463,
        "ReviewCount": 15
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 50,
        "ReviewItem2": 0,
        "PriceMax": 18.99,
        "ReviewItem5": 50,
        "Title": "PUMA Women's Uniform Cross Body Shoulder Bag",
        "ASIN": "B07K8QBH8S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51PnbA19noL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 18.99,
        "UploadTime": " March 24, 2019",
        "Id": 2464,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 3,
        "ReviewItem2": 2,
        "PriceMax": 2.59,
        "ReviewItem5": 75,
        "Title": "Coin Purse, Mikey Store Women Lady Retro Vintage Owl Small Wallet Hasp Purse Clutch Bag",
        "ASIN": "B07QZXQB7H",
        "ReviewItem3": 3,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jnlm13w8L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 2.59,
        "UploadTime": " October 3, 2018",
        "Id": 2465,
        "ReviewCount": 94
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 74.96,
        "ReviewItem5": 90,
        "Title": "Baggallini Hobo Crossbody with RFID Wristlet",
        "ASIN": "B07KRSY38D",
        "ReviewItem3": 10,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61JuhkVK2YL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 74.96,
        "UploadTime": " April 13, 2019",
        "Id": 2466,
        "ReviewCount": 10
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "Leopard Print Cellphone Crossbody Bag, 7\" X 4.5\".",
        "ASIN": "B07NGMX81R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51mJmnAzF4L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "Id": 2467,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Desigual Bols_Brooklyn Blackbout",
        "ASIN": "B06XPQ2W77",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51N7j-j2MxL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 11, 2017",
        "Id": 7731,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 2,
        "ReviewItem2": 3,
        "PriceMax": 16.99,
        "ReviewItem5": 72,
        "Title": "RFID Wallets for Men - Real Leather Bifold Wallets - Thin & Slim RFID Blocking Security Wallet",
        "ASIN": "B07KVZKGHP",
        "ReviewItem3": 5,
        "ReviewItem4": 18,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41gANFUE%2BGL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " April 10, 2018",
        "Id": 2469,
        "ReviewCount": 60
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Vera Bradley Composition Crossbody Bag, Colorblock Rouge/Off White",
        "ASIN": "B01DFORIOS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ofmfTj2fL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 25, 2016",
        "Id": 2470,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45.99,
        "ReviewItem5": 0,
        "Title": "Kipling Livie Bag, Adjustable Crossbody Strap, Zip Closure",
        "ASIN": "B07FLBQDR7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41QENA8WtsL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45.99,
        "UploadTime": " January 25, 2019",
        "Id": 2471,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 34.66,
        "ReviewItem5": 88,
        "Title": "Women Clear Handbag Fashion Shoulder Bag Stadium Approved Transparent Chain Purse Designer Tote Quilted Concert",
        "ASIN": "B07FY6BJF2",
        "ReviewItem3": 0,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IgXTIt75L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 34.66,
        "UploadTime": " July 26, 2018",
        "Id": 2472,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "Catkit Casual Womens Summer Sunflower Straw Knitted Beach Totes Handbag Sea Holiday Hobo Bag",
        "ASIN": "B010UST4N0",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51oD8fXYGZL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " July 3, 2015",
        "Id": 2473,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 0,
        "PriceMax": 12.99,
        "ReviewItem5": 50,
        "Title": "HUAYF Clear Crossbody Handbags, Fashion Women's Waterproof Drawstring Handbag Top Handle Shoulder Bag 2 in 1 Beach Bag",
        "ASIN": "B07F3LSTYF",
        "ReviewItem3": 0,
        "ReviewItem4": 25,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41MpJXyNLLL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.99,
        "UploadTime": " June 28, 2018",
        "Id": 2474,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Coin Purses & Pouches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "LIUCM Cute Coin Key Case Small Wallet Mini Cute Semicircle Women Men Coin Bag Money Key Storage Purses",
        "ASIN": "B07NRV4RZK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41kJSwilphL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " February 15, 2019",
        "Id": 2475,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 178,
        "ReviewItem5": 0,
        "Title": "Gianni Chiarini Women's BS6850CNVDSE10374 Gold Leather Handbag",
        "ASIN": "B07R8VRV6M",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jiRb0IocL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 178,
        "UploadTime": " April 29, 2019",
        "Id": 2476,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 127.95,
        "ReviewItem5": 0,
        "Title": "Michael Kors Jet Set Travel Double Zip Gusset Signature Crossbody Vanilla Pastel Pink PVC",
        "ASIN": "B07GRLM9T4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ldJmBa3OL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 127.95,
        "UploadTime": " August 22, 2018",
        "Id": 2477,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 8.99,
        "ReviewItem5": 0,
        "Title": "FORUU Bags, Unisex Woman Bag Chain Shoulder Bags Handbags Messenger Bags",
        "ASIN": "B07QQWCKC4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jxEgwxVvL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 8.99,
        "UploadTime": " April 16, 2019",
        "Id": 2478,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 58.55,
        "ReviewItem5": 0,
        "Title": "David King & Co. Slender Shoulder Bag 598, Café, One Size",
        "ASIN": "B000R5HM0Y",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41lMWm8wAIL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58.55,
        "Id": 2479,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 68,
        "ReviewItem5": 0,
        "Title": "GUESS Lizzy Metallic Mini Tote",
        "ASIN": "B079VZ8FK5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41qp5%2B06wPL._SR38,50_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 68,
        "UploadTime": " September 28, 2018",
        "Id": 2879,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 0,
        "PriceMax": 16.99,
        "ReviewItem5": 67,
        "Title": "Turtle Bohemian Hippie Hobo Hipster Boho Crossbody Shoulder Bag Purse",
        "ASIN": "B0714FXLQF",
        "ReviewItem3": 11,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41zsioZNXGL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 16.99,
        "UploadTime": " January 28, 2017",
        "Id": 2486,
        "ReviewCount": 9
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 0,
        "PriceMax": 13.99,
        "ReviewItem5": 50,
        "Title": "Nawoshow Nylon Floral Multi-Pocket Crossbody Purse Bags for Women Travel Shoulder Bag",
        "ASIN": "B07F3YNYTX",
        "ReviewItem3": 0,
        "ReviewItem4": 38,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61ZbjbFv86L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 13.99,
        "UploadTime": " June 28, 2018",
        "Id": 2487,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 244.99,
        "ReviewItem5": 100,
        "Title": "FRYE Melissa Native Sun Stud Hobo",
        "ASIN": "B079SSB21S",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/412wva2YEqL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 244.99,
        "UploadTime": " October 5, 2018",
        "Id": 2488,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 48,
        "ReviewItem5": 0,
        "Title": "Women's Leather Ladies Shoulder Bags Totes Top Handle Bags Satchel Handbag Cross Body Bag",
        "ASIN": "B07D9JBP1W",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51A4DJ%2BFycL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 48,
        "UploadTime": " March 31, 2019",
        "Id": 2489,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40.99,
        "ReviewItem5": 0,
        "Title": "Lucky Brand Women's Kay Small Crossbody",
        "ASIN": "B07JQWQ6KZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Jaq8iyguL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40.99,
        "UploadTime": " February 22, 2019",
        "Id": 2490,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 7.99,
        "ReviewItem5": 0,
        "Title": "Women's Handbag Leather Pure Color Crossbody Bag Phone Bag Shoulder Bag Hand Bag (Yellow)",
        "ASIN": "B07G168HLD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41f7dZKCB6L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.99,
        "Id": 2492,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 58.99,
        "ReviewItem5": 0,
        "Title": "Nodykka Women Tote Bags Top Handle Satchel Hobo Handbags Leather Crossbody Shoulder Purse",
        "ASIN": "B077HSR11H",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41x3flpGurL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 58.99,
        "UploadTime": " November 16, 2017",
        "Id": 2493,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 172.24,
        "ReviewItem5": 0,
        "Title": "MICHAEL Michael Kors Women's pebbled leather Karson large shoulder bag tote 35T8GKRL3L",
        "ASIN": "B07G8LB4PD",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51w5Dbpc0EL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 172.24,
        "UploadTime": " May 7, 2018",
        "Id": 2494,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 0,
        "Title": "Inktastic - Cancun Mexico Vacation Trip Tote Bag 34c46",
        "ASIN": "B07P92XKZB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41FvrazpIzL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " February 27, 2019",
        "Id": 2495,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 100,
        "Title": "Moroccan Bags and Purses Hand Made Carved Leather Clutch Tote Wallet Bag",
        "ASIN": "B00GCXFFFO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Hn4unp9%2BL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 1, 2013",
        "Id": 2508,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 3,
        "ReviewItem2": 6,
        "PriceMax": 0,
        "ReviewItem5": 67,
        "Title": "Star Wars - Rebel Alliance Bi-Fold Wallet 3 x 2in",
        "ASIN": "B00DUGA95C",
        "ReviewItem3": 7,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512fjkBt7NL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2509,
        "ReviewCount": 81
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "InterestPrint Dog Beagle Casual Crossbody Saddle Bags for Women Shoulder Purse Handbags",
        "ASIN": "B07PCLKWTL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416xzyEo56L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " March 4, 2019",
        "Id": 2532,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Byyong Women Straw Adjustable Shoulder Strap Waist Bag Leisure Simple Joker Crossbody Bags Solid Zipper Messenger Backpack",
        "ASIN": "B07QS4R6HC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AmFPRkLFL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 16, 2019",
        "Id": 2496,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.21,
        "ReviewItem5": 0,
        "Title": "Suvasana Indian Handicraft Rajasthani Jaipur Bohemian art Sling Bag ||Bohemian Style || Hippie Handbags||Shoulder bags",
        "ASIN": "B07J1SWSZM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/61S5A0jBE4L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.21,
        "UploadTime": " October 23, 2018",
        "Id": 2497,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Women Favorite Bags,Pocciol Womens Canvas Cotton Triangle Feather Space Bale Totes Handbag Down Mini Shoulder Bags (C)",
        "ASIN": "B07CL6XCG5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51SUQajO2gL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2498,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Vegan Faux Leather 2 PC Set Ostrich Croco Embossed Tote Shoulder Bag shopper with Matching Wallet",
        "ASIN": "B07R22HDR7",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51AnrfEUFnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " April 23, 2019",
        "Id": 2525,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 33.35,
        "ReviewItem5": 0,
        "Title": "Adorable Sleepyville Critters Three Toed Sloth Cross Body Purse",
        "ASIN": "B011PXJKR4",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zkP078QBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 33.35,
        "UploadTime": " July 15, 2015",
        "Id": 2598,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 28.8,
        "ReviewItem5": 0,
        "Title": "Jessica McClintock Gwen Sparkle Mesh Ring Pouch Clutch",
        "ASIN": "B07H5MHZBK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/512TuxBdODL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 28.8,
        "UploadTime": " December 22, 2018",
        "Id": 2499,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 75,
        "Title": "Circus by Sam Edelman Jovie Tote",
        "ASIN": "B073V9SB55",
        "ReviewItem3": 12,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416y3YGwweL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " November 4, 2017",
        "Id": 2500,
        "ReviewCount": 8
    }, {
        "Sale": "[]",
        "Category": "Clutches",
        "ReviewItem1": 8,
        "ReviewItem2": 6,
        "PriceMax": 19.99,
        "ReviewItem5": 66,
        "Title": "BMC Womens PU Leather Alligator Skin Pattern Glitter Metal Accent Flap Clutch",
        "ASIN": "B00XQD63R2",
        "ReviewItem3": 6,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51HbTv4GlTL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " May 15, 2015",
        "Id": 2510,
        "ReviewCount": 49
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 35.99,
        "ReviewItem5": 0,
        "Title": "Betsey Johnson Bets in The City Crossbody",
        "ASIN": "B07D3T3QS2",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41-3F0RwkTL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 35.99,
        "UploadTime": " September 14, 2018",
        "Id": 2533,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 5.98,
        "ReviewItem5": 0,
        "Title": "Swyss Novelty Cute Flower Shape Cross Body Mini Bag for Women Creative Single Shoulder Bag Fashion Bag,Blue",
        "ASIN": "B07RPZ2S92",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510TYF9G5wL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 5.98,
        "Id": 2501,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 6,
        "ReviewItem2": 0,
        "PriceMax": 38,
        "ReviewItem5": 82,
        "Title": "Bungalow 360 Original Vegan Leather Striped Hobo Bag",
        "ASIN": "B06XG22F78",
        "ReviewItem3": 0,
        "ReviewItem4": 12,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41uXYKmxGpL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 38,
        "UploadTime": " March 7, 2017",
        "Id": 2502,
        "ReviewCount": 17
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 31.5,
        "ReviewItem5": 100,
        "Title": "Chala Butterfly Cellphone Crossbody Handbag - Convertible Strap",
        "ASIN": "B0787KMFS5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Cx9Y-7uJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 31.5,
        "UploadTime": " December 12, 2017",
        "Id": 2503,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.97,
        "ReviewItem5": 0,
        "Title": "Kenoor Small Bucket Bag Women Fashion Work Tote Flap Shoulder Bag Satchel Small Handbags",
        "ASIN": "B07BGWP66X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/415KhY4OcSL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.97,
        "UploadTime": " February 1, 2018",
        "Id": 2504,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "ywbtuechars Cocktail Evening Party Women Velvet Clutch Solid Color Crossbody Shoulder Bag 4 colors",
        "ASIN": "B07H4HJ1FV",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31NoNXwAB9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " September 6, 2018",
        "Id": 2505,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Christmas Sling Shoulder Messenger Crossbody Bags For Women",
        "ASIN": "B07J42N785",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hWXalMwcL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 7, 2018",
        "Id": 2506,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Hawaiian Print Light Weight Cross body Bag Passport Bag in Aloha Palms Rainbow Color",
        "ASIN": "B074MKSGDT",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/410aC5q8QAL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 7, 2017",
        "Id": 2526,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Mentum Handbag Organizer Insert for Neverfull Speedy Tote Bags - Organization Made Easy 3MM Felt Thickness",
        "ASIN": "B07JRH9TLL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51gQaXvX6KL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " November 1, 2018",
        "Id": 2507,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 14,
        "ReviewItem2": 0,
        "PriceMax": 19.85,
        "ReviewItem5": 65,
        "Title": "London Stitch Women's Genuine Leather Multi Pocket Crossbody Bag",
        "ASIN": "B01LOJZSHU",
        "ReviewItem3": 7,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41Y5XqAYZWL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.85,
        "UploadTime": " September 6, 2016",
        "Id": 2511,
        "ReviewCount": 14
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.95,
        "ReviewItem5": 0,
        "Title": "Liquorbrand Ouija Board Punk Goth Halloween Chain Shoulder Crossbody Bag Purse",
        "ASIN": "B07L1D3KDZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RNe7j0cYL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.95,
        "UploadTime": " November 30, 2018",
        "Id": 2512,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 29.99,
        "ReviewItem5": 0,
        "Title": "baggallini Travel Hobo Tote",
        "ASIN": "B07KPP5JGL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41CMysAqXeL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 29.99,
        "UploadTime": " November 19, 2018",
        "Id": 2513,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 135,
        "ReviewItem5": 0,
        "Title": "Matt & Nat Eeha Dwell Crossbody Handbag, Ink",
        "ASIN": "B0797Q1W7F",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41z-yxvwX0L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 135,
        "UploadTime": " January 23, 2018",
        "Id": 2514,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 59.75,
        "ReviewItem5": 100,
        "Title": "A X Armani Exchange Pebble Pu Crossbody Bag",
        "ASIN": "B01N0ZEKPM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DL0KrwfvL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 59.75,
        "UploadTime": " March 9, 2017",
        "Id": 2515,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.99,
        "ReviewItem5": 0,
        "Title": "TOMORI Cute Crossbody Bag Plush Hamster Shoulder Bag Animal Messenger Bags",
        "ASIN": "B078PHXPGS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41JAoNWLSoL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.99,
        "UploadTime": " December 29, 2017",
        "Id": 2516,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Cross-Body Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 1245,
        "ReviewItem5": 0,
        "Title": "Gucci GG Charm Red Leather Large Convertible Dome Bag With Detachabel Strap 449660 6420",
        "ASIN": "B07FTWVDRB",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41BFnOKtOIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 1245,
        "UploadTime": " July 24, 2018",
        "Id": 2527,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 12,
        "ReviewItem2": 12,
        "PriceMax": 51.24,
        "ReviewItem5": 44,
        "Title": "London Fog Tillary Bucket",
        "ASIN": "B075RJ7TQY",
        "ReviewItem3": 19,
        "ReviewItem4": 13,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51FUw1V9xvL._SR38,50_.jpg",
        "AcquisitionTime": 1557936000000,
        "Price": "[]",
        "PriceMin": 51.24,
        "UploadTime": " November 8, 2017",
        "Id": 9407,
        "ReviewCount": 16
    }, {
        "Sale": "[]",
        "Category": "Backpacks",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 69.99,
        "ReviewItem5": 50,
        "Title": "tomtoc Vintage Travel Backpack Business Durable Laptops Backpack w/Charge Port, Waterproof Computer Book Bag for Women & Men Fits up to 15.6” Laptop Notebook & 10.5” iPad",
        "ASIN": "B07MFNPN3G",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51RuUtaFN9L._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 69.99,
        "Id": 2517,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Hobo Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.99,
        "ReviewItem5": 90,
        "Title": "Angel Barcelo Womens Fashion Handbags Tote Bag Cross Body Shoulder Bag Top Handle Satchel Purse",
        "ASIN": "B07GXJBNZ9",
        "ReviewItem3": 7,
        "ReviewItem4": 3,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41jbtxuAYrL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.99,
        "UploadTime": " July 23, 2018",
        "Id": 2518,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 40,
        "ReviewItem5": 67,
        "Title": "Buxton Nile Cross-Body Mini-Bag",
        "ASIN": "B018FFPDLM",
        "ReviewItem3": 33,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414EilfSToL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 40,
        "UploadTime": " November 24, 2015",
        "Id": 2593,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "HPASS Lovely Circular Shoulder Bag Small Purse with Chian for Women",
        "ASIN": "B07PH2YKQL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41sgZhdshaL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " March 7, 2019",
        "Id": 2519,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 9.99,
        "ReviewItem5": 0,
        "Title": "American Rag Blue Dusty Lipgloss Case Makeup Bag",
        "ASIN": "B00H4MMRZS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41E1xu9lSmL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 9.99,
        "UploadTime": " September 24, 2015",
        "Id": 2520,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 153.21,
        "ReviewItem5": 0,
        "Title": "Piero Guidi Women’s Small Hobo Cross-body Bag",
        "ASIN": "B01N69H1ET",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51LYglWKB3L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 153.21,
        "UploadTime": " May 8, 2018",
        "Id": 2521,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Tie Sets",
        "ReviewItem1": 2,
        "ReviewItem2": 1,
        "PriceMax": 12.98,
        "ReviewItem5": 76,
        "Title": "Barry.Wang Plaid Ties Check Mens Necktie Set with Handkerchief Cufflinks Classic",
        "ASIN": "B01M0QEA7Y",
        "ReviewItem3": 7,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51DBdRqAoJL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 12.98,
        "UploadTime": " November 24, 2016",
        "Id": 2522,
        "ReviewCount": 152
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Contacts Mens Genuine Leather Credit Card Zipper Pocket Phone Holder Clutch Purse Long Wallet",
        "ASIN": "B075S54JBR",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51AccUJHE%2BL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 22, 2017",
        "Id": 2523,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Handbag Organizers",
        "ReviewItem1": 2,
        "ReviewItem2": 2,
        "PriceMax": 14.99,
        "ReviewItem5": 77,
        "Title": "IN Felt Purse Organizer,Handbag Organizer Insert for Speedy 30 Purse Liner",
        "ASIN": "B07F2W8PZD",
        "ReviewItem3": 4,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/417VV3jU9rL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " June 27, 2018",
        "Id": 2524,
        "ReviewCount": 48
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Skyseen Womens Multi-color Geometric Pattern Shoulder Bag Hobo Tote Handbag Cross Body Purse",
        "ASIN": "B0714FW36J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51r0bFhE1iL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " May 19, 2017",
        "Id": 2528,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.99,
        "ReviewItem5": 0,
        "Title": "Women Casual Tote Bag Shoulder Bag Fluffy Fur Ball Pendant Girls Crossbody Bag",
        "ASIN": "B0772N9PJJ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41AoytanFIL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " October 31, 2017",
        "Id": 2529,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 10.69,
        "ReviewItem5": 0,
        "Title": "FitfulVan Clearance! Hot sale! Bags, FitfulVan Hair ball pendant fashion handbag shoulder Messenger bag ladies bag (Purple)",
        "ASIN": "B07F7N5PG9",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41IzSi2rFRL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 10.69,
        "Id": 2530,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 63.99,
        "ReviewItem5": 0,
        "Title": "Myra Bag Brique Upcycled Leather & Cowhide Crossbody Bag S-1503",
        "ASIN": "B07QH33VCS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/518xAQ8NqCL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 63.99,
        "UploadTime": " April 9, 2019",
        "Id": 2531,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 23.99,
        "ReviewItem5": 50,
        "Title": "Fashion Casual and Popular Female Sling Bag Crossbody Bag Shoulder Bag with Eiffel Tower Print",
        "ASIN": "B01AJO5M1I",
        "ReviewItem3": 0,
        "ReviewItem4": 50,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/510wM5I3M9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 23.99,
        "UploadTime": " June 12, 2015",
        "Id": 2564,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 25,
        "ReviewItem2": 25,
        "PriceMax": 0,
        "ReviewItem5": 50,
        "Title": "American Bling Concealed Gun Messenger Cross Body Purse and Wallet Set Daisy Cutouts",
        "ASIN": "B076KYG9MK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51L19xsSh9L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " October 19, 2017",
        "Id": 2534,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 17,
        "ReviewItem2": 5,
        "PriceMax": 21.99,
        "ReviewItem5": 58,
        "Title": "Women Tote Shoulder Handbags Large Waterproof Nylon Travel Gym Bag Weekender Bag",
        "ASIN": "B07R9K6F6V",
        "ReviewItem3": 3,
        "ReviewItem4": 17,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31ZgMa5EsUL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.99,
        "UploadTime": " April 25, 2019",
        "Id": 2535,
        "ReviewCount": 36
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Halfbye Credit Card Holder Wallets for Men Leather Wallet Bifold Multi Card Holder Purse Card Case",
        "ASIN": "B07R4W8RM6",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41aacw8k6mL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 25, 2019",
        "Id": 2536,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 11,
        "ReviewItem2": 11,
        "PriceMax": 24.99,
        "ReviewItem5": 48,
        "Title": "FiveloveTwo Women Modern Punk PU Leather Cross Body Rivet Top-handle Shoulder Bags Hobo Tote Satchel Handbags for Lady",
        "ASIN": "B079DPNX6Y",
        "ReviewItem3": 15,
        "ReviewItem4": 15,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51zumzo3OKL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 24.99,
        "UploadTime": " January 29, 2018",
        "Id": 2537,
        "ReviewCount": 27
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 27.5,
        "ReviewItem5": 0,
        "Title": "T-Shirt & Jeans Faux Fur Plush Mini Satchel",
        "ASIN": "B07822Z18Z",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51G77OPogVL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 27.5,
        "UploadTime": " April 21, 2018",
        "Id": 2538,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 7.99,
        "ReviewItem5": 100,
        "Title": "Nuni Women's Cute Pineapple Print Heavy Duty Canvas Tote Bag",
        "ASIN": "B072SKLTQC",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51OUdS9S40L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 7.99,
        "UploadTime": " June 17, 2017",
        "Id": 2539,
        "ReviewCount": 2
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 45,
        "ReviewItem5": 0,
        "Title": "Betsey Johnson Wavy Days Satchel Shoulder Bag, Cream",
        "ASIN": "B018UP9RBO",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41yoFZLdlRL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 45,
        "UploadTime": " October 31, 2016",
        "Id": 2540,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 37.73,
        "ReviewItem5": 0,
        "Title": "Travelon Women's Anti-Theft Boho Square Crossbody Cross Body Bag",
        "ASIN": "B0793FCT7N",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51Qq8PdYUuL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 37.73,
        "UploadTime": " March 1, 2018",
        "Id": 2541,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 39.99,
        "ReviewItem5": 0,
        "Title": "Myra Bag Eau De Nil Upcycled Canvas & Cowhide Shoulder Bag S-1430",
        "ASIN": "B07QDV6FSL",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51cACOrsGeL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 39.99,
        "UploadTime": " April 9, 2019",
        "Id": 2820,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Ladies' Fashion Small Purses wallets with Credit Card Holders With short handles and Zip Pocket Handbags",
        "ASIN": "B07QZX6NM5",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41xNT96f6vL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 11, 2019",
        "Id": 2542,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 115.3,
        "ReviewItem5": 0,
        "Title": "Rebecca Minkoff Women's Straw Circle Tote",
        "ASIN": "B0789TLJJN",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/515Pi8ncBuL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 115.3,
        "UploadTime": " March 6, 2018",
        "Id": 2543,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 174,
        "ReviewItem5": 0,
        "Title": "Michael Kors Carolyn Large Tote Soft Leather Handbag Mulberry",
        "ASIN": "B07JGKR2PQ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/413sccRcrhL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 174,
        "UploadTime": " October 14, 2018",
        "Id": 2544,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens Fashion Cahier Shoulder Bag Calf Leather Handbag",
        "ASIN": "B07JX6F9M8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41TBq5FTXsL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "Id": 2545,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Chloe Roy Chain Pouch Crossbody Bag made in Spain",
        "ASIN": "B07GC2CWLK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/31BzIWrLakL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 10, 2018",
        "Id": 2546,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 25.65,
        "ReviewItem5": 0,
        "Title": "Women Printed Zip Around Wallet Leaf Texture Leather Phone Clutch Travel Card Holder Purse",
        "ASIN": "B07R8ZG3TZ",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/416jbyS3uZL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 25.65,
        "UploadTime": " April 30, 2019",
        "Id": 2547,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 83,
        "Title": "Pink Camo Western Pistol Gun Redneck Fashion Purse",
        "ASIN": "B008SXS9S6",
        "ReviewItem3": 17,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/514k8O5DurL._US40_.jpg",
        "AcquisitionTime": 1557849600000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " August 4, 2012",
        "Id": 2667,
        "ReviewCount": 6
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 120.99,
        "ReviewItem5": 0,
        "Title": "Backpacks for Women Girls Ladies Genuine Leather Shoulder Bag Travel Casual School Bags",
        "ASIN": "B07CM53BWM",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/419f1fGmSOL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 120.99,
        "UploadTime": " April 24, 2018",
        "Id": 2548,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 11.88,
        "ReviewItem5": 0,
        "Title": "Men Wallet | Wife to Husband Gift | Dad Son Birthday Christmas Anniversary Gifts",
        "ASIN": "B07NQCH4WS",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/5133rEIr7HL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 11.88,
        "UploadTime": " March 31, 2019",
        "Id": 2549,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Jelly Rhinestone V- Line Quilted Handbag Crossbody with Chain",
        "ASIN": "B07QX2FG5X",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41V8dZZD9EL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " April 18, 2019",
        "Id": 2590,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 19.95,
        "ReviewItem5": 0,
        "Title": "NGIL Canvas Tote Bag with Matching Coin Purse",
        "ASIN": "B07NF7YM7J",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41rVvgFsWnL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 19.95,
        "UploadTime": " February 6, 2019",
        "Id": 2550,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Shoulder Bags",
        "ReviewItem1": 7,
        "ReviewItem2": 3,
        "PriceMax": 288,
        "ReviewItem5": 76,
        "Title": "Michael Kors Women’s Cynthia Hobos and Shoulder Bag",
        "ASIN": "B0761X14FD",
        "ReviewItem3": 0,
        "ReviewItem4": 14,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/414x764lfwL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 288,
        "UploadTime": " September 6, 2013",
        "Id": 2551,
        "ReviewCount": 29
    }, {
        "Sale": "[]",
        "Category": "Totes",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 50,
        "ReviewItem5": 100,
        "Title": "Pure Country Weavers - Collie Hand Finished Large Woven Tote Bag Cotton USA",
        "ASIN": "B005CXR7FG",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/614nYs2TmIL._SS40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 50,
        "Id": 2552,
        "ReviewCount": 4
    }, {
        "Sale": "[]",
        "Category": "Handbags & Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Womens SADDLE BAG IN CANVAS Dior Shoulder Bag With a Strap Handbag",
        "ASIN": "B07NSJY22R",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51e87fZO5DL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " December 29, 2018",
        "Id": 2553,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 21.95,
        "ReviewItem5": 0,
        "Title": "VanGoddy Hydei Crossbody Handbag for Nuvision 9.7 to 10.1\" Tablets",
        "ASIN": "B00JQQHBS8",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41EE3uqscBL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 21.95,
        "UploadTime": " April 16, 2014",
        "Id": 2554,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Wallets",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 14.99,
        "ReviewItem5": 89,
        "Title": "K A Women's RFID Blocking Zip Around Wallet Clutch Large Capacity Travel Purse Chevron Zigzag Bag with Wristlet",
        "ASIN": "B07KJBLDFX",
        "ReviewItem3": 0,
        "ReviewItem4": 11,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51hYNXA1tkL._SR38,50_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 14.99,
        "UploadTime": " December 20, 2018",
        "Id": 2555,
        "ReviewCount": 19
    }, {
        "Sale": "[]",
        "Category": "Top-Handle Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 0,
        "ReviewItem5": 0,
        "Title": "Jr. Bridesmaid Cotton Canvas Tote Bag in Black - One Size",
        "ASIN": "B01ND146JK",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/41ypN3mjLOL._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 0,
        "UploadTime": " January 30, 2017",
        "Id": 2556,
        "ReviewCount": 0
    }, {
        "Sale": "[]",
        "Category": "Crossbody Bags",
        "ReviewItem1": 0,
        "ReviewItem2": 0,
        "PriceMax": 43.1,
        "ReviewItem5": 0,
        "Title": "Gabor Women's Roberta Cross-Body Bag",
        "ASIN": "B0796HGB15",
        "ReviewItem3": 0,
        "ReviewItem4": 0,
        "Image": "https://images-na.ssl-images-amazon.com/images/I/51a2I4ZU-6L._US40_.jpg",
        "AcquisitionTime": 1557763200000,
        "Price": "[]",
        "PriceMin": 43.1,
        "UploadTime": " September 10, 2018",
        "Id": 2557,
        "ReviewCount": 0
    }]
}